export const councilDonors = [
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC18",
   "ENTITY": "COM",
   "ENTITY NAME": "Cement Mason's Local 400 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC7",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Line Dance Association of America (CLDAA)",
   "OCCUPATION": "Office Manager",
   "AMOUNT": 1100
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC4",
   "ENTITY": "IND",
   "ENTITY NAME": "Lin",
   "ENTITY NAME CONT.": "Kico",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kico Lin Realty",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 1100
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC5",
   "ENTITY": "IND",
   "ENTITY NAME": "Rai",
   "ENTITY NAME CONT.": "Sharanjit S. Kali",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Sharanjit S. Kali Rai",
   "OCCUPATION": "Lobbyist",
   "AMOUNT": 1100
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC13",
   "ENTITY": "OTH",
   "ENTITY NAME": "Armando Gomez Consulting",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC17",
   "ENTITY": "OTH",
   "ENTITY NAME": "Canyon Snow Consulting, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "E",
   "ID": "EXP30",
   "ENTITY": "OTH",
   "ENTITY NAME": "Deane & Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1864
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "E",
   "ID": "EXP32",
   "ENTITY": "OTH",
   "ENTITY NAME": "Deane & Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 933
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "E",
   "ID": "EXP28",
   "ENTITY": "OTH",
   "ENTITY NAME": "Deane & Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 750
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EXP35",
   "ENTITY": "OTH",
   "ENTITY NAME": "Deane & Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 266
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EXP36",
   "ENTITY": "OTH",
   "ENTITY NAME": "Deane & Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 259
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "F",
   "ID": "PAY2",
   "ENTITY": "OTH",
   "ENTITY NAME": "Deane & Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "F",
   "ID": "PAY3",
   "ENTITY": "OTH",
   "ENTITY NAME": "Deane & Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC14",
   "ENTITY": "OTH",
   "ENTITY NAME": "Hunter Properties, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC12",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pinnacle Strategy",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Hollister",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC6",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Schoennauer Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Arenas",
   "FIRST": "Sylvia",
   "PURPOSE": "Sylvia Arenas Legal Defense Fund",
   "DATE": "12/28/2018",
   "FORM": "A",
   "ID": "INC15",
   "ENTITY": "SCC",
   "ENTITY NAME": "Laborers Local Union 270 PAC Small Contributor Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2661",
   "ENTITY": "COM",
   "ENTITY NAME": "Bill Monning for Senate 2016",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Salinas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3737",
   "ENTITY": "COM",
   "ENTITY NAME": "Branch 193 NALC PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3728",
   "ENTITY": "COM",
   "ENTITY NAME": "Build Jobs PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4693",
   "ENTITY": "COM",
   "ENTITY NAME": "CA Teamsters Public Affairs Council Public Affairs Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3730",
   "ENTITY": "COM",
   "ENTITY NAME": "Cement Mason's Local 400",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3731",
   "ENTITY": "COM",
   "ENTITY NAME": "Cement Mason's Local 400",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2556",
   "ENTITY": "COM",
   "ENTITY NAME": "Construction & General Laborers Local Union 304 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2542",
   "ENTITY": "COM",
   "ENTITY NAME": "Fabian Nunez for Treasurer 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC5208",
   "ENTITY": "COM",
   "ENTITY NAME": "IBEW 332 Education Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3977",
   "ENTITY": "COM",
   "ENTITY NAME": "IFPTE Local 21 TJ Anthony PAC Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2660",
   "ENTITY": "COM",
   "ENTITY NAME": "Kevin de Leon for Senate 2014",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Long Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3796",
   "ENTITY": "COM",
   "ENTITY NAME": "Kumar for Council 2014",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3723",
   "ENTITY": "COM",
   "ENTITY NAME": "Laborers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Ana",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5264",
   "ENTITY": "COM",
   "ENTITY NAME": "Laborers Int. Union of North America Local 585 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2665",
   "ENTITY": "COM",
   "ENTITY NAME": "Laborers Local Union 270 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2550",
   "ENTITY": "COM",
   "ENTITY NAME": "Laborers Pacific Southwest Regional Organizing Coalition PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3722",
   "ENTITY": "COM",
   "ENTITY NAME": "laborers' International Union Local 1309",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Lakewood",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2541",
   "ENTITY": "COM",
   "ENTITY NAME": "Laborers' Local 220 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2540",
   "ENTITY": "COM",
   "ENTITY NAME": "Laborers' Local 300",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3735",
   "ENTITY": "COM",
   "ENTITY NAME": "Larry Stone County Assessor 18",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2662",
   "ENTITY": "COM",
   "ENTITY NAME": "Miguel Santiago for Assembly 2016",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Long Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3753",
   "ENTITY": "COM",
   "ENTITY NAME": "Northern CA Carpenters Regional Council",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3980",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbers, Steamfitters & Refrigeration Fitters Local 393",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2619",
   "ENTITY": "COM",
   "ENTITY NAME": "Portantino For Senate 2020",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Long Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5269",
   "ENTITY": "COM",
   "ENTITY NAME": "Re-Elect Scott Wiener for Senate 2020",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2666",
   "ENTITY": "COM",
   "ENTITY NAME": "San Jose Police Officers' Association",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2516",
   "ENTITY": "COM",
   "ENTITY NAME": "Santa Clara & San Benito Counties Building & Construction Trades Council PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3981",
   "ENTITY": "COM",
   "ENTITY NAME": "Santa Clara County Residents for Responsible Development",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4207",
   "ENTITY": "COM",
   "ENTITY NAME": "SEIU Local 521 Candidate PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4694",
   "ENTITY": "COM",
   "ENTITY NAME": "Sheet Metal Workers' International Assn. Local 104",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3756",
   "ENTITY": "COM",
   "ENTITY NAME": "Southern CA District Council of Laborers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2558",
   "ENTITY": "COM",
   "ENTITY NAME": "Steve Veres for L.A. Community College Trustee  2015",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2648",
   "ENTITY": "IND",
   "ENTITY NAME": "Adera",
   "ENTITY NAME CONT.": "Theodros",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Cit of San Jose",
   "OCCUPATION": "Council Aide",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1553",
   "ENTITY": "IND",
   "ENTITY NAME": "Aguilera",
   "ENTITY NAME CONT.": "Hilda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 108
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2599",
   "ENTITY": "IND",
   "ENTITY NAME": "Ahrens",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "California State Assembly",
   "OCCUPATION": "Senior District Representative",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2592",
   "ENTITY": "IND",
   "ENTITY NAME": "Alvarado",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "3 Dog Ventures",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3738",
   "ENTITY": "IND",
   "ENTITY NAME": "Alvarado",
   "ENTITY NAME CONT.": "Blanca",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3773",
   "ENTITY": "IND",
   "ENTITY NAME": "Alvarado",
   "ENTITY NAME CONT.": "Jaime",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "3 Dog Ventures",
   "OCCUPATION": "Self-Employed",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2670",
   "ENTITY": "IND",
   "ENTITY NAME": "Alvarez",
   "ENTITY NAME CONT.": "Edward",
   "ENTITY CITY": "Pismo Beach",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3744",
   "ENTITY": "IND",
   "ENTITY NAME": "Amador-Le Beau",
   "ENTITY NAME CONT.": "Rose",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Conxion",
   "OCCUPATION": "Supervisor",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5268",
   "ENTITY": "IND",
   "ENTITY NAME": "Amato",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Loan Officer",
   "OCCUPATION": "Commerce Home Mortgage",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3801",
   "ENTITY": "IND",
   "ENTITY NAME": "Andaluz",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown College Prep",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2653",
   "ENTITY": "IND",
   "ENTITY NAME": "Arellano",
   "ENTITY NAME CONT.": "Jorge",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3758",
   "ENTITY": "IND",
   "ENTITY NAME": "Arenas",
   "ENTITY NAME CONT.": "Sylvia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Member",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX877",
   "ENTITY": "IND",
   "ENTITY NAME": "Arenas",
   "ENTITY NAME CONT.": "Sylvia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5265",
   "ENTITY": "IND",
   "ENTITY NAME": "Arenas",
   "ENTITY NAME CONT.": "Sylvia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Member",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2639",
   "ENTITY": "IND",
   "ENTITY NAME": "Arenas",
   "ENTITY NAME CONT.": "Sylvia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Member",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2627",
   "ENTITY": "IND",
   "ENTITY NAME": "Arranga",
   "ENTITY NAME CONT.": "Victor M.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hewlett Packard",
   "OCCUPATION": "Operations",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2546",
   "ENTITY": "IND",
   "ENTITY NAME": "Arreola",
   "ENTITY NAME CONT.": "Jamie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "East Side Union High School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2654",
   "ENTITY": "IND",
   "ENTITY NAME": "Arreola",
   "ENTITY NAME CONT.": "Kiara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Aide",
   "AMOUNT": 20
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC5206",
   "ENTITY": "IND",
   "ENTITY NAME": "Aytch",
   "ENTITY NAME CONT.": "Keith",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Evergreen Valley College",
   "OCCUPATION": "President",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4700",
   "ENTITY": "IND",
   "ENTITY NAME": "Bainiwal",
   "ENTITY NAME CONT.": "Sukhdev",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Thermos",
   "OCCUPATION": "Senior Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2578",
   "ENTITY": "IND",
   "ENTITY NAME": "Balinton",
   "ENTITY NAME CONT.": "Milan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2622",
   "ENTITY": "IND",
   "ENTITY NAME": "Barraza",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Hilltop Public Solutions",
   "OCCUPATION": "Principal",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5272",
   "ENTITY": "IND",
   "ENTITY NAME": "Bartholomeusz",
   "ENTITY NAME CONT.": "Prameela",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "BPG Business Services LLC",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3975",
   "ENTITY": "IND",
   "ENTITY NAME": "Bentz",
   "ENTITY NAME CONT.": "Douglas",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Sharks",
   "OCCUPATION": "Marketing Manager",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3967",
   "ENTITY": "IND",
   "ENTITY NAME": "Berry",
   "ENTITY NAME CONT.": "Rhonda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Our City Forest",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5279",
   "ENTITY": "IND",
   "ENTITY NAME": "Bhanot",
   "ENTITY NAME CONT.": "Vipan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "N/A",
   "AMOUNT": 99
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2526",
   "ENTITY": "IND",
   "ENTITY NAME": "Blake",
   "ENTITY NAME CONT.": "Penelope",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2527",
   "ENTITY": "IND",
   "ENTITY NAME": "Blake",
   "ENTITY NAME CONT.": "Ronald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3767",
   "ENTITY": "IND",
   "ENTITY NAME": "Blake",
   "ENTITY NAME CONT.": "Ronald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3748",
   "ENTITY": "IND",
   "ENTITY NAME": "Bolger",
   "ENTITY NAME CONT.": "Brenna",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "PRx Digital",
   "OCCUPATION": "Public Relations",
   "AMOUNT": 75
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4658",
   "ENTITY": "IND",
   "ENTITY NAME": "Bothman",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Bothman Construction Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2645",
   "ENTITY": "IND",
   "ENTITY NAME": "Brackpool",
   "ENTITY NAME CONT.": "Keith",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Cadiz",
   "OCCUPATION": "Chairman",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2581",
   "ENTITY": "IND",
   "ENTITY NAME": "Brooks",
   "ENTITY NAME CONT.": "Chandra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Author",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3787",
   "ENTITY": "IND",
   "ENTITY NAME": "Brunner",
   "ENTITY NAME CONT.": "Alison",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Foundation of Silicon Valley",
   "OCCUPATION": "CEO/Attorney",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4642",
   "ENTITY": "IND",
   "ENTITY NAME": "Buchanan",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partnership USA",
   "OCCUPATION": "Communication Specialist",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2628",
   "ENTITY": "IND",
   "ENTITY NAME": "Burroughs",
   "ENTITY NAME CONT.": "Joshua",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2681",
   "ENTITY": "IND",
   "ENTITY NAME": "Bustamante",
   "ENTITY NAME CONT.": "Salvador",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "Latinos United for a New America",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5274",
   "ENTITY": "IND",
   "ENTITY NAME": "Bustamante",
   "ENTITY NAME CONT.": "Salvador",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Latinos United for a New America",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3793",
   "ENTITY": "IND",
   "ENTITY NAME": "Bustamante",
   "ENTITY NAME CONT.": "Salvador",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Latinos United for a New America",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3802",
   "ENTITY": "IND",
   "ENTITY NAME": "Bustamante",
   "ENTITY NAME CONT.": "Salvador",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Latinos United for a New America",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4643",
   "ENTITY": "IND",
   "ENTITY NAME": "Callender",
   "ENTITY NAME CONT.": "Enrico",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Water District",
   "OCCUPATION": "Government Relations",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3786",
   "ENTITY": "IND",
   "ENTITY NAME": "Calvo",
   "ENTITY NAME CONT.": "Cheye",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rocketship Public School",
   "OCCUPATION": "Chief Growth & Community Engagement Officer",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5275",
   "ENTITY": "IND",
   "ENTITY NAME": "Calvo",
   "ENTITY NAME CONT.": "Cheye",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rocketship Public School",
   "OCCUPATION": "Chief Growth & Community Engagement Officer",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2582",
   "ENTITY": "IND",
   "ENTITY NAME": "Candelas",
   "ENTITY NAME CONT.": "Domingo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "State of CA",
   "OCCUPATION": "District Director",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2647",
   "ENTITY": "IND",
   "ENTITY NAME": "Carr",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2675",
   "ENTITY": "IND",
   "ENTITY NAME": "Carrillo",
   "ENTITY NAME CONT.": "Pete",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Advisors",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3966",
   "ENTITY": "IND",
   "ENTITY NAME": "Casas Cuellar",
   "ENTITY NAME CONT.": "Jorge",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Policy Aide",
   "AMOUNT": 51
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3959",
   "ENTITY": "IND",
   "ENTITY NAME": "Casas Cuellar",
   "ENTITY NAME CONT.": "Jorge",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Policy Aide",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4691",
   "ENTITY": "IND",
   "ENTITY NAME": "Castro",
   "ENTITY NAME CONT.": "Marvin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Orale Inc.",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 400
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2642",
   "ENTITY": "IND",
   "ENTITY NAME": "Castro",
   "ENTITY NAME CONT.": "Huascr",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Assistant",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1919",
   "ENTITY": "IND",
   "ENTITY NAME": "Castro",
   "ENTITY NAME CONT.": "Huascr",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 70
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2533",
   "ENTITY": "IND",
   "ENTITY NAME": "Castro",
   "ENTITY NAME CONT.": "Huascr",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Assistant",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3789",
   "ENTITY": "IND",
   "ENTITY NAME": "Cecil",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "MC2 Bay Area Public Affairs",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2615",
   "ENTITY": "IND",
   "ENTITY NAME": "Chapman",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4667",
   "ENTITY": "IND",
   "ENTITY NAME": "Chapman",
   "ENTITY NAME CONT.": "Helen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Policy Aide",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2640",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Irene",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Kaiser Permanente",
   "OCCUPATION": "Senior Vice President Area Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3736",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Lorraine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Conxion",
   "OCCUPATION": "Executive Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3799",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Lorena",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Teach for America",
   "OCCUPATION": "Coordinator",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4668",
   "ENTITY": "IND",
   "ENTITY NAME": "Chu",
   "ENTITY NAME CONT.": "Kansen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "State of CA",
   "OCCUPATION": "Assemblymember",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2584",
   "ENTITY": "IND",
   "ENTITY NAME": "Chung",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2616",
   "ENTITY": "IND",
   "ENTITY NAME": "Clanton",
   "ENTITY NAME CONT.": "Vera",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4704",
   "ENTITY": "IND",
   "ENTITY NAME": "Coria",
   "ENTITY NAME CONT.": "Efrain",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "CPA",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2638",
   "ENTITY": "IND",
   "ENTITY NAME": "Cortese",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "Supervisor",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3765",
   "ENTITY": "IND",
   "ENTITY NAME": "Cortez",
   "ENTITY NAME CONT.": "Darrell",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "N/A",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4672",
   "ENTITY": "IND",
   "ENTITY NAME": "Crosby",
   "ENTITY NAME CONT.": "Tanis",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "YWCA",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2585",
   "ENTITY": "IND",
   "ENTITY NAME": "Cruz",
   "ENTITY NAME CONT.": "Juan",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3781",
   "ENTITY": "IND",
   "ENTITY NAME": "Cruz",
   "ENTITY NAME CONT.": "Mayra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "De Anza College",
   "OCCUPATION": "Professor",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2629",
   "ENTITY": "IND",
   "ENTITY NAME": "Cuevas",
   "ENTITY NAME CONT.": "Julian",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "CA Department of Education",
   "OCCUPATION": "Assistant",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2671",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunneen",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3732",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunneen",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Consultant",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4666",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunningham",
   "ENTITY NAME CONT.": "Lorien",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Emerge",
   "OCCUPATION": "Program Coordinator",
   "AMOUNT": 20
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2680",
   "ENTITY": "IND",
   "ENTITY NAME": "Dauber",
   "ENTITY NAME CONT.": "Michele",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "",
   "EMPLOYER": "Stanford Law School",
   "OCCUPATION": "Professor",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2587",
   "ENTITY": "IND",
   "ENTITY NAME": "Deras",
   "ENTITY NAME CONT.": "Karina",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2532",
   "ENTITY": "IND",
   "ENTITY NAME": "Dey",
   "ENTITY NAME CONT.": "Mita",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Women Now",
   "OCCUPATION": "Consultant",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4664",
   "ENTITY": "IND",
   "ENTITY NAME": "Dey",
   "ENTITY NAME CONT.": "Mita",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Women Now",
   "OCCUPATION": "Consultant",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2522",
   "ENTITY": "IND",
   "ENTITY NAME": "Dhillon",
   "ENTITY NAME CONT.": "B.S.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4697",
   "ENTITY": "IND",
   "ENTITY NAME": "Dhillon",
   "ENTITY NAME CONT.": "R.K",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "RK Dhillon Trust",
   "OCCUPATION": "Self-Employed",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5280",
   "ENTITY": "IND",
   "ENTITY NAME": "Dhillon",
   "ENTITY NAME CONT.": "Gurben Singh",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Taxi",
   "OCCUPATION": "Self-Employed",
   "AMOUNT": 70
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4209",
   "ENTITY": "IND",
   "ENTITY NAME": "Diaz",
   "ENTITY NAME CONT.": "Manolo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2554",
   "ENTITY": "IND",
   "ENTITY NAME": "Diaz",
   "ENTITY NAME CONT.": "Telma Jose",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2625",
   "ENTITY": "IND",
   "ENTITY NAME": "Dixit",
   "ENTITY NAME CONT.": "Satyananda",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5270",
   "ENTITY": "IND",
   "ENTITY NAME": "Dodd",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "Napa",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4659",
   "ENTITY": "IND",
   "ENTITY NAME": "Dodge",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "Watsonville",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "N/A",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2690",
   "ENTITY": "IND",
   "ENTITY NAME": "Dumont",
   "ENTITY NAME CONT.": "Diana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2597",
   "ENTITY": "IND",
   "ENTITY NAME": "Duong",
   "ENTITY NAME CONT.": "Kathy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Canyon Snow",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3752",
   "ENTITY": "IND",
   "ENTITY NAME": "Duran",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Duran HCP Inc.",
   "OCCUPATION": "Self-Employed",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3782",
   "ENTITY": "IND",
   "ENTITY NAME": "Eckert",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Alum Rock Counseling Center",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3760",
   "ENTITY": "IND",
   "ENTITY NAME": "Edwin",
   "ENTITY NAME CONT.": "Retna",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "N/A",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2555",
   "ENTITY": "IND",
   "ENTITY NAME": "Edwin",
   "ENTITY NAME CONT.": "Retna",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3761",
   "ENTITY": "IND",
   "ENTITY NAME": "Edwin",
   "ENTITY NAME CONT.": "Arul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VSCE, Inc.",
   "OCCUPATION": "Senior Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2663",
   "ENTITY": "IND",
   "ENTITY NAME": "Edwin",
   "ENTITY NAME CONT.": "Arul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 99
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2664",
   "ENTITY": "IND",
   "ENTITY NAME": "Edwin",
   "ENTITY NAME CONT.": "Retna",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "",
   "AMOUNT": 99
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2607",
   "ENTITY": "IND",
   "ENTITY NAME": "Espinoza",
   "ENTITY NAME CONT.": "Reymundo",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Gardner Health Services",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4706",
   "ENTITY": "IND",
   "ENTITY NAME": "Espinoza",
   "ENTITY NAME CONT.": "Reymundo",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Gardner Health Services",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2534",
   "ENTITY": "IND",
   "ENTITY NAME": "Ferrer",
   "ENTITY NAME CONT.": "Frederick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4645",
   "ENTITY": "IND",
   "ENTITY NAME": "Fiss",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4649",
   "ENTITY": "IND",
   "ENTITY NAME": "Flores",
   "ENTITY NAME CONT.": "Andrea",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4212",
   "ENTITY": "IND",
   "ENTITY NAME": "Flores Toral",
   "ENTITY NAME CONT.": "Eduardo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Flores Tax Service",
   "OCCUPATION": "Accountant",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3791",
   "ENTITY": "IND",
   "ENTITY NAME": "Flynn",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cavium",
   "OCCUPATION": "Engineer",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3794",
   "ENTITY": "IND",
   "ENTITY NAME": "Fontanilla",
   "ENTITY NAME CONT.": "Camille",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SOMOS Mayfair",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 175
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2626",
   "ENTITY": "IND",
   "ENTITY NAME": "Gaeta",
   "ENTITY NAME CONT.": "Margie",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3740",
   "ENTITY": "IND",
   "ENTITY NAME": "Garcia Merino",
   "ENTITY NAME CONT.": "Ruth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2676",
   "ENTITY": "IND",
   "ENTITY NAME": "Gardner",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4679",
   "ENTITY": "IND",
   "ENTITY NAME": "Gascoigne",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Clamente",
   "Entity_ST": "CA",
   "EMPLOYER": "Ultra Estate Planning",
   "OCCUPATION": "Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3750",
   "ENTITY": "IND",
   "ENTITY NAME": "Ginsborg",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County Assessor",
   "OCCUPATION": "Deputy Aide",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2630",
   "ENTITY": "IND",
   "ENTITY NAME": "Gogo",
   "ENTITY NAME CONT.": "Johnny",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "District Attorney",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2637",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Victor",
   "ENTITY CITY": "Hollister",
   "Entity_ST": "CA",
   "EMPLOYER": "Pinnacle Strategy",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5271",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Bernadette",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employer",
   "OCCUPATION": "Blogger",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3972",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Leticia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sacred Heart",
   "OCCUPATION": "Business Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2613",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzales",
   "ENTITY NAME CONT.": "Ronald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5267",
   "ENTITY": "IND",
   "ENTITY NAME": "Gorshteyn",
   "ENTITY NAME CONT.": "Vlad",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "All Seasons Roofing & Waterproofing",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2531",
   "ENTITY": "IND",
   "ENTITY NAME": "Grasty",
   "ENTITY NAME CONT.": "William Derek",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3772",
   "ENTITY": "IND",
   "ENTITY NAME": "Graziosi",
   "ENTITY NAME CONT.": "Erin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Robinson Oil Corp.",
   "OCCUPATION": "Supply & Transport",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2525",
   "ENTITY": "IND",
   "ENTITY NAME": "Guardino",
   "ENTITY NAME CONT.": "Carl Thomas",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3803",
   "ENTITY": "IND",
   "ENTITY NAME": "Guerra",
   "ENTITY NAME CONT.": "Hector",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homeless Veterans Emergency Agency",
   "OCCUPATION": "Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3983",
   "ENTITY": "IND",
   "ENTITY NAME": "Guerra",
   "ENTITY NAME CONT.": "Hector",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homeless Veterans Emergency Agency",
   "OCCUPATION": "Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2621",
   "ENTITY": "IND",
   "ENTITY NAME": "Guerrero",
   "ENTITY NAME CONT.": "Cynthia",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies",
   "OCCUPATION": "Partner",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4644",
   "ENTITY": "IND",
   "ENTITY NAME": "Guzman",
   "ENTITY NAME CONT.": "Anietra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "N/A",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4646",
   "ENTITY": "IND",
   "ENTITY NAME": "Guzman",
   "ENTITY NAME CONT.": "Jacqueline",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of Cupertino",
   "OCCUPATION": "Deputy City Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3788",
   "ENTITY": "IND",
   "ENTITY NAME": "Hammer",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Innovative Public Schools",
   "OCCUPATION": "CEO",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3785",
   "ENTITY": "IND",
   "ENTITY NAME": "Harasz",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Housing Authority",
   "OCCUPATION": "CEO",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2586",
   "ENTITY": "IND",
   "ENTITY NAME": "Haro",
   "ENTITY NAME CONT.": "Jesse",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2656",
   "ENTITY": "IND",
   "ENTITY NAME": "Hawes",
   "ENTITY NAME CONT.": "Amanda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2618",
   "ENTITY": "IND",
   "ENTITY NAME": "Helen Doherty",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3777",
   "ENTITY": "IND",
   "ENTITY NAME": "Herbert",
   "ENTITY NAME CONT.": "Frances",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Chief of Staff",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3734",
   "ENTITY": "IND",
   "ENTITY NAME": "Hernandez",
   "ENTITY NAME CONT.": "Paulo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Land Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4656",
   "ENTITY": "IND",
   "ENTITY NAME": "Hernandez",
   "ENTITY NAME CONT.": "Jose",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero",
   "OCCUPATION": "Realtor",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2583",
   "ENTITY": "IND",
   "ENTITY NAME": "Hernandez",
   "ENTITY NAME CONT.": "Miriam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Enterprise Foundation",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2588",
   "ENTITY": "IND",
   "ENTITY NAME": "Herrera",
   "ENTITY NAME CONT.": "Shawn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mazda Tech",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2649",
   "ENTITY": "IND",
   "ENTITY NAME": "Hicks",
   "ENTITY NAME CONT.": "Jodi",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "DiMare, Brown, Hicks & Kessler, LLC",
   "OCCUPATION": "Partner",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4639",
   "ENTITY": "IND",
   "ENTITY NAME": "Hicks",
   "ENTITY NAME CONT.": "Tristan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Facebook",
   "OCCUPATION": "Recruiter",
   "AMOUNT": 75
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4662",
   "ENTITY": "IND",
   "ENTITY NAME": "Higuerey",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Rocketship Public Schools",
   "OCCUPATION": "Community Engagement",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5276",
   "ENTITY": "IND",
   "ENTITY NAME": "Hill",
   "ENTITY NAME CONT.": "Jerry",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "CA State Senate",
   "OCCUPATION": "Senator",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2641",
   "ENTITY": "IND",
   "ENTITY NAME": "Hill",
   "ENTITY NAME CONT.": "Cayce",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Veggielution",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5281",
   "ENTITY": "IND",
   "ENTITY NAME": "Holguin",
   "ENTITY NAME CONT.": "Luis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "GiftStop/BoostMobile",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3800",
   "ENTITY": "IND",
   "ENTITY NAME": "Howard",
   "ENTITY NAME CONT.": "Derik",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Elemental Wellness Center",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1554",
   "ENTITY": "IND",
   "ENTITY NAME": "Hubris",
   "ENTITY NAME CONT.": "Grace",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 324
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2644",
   "ENTITY": "IND",
   "ENTITY NAME": "Huynh",
   "ENTITY NAME CONT.": "Dieu",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Aide",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2673",
   "ENTITY": "IND",
   "ENTITY NAME": "Ibanez",
   "ENTITY NAME CONT.": "Juan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3790",
   "ENTITY": "IND",
   "ENTITY NAME": "Jasty",
   "ENTITY NAME CONT.": "Ananth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cavium",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2591",
   "ENTITY": "IND",
   "ENTITY NAME": "Jensen",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2652",
   "ENTITY": "IND",
   "ENTITY NAME": "Jordan",
   "ENTITY NAME CONT.": "Katie",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2535",
   "ENTITY": "IND",
   "ENTITY NAME": "Kali Rai",
   "ENTITY NAME CONT.": "Sharanjit",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2537",
   "ENTITY": "IND",
   "ENTITY NAME": "Kali-Rai",
   "ENTITY NAME CONT.": "Miriam",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2521",
   "ENTITY": "IND",
   "ENTITY NAME": "Kalra",
   "ENTITY NAME CONT.": "Ashu",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "State of California",
   "OCCUPATION": "Assemblymember",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2549",
   "ENTITY": "IND",
   "ENTITY NAME": "Kaur",
   "ENTITY NAME CONT.": "Baljinder",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4242",
   "ENTITY": "IND",
   "ENTITY NAME": "King",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Healthier Kids Foundation",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4050",
   "ENTITY": "IND",
   "ENTITY NAME": "Knies",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Association",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2677",
   "ENTITY": "IND",
   "ENTITY NAME": "Kozuma",
   "ENTITY NAME CONT.": "Neil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "Foothill Community Health",
   "OCCUPATION": "Compliance Officer",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2650",
   "ENTITY": "IND",
   "ENTITY NAME": "Krishnan",
   "ENTITY NAME CONT.": "Uma",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4695",
   "ENTITY": "IND",
   "ENTITY NAME": "Lam Su",
   "ENTITY NAME CONT.": "Cindy Phuong",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Realty World",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4637",
   "ENTITY": "IND",
   "ENTITY NAME": "Lim",
   "ENTITY NAME CONT.": "Tiem",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Dentist",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2683",
   "ENTITY": "IND",
   "ENTITY NAME": "Lippman",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "ACE Charter Schools",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3964",
   "ENTITY": "IND",
   "ENTITY NAME": "Lomonaco",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Elemental Wellness Center",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX520",
   "ENTITY": "IND",
   "ENTITY NAME": "Lopez",
   "ENTITY NAME CONT.": "Baltazar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 750
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3754",
   "ENTITY": "IND",
   "ENTITY NAME": "Lucero",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3751",
   "ENTITY": "IND",
   "ENTITY NAME": "Ma Lebron",
   "ENTITY NAME CONT.": "Charisse",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Veggeilution",
   "OCCUPATION": "CEO",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2590",
   "ENTITY": "IND",
   "ENTITY NAME": "Maben",
   "ENTITY NAME CONT.": "Meri",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4653",
   "ENTITY": "IND",
   "ENTITY NAME": "Macias",
   "ENTITY NAME CONT.": "Ernesto",
   "ENTITY CITY": "Anaheim",
   "Entity_ST": "CA",
   "EMPLOYER": "West Coast Arborists",
   "OCCUPATION": "Area Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2624",
   "ENTITY": "IND",
   "ENTITY NAME": "Macias",
   "ENTITY NAME CONT.": "Alfredo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3762",
   "ENTITY": "IND",
   "ENTITY NAME": "Maciel",
   "ENTITY NAME CONT.": "Mario",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Division Manager",
   "AMOUNT": 99
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2631",
   "ENTITY": "IND",
   "ENTITY NAME": "Maciel",
   "ENTITY NAME CONT.": "Zulma",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3968",
   "ENTITY": "IND",
   "ENTITY NAME": "Magana",
   "ENTITY NAME CONT.": "Jose",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Learning Ovations Inc.",
   "OCCUPATION": "Director of School Outcomes",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4681",
   "ENTITY": "IND",
   "ENTITY NAME": "Mahoney",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Anaheim",
   "Entity_ST": "CA",
   "EMPLOYER": "West Coast Arborist",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4682",
   "ENTITY": "IND",
   "ENTITY NAME": "Mahoney",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Anaheim",
   "Entity_ST": "CA",
   "EMPLOYER": "West Coast Arborist",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4707",
   "ENTITY": "IND",
   "ENTITY NAME": "Mahoney",
   "ENTITY NAME CONT.": "Jolynn",
   "ENTITY CITY": "Anaheim",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1877",
   "ENTITY": "IND",
   "ENTITY NAME": "Mahoney",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Anaheim",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3971",
   "ENTITY": "IND",
   "ENTITY NAME": "Maldonado",
   "ENTITY NAME CONT.": "Maritza",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Amigos de Guadalupe Center for Justice & Empowerment",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2643",
   "ENTITY": "IND",
   "ENTITY NAME": "Martinez",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3970",
   "ENTITY": "IND",
   "ENTITY NAME": "McCord",
   "ENTITY NAME CONT.": "Socorro",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2600",
   "ENTITY": "IND",
   "ENTITY NAME": "McGarrity",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Aide",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5273",
   "ENTITY": "IND",
   "ENTITY NAME": "McGarrity",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Aide",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4195",
   "ENTITY": "IND",
   "ENTITY NAME": "Mendoza",
   "ENTITY NAME CONT.": "Nancy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4703",
   "ENTITY": "IND",
   "ENTITY NAME": "Montanez",
   "ENTITY NAME CONT.": "Maribel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gardner Health Clinics",
   "OCCUPATION": "Fund Developer",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2679",
   "ENTITY": "IND",
   "ENTITY NAME": "Moore",
   "ENTITY NAME CONT.": "Dorsey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "San Jose Conservation Corp",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4636",
   "ENTITY": "IND",
   "ENTITY NAME": "Mueller",
   "ENTITY NAME CONT.": "Raymond",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Context Legal Services",
   "OCCUPATION": "Consultant",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2633",
   "ENTITY": "IND",
   "ENTITY NAME": "Mueller",
   "ENTITY NAME CONT.": "Raymond",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Context Legal Services",
   "OCCUPATION": "Consultant",
   "AMOUNT": 20
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2684",
   "ENTITY": "IND",
   "ENTITY NAME": "Musser",
   "ENTITY NAME CONT.": "Reilly",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2553",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Olivia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Navarro Consulting",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3965",
   "ENTITY": "IND",
   "ENTITY NAME": "Neale",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Core Companies",
   "OCCUPATION": "Executive VP",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3969",
   "ENTITY": "IND",
   "ENTITY NAME": "Nevarez",
   "ENTITY NAME CONT.": "Lisset",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Latham & Watkins",
   "OCCUPATION": "Human Resources Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2611",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Tuan",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2636",
   "ENTITY": "IND",
   "ENTITY NAME": "Nunez",
   "ENTITY NAME CONT.": "Guisselle",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Chabot College",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2605",
   "ENTITY": "IND",
   "ENTITY NAME": "Nunez",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hispanic Foundation of SV",
   "OCCUPATION": "CEO",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4053",
   "ENTITY": "IND",
   "ENTITY NAME": "Nunez",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hispanic Foundation of SV",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2632",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Kane",
   "ENTITY NAME CONT.": "Sean",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3771",
   "ENTITY": "IND",
   "ENTITY NAME": "Ochoa",
   "ENTITY NAME CONT.": "Susana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Healthier Kids Foundation",
   "OCCUPATION": "Director of Programs",
   "AMOUNT": 10
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2575",
   "ENTITY": "IND",
   "ENTITY NAME": "Ortiz",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mt. Pleasant School District",
   "OCCUPATION": "Governing Boardmember",
   "AMOUNT": 10
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3795",
   "ENTITY": "IND",
   "ENTITY NAME": "Owens",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "Teach for America",
   "OCCUPATION": "Program Coordinator",
   "AMOUNT": 75
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2523",
   "ENTITY": "IND",
   "ENTITY NAME": "Pal Kalra",
   "ENTITY NAME CONT.": "Satya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3774",
   "ENTITY": "IND",
   "ENTITY NAME": "Pallin",
   "ENTITY NAME CONT.": "Zachary",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Reputation.com",
   "OCCUPATION": "Developer Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1555",
   "ENTITY": "IND",
   "ENTITY NAME": "Pinh",
   "ENTITY NAME CONT.": "Anh",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 324
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2601",
   "ENTITY": "IND",
   "ENTITY NAME": "Pla",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Cordoba Corporation",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1557",
   "ENTITY": "IND",
   "ENTITY NAME": "Plancarte",
   "ENTITY NAME CONT.": "Griselda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 392
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2552",
   "ENTITY": "IND",
   "ENTITY NAME": "Pyle",
   "ENTITY NAME CONT.": "Nancy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2557",
   "ENTITY": "IND",
   "ENTITY NAME": "Quigley",
   "ENTITY NAME CONT.": "Stephen T",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2623",
   "ENTITY": "IND",
   "ENTITY NAME": "Quintero",
   "ENTITY NAME CONT.": "Andres",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Alum Rock School District",
   "OCCUPATION": "Governing Boardmember",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2646",
   "ENTITY": "IND",
   "ENTITY NAME": "Radhakrishnan",
   "ENTITY NAME CONT.": "Sachin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Aide",
   "AMOUNT": 51
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2682",
   "ENTITY": "IND",
   "ENTITY NAME": "Rafiei",
   "ENTITY NAME CONT.": "Melahat",
   "ENTITY CITY": "Long Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "Progressive Solutions Consulting",
   "OCCUPATION": "Principal",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3770",
   "ENTITY": "IND",
   "ENTITY NAME": "Ragsdale",
   "ENTITY NAME CONT.": "Gerald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 40
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2617",
   "ENTITY": "IND",
   "ENTITY NAME": "Rajagopal",
   "ENTITY NAME CONT.": "Samantha",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4652",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Janine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CA Schools Charter Assn.",
   "OCCUPATION": "Director",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3797",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rocketship Schools",
   "OCCUPATION": "School Aide",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3745",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez Jones",
   "ENTITY NAME CONT.": "Lynda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3780",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramos",
   "ENTITY NAME CONT.": "Henry",
   "ENTITY CITY": "Creston",
   "Entity_ST": "CA",
   "EMPLOYER": "Arts & Social Investment Advisor",
   "OCCUPATION": "Writer / Editor",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2687",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramos",
   "ENTITY NAME CONT.": "Angelina",
   "ENTITY CITY": "Union City",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2545",
   "ENTITY": "IND",
   "ENTITY NAME": "Rasheed",
   "ENTITY NAME CONT.": "Adnan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "South Bay Islamic Association",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3742",
   "ENTITY": "IND",
   "ENTITY NAME": "Rawson",
   "ENTITY NAME CONT.": "Amanda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Museum of Art",
   "OCCUPATION": "Aide",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3746",
   "ENTITY": "IND",
   "ENTITY NAME": "Rawson",
   "ENTITY NAME CONT.": "Brendan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Jazz",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3798",
   "ENTITY": "IND",
   "ENTITY NAME": "Reguerin",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Escuela Popular",
   "OCCUPATION": "Educator",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3961",
   "ENTITY": "IND",
   "ENTITY NAME": "Reguerin",
   "ENTITY NAME CONT.": "Pablo",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "UC Santa Cruz",
   "OCCUPATION": "Associate Vice Chancellor for Student Achievement & Equity I",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3973",
   "ENTITY": "IND",
   "ENTITY NAME": "Rewkiewicz",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Frank, Rimerman + Co. LLP",
   "OCCUPATION": "CPA",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3766",
   "ENTITY": "IND",
   "ENTITY NAME": "Richardson",
   "ENTITY NAME CONT.": "Christopher",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown Streets Team",
   "OCCUPATION": "Chief program Officer",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2685",
   "ENTITY": "IND",
   "ENTITY NAME": "Robinson",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1558",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodgers",
   "ENTITY NAME CONT.": "Natalie",
   "ENTITY CITY": "Covina",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 900
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2672",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Jason",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2602",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Leslie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies",
   "OCCUPATION": "Principal",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3724",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Consuelo J.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "N/A",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2579",
   "ENTITY": "IND",
   "ENTITY NAME": "Romero",
   "ENTITY NAME CONT.": "Marco",
   "ENTITY CITY": "",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3779",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "Bill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Vmware",
   "OCCUPATION": "Director of Marketing",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2674",
   "ENTITY": "IND",
   "ENTITY NAME": "Salvo",
   "ENTITY NAME CONT.": "Joseph Di",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3739",
   "ENTITY": "IND",
   "ENTITY NAME": "Salvo",
   "ENTITY NAME CONT.": "Joseph Di",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Educational Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4692",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Alexander",
   "ENTITY CITY": "Aptos",
   "Entity_ST": "CA",
   "EMPLOYER": "ROEM Corporation",
   "OCCUPATION": "Executive VP",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2544",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 95
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3783",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Margaret",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 51
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2580",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3755",
   "ENTITY": "IND",
   "ENTITY NAME": "Sapien",
   "ENTITY NAME CONT.": "Hermelinda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Center for Employment Training",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2689",
   "ENTITY": "IND",
   "ENTITY NAME": "Sarabia",
   "ENTITY NAME CONT.": "Alexis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2688",
   "ENTITY": "IND",
   "ENTITY NAME": "Sausedo",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3974",
   "ENTITY": "IND",
   "ENTITY NAME": "Seaver",
   "ENTITY NAME CONT.": "Derrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Association",
   "OCCUPATION": "Director of Policy & Operations",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2610",
   "ENTITY": "IND",
   "ENTITY NAME": "Seaver",
   "ENTITY NAME CONT.": "Derrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Association",
   "OCCUPATION": "Director of Policy & Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2517",
   "ENTITY": "IND",
   "ENTITY NAME": "Silver Tause",
   "ENTITY NAME CONT.": "Ruth",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2548",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh",
   "ENTITY NAME CONT.": "Vikram",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Business owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3764",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh",
   "ENTITY NAME CONT.": "Paramjeet",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4702",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh",
   "ENTITY NAME CONT.": "Sukhjit",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5278",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh",
   "ENTITY NAME CONT.": "Hardeep",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Clydes Liquor",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 78
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4699",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh Grewal",
   "ENTITY NAME CONT.": "Pritam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Grewal Stores Inc.",
   "OCCUPATION": "Self-Employed",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2609",
   "ENTITY": "IND",
   "ENTITY NAME": "Sloat",
   "ENTITY NAME CONT.": "Julie Green",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Not Employed",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2686",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2595",
   "ENTITY": "IND",
   "ENTITY NAME": "Srinivasan",
   "ENTITY NAME CONT.": "Usha",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "12th Man Consulting",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3727",
   "ENTITY": "IND",
   "ENTITY NAME": "Staedler",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Synergy",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2678",
   "ENTITY": "IND",
   "ENTITY NAME": "Stafford-Gutierrez",
   "ENTITY NAME CONT.": "Janell",
   "ENTITY CITY": "95127",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 35
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2539",
   "ENTITY": "IND",
   "ENTITY NAME": "Strangis",
   "ENTITY NAME CONT.": "Jerry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Strangis Properties",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3792",
   "ENTITY": "IND",
   "ENTITY NAME": "Stuart",
   "ENTITY NAME CONT.": "Sasha",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 10
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4701",
   "ENTITY": "IND",
   "ENTITY NAME": "Takhar",
   "ENTITY NAME CONT.": "Hardev",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3749",
   "ENTITY": "IND",
   "ENTITY NAME": "Terrazas",
   "ENTITY NAME CONT.": "Eva",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4669",
   "ENTITY": "IND",
   "ENTITY NAME": "Teso",
   "ENTITY NAME CONT.": "Frances",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Voices Schools",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2635",
   "ENTITY": "IND",
   "ENTITY NAME": "Toensfeldt",
   "ENTITY NAME CONT.": "Hans W.",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1556",
   "ENTITY": "IND",
   "ENTITY NAME": "Tong",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 392
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1917",
   "ENTITY": "IND",
   "ENTITY NAME": "Torres",
   "ENTITY NAME CONT.": "Omar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 166
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3776",
   "ENTITY": "IND",
   "ENTITY NAME": "Torres",
   "ENTITY NAME CONT.": "Omar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Assistant",
   "AMOUNT": 43
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2577",
   "ENTITY": "IND",
   "ENTITY NAME": "Torres",
   "ENTITY NAME CONT.": "Omar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Council Assistant",
   "AMOUNT": 35
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3778",
   "ENTITY": "IND",
   "ENTITY NAME": "Tortora",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Sharks",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2612",
   "ENTITY": "IND",
   "ENTITY NAME": "Tran",
   "ENTITY NAME CONT.": "Huy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Justice at Work Group LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3963",
   "ENTITY": "IND",
   "ENTITY NAME": "Trejo",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 30
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4040",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Eddie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Silicon Valley Organization",
   "OCCUPATION": "Director of Public Policy",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2530",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Vanlan",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4638",
   "ENTITY": "IND",
   "ENTITY NAME": "Tureen",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Attorney",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3962",
   "ENTITY": "IND",
   "ENTITY NAME": "Uro-May",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Attorney",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3775",
   "ENTITY": "IND",
   "ENTITY NAME": "Valderrama",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4705",
   "ENTITY": "IND",
   "ENTITY NAME": "Valencia",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gardner Health Clinics",
   "OCCUPATION": "Pyschologist",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4196",
   "ENTITY": "IND",
   "ENTITY NAME": "Valencia Barajas",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2593",
   "ENTITY": "IND",
   "ENTITY NAME": "Van Every",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Republic Urban Properties",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3747",
   "ENTITY": "IND",
   "ENTITY NAME": "Vasquez Mendez",
   "ENTITY NAME CONT.": "Bea",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "N/A",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2614",
   "ENTITY": "IND",
   "ENTITY NAME": "Vuong",
   "ENTITY NAME CONT.": "Quyen",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2620",
   "ENTITY": "IND",
   "ENTITY NAME": "Waite",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2655",
   "ENTITY": "IND",
   "ENTITY NAME": "Wasser",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2596",
   "ENTITY": "IND",
   "ENTITY NAME": "Weideman",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "The Weideman Group",
   "OCCUPATION": "Principal",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2651",
   "ENTITY": "IND",
   "ENTITY NAME": "Weitzman",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "Dan Weitzman, LLC",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3784",
   "ENTITY": "IND",
   "ENTITY NAME": "Willcox",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "Strategic Growth Partners",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2598",
   "ENTITY": "IND",
   "ENTITY NAME": "Woolverton",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Stockwell Harris Woolverton Helphrey",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2657",
   "ENTITY": "IND",
   "ENTITY NAME": "Woolverton",
   "ENTITY NAME CONT.": "Katrina",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Musician",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX860",
   "ENTITY": "OTH",
   "ENTITY NAME": "Activate Marketing LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 609
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4696",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amar Corporation dba Strawberry Park Shell",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2524",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amar Corporation dba Strawberry Park Shell",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1108",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amazon",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 74
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5277",
   "ENTITY": "OTH",
   "ENTITY NAME": "Anonymous",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Anonymous",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC5207",
   "ENTITY": "OTH",
   "ENTITY NAME": "Arcadia Development Co.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2536",
   "ENTITY": "OTH",
   "ENTITY NAME": "Armando Gomez Consulting",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3759",
   "ENTITY": "OTH",
   "ENTITY NAME": "C.T. Auto Repair",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4689",
   "ENTITY": "OTH",
   "ENTITY NAME": "CA Home Repairs & Services Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4201",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Cubicles, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1915",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2667",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cameron Subs Corp.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 135
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "I",
   "ID": "RC5249",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 442
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1373",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX858",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose Clerk's Office",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2205
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3725",
   "ENTITY": "OTH",
   "ENTITY NAME": "Coca-Cola",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3982",
   "ENTITY": "OTH",
   "ENTITY NAME": "Communication Workers of America-COPE PCC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1903",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 564
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1368",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 452
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1902",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 116
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1901",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 54
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX861",
   "ENTITY": "OTH",
   "ENTITY NAME": "County of Santa Clara-Registrar of Voters",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 90
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2543",
   "ENTITY": "OTH",
   "ENTITY NAME": "De La Rosa Latin American Imports",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Las Vegas",
   "Entity_ST": "NV",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4199",
   "ENTITY": "OTH",
   "ENTITY NAME": "Devega Entertainment Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4684",
   "ENTITY": "OTH",
   "ENTITY NAME": "DRIVE Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4202",
   "ENTITY": "OTH",
   "ENTITY NAME": "El Girasol",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3978",
   "ENTITY": "OTH",
   "ENTITY NAME": "Flash Plastering, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Corona",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2594",
   "ENTITY": "OTH",
   "ENTITY NAME": "Flores Professional Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4204",
   "ENTITY": "OTH",
   "ENTITY NAME": "Friendship Banquet Hall",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3733",
   "ENTITY": "OTH",
   "ENTITY NAME": "Giant Creative Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2668",
   "ENTITY": "OTH",
   "ENTITY NAME": "Healthy Food Corp.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 135
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4690",
   "ENTITY": "OTH",
   "ENTITY NAME": "Home Ownership Financial",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1585",
   "ENTITY": "OTH",
   "ENTITY NAME": "Hukilau",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 84
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4683",
   "ENTITY": "OTH",
   "ENTITY NAME": "IBEW PAC Educational Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3757",
   "ENTITY": "OTH",
   "ENTITY NAME": "JBHA, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1114",
   "ENTITY": "OTH",
   "ENTITY NAME": "K & V Enterprises",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Moraga",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 900
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1900",
   "ENTITY": "OTH",
   "ENTITY NAME": "KT Electronics",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4698",
   "ENTITY": "OTH",
   "ENTITY NAME": "Kwikee Partners GP DBA Kwikee Mart",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4635",
   "ENTITY": "OTH",
   "ENTITY NAME": "Matos Professional Center, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2518",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mayola Inc. dba Precision Displays & Showcases",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5266",
   "ENTITY": "OTH",
   "ENTITY NAME": "McDonalds Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Chicago",
   "Entity_ST": "IL",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4211",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mendoza's Restaurant",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2547",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mexico Bakery Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4634",
   "ENTITY": "OTH",
   "ENTITY NAME": "Milargo Holdings, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1583",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mountain Mike's Pizza",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1895",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mountain Mike's Pizza",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 81
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1356",
   "ENTITY": "OTH",
   "ENTITY NAME": "Moutain Mikes",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 73
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2529",
   "ENTITY": "OTH",
   "ENTITY NAME": "Nathan Notary",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX873",
   "ENTITY": "OTH",
   "ENTITY NAME": "National Printing Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1210
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX521",
   "ENTITY": "OTH",
   "ENTITY NAME": "National Printing Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 627
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2551",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Horizon Chiropractic",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX869",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 537
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1357",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 183
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1118",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 132
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1369",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 121
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1105",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 117
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX863",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 81
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "I",
   "ID": "RC4687",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 81
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "I",
   "ID": "RC3769",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 78
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX868",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 73
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1896",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 66
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1355",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 66
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX522",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 49
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1906",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 49
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1897",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1101",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 33
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1119",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 26
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "I",
   "ID": "RC4685",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 26
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "I",
   "ID": "RC3768",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "I",
   "ID": "RC4686",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "I",
   "ID": "RC3992",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1102",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4633",
   "ENTITY": "OTH",
   "ENTITY NAME": "OutFront Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fairfield",
   "Entity_ST": "NJ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "G",
   "ID": "EX1905",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3039
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "F",
   "ID": "UB232",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX524",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 551
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1912",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 186
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX890",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 73
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX891",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 52
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1099",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 32
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1907",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 28
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX889",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1097",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1909",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 22
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1100",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1098",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 18
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1910",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 18
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX886",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1911",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX888",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1908",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX887",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4210",
   "ENTITY": "OTH",
   "ENTITY NAME": "PG&E Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4203",
   "ENTITY": "OTH",
   "ENTITY NAME": "Plaza Garibaldi Restaurant",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4205",
   "ENTITY": "OTH",
   "ENTITY NAME": "Plaza Jewelers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX862",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2900
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC5205",
   "ENTITY": "OTH",
   "ENTITY NAME": "PrimierOne Credit Union",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2528",
   "ENTITY": "OTH",
   "ENTITY NAME": "PRSA, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4632",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rancho Ibarra",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4688",
   "ENTITY": "OTH",
   "ENTITY NAME": "Realty World Todd Su & Co.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC4038",
   "ENTITY": "OTH",
   "ENTITY NAME": "Republic Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Phoenix",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC5209",
   "ENTITY": "OTH",
   "ENTITY NAME": "Roem Development Corp.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1359",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 112
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1353",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 27
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1358",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4208",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Water Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX854",
   "ENTITY": "OTH",
   "ENTITY NAME": "School of Arts & Culture",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 698
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3726",
   "ENTITY": "OTH",
   "ENTITY NAME": "Seven Hills Properties, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1113",
   "ENTITY": "OTH",
   "ENTITY NAME": "Signrocket",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "St. Paul",
   "Entity_ST": "MN",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1695
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1110",
   "ENTITY": "OTH",
   "ENTITY NAME": "Signrocket",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "St. Paul",
   "Entity_ST": "MN",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 285
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "I",
   "ID": "RC3993",
   "ENTITY": "OTH",
   "ENTITY NAME": "Signrocket",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "St. Paul",
   "Entity_ST": "MN",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 265
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1112",
   "ENTITY": "OTH",
   "ENTITY NAME": "Signrocket",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "St. Paul",
   "Entity_ST": "MN",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3979",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sobrato Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3960",
   "ENTITY": "OTH",
   "ENTITY NAME": "SoccerMagic.com LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX855",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX857",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX867",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1106",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1360",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1879",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1880",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1881",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1882",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1883",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1884",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1116",
   "ENTITY": "OTH",
   "ENTITY NAME": "Starbucks",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX529",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 473
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "I",
   "ID": "RC2691",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 179
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1914",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 115
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4197",
   "ENTITY": "OTH",
   "ENTITY NAME": "Super Taqueria Restaurants, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1581",
   "ENTITY": "OTH",
   "ENTITY NAME": "Terris Barnes Walters Boigon Heath",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 48734
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1563",
   "ENTITY": "OTH",
   "ENTITY NAME": "Terris Barnes Walters Boigon Heath",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9784
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1562",
   "ENTITY": "OTH",
   "ENTITY NAME": "Terris Barnes Walters Boigon Heath",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7671
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1904",
   "ENTITY": "OTH",
   "ENTITY NAME": "Terris Barnes Walters Boigon Heath",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3039
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1561",
   "ENTITY": "OTH",
   "ENTITY NAME": "Terris Barnes Walters Boigon Heath",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1400
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1560",
   "ENTITY": "OTH",
   "ENTITY NAME": "Terris Barnes Walters Boigon Heath",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 129
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2520",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Schoennauer Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3741",
   "ENTITY": "OTH",
   "ENTITY NAME": "Three Dog Ventures",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1354",
   "ENTITY": "OTH",
   "ENTITY NAME": "Togo's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 105
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4213",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tortas Ahogadas Tradicion Tapatia Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "G",
   "ID": "EX1142",
   "ENTITY": "OTH",
   "ENTITY NAME": "United States Postal Servie",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2465
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1894",
   "ENTITY": "OTH",
   "ENTITY NAME": "United States Postal Servie",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1584",
   "ENTITY": "OTH",
   "ENTITY NAME": "UPS Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 31
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2519",
   "ENTITY": "OTH",
   "ENTITY NAME": "V & B Enterprises",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC5204",
   "ENTITY": "OTH",
   "ENTITY NAME": "Veras",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX875",
   "ENTITY": "OTH",
   "ENTITY NAME": "Verizon",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1255
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1885",
   "ENTITY": "OTH",
   "ENTITY NAME": "Verizon",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 783
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX1582",
   "ENTITY": "OTH",
   "ENTITY NAME": "Verizon",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 625
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX874",
   "ENTITY": "OTH",
   "ENTITY NAME": "Verizon",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3763",
   "ENTITY": "OTH",
   "ENTITY NAME": "Vito's Pizza",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3729",
   "ENTITY": "OTH",
   "ENTITY NAME": "Walter Pierce Hammon Law Offices",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX872",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1918",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1916",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/1/2019",
   "FORM": "E",
   "ID": "EX1878",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1898",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX856",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "E",
   "ID": "EX859",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "E",
   "ID": "EX1899",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "I",
   "ID": "RC2669",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "2/12/2019",
   "FORM": "A",
   "ID": "RC3743",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wole Imaging Group LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC2538",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wole Imaging Group LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Carrasco",
   "FIRST": "Magdalena",
   "PURPOSE": "Re-Elect Magdalena Carrasco for City Council D5 2018",
   "DATE": "3/5/2019",
   "FORM": "A",
   "ID": "RC4206",
   "ENTITY": "OTH",
   "ENTITY NAME": "Zapateria Y Perfumeria Diana's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1345",
   "ENTITY": "COM",
   "ENTITY NAME": "California Apartment Association Political Action Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1344",
   "ENTITY": "COM",
   "ENTITY NAME": "California Real Estate Political Action Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "E",
   "ID": "EX356",
   "ENTITY": "IND",
   "ENTITY NAME": "Diep",
   "ENTITY NAME CONT.": "Lan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1337",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Can",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-employed",
   "OCCUPATION": "Owner, Vietnam Dail News, LLC",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1335",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Viavi Solutions",
   "OCCUPATION": "Head of Legal Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1340",
   "ENTITY": "IND",
   "ENTITY NAME": "Salata",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-employed",
   "OCCUPATION": "Owner, Garden City Construction",
   "AMOUNT": 500
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1348",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cadre Urban LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "E",
   "ID": "EX354",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "E",
   "ID": "EX355",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1346",
   "ENTITY": "OTH",
   "ENTITY NAME": "Greenwaste Recovery, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1342",
   "ENTITY": "OTH",
   "ENTITY NAME": "Guinn Construction",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Bakersfield",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1336",
   "ENTITY": "OTH",
   "ENTITY NAME": "KT Properties Urban, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1341",
   "ENTITY": "OTH",
   "ENTITY NAME": "Leftlane Creative",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1343",
   "ENTITY": "OTH",
   "ENTITY NAME": "Republic Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Phoenix",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1333",
   "ENTITY": "OTH",
   "ENTITY NAME": "Robert S. Kieve Revocable Trust",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1347",
   "ENTITY": "OTH",
   "ENTITY NAME": "Robinson Oil Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1332",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Fire Fighters, Local 230",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1338",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Water Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1339",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Schoennauer Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "11/2/2018",
   "FORM": "E",
   "ID": "EX1486",
   "ENTITY": "OTH",
   "ENTITY NAME": "US Post Office",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 64
 },
 {
   "LAST": "Diep",
   "FIRST": "Lan",
   "PURPOSE": "Shield Lan Diep Legal Defense Fund",
   "DATE": "1/22/2018",
   "FORM": "A",
   "ID": "RC1334",
   "ENTITY": "OTH",
   "ENTITY NAME": "Zanker Road Resource Managment, LTD.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963952",
   "ENTITY": "COM",
   "ENTITY NAME": "American Federation of State, County & Municipal Employees Council 57 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980519",
   "ENTITY": "COM",
   "ENTITY NAME": "American Federation of State, County & Municipal Employees Council 57 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990113",
   "ENTITY": "COM",
   "ENTITY NAME": "Asian Pacific-Islander Empowerment PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984233",
   "ENTITY": "COM",
   "ENTITY NAME": "Association of Retired San Jose Police Officers and Fire Fighters PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989506",
   "ENTITY": "COM",
   "ENTITY NAME": "Bay Area Municipal Election Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940344",
   "ENTITY": "COM",
   "ENTITY NAME": "Branch 193 PAC National Assoc. of Letter Carriers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980522",
   "ENTITY": "COM",
   "ENTITY NAME": "Branch 193 PAC National Assoc. of Letter Carriers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987922",
   "ENTITY": "COM",
   "ENTITY NAME": "Build Jobs PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10961092",
   "ENTITY": "COM",
   "ENTITY NAME": "California League of Conservation Voters SCC Chapter",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975810",
   "ENTITY": "COM",
   "ENTITY NAME": "California Teamsters Public Affairs Council Public Affairs Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935187",
   "ENTITY": "COM",
   "ENTITY NAME": "Cement Mason's Local 400 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960903",
   "ENTITY": "COM",
   "ENTITY NAME": "Democratic Activists for Women Now",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987865",
   "ENTITY": "COM",
   "ENTITY NAME": "Democratic Activists for Women Now",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557301",
   "ENTITY": "COM",
   "ENTITY NAME": "Democratic Activists for Women Now",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975811",
   "ENTITY": "COM",
   "ENTITY NAME": "DRIVE Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940343",
   "ENTITY": "COM",
   "ENTITY NAME": "East Side Teacher's Association PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961639",
   "ENTITY": "COM",
   "ENTITY NAME": "HNTB Holdings Ltd. PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Kansas City",
   "Entity_ST": "MO",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980586",
   "ENTITY": "COM",
   "ENTITY NAME": "HNTB Holdings Ltd. PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Kansas City",
   "Entity_ST": "MO",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931444",
   "ENTITY": "COM",
   "ENTITY NAME": "IBEW 332 Education Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980583",
   "ENTITY": "COM",
   "ENTITY NAME": "IBEW 332 Education Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989500",
   "ENTITY": "COM",
   "ENTITY NAME": "IBEW Local 18 Water & Power Defense League",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980585",
   "ENTITY": "COM",
   "ENTITY NAME": "IBEW PAC for Candidates Local Union 440",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Riverside",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987867",
   "ENTITY": "COM",
   "ENTITY NAME": "IBEW PAC Local Union No. 11",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Pasadena",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963951",
   "ENTITY": "COM",
   "ENTITY NAME": "IFPTE Local 21 TJ Anthony PAC Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983961",
   "ENTITY": "COM",
   "ENTITY NAME": "IFPTE Local 21 TJ Anthony PAC Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963950",
   "ENTITY": "COM",
   "ENTITY NAME": "Int'l. Union of Painters & Allied Trades PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987866",
   "ENTITY": "COM",
   "ENTITY NAME": "Int'l. Union of Painters & Allied Trades PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983962",
   "ENTITY": "COM",
   "ENTITY NAME": "International Brotherhood of Electrical Workers LU #6",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975806",
   "ENTITY": "COM",
   "ENTITY NAME": "International Brotherhood of Electrical Workers PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984239",
   "ENTITY": "COM",
   "ENTITY NAME": "International Brotherhood of Electrical Workers PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923848",
   "ENTITY": "COM",
   "ENTITY NAME": "Laborers Local Union 270 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984008",
   "ENTITY": "COM",
   "ENTITY NAME": "Laborers Local Union 270 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983288",
   "ENTITY": "COM",
   "ENTITY NAME": "Larry Stone County Assessor 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963953",
   "ENTITY": "COM",
   "ENTITY NAME": "Local 101 AFSCME AFL-CIO PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990385",
   "ENTITY": "COM",
   "ENTITY NAME": "Local 101 AFSCME AFL-CIO PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983289",
   "ENTITY": "COM",
   "ENTITY NAME": "Miller for Hospital District 2012",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935186",
   "ENTITY": "COM",
   "ENTITY NAME": "Northern California Carpenters Regional Council Small Contributor Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980520",
   "ENTITY": "COM",
   "ENTITY NAME": "Northern California Carpenters Regional Council Small Contributor Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987923",
   "ENTITY": "COM",
   "ENTITY NAME": "Northern California District Council of Laborers PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940345",
   "ENTITY": "COM",
   "ENTITY NAME": "Operating Engineers Local Union No. 3 District 90 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984006",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbers & Pipefitters Local 442 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Modesto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984005",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbers & Pipefitters Local 447 Political Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10986970",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbers & Steamfitters Local No. 467 State & Political Action Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984237",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbers & Steamfitters Local Union No. 230 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940347",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbers, Steamfitters, Refrigeration Fitters, Local 393 Political Action Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983285",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbers, Steamfitters, Refrigeration Fitters, Local 393 Political Action Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990300",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbing Industry Consumer Protection Fund United Association Local No. 159",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Martinez",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983284",
   "ENTITY": "COM",
   "ENTITY NAME": "Sanitary Truck Drivers & Helpers Teamsters Local 350",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Daly City",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935188",
   "ENTITY": "COM",
   "ENTITY NAME": "Santa Clara & San Benito Counties",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10979967",
   "ENTITY": "COM",
   "ENTITY NAME": "Santa Clara & San Benito Counties",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960900",
   "ENTITY": "COM",
   "ENTITY NAME": "Santa Clara County Residents for Responsible Development Candidate PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10979969",
   "ENTITY": "COM",
   "ENTITY NAME": "Santa Clara County Residents for Responsible Development Candidate PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980521",
   "ENTITY": "COM",
   "ENTITY NAME": "SCC Probation Peace Officers' Union AFSCME Local 1587",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940346",
   "ENTITY": "COM",
   "ENTITY NAME": "SCC Probation Peace Officers' Union AFSCME Local 1587",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964317",
   "ENTITY": "COM",
   "ENTITY NAME": "SEIU Local 521 Candidate PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987924",
   "ENTITY": "COM",
   "ENTITY NAME": "SEIU United Service Workers West Candidate PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960899",
   "ENTITY": "COM",
   "ENTITY NAME": "Sheet Metal Workers' International Association Local No. 104 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10979966",
   "ENTITY": "COM",
   "ENTITY NAME": "Sheet Metal Workers' International Association Local No. 104 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923847",
   "ENTITY": "COM",
   "ENTITY NAME": "Sprinkler Fitters and Apprentices Local 483 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983960",
   "ENTITY": "COM",
   "ENTITY NAME": "Sprinkler Fitters and Apprentices Local 483 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940348",
   "ENTITY": "COM",
   "ENTITY NAME": "Teamsters Union Local No. 287",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983947",
   "ENTITY": "COM",
   "ENTITY NAME": "Transparent Silicon Valley",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Hollister",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984236",
   "ENTITY": "COM",
   "ENTITY NAME": "U.A. Local Union No. 228",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Yuba City",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984238",
   "ENTITY": "COM",
   "ENTITY NAME": "UA Local 246 Plumbers and Pipefitters COPE Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fresno",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984235",
   "ENTITY": "COM",
   "ENTITY NAME": "UA Local 342 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Concord",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984007",
   "ENTITY": "COM",
   "ENTITY NAME": "UA Local 38 COPE Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975813",
   "ENTITY": "COM",
   "ENTITY NAME": "Unite Here Tip State and Local Fund Campaign Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960901",
   "ENTITY": "COM",
   "ENTITY NAME": "United Food & Commercial Workers Local 5 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10984781",
   "ENTITY": "COM",
   "ENTITY NAME": "United Food & Commercial Workers Local 5 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983806",
   "ENTITY": "IND",
   "ENTITY NAME": "Abels",
   "ENTITY NAME CONT.": "Gemma",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Morgan Hill Federation of Teachers",
   "OCCUPATION": "Office Staff",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940352",
   "ENTITY": "IND",
   "ENTITY NAME": "Abels",
   "ENTITY NAME CONT.": "Gemma",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "AFT 2022",
   "OCCUPATION": "President",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10979964",
   "ENTITY": "IND",
   "ENTITY NAME": "Acedo",
   "ENTITY NAME CONT.": "Sylvia",
   "ENTITY CITY": "Marina",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983287",
   "ENTITY": "IND",
   "ENTITY NAME": "Adams-Wilson",
   "ENTITY NAME CONT.": "BrendaF",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Investigator",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10929899",
   "ENTITY": "IND",
   "ENTITY NAME": "Ahrens",
   "ENTITY NAME CONT.": "PatrickJ",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "California State Assembly",
   "OCCUPATION": "Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980574",
   "ENTITY": "IND",
   "ENTITY NAME": "Ai",
   "ENTITY NAME CONT.": "Kougan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 10
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933763",
   "ENTITY": "IND",
   "ENTITY NAME": "Amador-Le Beau",
   "ENTITY NAME CONT.": "Rose",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ConXion to Community",
   "OCCUPATION": "President and CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984010",
   "ENTITY": "IND",
   "ENTITY NAME": "Amador-Le Beau",
   "ENTITY NAME CONT.": "Rose",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ConXion to Community",
   "OCCUPATION": "President and CEO",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984155",
   "ENTITY": "IND",
   "ENTITY NAME": "Amezcua",
   "ENTITY NAME CONT.": "Melinda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Safeway, Inc.",
   "OCCUPATION": "Analyst",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980257",
   "ENTITY": "IND",
   "ENTITY NAME": "Andonian",
   "ENTITY NAME CONT.": "Amy",
   "ENTITY CITY": "Pacifica",
   "Entity_ST": "CA",
   "EMPLOYER": "Avenidas",
   "OCCUPATION": "Nonprofit CEO",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989526",
   "ENTITY": "IND",
   "ENTITY NAME": "Araujo",
   "ENTITY NAME CONT.": "Ana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "College Instructor",
   "AMOUNT": 20
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933768",
   "ENTITY": "IND",
   "ENTITY NAME": "Arhontes-Marshall",
   "ENTITY NAME CONT.": "Lisa",
   "ENTITY CITY": "Blue Hill",
   "Entity_ST": "ME",
   "EMPLOYER": "Queen Bee",
   "OCCUPATION": "Owner",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990388",
   "ENTITY": "IND",
   "ENTITY NAME": "Armstrong",
   "ENTITY NAME CONT.": "Hilary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Foundation of Silicon Valley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989538",
   "ENTITY": "IND",
   "ENTITY NAME": "Arranaga",
   "ENTITY NAME CONT.": "Victor",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hewlett Packard",
   "OCCUPATION": "Director, Government Relations",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925419",
   "ENTITY": "IND",
   "ENTITY NAME": "Arretz",
   "ENTITY NAME CONT.": "Alphonse",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Cruz County",
   "OCCUPATION": "Probation 200",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940356",
   "ENTITY": "IND",
   "ENTITY NAME": "Arriola",
   "ENTITY NAME CONT.": "ChristopherJ",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Attorney",
   "AMOUNT": 75
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989523",
   "ENTITY": "IND",
   "ENTITY NAME": "Atwood",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Google",
   "OCCUPATION": "Software Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989534",
   "ENTITY": "IND",
   "ENTITY NAME": "Auerhahn",
   "ENTITY NAME CONT.": "Louise",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partnerships USA",
   "OCCUPATION": "Researcher",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940358",
   "ENTITY": "IND",
   "ENTITY NAME": "Auerhahn",
   "ENTITY NAME CONT.": "Louise",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partnerships USA",
   "OCCUPATION": "Researcher",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984149",
   "ENTITY": "IND",
   "ENTITY NAME": "Azcueta",
   "ENTITY NAME CONT.": "Priscilla",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "VAPAHCS",
   "OCCUPATION": "Voc Rehab Specialist",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923310",
   "ENTITY": "IND",
   "ENTITY NAME": "Balinton",
   "ENTITY NAME CONT.": "Milan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rise and Shine Consulting,LLC",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 75
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984152",
   "ENTITY": "IND",
   "ENTITY NAME": "Balinton",
   "ENTITY NAME CONT.": "Milan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "African American Community Service Agency",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933766",
   "ENTITY": "IND",
   "ENTITY NAME": "Barousse",
   "ENTITY NAME CONT.": "JeremyH",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SIREN",
   "OCCUPATION": "Director of Civic Engagement",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933770",
   "ENTITY": "IND",
   "ENTITY NAME": "Bata",
   "ENTITY NAME CONT.": "Rick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Behavioral Health Team Clinician",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928009",
   "ENTITY": "IND",
   "ENTITY NAME": "Batistich Abel-Saud",
   "ENTITY NAME CONT.": "Gay",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Gay Batistich Abel-Saud",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928003",
   "ENTITY": "IND",
   "ENTITY NAME": "Bean",
   "ENTITY NAME CONT.": "NaokoK.",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Delta Airlines",
   "OCCUPATION": "Flight Attendant",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928004",
   "ENTITY": "IND",
   "ENTITY NAME": "Bean",
   "ENTITY NAME CONT.": "WilliamA.",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "William Bean",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930900",
   "ENTITY": "IND",
   "ENTITY NAME": "Bechtel",
   "ENTITY NAME CONT.": "Blake",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Blake Bechtel",
   "OCCUPATION": "Investor",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983926",
   "ENTITY": "IND",
   "ENTITY NAME": "Becker",
   "ENTITY NAME CONT.": "Joshua",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Lex Machina",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960868",
   "ENTITY": "IND",
   "ENTITY NAME": "Bejarano",
   "ENTITY NAME CONT.": "Ernesto",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Social Work Supervisor",
   "AMOUNT": 40
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934883",
   "ENTITY": "IND",
   "ENTITY NAME": "Benavidez",
   "ENTITY NAME CONT.": "Ricardo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Google",
   "OCCUPATION": "Property Management",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983286",
   "ENTITY": "IND",
   "ENTITY NAME": "Bettencourt",
   "ENTITY NAME CONT.": "RobertJ.",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Robert Bettencourt",
   "OCCUPATION": "Rancher",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930915",
   "ENTITY": "IND",
   "ENTITY NAME": "Blase",
   "ENTITY NAME CONT.": "Graceann",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Revlon",
   "OCCUPATION": "Merchandiser",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930912",
   "ENTITY": "IND",
   "ENTITY NAME": "Blase-Harlan",
   "ENTITY NAME CONT.": "Cariste",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Gillmor & Associates",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980258",
   "ENTITY": "IND",
   "ENTITY NAME": "Block",
   "ENTITY NAME CONT.": "Christopher",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Episcopal Community Services",
   "OCCUPATION": "Executive",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925418",
   "ENTITY": "IND",
   "ENTITY NAME": "Boac",
   "ENTITY NAME CONT.": "ThelmaB",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963959",
   "ENTITY": "IND",
   "ENTITY NAME": "Bojorquez",
   "ENTITY NAME CONT.": "Chad",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984147",
   "ENTITY": "IND",
   "ENTITY NAME": "Bolger",
   "ENTITY NAME CONT.": "Brenna",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "PRxDigital",
   "OCCUPATION": "Communications Consultant",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935178",
   "ENTITY": "IND",
   "ENTITY NAME": "Bolger",
   "ENTITY NAME CONT.": "Brenna",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "PRxDigital",
   "OCCUPATION": "Marketing",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989525",
   "ENTITY": "IND",
   "ENTITY NAME": "Bonilla",
   "ENTITY NAME CONT.": "Rolando",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VSA",
   "OCCUPATION": "Consultant",
   "AMOUNT": 125
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983937",
   "ENTITY": "IND",
   "ENTITY NAME": "Bonilla-Giuriato",
   "ENTITY NAME CONT.": "MariaT",
   "ENTITY CITY": "Salinas",
   "Entity_ST": "CA",
   "EMPLOYER": "Bonilla-Giuriato & Associates",
   "OCCUPATION": "Senior Consultant",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983931",
   "ENTITY": "IND",
   "ENTITY NAME": "Brady",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "250 Omira Dr.",
   "OCCUPATION": "Senior Partner",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983939",
   "ENTITY": "IND",
   "ENTITY NAME": "Bramson",
   "ENTITY NAME CONT.": "Ray",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "Chief Impact Officer",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960874",
   "ENTITY": "IND",
   "ENTITY NAME": "Bramson",
   "ENTITY NAME CONT.": "Ray",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "Chief Impact Officer",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10929896",
   "ENTITY": "IND",
   "ENTITY NAME": "Bramson",
   "ENTITY NAME CONT.": "Ray",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "Chief Impact Officer",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10929895",
   "ENTITY": "IND",
   "ENTITY NAME": "Bright",
   "ENTITY NAME CONT.": "Darlene",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "La Lune Sucree",
   "OCCUPATION": "Bookkeeper",
   "AMOUNT": 300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923300",
   "ENTITY": "IND",
   "ENTITY NAME": "Brown",
   "ENTITY NAME CONT.": "Alison",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Alison Brown Placement Specialist",
   "OCCUPATION": "Recruiter",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935179",
   "ENTITY": "IND",
   "ENTITY NAME": "Brunner",
   "ENTITY NAME CONT.": "Alison",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Foundation of Silicon Valley",
   "OCCUPATION": "CEO",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984232",
   "ENTITY": "IND",
   "ENTITY NAME": "Brunner",
   "ENTITY NAME CONT.": "Alison",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Foundation of Silicon Valley",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975776",
   "ENTITY": "IND",
   "ENTITY NAME": "Buchanan",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partnerships USA",
   "OCCUPATION": "Public Policy",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990394",
   "ENTITY": "IND",
   "ENTITY NAME": "Buchanan",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partnerships USA",
   "OCCUPATION": "Public Policy",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983945",
   "ENTITY": "IND",
   "ENTITY NAME": "Burroughs",
   "ENTITY NAME CONT.": "Joshua",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Green Valley Corp",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923318",
   "ENTITY": "IND",
   "ENTITY NAME": "Butler",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Patrick Butler",
   "OCCUPATION": "Investor",
   "AMOUNT": 20
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960870",
   "ENTITY": "IND",
   "ENTITY NAME": "Cain",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Foundation of Silicon Valley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964773",
   "ENTITY": "IND",
   "ENTITY NAME": "Callender",
   "ENTITY NAME CONT.": "Rick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Valley Water District",
   "OCCUPATION": "Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984153",
   "ENTITY": "IND",
   "ENTITY NAME": "Callender",
   "ENTITY NAME CONT.": "Rick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Valley Water District",
   "OCCUPATION": "Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960878",
   "ENTITY": "IND",
   "ENTITY NAME": "Campos",
   "ENTITY NAME CONT.": "Rosa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990393",
   "ENTITY": "IND",
   "ENTITY NAME": "Campos",
   "ENTITY NAME CONT.": "Rosa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990392",
   "ENTITY": "IND",
   "ENTITY NAME": "Campos",
   "ENTITY NAME CONT.": "Nora",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nora Campos",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961640",
   "ENTITY": "IND",
   "ENTITY NAME": "Caruso",
   "ENTITY NAME CONT.": "Josephine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salvatore Caruso Design Corporation",
   "OCCUPATION": "Purchasing Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925417",
   "ENTITY": "IND",
   "ENTITY NAME": "Casey",
   "ENTITY NAME CONT.": "Alissa",
   "ENTITY CITY": "Laurel",
   "Entity_ST": "MD",
   "EMPLOYER": "Montgomery County Public Schools",
   "OCCUPATION": "Teacher",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989504",
   "ENTITY": "IND",
   "ENTITY NAME": "Castellano",
   "ENTITY NAME CONT.": "Carmen",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10986969",
   "ENTITY": "IND",
   "ENTITY NAME": "Castellano",
   "ENTITY NAME CONT.": "AlcarioG",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923842",
   "ENTITY": "IND",
   "ENTITY NAME": "Castellanos",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984142",
   "ENTITY": "IND",
   "ENTITY NAME": "Castellanos",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Immigrant Service Coordinator",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987915",
   "ENTITY": "IND",
   "ENTITY NAME": "Castellanos",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Immigrant Service Coordinator",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940357",
   "ENTITY": "IND",
   "ENTITY NAME": "Castorena",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Office of Patricia D. Castorena",
   "OCCUPATION": "Immigration Attorney",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990389",
   "ENTITY": "IND",
   "ENTITY NAME": "Cecil",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "MC2 Bay Area",
   "OCCUPATION": "Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960875",
   "ENTITY": "IND",
   "ENTITY NAME": "Cecil",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Don Cecil",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960876",
   "ENTITY": "IND",
   "ENTITY NAME": "Chapman",
   "ENTITY NAME CONT.": "DanJ",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Castileja School",
   "OCCUPATION": "Facilities Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934777",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Cynthia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "County Supervisor",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983805",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Cynthia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "County Supervisor",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984012",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Lorraine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ConXion To Community",
   "OCCUPATION": "COO",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923843",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Alejandra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Analyst",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989539",
   "ENTITY": "IND",
   "ENTITY NAME": "Chenery",
   "ENTITY NAME CONT.": "Arwen",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "Assembly Rules Committee",
   "OCCUPATION": "Legislative Staff",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987916",
   "ENTITY": "IND",
   "ENTITY NAME": "Cheng",
   "ENTITY NAME CONT.": "ShiaoPing",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kico Lin Realty",
   "OCCUPATION": "Office Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940353",
   "ENTITY": "IND",
   "ENTITY NAME": "Chicoine",
   "ENTITY NAME CONT.": "Louis",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Adobe Services",
   "OCCUPATION": "Administrator",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963960",
   "ENTITY": "IND",
   "ENTITY NAME": "Clanton",
   "ENTITY NAME CONT.": "Vera",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Vera Clanton",
   "OCCUPATION": "Organizer",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983935",
   "ENTITY": "IND",
   "ENTITY NAME": "Clanton",
   "ENTITY NAME CONT.": "Vera",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Vera Clanton",
   "OCCUPATION": "Community Organizer",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984248",
   "ENTITY": "IND",
   "ENTITY NAME": "Clanton",
   "ENTITY NAME CONT.": "Vera",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Vera Clanton",
   "OCCUPATION": "Community Organizer",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987913",
   "ENTITY": "IND",
   "ENTITY NAME": "Clanton",
   "ENTITY NAME CONT.": "Vera",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Vera Clanton",
   "OCCUPATION": "Community Organizer",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980576",
   "ENTITY": "IND",
   "ENTITY NAME": "Coen",
   "ENTITY NAME CONT.": "Carol",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gateway Community Outreach",
   "OCCUPATION": "Executive Director, Outreach",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960877",
   "ENTITY": "IND",
   "ENTITY NAME": "Cohen",
   "ENTITY NAME CONT.": "Jean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "US Local 393",
   "OCCUPATION": "Political Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923301",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "John Marshall Collins, P.C.",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923836",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "Carla",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984217",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "Carla",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925382",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "KathleenSusan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "US House of Representatives",
   "OCCUPATION": "Congressional Assistant",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987918",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "Carla",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930916",
   "ENTITY": "IND",
   "ENTITY NAME": "Corsiglia",
   "ENTITY NAME CONT.": "Leslye",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SV@Home",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 99
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983803",
   "ENTITY": "IND",
   "ENTITY NAME": "Cortese",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "Supervisor",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960864",
   "ENTITY": "IND",
   "ENTITY NAME": "Cortese",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "Supervisor",
   "AMOUNT": 300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960879",
   "ENTITY": "IND",
   "ENTITY NAME": "Cortez",
   "ENTITY NAME CONT.": "DarrellRay",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 30
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925386",
   "ENTITY": "IND",
   "ENTITY NAME": "Couture",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984148",
   "ENTITY": "IND",
   "ENTITY NAME": "Crosby",
   "ENTITY NAME CONT.": "Tanis",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "YWCA Silicon Valley",
   "OCCUPATION": "CEO",
   "AMOUNT": 60
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983946",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunneen",
   "ENTITY NAME CONT.": "JamesF.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies LLC",
   "OCCUPATION": "Partner",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960895",
   "ENTITY": "IND",
   "ENTITY NAME": "David",
   "ENTITY NAME CONT.": "S Phyllis",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940354",
   "ENTITY": "IND",
   "ENTITY NAME": "DeMaria",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "Fairfield",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930905",
   "ENTITY": "IND",
   "ENTITY NAME": "DeSilva",
   "ENTITY NAME CONT.": "Helen",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Highland Partners",
   "OCCUPATION": "Realtor",
   "AMOUNT": 10
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935183",
   "ENTITY": "IND",
   "ENTITY NAME": "Diaz",
   "ENTITY NAME CONT.": "ManoloJose",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Diaz & Associates",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987863",
   "ENTITY": "IND",
   "ENTITY NAME": "Diaz",
   "ENTITY NAME CONT.": "ManoloJose",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Diaz & Associates",
   "OCCUPATION": "President",
   "AMOUNT": 400
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557441",
   "ENTITY": "IND",
   "ENTITY NAME": "Do",
   "ENTITY NAME CONT.": "Thuc",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984144",
   "ENTITY": "IND",
   "ENTITY NAME": "Doherty",
   "ENTITY NAME CONT.": "Mary Helen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983936",
   "ENTITY": "IND",
   "ENTITY NAME": "Edwards",
   "ENTITY NAME CONT.": "Frances",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Professor",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963956",
   "ENTITY": "IND",
   "ENTITY NAME": "Edwards",
   "ENTITY NAME CONT.": "Frances",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Professor",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983927",
   "ENTITY": "IND",
   "ENTITY NAME": "Eldridge",
   "ENTITY NAME CONT.": "Jordan",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Jordan Eldridge",
   "OCCUPATION": "Campaign Professional",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989499",
   "ENTITY": "IND",
   "ENTITY NAME": "Ellick",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "Bethesda",
   "Entity_ST": "MD",
   "EMPLOYER": "Glazer, Winston, Monigman, Ellick",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935184",
   "ENTITY": "IND",
   "ENTITY NAME": "Emmett-Wilder",
   "ENTITY NAME CONT.": "Kate",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "VMWare, Inc.",
   "OCCUPATION": "Sales Executive",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923309",
   "ENTITY": "IND",
   "ENTITY NAME": "Ensunsa",
   "ENTITY NAME CONT.": "ToniA",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Live Oak Adult Day Servicces",
   "OCCUPATION": "COO",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984226",
   "ENTITY": "IND",
   "ENTITY NAME": "Escobar",
   "ENTITY NAME CONT.": "Aimee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Senior Housing Policy Analyst",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983928",
   "ENTITY": "IND",
   "ENTITY NAME": "Escobar",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Leadership",
   "OCCUPATION": "Director",
   "AMOUNT": 35
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935185",
   "ENTITY": "IND",
   "ENTITY NAME": "Escoto",
   "ENTITY NAME CONT.": "Adam",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "B1",
   "ID": "C10925404",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "All The Way Home/SV Community Foundation",
   "OCCUPATION": "Director",
   "AMOUNT": 4500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925378",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Alexandrina",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 599
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "B1",
   "ID": "C10923291",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "All The Way Home/SV Community Foundation",
   "OCCUPATION": "Director",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555948",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 216
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555947",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 207
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557416",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 82
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558233",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 42
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557295",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 38
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10927512",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Alexandrina",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "F",
   "ID": "D558342",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "F",
   "ID": "D552958",
   "ENTITY": "IND",
   "ENTITY NAME": "Esparza",
   "ENTITY NAME CONT.": "Maya",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960886",
   "ENTITY": "IND",
   "ENTITY NAME": "Espinoza",
   "ENTITY NAME CONT.": "Liza Ann",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Obstetrix Medical Center",
   "OCCUPATION": "Patient Service",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983943",
   "ENTITY": "IND",
   "ENTITY NAME": "Estrada",
   "ENTITY NAME CONT.": "KatherineG",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Senior Analyst",
   "AMOUNT": 75
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923307",
   "ENTITY": "IND",
   "ENTITY NAME": "Estremera",
   "ENTITY NAME CONT.": "Antonio",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Legal Aid Society of Santa Clara County",
   "OCCUPATION": "Directing Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "C",
   "ID": "C10960682",
   "ENTITY": "IND",
   "ENTITY NAME": "Estremera",
   "ENTITY NAME CONT.": "Yolanda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County Health & Hospital System",
   "OCCUPATION": "Sr. Management Analyst",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983949",
   "ENTITY": "IND",
   "ENTITY NAME": "Estremera",
   "ENTITY NAME CONT.": "Micael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Deputy County Counsel",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10929902",
   "ENTITY": "IND",
   "ENTITY NAME": "Ferreira",
   "ENTITY NAME CONT.": "Kathryn",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Cloud for Good",
   "OCCUPATION": "Account Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923835",
   "ENTITY": "IND",
   "ENTITY NAME": "Ferrer",
   "ENTITY NAME CONT.": "Frederick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Manzanita Solutions",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983959",
   "ENTITY": "IND",
   "ENTITY NAME": "Ferrer",
   "ENTITY NAME CONT.": "Frederick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Manzanita Solutions",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923297",
   "ENTITY": "IND",
   "ENTITY NAME": "Fifield",
   "ENTITY NAME CONT.": "Robin",
   "ENTITY CITY": "Rancho Mirage",
   "Entity_ST": "CA",
   "EMPLOYER": "Pivotal Software Inc",
   "OCCUPATION": "Senior Manager - IT",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960891",
   "ENTITY": "IND",
   "ENTITY NAME": "Flores",
   "ENTITY NAME CONT.": "Raul",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Investigator",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984157",
   "ENTITY": "IND",
   "ENTITY NAME": "Flores",
   "ENTITY NAME CONT.": "Raul",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Investigator",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983941",
   "ENTITY": "IND",
   "ENTITY NAME": "Flynn",
   "ENTITY NAME CONT.": "Rachel",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Google",
   "OCCUPATION": "Director",
   "AMOUNT": 95
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558229",
   "ENTITY": "IND",
   "ENTITY NAME": "Forrett",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 164
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989505",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox Sr.",
   "ENTITY NAME CONT.": "MichaelE.",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923313",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox Sr.",
   "ENTITY NAME CONT.": "MichaelE.",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935174",
   "ENTITY": "IND",
   "ENTITY NAME": "Fuentes",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Mental Health Manager",
   "AMOUNT": 98
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960880",
   "ENTITY": "IND",
   "ENTITY NAME": "Fuentes",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Mental Health Manager",
   "AMOUNT": 60
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987921",
   "ENTITY": "IND",
   "ENTITY NAME": "Fuentes",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Mental Health Manager",
   "AMOUNT": 60
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923837",
   "ENTITY": "IND",
   "ENTITY NAME": "Fuentes",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Mental Health Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980581",
   "ENTITY": "IND",
   "ENTITY NAME": "Fuentes",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Mental Health Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923299",
   "ENTITY": "IND",
   "ENTITY NAME": "Furlong",
   "ENTITY NAME CONT.": "Pilar",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Bill Wilson Center",
   "OCCUPATION": "Fundraiser",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960890",
   "ENTITY": "IND",
   "ENTITY NAME": "Gallardo",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Co.",
   "OCCUPATION": "Realtor",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963962",
   "ENTITY": "IND",
   "ENTITY NAME": "Gallaty",
   "ENTITY NAME CONT.": "Aaron",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Swenson Builders",
   "OCCUPATION": "Sales",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983929",
   "ENTITY": "IND",
   "ENTITY NAME": "Gardner",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Council of Non Profits",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923294",
   "ENTITY": "IND",
   "ENTITY NAME": "Gardner",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Council of Non Profits",
   "OCCUPATION": "CEO",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960862",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975778",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980251",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980532",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989532",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923839",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933764",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984158",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557157",
   "ENTITY": "IND",
   "ENTITY NAME": "Garvey",
   "ENTITY NAME CONT.": "CarolA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558240",
   "ENTITY": "IND",
   "ENTITY NAME": "Gaytan Baez",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 160
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983933",
   "ENTITY": "IND",
   "ENTITY NAME": "Gerston",
   "ENTITY NAME CONT.": "Marcia",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Greenfield Draa & Harrington LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930906",
   "ENTITY": "IND",
   "ENTITY NAME": "Gillmor",
   "ENTITY NAME CONT.": "Fatemeh",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930907",
   "ENTITY": "IND",
   "ENTITY NAME": "Gillmor",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983958",
   "ENTITY": "IND",
   "ENTITY NAME": "Ginsborg",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County Assessor",
   "OCCUPATION": "Deputy to the Assessor",
   "AMOUNT": 75
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960892",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Bernadette",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989528",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Armando",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Armando Gomez Consulting",
   "OCCUPATION": "Principal",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923841",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Ketzal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Management Aid",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989536",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzales",
   "ENTITY NAME CONT.": "RonaldR.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hispanic Foundation of Silicon Valley",
   "OCCUPATION": "CEO",
   "AMOUNT": 350
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980252",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzales",
   "ENTITY NAME CONT.": "RonaldR.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hispanic Foundation of Silicon Valley",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960861",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzales",
   "ENTITY NAME CONT.": "RonaldR.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hispanic Foundation of Silicon Valley",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557418",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzalez",
   "ENTITY NAME CONT.": "Petra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987917",
   "ENTITY": "IND",
   "ENTITY NAME": "Greenfield",
   "ENTITY NAME CONT.": "Wendy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Office of Richard Hobbs",
   "OCCUPATION": "Legal Assistant",
   "AMOUNT": 75
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984227",
   "ENTITY": "IND",
   "ENTITY NAME": "Greenfield",
   "ENTITY NAME CONT.": "Wendy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Office of Richard Hobbs",
   "OCCUPATION": "Legal Assistant",
   "AMOUNT": 70
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983942",
   "ENTITY": "IND",
   "ENTITY NAME": "Grey",
   "ENTITY NAME CONT.": "Adrienne",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Symphony Consulting",
   "OCCUPATION": "Supply Chain Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925413",
   "ENTITY": "IND",
   "ENTITY NAME": "Grey",
   "ENTITY NAME CONT.": "Adrienne",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Symphony Consulting",
   "OCCUPATION": "Supply Chain Consultant",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984242",
   "ENTITY": "IND",
   "ENTITY NAME": "Guardino",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Leadership Group",
   "OCCUPATION": "President/CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983930",
   "ENTITY": "IND",
   "ENTITY NAME": "Guel",
   "ENTITY NAME CONT.": "Lydia",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Sacred Heart Community Service",
   "OCCUPATION": "Community Development Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984141",
   "ENTITY": "IND",
   "ENTITY NAME": "Guel",
   "ENTITY NAME CONT.": "Lydia",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Sacred Heart Community Service",
   "OCCUPATION": "Community Development Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983940",
   "ENTITY": "IND",
   "ENTITY NAME": "Guerra",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brookfield Residential",
   "OCCUPATION": "Senior Director of Business Strategies",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930904",
   "ENTITY": "IND",
   "ENTITY NAME": "Gulbransen",
   "ENTITY NAME CONT.": "Susan",
   "ENTITY CITY": "Santa Barbara",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990391",
   "ENTITY": "IND",
   "ENTITY NAME": "Gutierrez",
   "ENTITY NAME CONT.": "Lennies",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Comcast",
   "OCCUPATION": "Director of Government Affairs",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980254",
   "ENTITY": "IND",
   "ENTITY NAME": "Haas",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "Reno",
   "Entity_ST": "NV",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980530",
   "ENTITY": "IND",
   "ENTITY NAME": "Haberly",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Infoblox",
   "OCCUPATION": "Paralegal",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923312",
   "ENTITY": "IND",
   "ENTITY NAME": "Haley",
   "ENTITY NAME CONT.": "Colleen",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "California Special Districts Association",
   "OCCUPATION": "Public Affairs Field Coordinator",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984150",
   "ENTITY": "IND",
   "ENTITY NAME": "Haley",
   "ENTITY NAME CONT.": "Colleen",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "California Special Districts Association",
   "OCCUPATION": "Public Affairs Field Coordinator",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987914",
   "ENTITY": "IND",
   "ENTITY NAME": "Hall",
   "ENTITY NAME CONT.": "Jason",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CWA Local 9423",
   "OCCUPATION": "President",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980575",
   "ENTITY": "IND",
   "ENTITY NAME": "Hammon",
   "ENTITY NAME CONT.": "Walter Pierce",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Offices of Walter Pierce Hammon",
   "OCCUPATION": "Attorney",
   "AMOUNT": 350
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10975780",
   "ENTITY": "IND",
   "ENTITY NAME": "Hancock",
   "ENTITY NAME CONT.": "Nicole",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Shea & Shea",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975816",
   "ENTITY": "IND",
   "ENTITY NAME": "Harasz",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County Housing Authority",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989522",
   "ENTITY": "IND",
   "ENTITY NAME": "Harkness",
   "ENTITY NAME CONT.": "Ross",
   "ENTITY CITY": "Manteca",
   "Entity_ST": "CA",
   "EMPLOYER": "Sandia National Laboratories",
   "OCCUPATION": "Security Professional",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930911",
   "ENTITY": "IND",
   "ENTITY NAME": "Harlan",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mountain Cascade",
   "OCCUPATION": "Mechanic",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940198",
   "ENTITY": "IND",
   "ENTITY NAME": "Harless",
   "ENTITY NAME CONT.": "Krista",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Berkeley Property Owners Association",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984229",
   "ENTITY": "IND",
   "ENTITY NAME": "Harris",
   "ENTITY NAME CONT.": "Jane",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925396",
   "ENTITY": "IND",
   "ENTITY NAME": "Harrison",
   "ENTITY NAME CONT.": "Leighna",
   "ENTITY CITY": "Carolina",
   "Entity_ST": "PR",
   "EMPLOYER": "Veterans Affairs",
   "OCCUPATION": "Psychologist",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10929900",
   "ENTITY": "IND",
   "ENTITY NAME": "Hata",
   "ENTITY NAME CONT.": "Lara",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Lara Hata",
   "OCCUPATION": "Photographer",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960881",
   "ENTITY": "IND",
   "ENTITY NAME": "Hawes",
   "ENTITY NAME CONT.": "Amanda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Amanda Hawes",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984222",
   "ENTITY": "IND",
   "ENTITY NAME": "Hawes",
   "ENTITY NAME CONT.": "Amanda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Amanda Hawes",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987919",
   "ENTITY": "IND",
   "ENTITY NAME": "Hawes",
   "ENTITY NAME CONT.": "Amanda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Amanda Hawes",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940355",
   "ENTITY": "IND",
   "ENTITY NAME": "Head",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Summerhill Homes",
   "OCCUPATION": "President",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963954",
   "ENTITY": "IND",
   "ENTITY NAME": "Heller",
   "ENTITY NAME CONT.": "YolandaM",
   "ENTITY CITY": "Encino",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 350
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925379",
   "ENTITY": "IND",
   "ENTITY NAME": "Heller",
   "ENTITY NAME CONT.": "YolandaM",
   "ENTITY CITY": "Encino",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925381",
   "ENTITY": "IND",
   "ENTITY NAME": "Heller",
   "ENTITY NAME CONT.": "JeffreySamuel",
   "ENTITY CITY": "Encino",
   "Entity_ST": "CA",
   "EMPLOYER": "LA Unified School District",
   "OCCUPATION": "Educator",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983956",
   "ENTITY": "IND",
   "ENTITY NAME": "Helstrup-Alvarez",
   "ENTITY NAME CONT.": "Anjee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "MACLA",
   "OCCUPATION": "Arts Administrator",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960873",
   "ENTITY": "IND",
   "ENTITY NAME": "Herbert",
   "ENTITY NAME CONT.": "Frances",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Chief of Staff",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923311",
   "ENTITY": "IND",
   "ENTITY NAME": "Hernandez",
   "ENTITY NAME CONT.": "EricA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gener8, Inc",
   "OCCUPATION": "QA Coordinator",
   "AMOUNT": 10
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989503",
   "ENTITY": "IND",
   "ENTITY NAME": "Hickie",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Old Lyme",
   "Entity_ST": "CT",
   "EMPLOYER": "Republic Family of Companies",
   "OCCUPATION": "CFO",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984140",
   "ENTITY": "IND",
   "ENTITY NAME": "Hill",
   "ENTITY NAME CONT.": "Cayce",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Veggielution",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10979965",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "WendyLee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Council of Nonprofits",
   "OCCUPATION": "Senior Policy Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923844",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "WendyLee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Council of Nonprofits",
   "OCCUPATION": "Senior Policy Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935175",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "WendyLee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Council of Nonprofits",
   "OCCUPATION": "Senior Policy Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960889",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "WendyLee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Council of Nonprofits",
   "OCCUPATION": "Senior Policy Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931455",
   "ENTITY": "IND",
   "ENTITY NAME": "Hogan",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "Fair Oaks",
   "Entity_ST": "CA",
   "EMPLOYER": "Pfizer",
   "OCCUPATION": "Analyst",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980533",
   "ENTITY": "IND",
   "ENTITY NAME": "Hunt",
   "ENTITY NAME CONT.": "Gerald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983957",
   "ENTITY": "IND",
   "ENTITY NAME": "Jackson",
   "ENTITY NAME CONT.": "Beverly",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rebuilding Together Silicon Valley",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925414",
   "ENTITY": "IND",
   "ENTITY NAME": "Jackson",
   "ENTITY NAME CONT.": "Beverly",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rebuilding Together Silicon Valley",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935176",
   "ENTITY": "IND",
   "ENTITY NAME": "Jackson",
   "ENTITY NAME CONT.": "Beverly",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rebuilding Together Silicon Valley",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960866",
   "ENTITY": "IND",
   "ENTITY NAME": "James",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Van Pelt, Yi & James LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980255",
   "ENTITY": "IND",
   "ENTITY NAME": "James",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Van Pelt, Yi & James LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980572",
   "ENTITY": "IND",
   "ENTITY NAME": "James",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Van Pelt, Yi & James LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934778",
   "ENTITY": "IND",
   "ENTITY NAME": "Jefferson",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unity Care Group",
   "OCCUPATION": "Regional Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960865",
   "ENTITY": "IND",
   "ENTITY NAME": "Jimenez",
   "ENTITY NAME CONT.": "Sergio",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Councilmember",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987862",
   "ENTITY": "IND",
   "ENTITY NAME": "Juang",
   "ENTITY NAME CONT.": "Shau-Chao",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Ming Systems",
   "OCCUPATION": "Business owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984013",
   "ENTITY": "IND",
   "ENTITY NAME": "Kali Rai",
   "ENTITY NAME CONT.": "SharanjitS.",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Jackson and Main LLC",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931449",
   "ENTITY": "IND",
   "ENTITY NAME": "Keegan",
   "ENTITY NAME CONT.": "SamuelPatrick",
   "ENTITY CITY": "Davis",
   "Entity_ST": "CA",
   "EMPLOYER": "Trader Joe's",
   "OCCUPATION": "Display Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984145",
   "ENTITY": "IND",
   "ENTITY NAME": "Keegan",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Valley Water District",
   "OCCUPATION": "Director, District 2",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925416",
   "ENTITY": "IND",
   "ENTITY NAME": "Keegan",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Valley Water District",
   "OCCUPATION": "Director, District 2",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935182",
   "ENTITY": "IND",
   "ENTITY NAME": "Kelly",
   "ENTITY NAME CONT.": "Pam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CreaTV San Jose",
   "OCCUPATION": "Marketing Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558251",
   "ENTITY": "IND",
   "ENTITY NAME": "Khaled Gomez",
   "ENTITY NAME CONT.": "Arturo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 320
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10929897",
   "ENTITY": "IND",
   "ENTITY NAME": "Kim",
   "ENTITY NAME CONT.": "Joanne",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Legendary Pictures",
   "OCCUPATION": "Director, Post Production Technology",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984218",
   "ENTITY": "IND",
   "ENTITY NAME": "Koff-Ginsborg",
   "ENTITY NAME CONT.": "Elisa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Behavioral Health Contractors Assoc.",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 75
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984154",
   "ENTITY": "IND",
   "ENTITY NAME": "Kohli",
   "ENTITY NAME CONT.": "Sarita",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "AACI",
   "OCCUPATION": "CEO",
   "AMOUNT": 35
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989498",
   "ENTITY": "IND",
   "ENTITY NAME": "Kramer",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Republic Family of Companies",
   "OCCUPATION": "Chairman",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928007",
   "ENTITY": "IND",
   "ENTITY NAME": "Kremen",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Dog Patch",
   "OCCUPATION": "Engineer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975814",
   "ENTITY": "IND",
   "ENTITY NAME": "Kremen",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Dog Patch",
   "OCCUPATION": "Engineer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923303",
   "ENTITY": "IND",
   "ENTITY NAME": "Larkin",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "Philadelphia",
   "Entity_ST": "PA",
   "EMPLOYER": "American Red Cross",
   "OCCUPATION": "Fundraiser",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925377",
   "ENTITY": "IND",
   "ENTITY NAME": "Lawrence",
   "ENTITY NAME CONT.": "Gerry",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934779",
   "ENTITY": "IND",
   "ENTITY NAME": "Le",
   "ENTITY NAME CONT.": "Christine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Talent Burst",
   "OCCUPATION": "Human Resources",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960883",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CA Line Dance Association",
   "OCCUPATION": "Office Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990941",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "OttoO.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intellectual Property Law Group",
   "OCCUPATION": "Partner",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983948",
   "ENTITY": "IND",
   "ENTITY NAME": "Lew",
   "ENTITY NAME CONT.": "Michele",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "The Health Trust",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935189",
   "ENTITY": "IND",
   "ENTITY NAME": "Lew",
   "ENTITY NAME CONT.": "Michele",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "The Health Trust",
   "OCCUPATION": "CEO",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960884",
   "ENTITY": "IND",
   "ENTITY NAME": "Lin",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Progressive Real Estate Partners",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930913",
   "ENTITY": "IND",
   "ENTITY NAME": "Livak",
   "ENTITY NAME CONT.": "Nick",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930914",
   "ENTITY": "IND",
   "ENTITY NAME": "Livak",
   "ENTITY NAME CONT.": "Mary Ellen",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989524",
   "ENTITY": "IND",
   "ENTITY NAME": "Loeb",
   "ENTITY NAME CONT.": "Aaron",
   "ENTITY CITY": "Santa Monica",
   "Entity_ST": "CA",
   "EMPLOYER": "FoxNext",
   "OCCUPATION": "Videogame Maker",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983955",
   "ENTITY": "IND",
   "ENTITY NAME": "Loving",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Destination:Home/SVCF",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923846",
   "ENTITY": "IND",
   "ENTITY NAME": "Loving",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984228",
   "ENTITY": "IND",
   "ENTITY NAME": "Lynn",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935180",
   "ENTITY": "IND",
   "ENTITY NAME": "Lynn",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989529",
   "ENTITY": "IND",
   "ENTITY NAME": "Lynn",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980577",
   "ENTITY": "IND",
   "ENTITY NAME": "Ma Lebron",
   "ENTITY NAME CONT.": "Charisse",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County Office of Supportive Housing",
   "OCCUPATION": "Policy & Research",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960869",
   "ENTITY": "IND",
   "ENTITY NAME": "Maben Hammon",
   "ENTITY NAME CONT.": "Meri",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Education Foundation",
   "OCCUPATION": "Education Manager",
   "AMOUNT": 350
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989527",
   "ENTITY": "IND",
   "ENTITY NAME": "Maben Hammon",
   "ENTITY NAME CONT.": "Meri",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Education Foundation",
   "OCCUPATION": "Education Manager",
   "AMOUNT": 350
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980253",
   "ENTITY": "IND",
   "ENTITY NAME": "Macapinlac",
   "ENTITY NAME CONT.": "Andrae",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "California State Senate",
   "OCCUPATION": "Senior District Representative",
   "AMOUNT": 27
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960871",
   "ENTITY": "IND",
   "ENTITY NAME": "Madrigal",
   "ENTITY NAME CONT.": "Rosana",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Sisters of the Presentation",
   "OCCUPATION": "Public Relations",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990305",
   "ENTITY": "IND",
   "ENTITY NAME": "MaNguyen",
   "ENTITY NAME CONT.": "Denise",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "MJ Realty Broker",
   "OCCUPATION": "Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990386",
   "ENTITY": "IND",
   "ENTITY NAME": "Mann",
   "ENTITY NAME CONT.": "MohinderS.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Mann Law Firm",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983934",
   "ENTITY": "IND",
   "ENTITY NAME": "Martinez",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923302",
   "ENTITY": "IND",
   "ENTITY NAME": "Martinez",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10929901",
   "ENTITY": "IND",
   "ENTITY NAME": "Mathany",
   "ENTITY NAME CONT.": "Kate",
   "ENTITY CITY": "West Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989530",
   "ENTITY": "IND",
   "ENTITY NAME": "Matsumura",
   "ENTITY NAME CONT.": "Ellen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Partnership for Working Families",
   "OCCUPATION": "California Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925385",
   "ENTITY": "IND",
   "ENTITY NAME": "Maxson",
   "ENTITY NAME CONT.": "Aaron",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "SalesForce",
   "OCCUPATION": "Sr. Sourcing Analyst",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975779",
   "ENTITY": "IND",
   "ENTITY NAME": "Mehrens",
   "ENTITY NAME CONT.": "Derecka",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partnerships",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935177",
   "ENTITY": "IND",
   "ENTITY NAME": "Melanio",
   "ENTITY NAME CONT.": "GraceSonia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Project Safety Net",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934780",
   "ENTITY": "IND",
   "ENTITY NAME": "Melo",
   "ENTITY NAME CONT.": "Marisa",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "MOWAC",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 40
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923304",
   "ENTITY": "IND",
   "ENTITY NAME": "Mjolsness",
   "ENTITY NAME CONT.": "Joel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mirantis",
   "OCCUPATION": "Technology Consultant",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984156",
   "ENTITY": "IND",
   "ENTITY NAME": "Momeni",
   "ENTITY NAME CONT.": "Abdul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Studio 34 Hair Salon",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930901",
   "ENTITY": "IND",
   "ENTITY NAME": "Moore",
   "ENTITY NAME CONT.": "DavidB.",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Student",
   "OCCUPATION": "Student",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930902",
   "ENTITY": "IND",
   "ENTITY NAME": "Moore",
   "ENTITY NAME CONT.": "Jenna",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Student",
   "OCCUPATION": "Student",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984014",
   "ENTITY": "IND",
   "ENTITY NAME": "Morgan",
   "ENTITY NAME CONT.": "Geoffrey",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "First Community Housing",
   "OCCUPATION": "Executive Director, Affordable Housing",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923315",
   "ENTITY": "IND",
   "ENTITY NAME": "Mukoyama",
   "ENTITY NAME CONT.": "Howard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963968",
   "ENTITY": "IND",
   "ENTITY NAME": "Mukoyama",
   "ENTITY NAME CONT.": "Howard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980529",
   "ENTITY": "IND",
   "ENTITY NAME": "Mukoyama",
   "ENTITY NAME CONT.": "Howard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930897",
   "ENTITY": "IND",
   "ENTITY NAME": "Mussman",
   "ENTITY NAME CONT.": "Janice",
   "ENTITY CITY": "Kearney",
   "Entity_ST": "MO",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930898",
   "ENTITY": "IND",
   "ENTITY NAME": "Mussman",
   "ENTITY NAME CONT.": "Lyle",
   "ENTITY CITY": "Kearney",
   "Entity_ST": "MO",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990390",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Rosalinda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco",
   "OCCUPATION": "Executive Assistant",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990424",
   "ENTITY": "IND",
   "ENTITY NAME": "Ndiaye",
   "ENTITY NAME CONT.": "Aboubacar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partnerships",
   "OCCUPATION": "Researcher",
   "AMOUNT": 20
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963955",
   "ENTITY": "IND",
   "ENTITY NAME": "Neale",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "The Core Companies",
   "OCCUPATION": "Developer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923317",
   "ENTITY": "IND",
   "ENTITY NAME": "Nevarez",
   "ENTITY NAME CONT.": "Kristi",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Fragomen Del Rey Bernsen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984224",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Hanh",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hanh Nguyen",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558231",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Hanh",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963967",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Mateo County",
   "OCCUPATION": "Analyst",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10986835",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "RichardH.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Valley Water District",
   "OCCUPATION": "Management Analyst II",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987864",
   "ENTITY": "IND",
   "ENTITY NAME": "Ni",
   "ENTITY NAME CONT.": "Yuling",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Engineer",
   "OCCUPATION": "Oracle",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984143",
   "ENTITY": "IND",
   "ENTITY NAME": "Niklaus",
   "ENTITY NAME CONT.": "Jenny",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "American Leadership Forum",
   "OCCUPATION": "Chief Impact Officer",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983290",
   "ENTITY": "IND",
   "ENTITY NAME": "Nilson",
   "ENTITY NAME CONT.": "ChristopherD.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Avnera",
   "OCCUPATION": "Engineer",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984231",
   "ENTITY": "IND",
   "ENTITY NAME": "Nunez",
   "ENTITY NAME CONT.": "GuisselleVanessa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Chabot-Las Positas Community College District",
   "OCCUPATION": "Director, PR/Marketing/Govt. Relations",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960863",
   "ENTITY": "IND",
   "ENTITY NAME": "Nunez",
   "ENTITY NAME CONT.": "GuisselleVanessa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Chabot-Las Positas Community College District",
   "OCCUPATION": "Director, PR/Marketing/Govt. Relations",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925384",
   "ENTITY": "IND",
   "ENTITY NAME": "Orozco",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Paul Orozco",
   "OCCUPATION": "Investor",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980582",
   "ENTITY": "IND",
   "ENTITY NAME": "Orozco",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Paul Orozco",
   "OCCUPATION": "Investor",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960893",
   "ENTITY": "IND",
   "ENTITY NAME": "Orozco",
   "ENTITY NAME CONT.": "Timothy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California State Senate",
   "OCCUPATION": "Legislative Aide",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931453",
   "ENTITY": "IND",
   "ENTITY NAME": "Page",
   "ENTITY NAME CONT.": "Ted",
   "ENTITY CITY": "Buttonwillow",
   "Entity_ST": "CA",
   "EMPLOYER": "Ted Page",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931454",
   "ENTITY": "IND",
   "ENTITY NAME": "Page",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "Buttonwillow",
   "Entity_ST": "CA",
   "EMPLOYER": "Brooklands Farm",
   "OCCUPATION": "Accountant",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925423",
   "ENTITY": "IND",
   "ENTITY NAME": "Pajuelo-Schwartz",
   "ENTITY NAME CONT.": "Marcel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558242",
   "ENTITY": "IND",
   "ENTITY NAME": "Pearce",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933762",
   "ENTITY": "IND",
   "ENTITY NAME": "Pearl",
   "ENTITY NAME CONT.": "Amy",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Acorn Financial Planning",
   "OCCUPATION": "Registered Investment Advisor",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10986983",
   "ENTITY": "IND",
   "ENTITY NAME": "Perry",
   "ENTITY NAME CONT.": "Andrea",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980531",
   "ENTITY": "IND",
   "ENTITY NAME": "Pirayou",
   "ENTITY NAME CONT.": "Ash",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Rutan & Tucker",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930909",
   "ENTITY": "IND",
   "ENTITY NAME": "Profitt",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930910",
   "ENTITY": "IND",
   "ENTITY NAME": "Profitt",
   "ENTITY NAME CONT.": "Michelle",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925422",
   "ENTITY": "IND",
   "ENTITY NAME": "Quinones",
   "ENTITY NAME CONT.": "Joel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Franklin McKinley School District",
   "OCCUPATION": "Maintenance",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983804",
   "ENTITY": "IND",
   "ENTITY NAME": "Quinones",
   "ENTITY NAME CONT.": "Juan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Google",
   "OCCUPATION": "Business Partner",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925420",
   "ENTITY": "IND",
   "ENTITY NAME": "Quintero",
   "ENTITY NAME CONT.": "Andres",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Evergreen Valley College",
   "OCCUPATION": "Professor",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555938",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Cesar",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 910
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964768",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "LisaA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Yageo Corporation",
   "OCCUPATION": "Sales Account Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987861",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Lawrence",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Litigation Law Group",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989502",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "LisaA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Yageo Corporation",
   "OCCUPATION": "Sales Account Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551870",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Cesar",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 320
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10975777",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Janine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CCSA",
   "OCCUPATION": "Regional Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923316",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Rene",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "HomeFirst",
   "OCCUPATION": "COO",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923840",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Management Analyst",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984230",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Janine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CCSA",
   "OCCUPATION": "Regional Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923314",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Cesar",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "InkSprite Design",
   "OCCUPATION": "Graphic Designer",
   "AMOUNT": 1
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10927045",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Cesar",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "InkSprite Design",
   "OCCUPATION": "Graphic Designer",
   "AMOUNT": 1
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964273",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Cesar",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "InkSprite Design",
   "OCCUPATION": "Graphic Designer",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923293",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Cesar",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "InkSprite Design",
   "OCCUPATION": "Graphic Designer",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963966",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Cesar",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "InkSprite Design",
   "OCCUPATION": "Graphic Designer",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964271",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Cesar",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "InkSprite Design",
   "OCCUPATION": "Graphic Designer",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558250",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez Leon",
   "ENTITY NAME CONT.": "Tiffany",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 260
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925415",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramos",
   "ENTITY NAME CONT.": "Angelica",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Angelica Ramos",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960867",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramos",
   "ENTITY NAME CONT.": "Christina",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Chief of Staff",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10986834",
   "ENTITY": "IND",
   "ENTITY NAME": "Richardson",
   "ENTITY NAME CONT.": "Eileen",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown Streets, Inc.",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931452",
   "ENTITY": "IND",
   "ENTITY NAME": "Ritchie",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "Visalia",
   "Entity_ST": "CA",
   "EMPLOYER": "Jeff Ritchie",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931446",
   "ENTITY": "IND",
   "ENTITY NAME": "Ritchie",
   "ENTITY NAME CONT.": "Casey",
   "ENTITY CITY": "Visalia",
   "Entity_ST": "CA",
   "EMPLOYER": "Casey Ritchie",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931447",
   "ENTITY": "IND",
   "ENTITY NAME": "Ritchie",
   "ENTITY NAME CONT.": "MaryE.",
   "ENTITY CITY": "Visalia",
   "Entity_ST": "CA",
   "EMPLOYER": "Mary Ritchie",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931450",
   "ENTITY": "IND",
   "ENTITY NAME": "Ritchie",
   "ENTITY NAME CONT.": "LarryJ.",
   "ENTITY CITY": "Visalia",
   "Entity_ST": "CA",
   "EMPLOYER": "Larry Ritchie",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940349",
   "ENTITY": "IND",
   "ENTITY NAME": "Ritchie",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "Selma",
   "Entity_ST": "CA",
   "EMPLOYER": "Catherine Ritchie",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558253",
   "ENTITY": "IND",
   "ENTITY NAME": "Rivera Ramirez",
   "ENTITY NAME CONT.": "Kara",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 280
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983944",
   "ENTITY": "IND",
   "ENTITY NAME": "Roberts",
   "ENTITY NAME CONT.": "Joel",
   "ENTITY CITY": "Newport Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "PATH",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935191",
   "ENTITY": "IND",
   "ENTITY NAME": "Roberts",
   "ENTITY NAME CONT.": "Joel",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "PATH",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10986971",
   "ENTITY": "IND",
   "ENTITY NAME": "Robinson",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Charities Housing",
   "OCCUPATION": "Non-Profit Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989531",
   "ENTITY": "IND",
   "ENTITY NAME": "Rocha",
   "ENTITY NAME CONT.": "LouisH",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Communication Workers of America",
   "OCCUPATION": "Union Staff Rep",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923838",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Guadalupe",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Planned Parenthood",
   "OCCUPATION": "Director, Public Affairs",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989537",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Guadalupe",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Planned Parenthood Mar Monte",
   "OCCUPATION": "Director, Public Affairs",
   "AMOUNT": 20
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984221",
   "ENTITY": "IND",
   "ENTITY NAME": "Ross",
   "ENTITY NAME CONT.": "StaceyH.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VTA",
   "OCCUPATION": "Communications Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960888",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruiz Herrera",
   "ENTITY NAME CONT.": "Esau",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Esau Ruiz Herrera",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10965421",
   "ENTITY": "IND",
   "ENTITY NAME": "Salinas",
   "ENTITY NAME CONT.": "Jacquelin",
   "ENTITY CITY": "San Martin",
   "Entity_ST": "CA",
   "EMPLOYER": "Valley Recycling",
   "OCCUPATION": "Systems Engineer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "C10965422",
   "ENTITY": "IND",
   "ENTITY NAME": "Salinas",
   "ENTITY NAME CONT.": "Monica",
   "ENTITY CITY": "San Martin",
   "Entity_ST": "CA",
   "EMPLOYER": "Student",
   "OCCUPATION": "Student",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10989508",
   "ENTITY": "IND",
   "ENTITY NAME": "Salinas",
   "ENTITY NAME CONT.": "Monica",
   "ENTITY CITY": "San Martin",
   "Entity_ST": "CA",
   "EMPLOYER": "Student",
   "OCCUPATION": "Student",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960896",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "GeorgeG.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "East Side Union High School District",
   "OCCUPATION": "Educator",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928008",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "GeorgeG.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "East Side Union High School District",
   "OCCUPATION": "Educator",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980578",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "GeorgeG.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989533",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Angelina",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "East Side Union High School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980523",
   "ENTITY": "IND",
   "ENTITY NAME": "Sandoval",
   "ENTITY NAME CONT.": "Dolores",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Los Gatos Saratoga Unified School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553419",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553827",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557302",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557419",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553420",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 929
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557404",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 511
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555935",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553833",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 425
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553828",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 278
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557297",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 271
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "D554973",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 191
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557420",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 112
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "F",
   "ID": "D557140",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "F",
   "ID": "D552939",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "F",
   "ID": "D553481",
   "ENTITY": "IND",
   "ENTITY NAME": "Santiago",
   "ENTITY NAME CONT.": "Miguel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923845",
   "ENTITY": "IND",
   "ENTITY NAME": "Santos",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10979963",
   "ENTITY": "IND",
   "ENTITY NAME": "Sapien",
   "ENTITY NAME CONT.": "Hermelinda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CET",
   "OCCUPATION": "President",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558248",
   "ENTITY": "IND",
   "ENTITY NAME": "Sarmientos",
   "ENTITY NAME CONT.": "Ana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 360
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923298",
   "ENTITY": "IND",
   "ENTITY NAME": "Scopazzi",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Testarossa Winery",
   "OCCUPATION": "Marketing Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925421",
   "ENTITY": "IND",
   "ENTITY NAME": "Selo",
   "ENTITY NAME CONT.": "Joshua",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "West Valley Community Services",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960885",
   "ENTITY": "IND",
   "ENTITY NAME": "Shirakawa",
   "ENTITY NAME CONT.": "NavetteA",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Thermo Fisher Scientific",
   "OCCUPATION": "Product Line Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989535",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Theodore (Ted)G",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Theodore Smith",
   "OCCUPATION": "Environmental Consultant",
   "AMOUNT": 350
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984223",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "TheodoreG",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Theodore Smith",
   "OCCUPATION": "Environmental Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558252",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Graham",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 160
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925412",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "ElizabethA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961641",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "TheodoreG",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Theodore Smith",
   "OCCUPATION": "Environmental Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10929898",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Burton",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 35
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933760",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Burton",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 35
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933769",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "Portland",
   "Entity_ST": "OR",
   "EMPLOYER": "Cosgrave Vergeer Kester LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983938",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Burton",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925387",
   "ENTITY": "IND",
   "ENTITY NAME": "Smyrniotis",
   "ENTITY NAME CONT.": "Kathy",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "De Anza Properties",
   "OCCUPATION": "Property Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984234",
   "ENTITY": "IND",
   "ENTITY NAME": "Solis",
   "ENTITY NAME CONT.": "Mary Jane",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987920",
   "ENTITY": "IND",
   "ENTITY NAME": "Solis",
   "ENTITY NAME CONT.": "Mary Jane",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925380",
   "ENTITY": "IND",
   "ENTITY NAME": "Soto",
   "ENTITY NAME CONT.": "Sandra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "U.S. House of Representatives",
   "OCCUPATION": "Chief of Staff",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933765",
   "ENTITY": "IND",
   "ENTITY NAME": "Soto",
   "ENTITY NAME CONT.": "Sandra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "U.S. House of Representatives",
   "OCCUPATION": "Chief of Staff",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10927997",
   "ENTITY": "IND",
   "ENTITY NAME": "Stapleton",
   "ENTITY NAME CONT.": "Laurie",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Art Direction",
   "OCCUPATION": "Artist",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984220",
   "ENTITY": "IND",
   "ENTITY NAME": "Strickland",
   "ENTITY NAME CONT.": "ElizabethB",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "FLY",
   "OCCUPATION": "Chief Development Officer",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963964",
   "ENTITY": "IND",
   "ENTITY NAME": "Stromberg",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "Project Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928001",
   "ENTITY": "IND",
   "ENTITY NAME": "Stuart",
   "ENTITY NAME CONT.": "WilliamR.",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Milestone Financial",
   "OCCUPATION": "Mortgage Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928002",
   "ENTITY": "IND",
   "ENTITY NAME": "Stuart",
   "ENTITY NAME CONT.": "Julia",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Student",
   "OCCUPATION": "Student",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928005",
   "ENTITY": "IND",
   "ENTITY NAME": "Stuart",
   "ENTITY NAME CONT.": "CarolynT.",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Carolyn Stuart",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930908",
   "ENTITY": "IND",
   "ENTITY NAME": "Sudderth",
   "ENTITY NAME CONT.": "Veronika",
   "ENTITY CITY": "Olivehurst",
   "Entity_ST": "CA",
   "EMPLOYER": "Veronika Sudderth",
   "OCCUPATION": "Hairdresser",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984219",
   "ENTITY": "IND",
   "ENTITY NAME": "Sutherland",
   "ENTITY NAME CONT.": "Kathy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Board Aide",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963963",
   "ENTITY": "IND",
   "ENTITY NAME": "Swenson",
   "ENTITY NAME CONT.": "Case",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Swenson Builders",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990419",
   "ENTITY": "IND",
   "ENTITY NAME": "Taube",
   "ENTITY NAME CONT.": "RuthSilver",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara University",
   "OCCUPATION": "Attorney",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558245",
   "ENTITY": "IND",
   "ENTITY NAME": "Tellez Gutierrez",
   "ENTITY NAME CONT.": "Soledad",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963958",
   "ENTITY": "IND",
   "ENTITY NAME": "Teutle",
   "ENTITY NAME CONT.": "Omar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CA Public Utilities Commission",
   "OCCUPATION": "Management Analyst",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925391",
   "ENTITY": "IND",
   "ENTITY NAME": "Tomaino",
   "ENTITY NAME CONT.": "Kathryn",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960872",
   "ENTITY": "IND",
   "ENTITY NAME": "Tran",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Senior Policy Aide",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928000",
   "ENTITY": "IND",
   "ENTITY NAME": "Tuerk",
   "ENTITY NAME CONT.": "FredW.",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Gillbane Building Company",
   "OCCUPATION": "Project Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963961",
   "ENTITY": "IND",
   "ENTITY NAME": "Van Every",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Republic Urban Properties",
   "OCCUPATION": "President/CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980256",
   "ENTITY": "IND",
   "ENTITY NAME": "Van Every",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Republic Urban Properties",
   "OCCUPATION": "President/CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990115",
   "ENTITY": "IND",
   "ENTITY NAME": "Vega",
   "ENTITY NAME CONT.": "Javier",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Prestige Real Estate Management Group LLC",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10986837",
   "ENTITY": "IND",
   "ENTITY NAME": "Venton",
   "ENTITY NAME CONT.": "Philip",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925398",
   "ENTITY": "IND",
   "ENTITY NAME": "Vidovich",
   "ENTITY NAME CONT.": "Kathryn",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Meier Vidovich",
   "OCCUPATION": "Property Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925400",
   "ENTITY": "IND",
   "ENTITY NAME": "Vidovich",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Stephen Vidovich",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925402",
   "ENTITY": "IND",
   "ENTITY NAME": "Vidovich",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Sandridge Partners",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10926743",
   "ENTITY": "IND",
   "ENTITY NAME": "Vidovich",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10927996",
   "ENTITY": "IND",
   "ENTITY NAME": "Vidovich",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Sandridge Partners",
   "OCCUPATION": "Farmer",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10927998",
   "ENTITY": "IND",
   "ENTITY NAME": "Vidovich",
   "ENTITY NAME CONT.": "MichaelA.",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Student",
   "OCCUPATION": "Student",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980579",
   "ENTITY": "IND",
   "ENTITY NAME": "Vo",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 20
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980573",
   "ENTITY": "IND",
   "ENTITY NAME": "Vu",
   "ENTITY NAME CONT.": "Hau",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 20
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935181",
   "ENTITY": "IND",
   "ENTITY NAME": "Walker",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980580",
   "ENTITY": "IND",
   "ENTITY NAME": "Walker",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933767",
   "ENTITY": "IND",
   "ENTITY NAME": "Watanabe",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "City of Santa Clara",
   "OCCUPATION": "Vice Mayor",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984146",
   "ENTITY": "IND",
   "ENTITY NAME": "Watanabe",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "City of Santa Clara",
   "OCCUPATION": "Vice Mayor",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925388",
   "ENTITY": "IND",
   "ENTITY NAME": "Weed",
   "ENTITY NAME CONT.": "Steven",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel Realtors",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925393",
   "ENTITY": "IND",
   "ENTITY NAME": "Weed",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Kara",
   "OCCUPATION": "Therpay Intern",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928006",
   "ENTITY": "IND",
   "ENTITY NAME": "Weed",
   "ENTITY NAME CONT.": "Spencer",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Coconuts Media",
   "OCCUPATION": "Technology & Design Director",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984151",
   "ENTITY": "IND",
   "ENTITY NAME": "Welsh",
   "ENTITY NAME CONT.": "Carol",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "SBI",
   "OCCUPATION": "Development",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963957",
   "ENTITY": "IND",
   "ENTITY NAME": "Willette",
   "ENTITY NAME CONT.": "Mullissa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Investigator",
   "AMOUNT": 40
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964772",
   "ENTITY": "IND",
   "ENTITY NAME": "Willette",
   "ENTITY NAME CONT.": "Mullissa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Investigator",
   "AMOUNT": 40
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933761",
   "ENTITY": "IND",
   "ENTITY NAME": "Willette",
   "ENTITY NAME CONT.": "Mullissa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Investigator",
   "AMOUNT": 10
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923296",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilson",
   "ENTITY NAME CONT.": "Alex",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "PlayStations",
   "OCCUPATION": "Corporate Communications Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10984216",
   "ENTITY": "IND",
   "ENTITY NAME": "Witczak",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "Dublin",
   "Entity_ST": "CA",
   "EMPLOYER": "Hayward Unified School District",
   "OCCUPATION": "Assistant Principal",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983932",
   "ENTITY": "IND",
   "ENTITY NAME": "Wong",
   "ENTITY NAME CONT.": "Gilbert",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Foothill De Anza Community College District",
   "OCCUPATION": "Trustee",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10987860",
   "ENTITY": "IND",
   "ENTITY NAME": "Yuen Choy",
   "ENTITY NAME CONT.": "Margaret",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "Margaret Jewelry",
   "OCCUPATION": "Business owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960894",
   "ENTITY": "IND",
   "ENTITY NAME": "Yuk Chan",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Bay Area Compliance Labs Corp",
   "OCCUPATION": "Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557303",
   "ENTITY": "IND",
   "ENTITY NAME": "Zapien",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10923834",
   "ENTITY": "IND",
   "ENTITY NAME": "Zarou Prazer",
   "ENTITY NAME CONT.": "Amal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Health Trust",
   "OCCUPATION": "Administrative Assistant",
   "AMOUNT": 60
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10983954",
   "ENTITY": "IND",
   "ENTITY NAME": "Zwick",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Housing Trust Silicon Valley",
   "OCCUPATION": "Nonprofit Director",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940351",
   "ENTITY": "IND",
   "ENTITY NAME": "Zwick",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Housing Trust Silicon Valley",
   "OCCUPATION": "Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960887",
   "ENTITY": "OTH",
   "ENTITY NAME": "10 Jackson Street LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553829",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amazon.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 123
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557417",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amazon.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 82
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "F",
   "ID": "D557144",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amazon.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10927999",
   "ENTITY": "OTH",
   "ENTITY NAME": "Apex Resources, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oklahoma City",
   "Entity_ST": "OK",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990306",
   "ENTITY": "OTH",
   "ENTITY NAME": "ARDA LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964318",
   "ENTITY": "OTH",
   "ENTITY NAME": "Black Sea Gallery Development, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984225",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Labor Force",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550911",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555936",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2270
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551873",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2240
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "I",
   "ID": "C10980525",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 593
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551874",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555952",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cole MT San Jose CA, LP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Phoenix",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6040
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558322",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comerica Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557675",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comerica Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 18
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551871",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1290
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556722",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 966
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557415",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 960
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552049",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 640
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553831",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 590
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555956",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 469
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553017",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 421
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "D554975",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 405
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551872",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 366
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555950",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 152
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553018",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557409",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 68
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "F",
   "ID": "D557141",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "F",
   "ID": "D552948",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "F",
   "ID": "D553482",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10986836",
   "ENTITY": "OTH",
   "ENTITY NAME": "De Haro Ramirez Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "D554974",
   "ENTITY": "OTH",
   "ENTITY NAME": "Denny's Restaurant",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 191
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980584",
   "ENTITY": "OTH",
   "ENTITY NAME": "Duran Construction Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557296",
   "ENTITY": "OTH",
   "ENTITY NAME": "El Pollo Loco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 38
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558237",
   "ENTITY": "OTH",
   "ENTITY NAME": "El Pollo Loco",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 23
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558254",
   "ENTITY": "OTH",
   "ENTITY NAME": "Elma's Catering",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1967
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964770",
   "ENTITY": "OTH",
   "ENTITY NAME": "Environmental Resource Recovery, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10989507",
   "ENTITY": "OTH",
   "ENTITY NAME": "Environmental Resource Recovery, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990420",
   "ENTITY": "OTH",
   "ENTITY NAME": "Five Sisters Group LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555949",
   "ENTITY": "OTH",
   "ENTITY NAME": "GoDaddy.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Scottsdale",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 120
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931445",
   "ENTITY": "OTH",
   "ENTITY NAME": "Graham & Associates",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Visalia",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557440",
   "ENTITY": "OTH",
   "ENTITY NAME": "InFocus Campaigns",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fort Worth",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 364
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557299",
   "ENTITY": "OTH",
   "ENTITY NAME": "InFocus Campaigns",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fort Worth",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 298
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557298",
   "ENTITY": "OTH",
   "ENTITY NAME": "InFocus Campaigns",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fort Worth",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 257
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553830",
   "ENTITY": "OTH",
   "ENTITY NAME": "InFocus Campaigns",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fort Worth",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 165
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "D554972",
   "ENTITY": "OTH",
   "ENTITY NAME": "InFocus Campaigns",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fort Worth",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 93
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960902",
   "ENTITY": "OTH",
   "ENTITY NAME": "K-1/K-2 Ranch",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555939",
   "ENTITY": "OTH",
   "ENTITY NAME": "Le Gio To Nghe Thuat San Khau",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984240",
   "ENTITY": "OTH",
   "ENTITY NAME": "LINQ Apartment Homes",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552967",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mailrite Print and Mail, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 680
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553521",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mailrite Print and Mail, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 634
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553511",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mailrite Print and Mail, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 516
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552961",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mark Weiss Associates",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Bethesda",
   "Entity_ST": "MD",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1735
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552963",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mark Weiss Associates",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Bethesda",
   "Entity_ST": "MD",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1481
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557408",
   "ENTITY": "OTH",
   "ENTITY NAME": "McDonald's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 22
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "F",
   "ID": "D557142",
   "ENTITY": "OTH",
   "ENTITY NAME": "McDonald's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552954",
   "ENTITY": "OTH",
   "ENTITY NAME": "McLaughlin Corridor Neighborhood Association",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D557057",
   "ENTITY": "OTH",
   "ENTITY NAME": "Merry Thanh Le",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552876",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mezcal Restaurant & Bar",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960882",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mezcal Restaurant & Bar",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990423",
   "ENTITY": "OTH",
   "ENTITY NAME": "Michael James Company, Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989540",
   "ENTITY": "OTH",
   "ENTITY NAME": "Morley Bros., LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557407",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mountain Mike's Pizza",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 80
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553019",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558323",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557410",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 164
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "F",
   "ID": "D552951",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553512",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Standard Print",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 946
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557413",
   "ENTITY": "OTH",
   "ENTITY NAME": "Panera Bread",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555946",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 208
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556925",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 158
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "D550922",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 145
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555945",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 113
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552952",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 91
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552953",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 90
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553462",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 69
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552144",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557414",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 22
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553328",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551337",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557432",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "D555084",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553832",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556924",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555443",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557439",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558232",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pho Ha Noi San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551876",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555937",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553416",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 674
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553479",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 313
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555955",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 270
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D554976",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 227
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553421",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 212
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557300",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 97
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553417",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 83
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552518",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 29
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557412",
   "ENTITY": "OTH",
   "ENTITY NAME": "Popeyes",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 44
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964774",
   "ENTITY": "OTH",
   "ENTITY NAME": "Premier Real Estate Investments",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990421",
   "ENTITY": "OTH",
   "ENTITY NAME": "Red Dragon Holding LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984009",
   "ENTITY": "OTH",
   "ENTITY NAME": "Republic Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Phoenix",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553520",
   "ENTITY": "OTH",
   "ENTITY NAME": "RiverCity Printers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rancho Cordova",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4429
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552966",
   "ENTITY": "OTH",
   "ENTITY NAME": "RiverCity Printers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rancho Cordova",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3499
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552964",
   "ENTITY": "OTH",
   "ENTITY NAME": "RiverCity Printers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rancho Cordova",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3221
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553510",
   "ENTITY": "OTH",
   "ENTITY NAME": "RiverCity Printers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rancho Cordova",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3218
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553513",
   "ENTITY": "OTH",
   "ENTITY NAME": "RiverCity Printers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rancho Cordova",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1855
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552962",
   "ENTITY": "OTH",
   "ENTITY NAME": "RiverCity Printers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rancho Cordova",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1262
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552960",
   "ENTITY": "OTH",
   "ENTITY NAME": "RiverCity Printers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rancho Cordova",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1079
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558235",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway - San Carlos",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10980524",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Water Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990422",
   "ENTITY": "OTH",
   "ENTITY NAME": "Simple Neighbors Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558255",
   "ENTITY": "OTH",
   "ENTITY NAME": "SJSU Tower Foundation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557387",
   "ENTITY": "OTH",
   "ENTITY NAME": "Soul Amazin' Catering",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557406",
   "ENTITY": "OTH",
   "ENTITY NAME": "Staples",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 70
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557405",
   "ENTITY": "OTH",
   "ENTITY NAME": "Staples",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 21
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "F",
   "ID": "D553483",
   "ENTITY": "OTH",
   "ENTITY NAME": "Staples",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557411",
   "ENTITY": "OTH",
   "ENTITY NAME": "Starbucks Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555951",
   "ENTITY": "OTH",
   "ENTITY NAME": "State Farm Insurance",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 533
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558230",
   "ENTITY": "OTH",
   "ENTITY NAME": "Subway",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 164
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "C10925383",
   "ENTITY": "OTH",
   "ENTITY NAME": "Symbiotic Productions LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Encino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930899",
   "ENTITY": "OTH",
   "ENTITY NAME": "Synergy Fitness Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557422",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 57
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557421",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 55
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "F",
   "ID": "D557143",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964775",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Litigation Law Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556719",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14204
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556724",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13126
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552877",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10360
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552858",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10071
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553519",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7956
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553418",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6856
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556721",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5724
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555954",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556720",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4408
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553480",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3732
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551877",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2087
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "E",
   "ID": "D555953",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1850
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552047",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1800
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552041",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1745
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551875",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1725
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553415",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1538
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552048",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "D550340",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Pivot Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 340
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960897",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Sausedo Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984011",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Schoennauer Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "F",
   "ID": "D552959",
   "ENTITY": "OTH",
   "ENTITY NAME": "TotallyPromotional.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Coldwater",
   "Entity_ST": "OH",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552965",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Post Office",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2231
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "F",
   "ID": "D558343",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Post Office - Hillview",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557305",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557204",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557205",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557206",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557207",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557208",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "D557304",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553441",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service - Garden Station",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553442",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service - Garden Station",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553443",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service - Garden Station",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553444",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service - Garden Station",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10960898",
   "ENTITY": "OTH",
   "ENTITY NAME": "VER Consultants, Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556718",
   "ENTITY": "OTH",
   "ENTITY NAME": "Viet-Nam Nhat Bao",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "E",
   "ID": "D556723",
   "ENTITY": "OTH",
   "ENTITY NAME": "Viet-Nam Nhat Bao",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557442",
   "ENTITY": "OTH",
   "ENTITY NAME": "Vietnam Daily News",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "10/25/2018",
   "FORM": "A",
   "ID": "C10989501",
   "ENTITY": "SCC",
   "ENTITY NAME": "I.B.E.W. 302 Community Candidates PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fairfield",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "C10990114",
   "ENTITY": "SCC",
   "ENTITY NAME": "International Brotherhood of Electrical Workers Local 595 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Dublin",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 350
 },
 {
   "LAST": "Esparza",
   "FIRST": "Maya",
   "PURPOSE": "Maya Esparza for San Jose City Council D7 2018",
   "DATE": "9/27/2018",
   "FORM": "A",
   "ID": "C10984241",
   "ENTITY": "SCC",
   "ENTITY NAME": "International Brotherhood of Electrical Workers Local 595 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Dublin",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4246",
   "ENTITY": "COM",
   "ENTITY NAME": "Associated Builders and Contractors Northern California Chapter PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Livermore",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4734",
   "ENTITY": "COM",
   "ENTITY NAME": "Associated Builders and Contractors Northern California Chapter PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Livermore",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5144",
   "ENTITY": "COM",
   "ENTITY NAME": "Bay Area Municipal Election Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5004",
   "ENTITY": "COM",
   "ENTITY NAME": "Build Jobs PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5110",
   "ENTITY": "COM",
   "ENTITY NAME": "Business San Jose Chamber PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Rafael",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1102",
   "ENTITY": "COM",
   "ENTITY NAME": "California Apartment Association PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4324",
   "ENTITY": "COM",
   "ENTITY NAME": "California Apartment Association PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC961",
   "ENTITY": "COM",
   "ENTITY NAME": "California Real Estate PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC5192",
   "ENTITY": "COM",
   "ENTITY NAME": "California Real Estate PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4792",
   "ENTITY": "COM",
   "ENTITY NAME": "Jeff Rosen for DA 2018 FPPC #1375160",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5001",
   "ENTITY": "COM",
   "ENTITY NAME": "San Jose Teacher's Association PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4740",
   "ENTITY": "COM",
   "ENTITY NAME": "Transparent Silicon Valley",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Hollister",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4777",
   "ENTITY": "IND",
   "ENTITY NAME": "Acharya",
   "ENTITY NAME CONT.": "Sanjeev",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Sage Builders",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4778",
   "ENTITY": "IND",
   "ENTITY NAME": "Acharya",
   "ENTITY NAME CONT.": "Mina",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Sage Builders",
   "OCCUPATION": "Designer",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4750",
   "ENTITY": "IND",
   "ENTITY NAME": "Adams",
   "ENTITY NAME CONT.": "Tracy",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Greenwaste",
   "OCCUPATION": "Co-Chief Operating Officer",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC973",
   "ENTITY": "IND",
   "ENTITY NAME": "Adams",
   "ENTITY NAME CONT.": "Sandy",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Sandy Adams Properties",
   "OCCUPATION": "Residential Property Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4357",
   "ENTITY": "IND",
   "ENTITY NAME": "Adams",
   "ENTITY NAME CONT.": "Sandy",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Sandy Adams Properties",
   "OCCUPATION": "Residential Property Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3054",
   "ENTITY": "IND",
   "ENTITY NAME": "Affonso",
   "ENTITY NAME CONT.": "Jackie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brannons Medical",
   "OCCUPATION": "Owner",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC953",
   "ENTITY": "IND",
   "ENTITY NAME": "Agam",
   "ENTITY NAME CONT.": "Isaac",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4957",
   "ENTITY": "IND",
   "ENTITY NAME": "Albanese",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Joseph J. Albanese, Inc.",
   "OCCUPATION": "Contractor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC905",
   "ENTITY": "IND",
   "ENTITY NAME": "Alpers",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Richard Alpers",
   "OCCUPATION": "Construction Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4408",
   "ENTITY": "IND",
   "ENTITY NAME": "Alpers",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Richard Alpers",
   "OCCUPATION": "Construction Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC906",
   "ENTITY": "IND",
   "ENTITY NAME": "Anderson",
   "ENTITY NAME CONT.": "Ray",
   "ENTITY CITY": "Boulder Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4269",
   "ENTITY": "IND",
   "ENTITY NAME": "Anderson",
   "ENTITY NAME CONT.": "Ray",
   "ENTITY CITY": "Boulder Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC917",
   "ENTITY": "IND",
   "ENTITY NAME": "Babbar",
   "ENTITY NAME CONT.": "Anil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Apartment Association",
   "OCCUPATION": "VP Public Affairs",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4319",
   "ENTITY": "IND",
   "ENTITY NAME": "Babbar",
   "ENTITY NAME CONT.": "Anil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Apartment Association",
   "OCCUPATION": "VP Public Affairs",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2989",
   "ENTITY": "IND",
   "ENTITY NAME": "Bach",
   "ENTITY NAME CONT.": "Lieu",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC884",
   "ENTITY": "IND",
   "ENTITY NAME": "Badagliacco",
   "ENTITY NAME CONT.": "Colleen",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Legacy Real Estate & Associates",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC1329",
   "ENTITY": "IND",
   "ENTITY NAME": "Badagliacco",
   "ENTITY NAME CONT.": "Colleen",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Legacy Real Estate & Associates",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4363",
   "ENTITY": "IND",
   "ENTITY NAME": "Badagliacco",
   "ENTITY NAME CONT.": "Dennis",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Barking Sands Investments Inc",
   "OCCUPATION": "Realtor",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4364",
   "ENTITY": "IND",
   "ENTITY NAME": "Badagliacco",
   "ENTITY NAME CONT.": "Dennis",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Barking Sands Investments Inc",
   "OCCUPATION": "Realtor",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC981",
   "ENTITY": "IND",
   "ENTITY NAME": "Baird",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Velocity",
   "OCCUPATION": "Consultant",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC971",
   "ENTITY": "IND",
   "ENTITY NAME": "Ball",
   "ENTITY NAME CONT.": "John & Paula",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC887",
   "ENTITY": "IND",
   "ENTITY NAME": "Bannister",
   "ENTITY NAME CONT.": "Brad",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker Residential Brokerage",
   "OCCUPATION": "Realtor",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2975",
   "ENTITY": "IND",
   "ENTITY NAME": "Barnett",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel",
   "OCCUPATION": "Realtor",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC911",
   "ENTITY": "IND",
   "ENTITY NAME": "Baron",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mobilehome Communities of America/Brandenburg Properties",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4737",
   "ENTITY": "IND",
   "ENTITY NAME": "Baron",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mobilehome Communities of America/Brandenburg Properties",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC985",
   "ENTITY": "IND",
   "ENTITY NAME": "Barry",
   "ENTITY NAME CONT.": "Geraldine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Real Worth Network",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4392",
   "ENTITY": "IND",
   "ENTITY NAME": "Bates",
   "ENTITY NAME CONT.": "Rob",
   "ENTITY CITY": "Hollister",
   "Entity_ST": "CA",
   "EMPLOYER": "Elite Services 4 Real Estate",
   "OCCUPATION": "Real Estate Consulting & Termite Services",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC869",
   "ENTITY": "IND",
   "ENTITY NAME": "Bell",
   "ENTITY NAME CONT.": "Martin",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 10
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2749",
   "ENTITY": "IND",
   "ENTITY NAME": "Bertolone",
   "ENTITY NAME CONT.": "Michele",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Michele Bertolone",
   "OCCUPATION": "Writer",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC903",
   "ENTITY": "IND",
   "ENTITY NAME": "Biesterveld",
   "ENTITY NAME CONT.": "Robin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4775",
   "ENTITY": "IND",
   "ENTITY NAME": "Biesterveld",
   "ENTITY NAME CONT.": "Robin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC796",
   "ENTITY": "IND",
   "ENTITY NAME": "Blach",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Blach Construction",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC957",
   "ENTITY": "IND",
   "ENTITY NAME": "Bolster",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Osprey Aquatics",
   "OCCUPATION": "Coach",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4284",
   "ENTITY": "IND",
   "ENTITY NAME": "Bolster",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Osprey Aquatics",
   "OCCUPATION": "Coach",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4325",
   "ENTITY": "IND",
   "ENTITY NAME": "Boothe",
   "ENTITY NAME CONT.": "Tim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Western Alliance Bank",
   "OCCUPATION": "Banker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC918",
   "ENTITY": "IND",
   "ENTITY NAME": "Boothe",
   "ENTITY NAME CONT.": "Tim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Western Alliance Bank",
   "OCCUPATION": "Banker",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4304",
   "ENTITY": "IND",
   "ENTITY NAME": "Bowman",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sterling Madison",
   "OCCUPATION": "Process Server",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2706",
   "ENTITY": "IND",
   "ENTITY NAME": "Bozzuto",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bozzuto & Associates",
   "OCCUPATION": "Insurance Broker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3061",
   "ENTITY": "IND",
   "ENTITY NAME": "Bozzuto",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bozzuto & Associates",
   "OCCUPATION": "Insurance Broker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4709",
   "ENTITY": "IND",
   "ENTITY NAME": "Bozzuto",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bozzuto & Associates Insurance Services",
   "OCCUPATION": "Insurance Broker",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC815",
   "ENTITY": "IND",
   "ENTITY NAME": "Brandenburg",
   "ENTITY NAME CONT.": "Lee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg Properties",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC816",
   "ENTITY": "IND",
   "ENTITY NAME": "Brandenburg",
   "ENTITY NAME CONT.": "Diane",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg Properties",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4742",
   "ENTITY": "IND",
   "ENTITY NAME": "Brandenburg",
   "ENTITY NAME CONT.": "Diane",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg Properties",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4342",
   "ENTITY": "IND",
   "ENTITY NAME": "Bray",
   "ENTITY NAME CONT.": "Alida",
   "ENTITY CITY": "Pacifica",
   "Entity_ST": "CA",
   "EMPLOYER": "History San Jose",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4381",
   "ENTITY": "IND",
   "ENTITY NAME": "Brewer",
   "ENTITY NAME CONT.": "Law Offices of Peter",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Offices of Peter Brewer",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC885",
   "ENTITY": "IND",
   "ENTITY NAME": "Britton",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Portland",
   "Entity_ST": "OR",
   "EMPLOYER": "Apple",
   "OCCUPATION": "Software Engineer",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4772",
   "ENTITY": "IND",
   "ENTITY NAME": "Britton",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Portland",
   "Entity_ST": "OR",
   "EMPLOYER": "Apple",
   "OCCUPATION": "Software Engineer",
   "AMOUNT": 400
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC943",
   "ENTITY": "IND",
   "ENTITY NAME": "Brown",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1094",
   "ENTITY": "IND",
   "ENTITY NAME": "Bui",
   "ENTITY NAME CONT.": "Lan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4793",
   "ENTITY": "IND",
   "ENTITY NAME": "Burroughs",
   "ENTITY NAME CONT.": "Joshua",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Green Valley Corp",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1097",
   "ENTITY": "IND",
   "ENTITY NAME": "Bybokas",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zell Associates",
   "OCCUPATION": "Investor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC805",
   "ENTITY": "IND",
   "ENTITY NAME": "Cady",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Platinum Real Estate",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC806",
   "ENTITY": "IND",
   "ENTITY NAME": "Cady",
   "ENTITY NAME CONT.": "Randall",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4729",
   "ENTITY": "IND",
   "ENTITY NAME": "Cady",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Platinum Real Estate",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4730",
   "ENTITY": "IND",
   "ENTITY NAME": "Cady",
   "ENTITY NAME CONT.": "Randall",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC947",
   "ENTITY": "IND",
   "ENTITY NAME": "Campagna",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Snapfi",
   "OCCUPATION": "Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5138",
   "ENTITY": "IND",
   "ENTITY NAME": "Campos",
   "ENTITY NAME CONT.": "Nora",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nora Campos",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4367",
   "ENTITY": "IND",
   "ENTITY NAME": "Cancilla",
   "ENTITY NAME CONT.": "Francesco",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "FCC Realty",
   "OCCUPATION": "Realtor",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2863",
   "ENTITY": "IND",
   "ENTITY NAME": "Caplan",
   "ENTITY NAME CONT.": "Stephen & Cheryl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4301",
   "ENTITY": "IND",
   "ENTITY NAME": "Caplan",
   "ENTITY NAME CONT.": "Stephen & Cheryl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC802",
   "ENTITY": "IND",
   "ENTITY NAME": "Carter",
   "ENTITY NAME CONT.": "Karen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unity Care",
   "OCCUPATION": "Marketing",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC870",
   "ENTITY": "IND",
   "ENTITY NAME": "Cato",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4279",
   "ENTITY": "IND",
   "ENTITY NAME": "Cato",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4390",
   "ENTITY": "IND",
   "ENTITY NAME": "Chemali",
   "ENTITY NAME CONT.": "William & Violette",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kia Dealership",
   "OCCUPATION": "Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4391",
   "ENTITY": "IND",
   "ENTITY NAME": "Chemali",
   "ENTITY NAME CONT.": "Philip",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Betterhelp",
   "OCCUPATION": "Full Stack Developer",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4735",
   "ENTITY": "IND",
   "ENTITY NAME": "Cheng",
   "ENTITY NAME CONT.": "Shiao Ping",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kicolin Realty",
   "OCCUPATION": "Office Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC801",
   "ENTITY": "IND",
   "ENTITY NAME": "Chinchen",
   "ENTITY NAME CONT.": "Stan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4308",
   "ENTITY": "IND",
   "ENTITY NAME": "Chinchen",
   "ENTITY NAME CONT.": "Stan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC948",
   "ENTITY": "IND",
   "ENTITY NAME": "Chiou",
   "ENTITY NAME CONT.": "Sham",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC949",
   "ENTITY": "IND",
   "ENTITY NAME": "Chiou",
   "ENTITY NAME CONT.": "Alice",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4744",
   "ENTITY": "IND",
   "ENTITY NAME": "Chirco",
   "ENTITY NAME CONT.": "Judy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4351",
   "ENTITY": "IND",
   "ENTITY NAME": "Chong",
   "ENTITY NAME CONT.": "Helen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Haylen Group",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2865",
   "ENTITY": "IND",
   "ENTITY NAME": "Christa",
   "ENTITY NAME CONT.": "Patty",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4360",
   "ENTITY": "IND",
   "ENTITY NAME": "Chu",
   "ENTITY NAME CONT.": "Su",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Elite RE Solutions",
   "OCCUPATION": "Accountant",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC968",
   "ENTITY": "IND",
   "ENTITY NAME": "Cilker",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cilker Orchards Management Group",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC942",
   "ENTITY": "IND",
   "ENTITY NAME": "Cole",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel Realtors",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4339",
   "ENTITY": "IND",
   "ENTITY NAME": "Cole",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel Realtors",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4340",
   "ENTITY": "IND",
   "ENTITY NAME": "Cole",
   "ENTITY NAME CONT.": "Gina",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel Realtors",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC800",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "Neil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SCCAOR",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4292",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "Neil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SCCAOR",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "C",
   "ID": "RC3955",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "Wendy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 93
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4993",
   "ENTITY": "IND",
   "ENTITY NAME": "Connolly",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Armed Courier Services",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3868",
   "ENTITY": "IND",
   "ENTITY NAME": "Connolly",
   "ENTITY NAME CONT.": "Shane Patrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose, District 10",
   "OCCUPATION": "Chief of Staff",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4790",
   "ENTITY": "IND",
   "ENTITY NAME": "Connolly",
   "ENTITY NAME CONT.": "Shane Patrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose, District 10",
   "OCCUPATION": "Chief of Staff",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC962",
   "ENTITY": "IND",
   "ENTITY NAME": "Cottle",
   "ENTITY NAME CONT.": "Sean",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Hoge, Fenton, Jones & Appel",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4293",
   "ENTITY": "IND",
   "ENTITY NAME": "Crema",
   "ENTITY NAME CONT.": "Gerry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC874",
   "ENTITY": "IND",
   "ENTITY NAME": "Crema",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Crema Properties",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2978",
   "ENTITY": "IND",
   "ENTITY NAME": "Cristina",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Zanker Resource Management",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4751",
   "ENTITY": "IND",
   "ENTITY NAME": "Cristina",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Greenwaste",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4752",
   "ENTITY": "IND",
   "ENTITY NAME": "Cristina",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Zanker Resource Management",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4749",
   "ENTITY": "IND",
   "ENTITY NAME": "Cristina",
   "ENTITY NAME CONT.": "Barry",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Greenwaste",
   "OCCUPATION": "Human Resources/Special Projects Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4286",
   "ENTITY": "IND",
   "ENTITY NAME": "Crowley",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Better Homes & Gardens Real Estate/Ventura Barnett Properties",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC4104",
   "ENTITY": "IND",
   "ENTITY NAME": "Crowley",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Better Homes & Gardens Real Estate/Ventura Barnett Properties",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC916",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunneen",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies",
   "OCCUPATION": "Partner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4266",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunneen",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies",
   "OCCUPATION": "Partner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2987",
   "ENTITY": "IND",
   "ENTITY NAME": "D'Ambrosio",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5115",
   "ENTITY": "IND",
   "ENTITY NAME": "Daily",
   "ENTITY NAME CONT.": "Dean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2118",
   "ENTITY": "IND",
   "ENTITY NAME": "Dang",
   "ENTITY NAME CONT.": "Allan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Workday, Inc.",
   "OCCUPATION": "IT Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4374",
   "ENTITY": "IND",
   "ENTITY NAME": "Dang",
   "ENTITY NAME CONT.": "Allan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Workday, Inc.",
   "OCCUPATION": "IT Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4282",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "John Davis & Christine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "TMFC, Inc",
   "OCCUPATION": "Owners",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4283",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "John Davis & Christine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "TMFC, Inc",
   "OCCUPATION": "Owners",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3871",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "John Davis & Christine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "TMFC, Inc",
   "OCCUPATION": "Owners",
   "AMOUNT": 350
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3870",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "John Davis & Christine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "TMFC, Inc",
   "OCCUPATION": "Owners",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC945",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "John Davis & Christine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "TMFC, Inc",
   "OCCUPATION": "Owners",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4285",
   "ENTITY": "IND",
   "ENTITY NAME": "Denner",
   "ENTITY NAME CONT.": "Timothy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Taps Termite & Pest Specialists",
   "OCCUPATION": "Termite Operator",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC804",
   "ENTITY": "IND",
   "ENTITY NAME": "Denner",
   "ENTITY NAME CONT.": "Timothy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Taps Termite & Pest Specialists",
   "OCCUPATION": "Termite Operator",
   "AMOUNT": 75
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC882",
   "ENTITY": "IND",
   "ENTITY NAME": "Do",
   "ENTITY NAME CONT.": "Thang",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Aedis Architects",
   "OCCUPATION": "Architect",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC994",
   "ENTITY": "IND",
   "ENTITY NAME": "Doar",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "LinkedIn",
   "OCCUPATION": "Software Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC892",
   "ENTITY": "IND",
   "ENTITY NAME": "Doar",
   "ENTITY NAME CONT.": "Katherine Baginski",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "St. Francis",
   "OCCUPATION": "Priest",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1116",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital Consultants",
   "OCCUPATION": "Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1117",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital Consultants",
   "OCCUPATION": "Vice President",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4306",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital Consultants",
   "OCCUPATION": "Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4307",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital Consultants",
   "OCCUPATION": "Vice President",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4352",
   "ENTITY": "IND",
   "ENTITY NAME": "Du",
   "ENTITY NAME CONT.": "Ming",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ovt.com",
   "OCCUPATION": "Engineer",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4794",
   "ENTITY": "IND",
   "ENTITY NAME": "Du",
   "ENTITY NAME CONT.": "Ming",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ovt.com",
   "OCCUPATION": "Engineer",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4385",
   "ENTITY": "IND",
   "ENTITY NAME": "Earle",
   "ENTITY NAME CONT.": "Ted",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "NetApp",
   "OCCUPATION": "Technology Sales",
   "AMOUNT": 125
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2713",
   "ENTITY": "IND",
   "ENTITY NAME": "Earle",
   "ENTITY NAME CONT.": "Ted & Viktoria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CommonWealth Credit Union",
   "OCCUPATION": "Banker",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "C",
   "ID": "RC3950",
   "ENTITY": "IND",
   "ENTITY NAME": "Earle",
   "ENTITY NAME CONT.": "Ted & Viktoria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CommonWealth Credit Union",
   "OCCUPATION": "Banker",
   "AMOUNT": 26
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4990",
   "ENTITY": "IND",
   "ENTITY NAME": "Eisbach",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Amber Realty",
   "OCCUPATION": "Realtor",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4354",
   "ENTITY": "IND",
   "ENTITY NAME": "Eisbach",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Amber Realty",
   "OCCUPATION": "Realtor",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC959",
   "ENTITY": "IND",
   "ENTITY NAME": "Emami",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "ROEM Development Corp",
   "OCCUPATION": "Builder",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4796",
   "ENTITY": "IND",
   "ENTITY NAME": "Emami",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "ROEM Development Corp.",
   "OCCUPATION": "President/Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2859",
   "ENTITY": "IND",
   "ENTITY NAME": "Enfantino",
   "ENTITY NAME CONT.": "Tracey",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "Environmental Systems, Inc.",
   "OCCUPATION": "General Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3056",
   "ENTITY": "IND",
   "ENTITY NAME": "Escher",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Chris Escher",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4795",
   "ENTITY": "IND",
   "ENTITY NAME": "Escher",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Chris Escher",
   "OCCUPATION": "Consultant",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "RC3947",
   "ENTITY": "IND",
   "ENTITY NAME": "Fagundo",
   "ENTITY NAME CONT.": "Cosme",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Willco Management",
   "OCCUPATION": "Restauranteur",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4726",
   "ENTITY": "IND",
   "ENTITY NAME": "Fagundo",
   "ENTITY NAME CONT.": "Cosme",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Willco Management",
   "OCCUPATION": "Restauranteur",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2866",
   "ENTITY": "IND",
   "ENTITY NAME": "Farace",
   "ENTITY NAME CONT.": "Elaine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2746",
   "ENTITY": "IND",
   "ENTITY NAME": "Faulkner",
   "ENTITY NAME CONT.": "Cindy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Valley Heating",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4384",
   "ENTITY": "IND",
   "ENTITY NAME": "Faulkner",
   "ENTITY NAME CONT.": "Cindy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Valley Heating",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC992",
   "ENTITY": "IND",
   "ENTITY NAME": "Feller",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "Allen",
   "Entity_ST": "TX",
   "EMPLOYER": "Liberty Mutual",
   "OCCUPATION": "Claim Team Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2868",
   "ENTITY": "IND",
   "ENTITY NAME": "Feller",
   "ENTITY NAME CONT.": "Margaret",
   "ENTITY CITY": "Gresham",
   "Entity_ST": "OR",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4294",
   "ENTITY": "IND",
   "ENTITY NAME": "Feller",
   "ENTITY NAME CONT.": "Margaret",
   "ENTITY CITY": "Gresham",
   "Entity_ST": "OR",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2856",
   "ENTITY": "IND",
   "ENTITY NAME": "Feller",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "Portland",
   "Entity_ST": "OR",
   "EMPLOYER": "PCC Structurals",
   "OCCUPATION": "Supervisor",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4368",
   "ENTITY": "IND",
   "ENTITY NAME": "Feng",
   "ENTITY NAME CONT.": "Jun",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SKHMS America",
   "OCCUPATION": "Senior Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC879",
   "ENTITY": "IND",
   "ENTITY NAME": "Fenton",
   "ENTITY NAME CONT.": "Liesa",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenberg Properties",
   "OCCUPATION": "Executive Project Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1100",
   "ENTITY": "IND",
   "ENTITY NAME": "Fitzgerald",
   "ENTITY NAME CONT.": "Peggy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Peggy Fitzgerald",
   "OCCUPATION": "Landlord",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1101",
   "ENTITY": "IND",
   "ENTITY NAME": "Fitzgerald",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Michael Fitzgerald",
   "OCCUPATION": "Landlord",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "B1",
   "ID": "LN17",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Pam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Owner/President",
   "AMOUNT": 18000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/9/2019",
   "FORM": "A",
   "ID": "LP407",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Pam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Owner/President",
   "AMOUNT": 8471
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1721",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Katelin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "B1",
   "ID": "LN1",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Pam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Owner/President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "B1",
   "ID": "LN16",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Pam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Owner/President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/9/2019",
   "FORM": "A",
   "ID": "LP408",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Pam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Owner/President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/9/2019",
   "FORM": "A",
   "ID": "LP409",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Pam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Owner/President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC813",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX1822",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Pam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 450
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1311",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Katelin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 30
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4338",
   "ENTITY": "IND",
   "ENTITY NAME": "Foley",
   "ENTITY NAME CONT.": "Katelin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4779",
   "ENTITY": "IND",
   "ENTITY NAME": "Folzman",
   "ENTITY NAME CONT.": "Claudia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Iron Construction",
   "OCCUPATION": "Contractor",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2816",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2817",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Mary Ellen",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4299",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4736",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "GWSV",
   "OCCUPATION": "Executive",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC937",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "GWSV",
   "OCCUPATION": "Executive",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3052",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "GWSV",
   "OCCUPATION": "Executive",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC871",
   "ENTITY": "IND",
   "ENTITY NAME": "Gackstetter",
   "ENTITY NAME CONT.": "Edwin",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Edwin Gackstetter",
   "OCCUPATION": "Self employed",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC886",
   "ENTITY": "IND",
   "ENTITY NAME": "Gedryn",
   "ENTITY NAME CONT.": "Melinda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker Residential Brokerage",
   "OCCUPATION": "Realtor",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC1087",
   "ENTITY": "IND",
   "ENTITY NAME": "Gernreich",
   "ENTITY NAME CONT.": "Oreen",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC877",
   "ENTITY": "IND",
   "ENTITY NAME": "Giacalone",
   "ENTITY NAME CONT.": "Vic",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Best Electrical",
   "OCCUPATION": "Contractor",
   "AMOUNT": 125
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2907",
   "ENTITY": "IND",
   "ENTITY NAME": "Giacalone",
   "ENTITY NAME CONT.": "Vic",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Best Electrical",
   "OCCUPATION": "Contractor",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC811",
   "ENTITY": "IND",
   "ENTITY NAME": "Giannini",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Miller & Giannini",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4281",
   "ENTITY": "IND",
   "ENTITY NAME": "Giannini",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Miller & Giannini",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2711",
   "ENTITY": "IND",
   "ENTITY NAME": "Gifford",
   "ENTITY NAME CONT.": "Duane E & Marilyn L",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Duane E & Marilyn L Gifford",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4365",
   "ENTITY": "IND",
   "ENTITY NAME": "Gifford",
   "ENTITY NAME CONT.": "Duane",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Duane E & Marilyn L Gifford",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC878",
   "ENTITY": "IND",
   "ENTITY NAME": "Ginsborg",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Deputy Assessor",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4295",
   "ENTITY": "IND",
   "ENTITY NAME": "Ginsborg",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Deputy Assessor",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC978",
   "ENTITY": "IND",
   "ENTITY NAME": "Gladstone",
   "ENTITY NAME CONT.": "Joshua",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Palo Alto Networks",
   "OCCUPATION": "Sales Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC979",
   "ENTITY": "IND",
   "ENTITY NAME": "Gladstone",
   "ENTITY NAME CONT.": "Trista",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Unified School District",
   "OCCUPATION": "Campus Supervisor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4991",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Armando",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Armando Gomez Consulting",
   "OCCUPATION": "Principal",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4313",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzalez",
   "ENTITY NAME CONT.": "Gustavo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Valley View Properties",
   "OCCUPATION": "Broker/Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2710",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzalez",
   "ENTITY NAME CONT.": "Alfred",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4372",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzalez",
   "ENTITY NAME CONT.": "Andres",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Andres Gonzalez",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4776",
   "ENTITY": "IND",
   "ENTITY NAME": "Gordon",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Gordon Biersch Brewing Company",
   "OCCUPATION": "Brewery Management",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1114",
   "ENTITY": "IND",
   "ENTITY NAME": "Goreniuc",
   "ENTITY NAME CONT.": "Mircea C. Paul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC940",
   "ENTITY": "IND",
   "ENTITY NAME": "Gorman",
   "ENTITY NAME CONT.": "Craig",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate",
   "OCCUPATION": "Realtor",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3059",
   "ENTITY": "IND",
   "ENTITY NAME": "Gorman",
   "ENTITY NAME CONT.": "Craig",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate",
   "OCCUPATION": "Realtor",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4300",
   "ENTITY": "IND",
   "ENTITY NAME": "Gorman",
   "ENTITY NAME CONT.": "Craig",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate",
   "OCCUPATION": "Realtor",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC888",
   "ENTITY": "IND",
   "ENTITY NAME": "Goss",
   "ENTITY NAME CONT.": "Douglas",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "KW Bay Area Estates",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4347",
   "ENTITY": "IND",
   "ENTITY NAME": "Goss",
   "ENTITY NAME CONT.": "Douglas",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "KW Bay Area Estates",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC812",
   "ENTITY": "IND",
   "ENTITY NAME": "Greer",
   "ENTITY NAME CONT.": "Jerry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Mortgage Outlet",
   "OCCUPATION": "Mortgage Broker",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2862",
   "ENTITY": "IND",
   "ENTITY NAME": "Grilli",
   "ENTITY NAME CONT.": "Guido",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 80
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4747",
   "ENTITY": "IND",
   "ENTITY NAME": "Gross",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zanker Recycling",
   "OCCUPATION": "Director of Sustainability",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4370",
   "ENTITY": "IND",
   "ENTITY NAME": "Gu",
   "ENTITY NAME CONT.": "Wilma",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 20
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3098",
   "ENTITY": "IND",
   "ENTITY NAME": "Guardino",
   "ENTITY NAME CONT.": "Leslee",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "Canyon Snow Consulting LLC",
   "OCCUPATION": "Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC899",
   "ENTITY": "IND",
   "ENTITY NAME": "Guptill",
   "ENTITY NAME CONT.": "Kimberley",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kim Guptill",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4359",
   "ENTITY": "IND",
   "ENTITY NAME": "Ha",
   "ENTITY NAME CONT.": "Audrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC900",
   "ENTITY": "IND",
   "ENTITY NAME": "Haas",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Real Estate Investment Counsel",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4335",
   "ENTITY": "IND",
   "ENTITY NAME": "Haas",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Real Estate Investment Counsel",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC793",
   "ENTITY": "IND",
   "ENTITY NAME": "Hanleigh",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Stephen Hanleigh",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC807",
   "ENTITY": "IND",
   "ENTITY NAME": "Hanleigh",
   "ENTITY NAME CONT.": "Valeri",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Chicago Title",
   "OCCUPATION": "Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4264",
   "ENTITY": "IND",
   "ENTITY NAME": "Hanleigh",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Stephen Hanleigh",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4265",
   "ENTITY": "IND",
   "ENTITY NAME": "Hanleigh",
   "ENTITY NAME CONT.": "Valeri",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Chicago Title",
   "OCCUPATION": "Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC872",
   "ENTITY": "IND",
   "ENTITY NAME": "Hansen",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Anne Hansen Properties",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4362",
   "ENTITY": "IND",
   "ENTITY NAME": "Hansen",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Anne Hansen Properties",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3883",
   "ENTITY": "IND",
   "ENTITY NAME": "Hansen",
   "ENTITY NAME CONT.": "Tom & Kris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC966",
   "ENTITY": "IND",
   "ENTITY NAME": "Hawkins",
   "ENTITY NAME CONT.": "Melonee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Badabean Inc.",
   "OCCUPATION": "CPA",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC969",
   "ENTITY": "IND",
   "ENTITY NAME": "Head",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Summerhill Homes",
   "OCCUPATION": "Home Builder",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC990",
   "ENTITY": "IND",
   "ENTITY NAME": "Henderson",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Samaritan Medical Center",
   "OCCUPATION": "Medical Real Estate",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4303",
   "ENTITY": "IND",
   "ENTITY NAME": "Hennessy",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Car Guy Channel",
   "OCCUPATION": "Producer",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1093",
   "ENTITY": "IND",
   "ENTITY NAME": "Hennessy",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Car Guy Channel",
   "OCCUPATION": "Producer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5132",
   "ENTITY": "IND",
   "ENTITY NAME": "Higgins",
   "ENTITY NAME CONT.": "Shawn",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC896",
   "ENTITY": "IND",
   "ENTITY NAME": "Hoffman",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "Hoge, Fenton, Jones & Appel",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC974",
   "ENTITY": "IND",
   "ENTITY NAME": "Hoffman",
   "ENTITY NAME CONT.": "Lenore",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4329",
   "ENTITY": "IND",
   "ENTITY NAME": "Hoffman",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "Hoge, Fenton, Jones & Appel",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4330",
   "ENTITY": "IND",
   "ENTITY NAME": "Hoffman",
   "ENTITY NAME CONT.": "Lenore",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4379",
   "ENTITY": "IND",
   "ENTITY NAME": "Hu",
   "ENTITY NAME CONT.": "Qi",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "LinkedIn",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1115",
   "ENTITY": "IND",
   "ENTITY NAME": "Huang",
   "ENTITY NAME CONT.": "ShuChun",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC984",
   "ENTITY": "IND",
   "ENTITY NAME": "Huff",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Capital Properties",
   "OCCUPATION": "RE Broker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC893",
   "ENTITY": "IND",
   "ENTITY NAME": "Hulberg",
   "ENTITY NAME CONT.": "Norm",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hulberg & Assoc",
   "OCCUPATION": "Appraiser",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4344",
   "ENTITY": "IND",
   "ENTITY NAME": "Hulberg",
   "ENTITY NAME CONT.": "Norm",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hulberg & Assoc",
   "OCCUPATION": "Appraiser",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4341",
   "ENTITY": "IND",
   "ENTITY NAME": "Hunt",
   "ENTITY NAME CONT.": "Gene",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley House Hunt",
   "OCCUPATION": "Owner",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC941",
   "ENTITY": "IND",
   "ENTITY NAME": "Hunt",
   "ENTITY NAME CONT.": "Gene",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley House Hunt",
   "OCCUPATION": "Owner",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4738",
   "ENTITY": "IND",
   "ENTITY NAME": "Iglesias",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4386",
   "ENTITY": "IND",
   "ENTITY NAME": "Issel",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "Foster City",
   "Entity_ST": "CA",
   "EMPLOYER": "AutoCamp",
   "OCCUPATION": "Senior VP Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4412",
   "ENTITY": "IND",
   "ENTITY NAME": "Jamison",
   "ENTITY NAME CONT.": "Sandy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Tuscana Properties",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC983",
   "ENTITY": "IND",
   "ENTITY NAME": "Jamison",
   "ENTITY NAME CONT.": "Sandy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Tuscana Properties",
   "OCCUPATION": "Realtor",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC1042",
   "ENTITY": "IND",
   "ENTITY NAME": "Jamison",
   "ENTITY NAME CONT.": "Sandy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Tuscana Properties",
   "OCCUPATION": "Realtor",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2707",
   "ENTITY": "IND",
   "ENTITY NAME": "Jessup",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CSR",
   "OCCUPATION": "Sales",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1092",
   "ENTITY": "IND",
   "ENTITY NAME": "Jewett",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC915",
   "ENTITY": "IND",
   "ENTITY NAME": "Jones",
   "ENTITY NAME CONT.": "Korina",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Executive Assistant",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3857",
   "ENTITY": "IND",
   "ENTITY NAME": "Kahn",
   "ENTITY NAME CONT.": "Marsey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "C",
   "ID": "RC3949",
   "ENTITY": "IND",
   "ENTITY NAME": "Kahn",
   "ENTITY NAME CONT.": "Marsey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 31
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4318",
   "ENTITY": "IND",
   "ENTITY NAME": "Kali-Rai",
   "ENTITY NAME CONT.": "Miriam",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Jackson and Main LLC",
   "OCCUPATION": "Research Analyst",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC977",
   "ENTITY": "IND",
   "ENTITY NAME": "Kalirai",
   "ENTITY NAME CONT.": "Sharanjit",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Jackson and Main, LLC",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4317",
   "ENTITY": "IND",
   "ENTITY NAME": "Kalirai",
   "ENTITY NAME CONT.": "Sharanjit",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Jackson and Main, LLC",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC868",
   "ENTITY": "IND",
   "ENTITY NAME": "Kane",
   "ENTITY NAME CONT.": "Teri",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Teri Ravel Kane Landscape Architect",
   "OCCUPATION": "Landscape Architect",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4280",
   "ENTITY": "IND",
   "ENTITY NAME": "Kane",
   "ENTITY NAME CONT.": "Teri",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Teri Ravel Kane Landscape Architect",
   "OCCUPATION": "Landscape Architect",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2701",
   "ENTITY": "IND",
   "ENTITY NAME": "Kanter",
   "ENTITY NAME CONT.": "Paul & Salese",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2702",
   "ENTITY": "IND",
   "ENTITY NAME": "Kehriotis",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "JMK Investments",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC891",
   "ENTITY": "IND",
   "ENTITY NAME": "Kennett",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rotary Club of San Jose",
   "OCCUPATION": "Non-Profit Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4278",
   "ENTITY": "IND",
   "ENTITY NAME": "Kennett",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rotary Club of San Jose",
   "OCCUPATION": "Non-Profit Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC913",
   "ENTITY": "IND",
   "ENTITY NAME": "Kennett",
   "ENTITY NAME CONT.": "Alex",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Real Estate Solutions",
   "OCCUPATION": "Realtor",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC809",
   "ENTITY": "IND",
   "ENTITY NAME": "Kieve",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Empire Broadcasting",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4989",
   "ENTITY": "IND",
   "ENTITY NAME": "Kieve",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Empire Broadcasting",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4746",
   "ENTITY": "IND",
   "ENTITY NAME": "Kline",
   "ENTITY NAME CONT.": "Norman",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "LibraryWorld, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2976",
   "ENTITY": "IND",
   "ENTITY NAME": "Kline",
   "ENTITY NAME CONT.": "Norman",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "LibraryWorld, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2867",
   "ENTITY": "IND",
   "ENTITY NAME": "Knies",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Association",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC982",
   "ENTITY": "IND",
   "ENTITY NAME": "Kovaleski",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Commercial Real Estate Broker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4791",
   "ENTITY": "IND",
   "ENTITY NAME": "Kremen",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Dogpatch",
   "OCCUPATION": "Engineer",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4799",
   "ENTITY": "IND",
   "ENTITY NAME": "Krouskup",
   "ENTITY NAME CONT.": "Brad & Dana",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Toeniskoetter Development, Inc.",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4345",
   "ENTITY": "IND",
   "ENTITY NAME": "Kulick",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5188",
   "ENTITY": "IND",
   "ENTITY NAME": "Kupper",
   "ENTITY NAME CONT.": "Brad",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Case Design and Remodeling",
   "OCCUPATION": "Construction",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3567",
   "ENTITY": "IND",
   "ENTITY NAME": "Lau",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "John Lau",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 20
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5131",
   "ENTITY": "IND",
   "ENTITY NAME": "Lau",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "John Lau",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 20
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4288",
   "ENTITY": "IND",
   "ENTITY NAME": "Lau",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "John Lau",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 15
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4366",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "Karl",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Realty World Results Pros",
   "OCCUPATION": "Realtor",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC938",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "Karl",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Realty World Results Pros",
   "OCCUPATION": "Realtor",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC956",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC5191",
   "ENTITY": "IND",
   "ENTITY NAME": "Leets",
   "ENTITY NAME CONT.": "Tim",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "BBSI, Inc",
   "OCCUPATION": "Consultant",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2708",
   "ENTITY": "IND",
   "ENTITY NAME": "Lerner",
   "ENTITY NAME CONT.": "Heather",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Boy Scouts Silicon Valley Monterey Bay",
   "OCCUPATION": "Development Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4356",
   "ENTITY": "IND",
   "ENTITY NAME": "Li",
   "ENTITY NAME CONT.": "Xiaodong",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Xiaodong Li",
   "OCCUPATION": "Independent Employee",
   "AMOUNT": 20
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1312",
   "ENTITY": "IND",
   "ENTITY NAME": "Lin",
   "ENTITY NAME CONT.": "Kico",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kicolin Realty",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC946",
   "ENTITY": "IND",
   "ENTITY NAME": "Lin",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mike Lin",
   "OCCUPATION": "Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4728",
   "ENTITY": "IND",
   "ENTITY NAME": "Lin",
   "ENTITY NAME CONT.": "Kico",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kicolin Realty",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "RC4165",
   "ENTITY": "IND",
   "ENTITY NAME": "Liu",
   "ENTITY NAME CONT.": "Etienne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Infoblox",
   "OCCUPATION": "Internet Architect",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC993",
   "ENTITY": "IND",
   "ENTITY NAME": "Liu",
   "ENTITY NAME CONT.": "S. Paige",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rochelle Duskato Design",
   "OCCUPATION": "Interior Designer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3049",
   "ENTITY": "IND",
   "ENTITY NAME": "Lopes",
   "ENTITY NAME CONT.": "Alice",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3050",
   "ENTITY": "IND",
   "ENTITY NAME": "Lopes",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "WSO",
   "OCCUPATION": "Oil Sales",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3891",
   "ENTITY": "IND",
   "ENTITY NAME": "Lucero",
   "ENTITY NAME CONT.": "Matt",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Viktoriya's Medical Supplies, LLC",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX1165",
   "ENTITY": "IND",
   "ENTITY NAME": "Lucero",
   "ENTITY NAME CONT.": "Matt",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4387",
   "ENTITY": "IND",
   "ENTITY NAME": "Lucero",
   "ENTITY NAME CONT.": "Matt",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Viktoriya's Medical Supplies, LLC",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4375",
   "ENTITY": "IND",
   "ENTITY NAME": "Lui",
   "ENTITY NAME CONT.": "Shu",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "South Bay Industry, LLC",
   "OCCUPATION": "Housing Provider",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC901",
   "ENTITY": "IND",
   "ENTITY NAME": "Lymberis",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2745",
   "ENTITY": "IND",
   "ENTITY NAME": "Lymberis",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "Livermore",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3062",
   "ENTITY": "IND",
   "ENTITY NAME": "Lymberis",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "Livermore",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4353",
   "ENTITY": "IND",
   "ENTITY NAME": "Lymberis",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "Livermore",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4784",
   "ENTITY": "IND",
   "ENTITY NAME": "Mahood",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "The Silicon Valley Organization",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC789",
   "ENTITY": "IND",
   "ENTITY NAME": "Martz",
   "ENTITY NAME CONT.": "Anna",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC790",
   "ENTITY": "IND",
   "ENTITY NAME": "Martz",
   "ENTITY NAME CONT.": "Kenneth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4754",
   "ENTITY": "IND",
   "ENTITY NAME": "Martz",
   "ENTITY NAME CONT.": "Kenneth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4755",
   "ENTITY": "IND",
   "ENTITY NAME": "Martz",
   "ENTITY NAME CONT.": "Anna",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2709",
   "ENTITY": "IND",
   "ENTITY NAME": "Matusich",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "Pleasanton",
   "Entity_ST": "CA",
   "EMPLOYER": "Richard Matusich & Assoc Inc",
   "OCCUPATION": "Realtor",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4287",
   "ENTITY": "IND",
   "ENTITY NAME": "Matusich",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "Pleasanton",
   "Entity_ST": "CA",
   "EMPLOYER": "Richard Matusich & Assoc Inc",
   "OCCUPATION": "Realtor",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC967",
   "ENTITY": "IND",
   "ENTITY NAME": "Meheula",
   "ENTITY NAME CONT.": "Cheryl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Foley Mortgage",
   "OCCUPATION": "Loan Officer",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC810",
   "ENTITY": "IND",
   "ENTITY NAME": "Meheula",
   "ENTITY NAME CONT.": "Lyn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Google",
   "OCCUPATION": "Recruiter",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC986",
   "ENTITY": "IND",
   "ENTITY NAME": "Meyer",
   "ENTITY NAME CONT.": "Terry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CSR Real Estate Services",
   "OCCUPATION": "RE Broker",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2705",
   "ENTITY": "IND",
   "ENTITY NAME": "Micheletti",
   "ENTITY NAME CONT.": "Matt",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Micheletti Insurance Services",
   "OCCUPATION": "Insurance Broker",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4326",
   "ENTITY": "IND",
   "ENTITY NAME": "Miguel",
   "ENTITY NAME CONT.": "Carl San",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Highland Properties",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC895",
   "ENTITY": "IND",
   "ENTITY NAME": "Miguel",
   "ENTITY NAME CONT.": "Carl San",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Highland Properties",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4333",
   "ENTITY": "IND",
   "ENTITY NAME": "Mirenda",
   "ENTITY NAME CONT.": "Anthony",
   "ENTITY CITY": "Hayward",
   "Entity_ST": "CA",
   "EMPLOYER": "Blach Construction Company",
   "OCCUPATION": "Construction Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC795",
   "ENTITY": "IND",
   "ENTITY NAME": "Monley",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel Realtors",
   "OCCUPATION": "Realtor",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC814",
   "ENTITY": "IND",
   "ENTITY NAME": "Moore",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg, Staedler & Moore",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4780",
   "ENTITY": "IND",
   "ENTITY NAME": "Moore",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg, Staedler & Moore",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC866",
   "ENTITY": "IND",
   "ENTITY NAME": "Moreles",
   "ENTITY NAME CONT.": "Jess",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Whole Foods",
   "OCCUPATION": "Asst. Store Team Lead",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC910",
   "ENTITY": "IND",
   "ENTITY NAME": "Moreno",
   "ENTITY NAME CONT.": "Ernesto",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Moreno & Associates",
   "OCCUPATION": "Building Maintenance",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3568",
   "ENTITY": "IND",
   "ENTITY NAME": "Mulcahy",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SDS NexGen Partners LP",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4350",
   "ENTITY": "IND",
   "ENTITY NAME": "Mulcahy",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SDS NexGen Partners LP",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3055",
   "ENTITY": "IND",
   "ENTITY NAME": "Myrick",
   "ENTITY NAME CONT.": "Jim & Denise",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Keller Williams",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC5193",
   "ENTITY": "IND",
   "ENTITY NAME": "Naboulsi",
   "ENTITY NAME CONT.": "Hassan",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "SiliconSage Builders",
   "OCCUPATION": "Technology Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC5202",
   "ENTITY": "IND",
   "ENTITY NAME": "Naboulsi",
   "ENTITY NAME CONT.": "Marwan",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "Dell Technologies",
   "OCCUPATION": "Engineering Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC5203",
   "ENTITY": "IND",
   "ENTITY NAME": "Naboulsi",
   "ENTITY NAME CONT.": "Rana",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "VIAVI Solutions",
   "OCCUPATION": "Accountant",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5000",
   "ENTITY": "IND",
   "ENTITY NAME": "Neale",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Core Companies",
   "OCCUPATION": "Executive Vice President",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3869",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngin",
   "ENTITY NAME CONT.": "Charmaine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC912",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Tung",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Movoto Real Estate",
   "OCCUPATION": "Broker",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC987",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Madison",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hunger at Home",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC963",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Jimmy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Offices of Jimmy Nguyen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC5201",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "Desmond",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "Hard Rock Concrete, Inc.",
   "OCCUPATION": "Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC991",
   "ENTITY": "IND",
   "ENTITY NAME": "Nunez",
   "ENTITY NAME CONT.": "Bob",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC988",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Kane",
   "ENTITY NAME CONT.": "Sean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Big Kahuna Productions",
   "OCCUPATION": "Marketing Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2761",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Mahony",
   "ENTITY NAME CONT.": "Carol",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara University",
   "OCCUPATION": "Educational Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC989",
   "ENTITY": "IND",
   "ENTITY NAME": "ONeill",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Evergreen School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4745",
   "ENTITY": "IND",
   "ENTITY NAME": "Orloff",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Hollister",
   "Entity_ST": "CA",
   "EMPLOYER": "Orloff Marketing",
   "OCCUPATION": "Marketing",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2766",
   "ENTITY": "IND",
   "ENTITY NAME": "Paine",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Paine Financial & Insurance Services, Inc.",
   "OCCUPATION": "Financial Services",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4348",
   "ENTITY": "IND",
   "ENTITY NAME": "Pan",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1091",
   "ENTITY": "IND",
   "ENTITY NAME": "Park",
   "ENTITY NAME CONT.": "Stewart & Sandra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3063",
   "ENTITY": "IND",
   "ENTITY NAME": "Parkinson",
   "ENTITY NAME CONT.": "Marc",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Petrinovich Pugh & Co",
   "OCCUPATION": "CPA",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4753",
   "ENTITY": "IND",
   "ENTITY NAME": "Pena",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zero Waste Energy",
   "OCCUPATION": "Operations Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC1086",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralta",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4245",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralta",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4732",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralta",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC898",
   "ENTITY": "IND",
   "ENTITY NAME": "Perez",
   "ENTITY NAME CONT.": "Gabrielle",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "First Statewide Realty",
   "OCCUPATION": "Senior Property Manager",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC951",
   "ENTITY": "IND",
   "ENTITY NAME": "Peter",
   "ENTITY NAME CONT.": "Louise",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mojo Networks",
   "OCCUPATION": "Marketing",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3097",
   "ENTITY": "IND",
   "ENTITY NAME": "Pham",
   "ENTITY NAME CONT.": "Rachel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4994",
   "ENTITY": "IND",
   "ENTITY NAME": "Pirayou",
   "ENTITY NAME CONT.": "Ashurbel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rutan & Tucker, LLP",
   "OCCUPATION": "Partner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC881",
   "ENTITY": "IND",
   "ENTITY NAME": "Poyner",
   "ENTITY NAME CONT.": "Jessica",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Poyner & Poyner LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5111",
   "ENTITY": "IND",
   "ENTITY NAME": "Pries",
   "ENTITY NAME CONT.": "Terry",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Terry Pries",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 550
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5112",
   "ENTITY": "IND",
   "ENTITY NAME": "Pries",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "George Pries",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 550
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5113",
   "ENTITY": "IND",
   "ENTITY NAME": "Pries",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Maria Pries",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 550
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5114",
   "ENTITY": "IND",
   "ENTITY NAME": "Pries",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Paul Pries",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 550
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5136",
   "ENTITY": "IND",
   "ENTITY NAME": "Prouty",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mechanics Bank",
   "OCCUPATION": "Commercial Banking",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2873",
   "ENTITY": "IND",
   "ENTITY NAME": "Quilici",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Quilici Engineers",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4361",
   "ENTITY": "IND",
   "ENTITY NAME": "Quilici",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Quilici Engineers",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4783",
   "ENTITY": "IND",
   "ENTITY NAME": "Raffanti",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "House Center Realty Inc",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4380",
   "ENTITY": "IND",
   "ENTITY NAME": "Reed",
   "ENTITY NAME CONT.": "Chuck",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Lawyer",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC797",
   "ENTITY": "IND",
   "ENTITY NAME": "Reed",
   "ENTITY NAME CONT.": "Chuck",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Lawyer",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4782",
   "ENTITY": "IND",
   "ENTITY NAME": "Reilly",
   "ENTITY NAME CONT.": "Terry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4743",
   "ENTITY": "IND",
   "ENTITY NAME": "Ribble",
   "ENTITY NAME CONT.": "Bill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "C",
   "ID": "RC3954",
   "ENTITY": "IND",
   "ENTITY NAME": "Ribble",
   "ENTITY NAME CONT.": "Bill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 99
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC867",
   "ENTITY": "IND",
   "ENTITY NAME": "Rix",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Diocese",
   "OCCUPATION": "Teacher",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC909",
   "ENTITY": "IND",
   "ENTITY NAME": "Roberts",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "PGR Solutions, LLC",
   "OCCUPATION": "Investment Advisor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC914",
   "ENTITY": "IND",
   "ENTITY NAME": "Rocha",
   "ENTITY NAME CONT.": "Vincent",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County Association of Realtors",
   "OCCUPATION": "Government Affairs Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4291",
   "ENTITY": "IND",
   "ENTITY NAME": "Rocha",
   "ENTITY NAME CONT.": "Vincent",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Vincent Rocha",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC883",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Leslie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies and Advocacy, LLC",
   "OCCUPATION": "Lobbyist",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX316",
   "ENTITY": "IND",
   "ENTITY NAME": "Rosenthal",
   "ENTITY NAME CONT.": "Jay",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2310
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC965",
   "ENTITY": "IND",
   "ENTITY NAME": "Ross",
   "ENTITY NAME CONT.": "Jay",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4337",
   "ENTITY": "IND",
   "ENTITY NAME": "Ross",
   "ENTITY NAME CONT.": "Jay",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5002",
   "ENTITY": "IND",
   "ENTITY NAME": "Rossi",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Aantex",
   "OCCUPATION": "Pest Control",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4247",
   "ENTITY": "IND",
   "ENTITY NAME": "Rossi",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Aantex",
   "OCCUPATION": "Pest Control",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "EX1404",
   "ENTITY": "IND",
   "ENTITY NAME": "Rossi",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC980",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Viavi Solutions",
   "OCCUPATION": "Head of Legal Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2828",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Viavi Solutions",
   "OCCUPATION": "Head of Legal Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4773",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Viavi Solutions",
   "OCCUPATION": "Head of Legal Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4377",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Viavi Solutions",
   "OCCUPATION": "Head of Legal Operations",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4268",
   "ENTITY": "IND",
   "ENTITY NAME": "Rousseau",
   "ENTITY NAME CONT.": "Kenneth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kenneth Rousseau",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2860",
   "ENTITY": "IND",
   "ENTITY NAME": "Rousseau",
   "ENTITY NAME CONT.": "Kenneth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kenneth Rousseau",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4343",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruiz",
   "ENTITY NAME CONT.": "Sal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sal Ruiz",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC889",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruvalcaba",
   "ENTITY NAME CONT.": "Emily",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bridge Bank",
   "OCCUPATION": "Banker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4748",
   "ENTITY": "IND",
   "ENTITY NAME": "Ryan",
   "ENTITY NAME CONT.": "Gregory",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Zanker Recycling",
   "OCCUPATION": "General Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC897",
   "ENTITY": "IND",
   "ENTITY NAME": "Salas",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salas O'Brien LLC",
   "OCCUPATION": "Engineer",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC975",
   "ENTITY": "IND",
   "ENTITY NAME": "Salas",
   "ENTITY NAME CONT.": "Marianne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salas O'Brien LLC",
   "OCCUPATION": "Property Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4331",
   "ENTITY": "IND",
   "ENTITY NAME": "Salas",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salas O'Brien LLC",
   "OCCUPATION": "Engineer",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4332",
   "ENTITY": "IND",
   "ENTITY NAME": "Salas",
   "ENTITY NAME CONT.": "Marianne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salas O'Brien LLC",
   "OCCUPATION": "Property Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC803",
   "ENTITY": "IND",
   "ENTITY NAME": "Salata",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "Capitola",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Construction",
   "OCCUPATION": "Owner",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3051",
   "ENTITY": "IND",
   "ENTITY NAME": "Salata",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "Capitola",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Construction",
   "OCCUPATION": "Owner",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4731",
   "ENTITY": "IND",
   "ENTITY NAME": "San Miguel",
   "ENTITY NAME CONT.": "Sally",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1109",
   "ENTITY": "IND",
   "ENTITY NAME": "Sandretto",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4289",
   "ENTITY": "IND",
   "ENTITY NAME": "Sandretto",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4290",
   "ENTITY": "IND",
   "ENTITY NAME": "Sausedo",
   "ENTITY NAME CONT.": "Pat",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Pat Sausedo",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2864",
   "ENTITY": "IND",
   "ENTITY NAME": "Sausedo",
   "ENTITY NAME CONT.": "Pat",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Pat Sausedo",
   "OCCUPATION": "Consultant",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4741",
   "ENTITY": "IND",
   "ENTITY NAME": "Scharf",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "USAD - DOJ",
   "OCCUPATION": "AUSA",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5133",
   "ENTITY": "IND",
   "ENTITY NAME": "Schmidt",
   "ENTITY NAME CONT.": "Donna",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1099",
   "ENTITY": "IND",
   "ENTITY NAME": "Schneebeli",
   "ENTITY NAME CONT.": "Kent",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kent Schneeball",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3057",
   "ENTITY": "IND",
   "ENTITY NAME": "Schneider",
   "ENTITY NAME CONT.": "Janis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "R & J Jewelry and Loan",
   "OCCUPATION": "Pawnbroker",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4786",
   "ENTITY": "IND",
   "ENTITY NAME": "Schneider",
   "ENTITY NAME CONT.": "Janis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "R & J Jewelry and Loan",
   "OCCUPATION": "Pawnbroker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC970",
   "ENTITY": "IND",
   "ENTITY NAME": "Schoennauer",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Schoennauer Company",
   "OCCUPATION": "Planning Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC4997",
   "ENTITY": "IND",
   "ENTITY NAME": "Schoennauer",
   "ENTITY NAME CONT.": "Erik",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Schoennauer Company",
   "OCCUPATION": "Land Use Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC1314",
   "ENTITY": "IND",
   "ENTITY NAME": "Schroeder",
   "ENTITY NAME CONT.": "Catharyn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SJUSD",
   "OCCUPATION": "Teacher",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC791",
   "ENTITY": "IND",
   "ENTITY NAME": "Schumb",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Offices of Chris Schumb",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC792",
   "ENTITY": "IND",
   "ENTITY NAME": "Schumb",
   "ENTITY NAME CONT.": "Jill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brocade",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3888",
   "ENTITY": "IND",
   "ENTITY NAME": "Sciaky",
   "ENTITY NAME CONT.": "Enrico",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intrepid Security Solutions",
   "OCCUPATION": "CEO",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4369",
   "ENTITY": "IND",
   "ENTITY NAME": "Shao",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "Los Altos Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1110",
   "ENTITY": "IND",
   "ENTITY NAME": "Shao",
   "ENTITY NAME CONT.": "Becky",
   "ENTITY CITY": "Los Altos Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 75
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1111",
   "ENTITY": "IND",
   "ENTITY NAME": "Shao",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "Los Altos Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 75
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4358",
   "ENTITY": "IND",
   "ENTITY NAME": "Shao",
   "ENTITY NAME CONT.": "Baohong",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4756",
   "ENTITY": "IND",
   "ENTITY NAME": "Shara",
   "ENTITY NAME CONT.": "Kay",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC799",
   "ENTITY": "IND",
   "ENTITY NAME": "Shara",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Offices of Gary T. Shara",
   "OCCUPATION": "Attorney",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC875",
   "ENTITY": "IND",
   "ENTITY NAME": "Shelby",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4327",
   "ENTITY": "IND",
   "ENTITY NAME": "Sibilia",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Keller Williams Realty-Silicon Valley",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC902",
   "ENTITY": "IND",
   "ENTITY NAME": "Sibilia",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Keller Williams Realty-Silicon Valley",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC873",
   "ENTITY": "IND",
   "ENTITY NAME": "Silva",
   "ENTITY NAME CONT.": "Larry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Yellow Checker Cab",
   "OCCUPATION": "GM",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4797",
   "ENTITY": "IND",
   "ENTITY NAME": "Silva",
   "ENTITY NAME CONT.": "Larry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Yellow Checker Cab",
   "OCCUPATION": "GM",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4760",
   "ENTITY": "IND",
   "ENTITY NAME": "Skyba",
   "ENTITY NAME CONT.": "Jakub",
   "ENTITY CITY": "Half Moon Bay",
   "Entity_ST": "CA",
   "EMPLOYER": "Leftlane Creative",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2751",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Jacqueline",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2752",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4336",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Rick",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Windermere & RCS Property Management, Inc.",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4296",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4297",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Jacqueline",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1098",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Irene",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Irene Smith",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1313",
   "ENTITY": "IND",
   "ENTITY NAME": "Soukoulis",
   "ENTITY NAME CONT.": "Robin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC972",
   "ENTITY": "IND",
   "ENTITY NAME": "Soukoulis",
   "ENTITY NAME CONT.": "Rick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Western Bancorp",
   "OCCUPATION": "Executive",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC817",
   "ENTITY": "IND",
   "ENTITY NAME": "Staedler",
   "ENTITY NAME CONT.": "Randy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg, Staedler & Moore",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC818",
   "ENTITY": "IND",
   "ENTITY NAME": "Staedler",
   "ENTITY NAME CONT.": "Beverly",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg, Staedler & Moore",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4781",
   "ENTITY": "IND",
   "ENTITY NAME": "Staedler",
   "ENTITY NAME CONT.": "Rudy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg, Staedler & Moore",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1090",
   "ENTITY": "IND",
   "ENTITY NAME": "Stone",
   "ENTITY NAME CONT.": "Clarence",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "California Equity Group",
   "OCCUPATION": "Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5003",
   "ENTITY": "IND",
   "ENTITY NAME": "Stone",
   "ENTITY NAME CONT.": "Clarence",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "California Equity Group",
   "OCCUPATION": "Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4312",
   "ENTITY": "IND",
   "ENTITY NAME": "Stone",
   "ENTITY NAME CONT.": "Larry",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Assessor",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2753",
   "ENTITY": "IND",
   "ENTITY NAME": "Stone",
   "ENTITY NAME CONT.": "Larry",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Assessor",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2977",
   "ENTITY": "IND",
   "ENTITY NAME": "Stump",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Table",
   "OCCUPATION": "Owner",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4271",
   "ENTITY": "IND",
   "ENTITY NAME": "Swenson",
   "ENTITY NAME CONT.": "Case",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Swenson Builders",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4298",
   "ENTITY": "IND",
   "ENTITY NAME": "Tadokoro",
   "ENTITY NAME CONT.": "Seigi",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1112",
   "ENTITY": "IND",
   "ENTITY NAME": "Tadokoro",
   "ENTITY NAME CONT.": "Seigi",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 150
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1113",
   "ENTITY": "IND",
   "ENTITY NAME": "Tadokoro",
   "ENTITY NAME CONT.": "Betty",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4788",
   "ENTITY": "IND",
   "ENTITY NAME": "Talburt",
   "ENTITY NAME CONT.": "Shauna & Aron",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Apple",
   "OCCUPATION": "Computer Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4992",
   "ENTITY": "IND",
   "ENTITY NAME": "Tamura",
   "ENTITY NAME CONT.": "Lance",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Synopsys",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4355",
   "ENTITY": "IND",
   "ENTITY NAME": "Theard",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Stephen Theard",
   "OCCUPATION": "Realtor",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4785",
   "ENTITY": "IND",
   "ENTITY NAME": "Thomas",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Apple",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3065",
   "ENTITY": "IND",
   "ENTITY NAME": "Tittle",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "YA - Tittle Insurance Services",
   "OCCUPATION": "Insurance Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4789",
   "ENTITY": "IND",
   "ENTITY NAME": "Toeniskoetter",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Toeniskoetter Companies",
   "OCCUPATION": "Commercial Builder",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4774",
   "ENTITY": "IND",
   "ENTITY NAME": "Trekell",
   "ENTITY NAME CONT.": "Todd",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Toeniskoetter Development, Inc.",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4267",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Edwin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "IATSE Local 134",
   "OCCUPATION": "Stagehand",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4302",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Eddie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Silicon Valley Organization",
   "OCCUPATION": "Director of Public Policy",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC865",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Eddie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Silicon Valley Organization",
   "OCCUPATION": "Director of Public Policy",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC808",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Eddie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Silicon Valley Organization",
   "OCCUPATION": "Director of Public Policy",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "A",
   "ID": "RC4995",
   "ENTITY": "IND",
   "ENTITY NAME": "Tseng",
   "ENTITY NAME CONT.": "Stanley",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Nova Financial Services, Inc.",
   "OCCUPATION": "Loan Officer",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4388",
   "ENTITY": "IND",
   "ENTITY NAME": "Valencia",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "RC3946",
   "ENTITY": "IND",
   "ENTITY NAME": "Valentine",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4270",
   "ENTITY": "IND",
   "ENTITY NAME": "Van Every",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Republic Urban Properties",
   "OCCUPATION": "President/CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2762",
   "ENTITY": "IND",
   "ENTITY NAME": "Van Every",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Republic Urban Properties",
   "OCCUPATION": "President/CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4346",
   "ENTITY": "IND",
   "ENTITY NAME": "Verdonk",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Unified School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2748",
   "ENTITY": "IND",
   "ENTITY NAME": "Virgilio",
   "ENTITY NAME CONT.": "Quincy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Quincy Virgilio",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4371",
   "ENTITY": "IND",
   "ENTITY NAME": "Virgilio",
   "ENTITY NAME CONT.": "Quincy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Quincy Virgilio",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3058",
   "ENTITY": "IND",
   "ENTITY NAME": "Vogel",
   "ENTITY NAME CONT.": "Bernie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Law Group",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC958",
   "ENTITY": "IND",
   "ENTITY NAME": "Wagstaff",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Petrinovich Pugh and Company",
   "OCCUPATION": "CPA",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3900",
   "ENTITY": "IND",
   "ENTITY NAME": "Waite",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4739",
   "ENTITY": "IND",
   "ENTITY NAME": "Walia",
   "ENTITY NAME CONT.": "Vinni",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Team San Jose",
   "OCCUPATION": "Director of Facilities",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC904",
   "ENTITY": "IND",
   "ENTITY NAME": "Walker",
   "ENTITY NAME CONT.": "Sandy",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "YMCA of Silicon Valley",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4334",
   "ENTITY": "IND",
   "ENTITY NAME": "Walsh",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel Realtors",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC908",
   "ENTITY": "IND",
   "ENTITY NAME": "Walsh",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel Realtors",
   "OCCUPATION": "Realtor",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC894",
   "ENTITY": "IND",
   "ENTITY NAME": "Wan",
   "ENTITY NAME CONT.": "Dennis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "DW Investment",
   "OCCUPATION": "RE Broker",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4244",
   "ENTITY": "IND",
   "ENTITY NAME": "Warshawsky",
   "ENTITY NAME CONT.": "Randy & Cathy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Tax Man",
   "OCCUPATION": "Tax Man",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4710",
   "ENTITY": "IND",
   "ENTITY NAME": "Waterman",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Richard Waterman",
   "OCCUPATION": "CPA",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2988",
   "ENTITY": "IND",
   "ENTITY NAME": "Waxman",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "CBIZ, Inc.",
   "OCCUPATION": "Chief Marketing Officer",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1095",
   "ENTITY": "IND",
   "ENTITY NAME": "Wayne",
   "ENTITY NAME CONT.": "Lisa Ann",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4376",
   "ENTITY": "IND",
   "ENTITY NAME": "Wei",
   "ENTITY NAME CONT.": "Lee",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco Systems",
   "OCCUPATION": "Engineer",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4758",
   "ENTITY": "IND",
   "ENTITY NAME": "Weigel",
   "ENTITY NAME CONT.": "Frank",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Green Waste",
   "OCCUPATION": "Secretary/Co-Chief Operating Officer",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC939",
   "ENTITY": "IND",
   "ENTITY NAME": "Welch",
   "ENTITY NAME CONT.": "Julia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Red Carpet",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC976",
   "ENTITY": "IND",
   "ENTITY NAME": "Welch",
   "ENTITY NAME CONT.": "Bill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Red Carpet",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC964",
   "ENTITY": "IND",
   "ENTITY NAME": "Why",
   "ENTITY NAME CONT.": "Dr. Bert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC907",
   "ENTITY": "IND",
   "ENTITY NAME": "Wolf-Reid",
   "ENTITY NAME CONT.": "Heide",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Legacy Real Estate & Associates",
   "OCCUPATION": "Realtor",
   "AMOUNT": 25
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2754",
   "ENTITY": "IND",
   "ENTITY NAME": "Wright",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kathleen S Wright Attorney",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4378",
   "ENTITY": "IND",
   "ENTITY NAME": "Wu",
   "ENTITY NAME CONT.": "Xiaodong",
   "ENTITY CITY": "Pleasanton",
   "Entity_ST": "CA",
   "EMPLOYER": "Xiaodong Wu",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2747",
   "ENTITY": "IND",
   "ENTITY NAME": "Wymer",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nextdoor.com",
   "OCCUPATION": "Executive",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4328",
   "ENTITY": "IND",
   "ENTITY NAME": "Wymer",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nextdoor.com",
   "OCCUPATION": "Executive",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1096",
   "ENTITY": "IND",
   "ENTITY NAME": "Youssefpour",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zell Associates",
   "OCCUPATION": "Investor",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC4996",
   "ENTITY": "IND",
   "ENTITY NAME": "Zechman",
   "ENTITY NAME CONT.": "Randy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Clean Solar",
   "OCCUPATION": "Entrepreneur",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC950",
   "ENTITY": "IND",
   "ENTITY NAME": "Zell",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC952",
   "ENTITY": "IND",
   "ENTITY NAME": "Zell",
   "ENTITY NAME CONT.": "Shirley",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC954",
   "ENTITY": "IND",
   "ENTITY NAME": "Zell",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zell Associates",
   "OCCUPATION": "Property Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC955",
   "ENTITY": "IND",
   "ENTITY NAME": "Zell",
   "ENTITY NAME CONT.": "Karen",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara School District",
   "OCCUPATION": "Librarian",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4309",
   "ENTITY": "IND",
   "ENTITY NAME": "Zell",
   "ENTITY NAME CONT.": "Shirley",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "None",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4310",
   "ENTITY": "IND",
   "ENTITY NAME": "Zell",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zell Associates",
   "OCCUPATION": "Property Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4349",
   "ENTITY": "IND",
   "ENTITY NAME": "Zhao",
   "ENTITY NAME CONT.": "Yong",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "MaxReal",
   "OCCUPATION": "Realtor",
   "AMOUNT": 99
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4373",
   "ENTITY": "IND",
   "ENTITY NAME": "Zhou",
   "ENTITY NAME CONT.": "Faith",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SCU",
   "OCCUPATION": "Chemist",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4771",
   "ENTITY": "IND",
   "ENTITY NAME": "Zicarelli",
   "ENTITY NAME CONT.": "Pat",
   "ENTITY CITY": "Tarzana",
   "Entity_ST": "CA",
   "EMPLOYER": "Style Realty, Inc.",
   "OCCUPATION": "CEO/Realtor",
   "AMOUNT": 50
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2700",
   "ENTITY": "IND",
   "ENTITY NAME": "Zraick",
   "ENTITY NAME CONT.": "Ronald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Petrinovich Pugh & Co",
   "OCCUPATION": "Accountant",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3053",
   "ENTITY": "IND",
   "ENTITY NAME": "Zraick",
   "ENTITY NAME CONT.": "Ronald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Petrinovich Pugh & Co",
   "OCCUPATION": "Accountant",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC890",
   "ENTITY": "IND",
   "ENTITY NAME": "Zwick",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Housing Trust Silicon Valley",
   "OCCUPATION": "Non-Profit Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4314",
   "ENTITY": "OTH",
   "ENTITY NAME": "5th St Promenade Investments LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4322",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACCO Management Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1108",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACCO Management Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1723",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6530
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1727",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5710
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX662",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5318
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX967",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5318
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX997",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5318
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1709",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5245
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1724",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5245
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX1026",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4520
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX1011",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4365
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1783",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4260
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1710",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 845
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1725",
   "ENTITY": "OTH",
   "ENTITY NAME": "AMS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 845
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1105",
   "ENTITY": "OTH",
   "ENTITY NAME": "Arcadia Development Co",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4321",
   "ENTITY": "OTH",
   "ENTITY NAME": "Arcadia Development Co",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5145",
   "ENTITY": "OTH",
   "ENTITY NAME": "ARDA LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1720",
   "ENTITY": "OTH",
   "ENTITY NAME": "Austin Belisle",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "EX1443",
   "ENTITY": "OTH",
   "ENTITY NAME": "Autumn Press",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4676
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX651",
   "ENTITY": "OTH",
   "ENTITY NAME": "Autumn Press",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3248
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX994",
   "ENTITY": "OTH",
   "ENTITY NAME": "Autumn Press",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3126
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX995",
   "ENTITY": "OTH",
   "ENTITY NAME": "Autumn Press",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3126
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX536",
   "ENTITY": "OTH",
   "ENTITY NAME": "Autumn Press",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1879
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX566",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclay Card US",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1876
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX310",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclay Card US",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 464
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX319",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclay Card US",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 270
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX312",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclay Card US",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 188
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX311",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclay Card US",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 124
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX538",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclay Card US",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 37
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX639",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclay Card US",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 31
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX1821",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4288
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1761",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1381
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1201",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1013
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX1010",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 388
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1618",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 355
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1638",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 274
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1661",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 181
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/9/2019",
   "FORM": "E",
   "ID": "EX1851",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 108
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1468",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barclays",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "City of Industry",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 77
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2703",
   "ENTITY": "OTH",
   "ENTITY NAME": "Boyce Associates",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1655",
   "ENTITY": "OTH",
   "ENTITY NAME": "Budget Watchdogs",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1386
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX563",
   "ENTITY": "OTH",
   "ENTITY NAME": "Budget Watchdogs",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1210
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1107",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cal-Western Property Management",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4320",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cal-Western Property Management",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC3066",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Janitorial Supply, Corp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX560",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Latino Voters' Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 325
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX615",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Public Safety Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "I",
   "ID": "RC4169",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Public Safety Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1297",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Public Safety Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1659",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 407
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX564",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 373
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1656",
   "ENTITY": "OTH",
   "ENTITY NAME": "CALSAL Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 649
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX561",
   "ENTITY": "OTH",
   "ENTITY NAME": "CALSAL Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 624
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1104",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cambridge Management Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4305",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cambridge Management Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX570",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2480
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1617",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2450
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "I",
   "ID": "RC4727",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 779
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1143",
   "ENTITY": "OTH",
   "ENTITY NAME": "Competitive Edge Research & Communication",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1620",
   "ENTITY": "OTH",
   "ENTITY NAME": "Computerized Political Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "EX1445",
   "ENTITY": "OTH",
   "ENTITY NAME": "Computerized Political Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 534
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX537",
   "ENTITY": "OTH",
   "ENTITY NAME": "Computerized Political Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 321
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1654",
   "ENTITY": "OTH",
   "ENTITY NAME": "COPS Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Folsom",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1527
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX610",
   "ENTITY": "OTH",
   "ENTITY NAME": "COPS Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Folsom",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1394
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX1819",
   "ENTITY": "OTH",
   "ENTITY NAME": "Diamond Quality Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7472
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1711",
   "ENTITY": "OTH",
   "ENTITY NAME": "Diamond Quality Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2442
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1785",
   "ENTITY": "OTH",
   "ENTITY NAME": "Diamond Quality Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2287
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1713",
   "ENTITY": "OTH",
   "ENTITY NAME": "Diamond Quality Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1350
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "EX1403",
   "ENTITY": "OTH",
   "ENTITY NAME": "Diamond Quality Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 922
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1784",
   "ENTITY": "OTH",
   "ENTITY NAME": "DKH Studios",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2675
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1285",
   "ENTITY": "OTH",
   "ENTITY NAME": "DKH Studios",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1750
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX641",
   "ENTITY": "OTH",
   "ENTITY NAME": "DKH Studios",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX793",
   "ENTITY": "OTH",
   "ENTITY NAME": "DKH Studios",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX1027",
   "ENTITY": "OTH",
   "ENTITY NAME": "DKH Studios",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 350
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4389",
   "ENTITY": "OTH",
   "ENTITY NAME": "DMV Holdings, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX534",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX535",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX571",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX640",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX966",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1470",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1619",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1648",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1712",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1786",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1621",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 846
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX1820",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 478
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1657",
   "ENTITY": "OTH",
   "ENTITY NAME": "Election Digest",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1081
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "I",
   "ID": "RC5210",
   "ENTITY": "OTH",
   "ENTITY NAME": "Election Digest",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1081
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX1823",
   "ENTITY": "OTH",
   "ENTITY NAME": "Election Digest",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1081
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX562",
   "ENTITY": "OTH",
   "ENTITY NAME": "Election Digest",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Torrance",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 943
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX559",
   "ENTITY": "OTH",
   "ENTITY NAME": "Families First Education Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Long Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 550
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4315",
   "ENTITY": "OTH",
   "ENTITY NAME": "Figueres Partners LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5140",
   "ENTITY": "OTH",
   "ENTITY NAME": "Five Sisters Group LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC1089",
   "ENTITY": "OTH",
   "ENTITY NAME": "George M. Marcus & Affiliated Entities",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2980",
   "ENTITY": "OTH",
   "ENTITY NAME": "Greenwaste Recovery, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4759",
   "ENTITY": "OTH",
   "ENTITY NAME": "Greenwaste Recovery, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1722",
   "ENTITY": "OTH",
   "ENTITY NAME": "Jack Riley",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX613",
   "ENTITY": "OTH",
   "ENTITY NAME": "Jim Lacy's \"Taxifornia\" Tax Fighter's Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "I",
   "ID": "RC4167",
   "ENTITY": "OTH",
   "ENTITY NAME": "Jim Lacy's \"Taxifornia\" Tax Fighter's Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1293",
   "ENTITY": "OTH",
   "ENTITY NAME": "Jim Lacy's \"Taxifornia\" Tax Fighter's Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX366",
   "ENTITY": "OTH",
   "ENTITY NAME": "JP Graphics",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 172
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC4999",
   "ENTITY": "OTH",
   "ENTITY NAME": "Largo Concrete, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Tustin",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX611",
   "ENTITY": "OTH",
   "ENTITY NAME": "Latino Family Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Long Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 550
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1586",
   "ENTITY": "OTH",
   "ENTITY NAME": "Marlena Smith",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1637",
   "ENTITY": "OTH",
   "ENTITY NAME": "Marlena Smith",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1649",
   "ENTITY": "OTH",
   "ENTITY NAME": "MB Public Affairs, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6350
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC4998",
   "ENTITY": "OTH",
   "ENTITY NAME": "Meridian At Midtown",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5143",
   "ENTITY": "OTH",
   "ENTITY NAME": "Michael James Real Estate",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX616",
   "ENTITY": "OTH",
   "ENTITY NAME": "National Tax Limitation Committee Early Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "I",
   "ID": "RC4170",
   "ENTITY": "OTH",
   "ENTITY NAME": "National Tax Limitation Committee Early Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1291",
   "ENTITY": "OTH",
   "ENTITY NAME": "National Tax Limitation Committee Early Voter Guide",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4798",
   "ENTITY": "OTH",
   "ENTITY NAME": "Newbury Park Associates LLC dba LINQ Apartment Homes",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC1088",
   "ENTITY": "OTH",
   "ENTITY NAME": "Prodesse Property Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Foster City",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5141",
   "ENTITY": "OTH",
   "ENTITY NAME": "Red Dragon Holding LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4761",
   "ENTITY": "OTH",
   "ENTITY NAME": "Republic Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Phoenix",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "RC3872",
   "ENTITY": "OTH",
   "ENTITY NAME": "Republic Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Phoenix",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4800",
   "ENTITY": "OTH",
   "ENTITY NAME": "Robinson Oil Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC960",
   "ENTITY": "OTH",
   "ENTITY NAME": "ROEM Development Corp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2981",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Water Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4733",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Water Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX612",
   "ENTITY": "OTH",
   "ENTITY NAME": "Save Prop 13",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "I",
   "ID": "RC4166",
   "ENTITY": "OTH",
   "ENTITY NAME": "Save Prop 13",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1296",
   "ENTITY": "OTH",
   "ENTITY NAME": "Save Prop 13",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5142",
   "ENTITY": "OTH",
   "ENTITY NAME": "Simple Neighbors Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2704",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sobrato Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX1012",
   "ENTITY": "OTH",
   "ENTITY NAME": "St. Christopher's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX318",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 967
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1587",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 769
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX674",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 226
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1662",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 128
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/24/2018",
   "FORM": "E",
   "ID": "EX1726",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX1815",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 77
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "E",
   "ID": "EX1809",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC944",
   "ENTITY": "OTH",
   "ENTITY NAME": "Taps Termite & Pest Specialists",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX618",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tayesa Knight",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EX792",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tayesa Knight",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1312",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tayesa Knight",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1478",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tayesa Knight",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 750
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "5/25/2018",
   "FORM": "C",
   "ID": "RC3956",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tayesa Knight",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 309
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "EX1406",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tayesa Knight",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 135
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "E",
   "ID": "EX1405",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tayesa Knight",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 132
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2861",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Encinitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4311",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Encinitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5134",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tiger Lines, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Lodi",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "E",
   "ID": "EX1660",
   "ENTITY": "OTH",
   "ENTITY NAME": "US Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 73
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX1849",
   "ENTITY": "OTH",
   "ENTITY NAME": "US Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 35
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX313",
   "ENTITY": "OTH",
   "ENTITY NAME": "US Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX314",
   "ENTITY": "OTH",
   "ENTITY NAME": "US Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "E",
   "ID": "EX315",
   "ENTITY": "OTH",
   "ENTITY NAME": "US Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4316",
   "ENTITY": "OTH",
   "ENTITY NAME": "Valley View Properties",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1106",
   "ENTITY": "OTH",
   "ENTITY NAME": "Vasona Management, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "7/31/2018",
   "FORM": "A",
   "ID": "RC4323",
   "ENTITY": "OTH",
   "ENTITY NAME": "Vasona Management, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "E",
   "ID": "EX614",
   "ENTITY": "OTH",
   "ENTITY NAME": "Woman's Voice",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "I",
   "ID": "RC4168",
   "ENTITY": "OTH",
   "ENTITY NAME": "Woman's Voice",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "EX1292",
   "ENTITY": "OTH",
   "ENTITY NAME": "Woman's Voice",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Laguna Niguel",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 802
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "2/1/2018",
   "FORM": "A",
   "ID": "RC1103",
   "ENTITY": "OTH",
   "ENTITY NAME": "Woodmont Real Estate Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "11/5/2018",
   "FORM": "A",
   "ID": "RC5135",
   "ENTITY": "OTH",
   "ENTITY NAME": "Woodmont Real Estate Services, LP, Including Aggregated Contributions",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "1/13/2019",
   "FORM": "A",
   "ID": "RC2979",
   "ENTITY": "OTH",
   "ENTITY NAME": "Zanker Road Resource Management",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Foley",
   "FIRST": "Pam",
   "PURPOSE": "Pam Foley for San Jose City Council D9 2018",
   "DATE": "10/31/2018",
   "FORM": "A",
   "ID": "RC4757",
   "ENTITY": "OTH",
   "ENTITY NAME": "Zanker Road Resource Management",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "A",
   "ID": "UND01",
   "ENTITY": "COM",
   "ENTITY NAME": "Bricklayers & Allied Craftworkers Local 3",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "A",
   "ID": "UND02",
   "ENTITY": "COM",
   "ENTITY NAME": "California Teamsters Public Affairs Council Public Affairs Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "A",
   "ID": "UND03",
   "ENTITY": "IND",
   "ENTITY NAME": "D10 Democrats of Santa Clara County",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "A",
   "ID": "UND05",
   "ENTITY": "IND",
   "ENTITY NAME": "Eric Morley",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "A",
   "ID": "UND06",
   "ENTITY": "IND",
   "ENTITY NAME": "Gloria Quiroz",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "A",
   "ID": "UND04",
   "ENTITY": "IND",
   "ENTITY NAME": "Mary Jo Dilger",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "A",
   "ID": "UND01",
   "ENTITY": "IND",
   "ENTITY NAME": "Union Bank of California",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2664
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND11",
   "ENTITY": "OTH",
   "ENTITY NAME": "7 Eleven",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND38",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democratic Party 21st Century Club",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND15",
   "ENTITY": "OTH",
   "ENTITY NAME": "Dollar Tree",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 26
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND16",
   "ENTITY": "OTH",
   "ENTITY NAME": "Dollar Tree",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND12",
   "ENTITY": "OTH",
   "ENTITY NAME": "Dulce Collins",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND36",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eric Stoker",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4000
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND17",
   "ENTITY": "OTH",
   "ENTITY NAME": "Erica Fernandez Zamora",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND31",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND39",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 140
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND18",
   "ENTITY": "OTH",
   "ENTITY NAME": "Flying Colors USA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND13",
   "ENTITY": "OTH",
   "ENTITY NAME": "Ian Crueldad",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND14",
   "ENTITY": "OTH",
   "ENTITY NAME": "Ian Crueldad",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 915
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND07",
   "ENTITY": "OTH",
   "ENTITY NAME": "In-N-Out",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 52
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND19",
   "ENTITY": "OTH",
   "ENTITY NAME": "Isaiah Gonzalez",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND08",
   "ENTITY": "OTH",
   "ENTITY NAME": "Jamba Juice",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND29",
   "ENTITY": "OTH",
   "ENTITY NAME": "Maribel Villareal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND30",
   "ENTITY": "OTH",
   "ENTITY NAME": "Maribel Villareal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND27",
   "ENTITY": "OTH",
   "ENTITY NAME": "Marlena Smith",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND28",
   "ENTITY": "OTH",
   "ENTITY NAME": "Marlena Smith",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1080
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND20",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mauricio Marroguin",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND32",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND21",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 846
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND35",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1150
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND22",
   "ENTITY": "OTH",
   "ENTITY NAME": "Party City",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 102
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND41",
   "ENTITY": "OTH",
   "ENTITY NAME": "Party City",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND37",
   "ENTITY": "OTH",
   "ENTITY NAME": "Patricia Jimenez",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND26",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 403
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND33",
   "ENTITY": "OTH",
   "ENTITY NAME": "Starbucks",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND24",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stephani Redeau",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND09",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND23",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sylvia Rayas",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND40",
   "ENTITY": "OTH",
   "ENTITY NAME": "Union Bank of California",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 189
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND42",
   "ENTITY": "OTH",
   "ENTITY NAME": "Union Bank of California",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND10",
   "ENTITY": "OTH",
   "ENTITY NAME": "Williams",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 67
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND34",
   "ENTITY": "OTH",
   "ENTITY NAME": "Williams",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 53
 },
 {
   "LAST": "Jimenez",
   "FIRST": "Sergio",
   "PURPOSE": "Sergio Jimenez for City Council 2016",
   "DATE": "12/12/2018",
   "FORM": "E",
   "ID": "UND25",
   "ENTITY": "OTH",
   "ENTITY NAME": "Yazmin Rios",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "D",
   "ID": "DEX1054",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose Suppoted by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX1054",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose Suppoted by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3449",
   "ENTITY": "IND",
   "ENTITY NAME": "Ahrens",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "California Assembly District 28",
   "OCCUPATION": "Advisor",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1881",
   "ENTITY": "IND",
   "ENTITY NAME": "Alexander",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Synaptics",
   "OCCUPATION": "Engineer",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3431",
   "ENTITY": "IND",
   "ENTITY NAME": "Arnold",
   "ENTITY NAME CONT.": "Harriett",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "President, Alumni Association",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1880",
   "ENTITY": "IND",
   "ENTITY NAME": "Ayer",
   "ENTITY NAME CONT.": "Bryan",
   "ENTITY CITY": "Bethel",
   "Entity_ST": "CT",
   "EMPLOYER": "Beiersdorf Inc",
   "OCCUPATION": "Sales Communication Manager",
   "AMOUNT": 75
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3422",
   "ENTITY": "IND",
   "ENTITY NAME": "Baez",
   "ENTITY NAME CONT.": "Carlos",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Abbott",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1850",
   "ENTITY": "IND",
   "ENTITY NAME": "Beauchman",
   "ENTITY NAME CONT.": "Leon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "self",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3464",
   "ENTITY": "IND",
   "ENTITY NAME": "Bell",
   "ENTITY NAME CONT.": "Leonard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Apple",
   "OCCUPATION": "Sales",
   "AMOUNT": 25
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1858",
   "ENTITY": "IND",
   "ENTITY NAME": "Berkes",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Federal Realty Investment Trust",
   "OCCUPATION": "Commercial Real Estate Executive",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3953",
   "ENTITY": "IND",
   "ENTITY NAME": "Berry",
   "ENTITY NAME CONT.": "Rhonda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Our City Forest",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3360",
   "ENTITY": "IND",
   "ENTITY NAME": "Bozzutto",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Bozzutto Insurance",
   "OCCUPATION": "Owner",
   "AMOUNT": 300
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1874",
   "ENTITY": "IND",
   "ENTITY NAME": "Brown",
   "ENTITY NAME CONT.": "Geoffry",
   "ENTITY CITY": "Union City",
   "Entity_ST": "CA",
   "EMPLOYER": "ACWD",
   "OCCUPATION": "Analyst",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3332",
   "ENTITY": "IND",
   "ENTITY NAME": "Cacas",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Universal Audio",
   "OCCUPATION": "Business Application Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3339",
   "ENTITY": "IND",
   "ENTITY NAME": "Carrillo",
   "ENTITY NAME CONT.": "Pedro",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Advisors",
   "OCCUPATION": "Principal",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1878",
   "ENTITY": "IND",
   "ENTITY NAME": "Chatman",
   "ENTITY NAME CONT.": "Reginald",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Bloom Energy",
   "OCCUPATION": "Director",
   "AMOUNT": 25
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1870",
   "ENTITY": "IND",
   "ENTITY NAME": "Cormier",
   "ENTITY NAME CONT.": "Macheinil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "O'Connor Hospital",
   "OCCUPATION": "RN",
   "AMOUNT": 25
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1859",
   "ENTITY": "IND",
   "ENTITY NAME": "Crooms",
   "ENTITY NAME CONT.": "Leamon and Lisa",
   "ENTITY CITY": "Tucson",
   "Entity_ST": "AZ",
   "EMPLOYER": "self",
   "OCCUPATION": "Digital Marketing",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1872",
   "ENTITY": "IND",
   "ENTITY NAME": "Cuneen",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies",
   "OCCUPATION": "Partner",
   "AMOUNT": 300
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3465",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunningham",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2029",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunningham",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Lockheed Martin Company",
   "OCCUPATION": "manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1882",
   "ENTITY": "IND",
   "ENTITY NAME": "Daniels",
   "ENTITY NAME CONT.": "Theodore",
   "ENTITY CITY": "Manteca",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3129",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Club Autosport",
   "OCCUPATION": "Co-managing Partner",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2567",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital Consultants Inc.",
   "OCCUPATION": "VP",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2572",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital Consultant",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3440",
   "ENTITY": "IND",
   "ENTITY NAME": "Flynn",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "unemployed",
   "OCCUPATION": "mediator",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3461",
   "ENTITY": "IND",
   "ENTITY NAME": "Fong",
   "ENTITY NAME CONT.": "Dennis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "DPJW",
   "OCCUPATION": "member",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2044",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Goodwill of Silicon Vallley",
   "OCCUPATION": "CEO",
   "AMOUNT": 300
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3353",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Goodwill of Silicon Vallley",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1883",
   "ENTITY": "IND",
   "ENTITY NAME": "Franklin",
   "ENTITY NAME CONT.": "Willie",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "First in Packaging",
   "OCCUPATION": "self",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3418",
   "ENTITY": "IND",
   "ENTITY NAME": "Gagliardi",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sellar Hazard & Lucia",
   "OCCUPATION": "attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1877",
   "ENTITY": "IND",
   "ENTITY NAME": "Gasper",
   "ENTITY NAME CONT.": "Everett",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nyanda & Associates",
   "OCCUPATION": "Technology Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1860",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Armando",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Armando Gomez Consulting",
   "OCCUPATION": "Principal",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1867",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "Armando",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Armando Gomez Consulting",
   "OCCUPATION": "Principal",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3462",
   "ENTITY": "IND",
   "ENTITY NAME": "Graziosi",
   "ENTITY NAME CONT.": "Erin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rotten Robbie",
   "OCCUPATION": "Vice President",
   "AMOUNT": 300
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3334",
   "ENTITY": "IND",
   "ENTITY NAME": "Greathouse",
   "ENTITY NAME CONT.": "Ken",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3344",
   "ENTITY": "IND",
   "ENTITY NAME": "Guardino",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Leadership Group",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3326",
   "ENTITY": "IND",
   "ENTITY NAME": "Hariri",
   "ENTITY NAME CONT.": "Perry",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Fortbay",
   "OCCUPATION": "Principal",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1853",
   "ENTITY": "IND",
   "ENTITY NAME": "Hawkins",
   "ENTITY NAME CONT.": "Martin",
   "ENTITY CITY": "Union City",
   "Entity_ST": "CA",
   "EMPLOYER": "Robert Half Legal",
   "OCCUPATION": "Contracts Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2031",
   "ENTITY": "IND",
   "ENTITY NAME": "He",
   "ENTITY NAME CONT.": "Quan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "HQT New Height",
   "OCCUPATION": "Financial Advisor",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3359",
   "ENTITY": "IND",
   "ENTITY NAME": "Head",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Summerhill Housing Group",
   "OCCUPATION": "Managing Director",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2045",
   "ENTITY": "IND",
   "ENTITY NAME": "Hill",
   "ENTITY NAME CONT.": "Kenneth",
   "ENTITY CITY": "Corona",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 20
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1885",
   "ENTITY": "IND",
   "ENTITY NAME": "Holsey",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Dublin",
   "Entity_ST": "CA",
   "EMPLOYER": "Kaiser",
   "OCCUPATION": "Sr. IT Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3468",
   "ENTITY": "IND",
   "ENTITY NAME": "Holsey",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Dublin",
   "Entity_ST": "CA",
   "EMPLOYER": "Kaiser",
   "OCCUPATION": "Sr. IT Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3424",
   "ENTITY": "IND",
   "ENTITY NAME": "Holsey",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Dublin",
   "Entity_ST": "CA",
   "EMPLOYER": "Kaiser",
   "OCCUPATION": "Sr. IT Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1884",
   "ENTITY": "IND",
   "ENTITY NAME": "Hutto",
   "ENTITY NAME CONT.": "Geoffry",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Google",
   "OCCUPATION": "Engineer",
   "AMOUNT": 25
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2028",
   "ENTITY": "IND",
   "ENTITY NAME": "Jackson",
   "ENTITY NAME CONT.": "Wilbur",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3352",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobs",
   "ENTITY NAME CONT.": "Elaine",
   "ENTITY CITY": "Benecia",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3455",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnsen",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3456",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnsen",
   "ENTITY NAME CONT.": "Joan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3321",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "self",
   "OCCUPATION": "Forensic Economist",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3322",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Cecilie",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "self",
   "OCCUPATION": "attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "B1",
   "ID": "LN20",
   "ENTITY": "IND",
   "ENTITY NAME": "Jones",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "City Councilman",
   "AMOUNT": 10200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX1651",
   "ENTITY": "IND",
   "ENTITY NAME": "Jones",
   "ENTITY NAME CONT.": "Kelli",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 283
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1879",
   "ENTITY": "IND",
   "ENTITY NAME": "Jones",
   "ENTITY NAME CONT.": "Sharla",
   "ENTITY CITY": "San Antonio",
   "Entity_ST": "TX",
   "EMPLOYER": "San Antonio Community College",
   "OCCUPATION": "Professor",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3423",
   "ENTITY": "IND",
   "ENTITY NAME": "Jones",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3354",
   "ENTITY": "IND",
   "ENTITY NAME": "Kali Rai",
   "ENTITY NAME CONT.": "Sharanjit",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Jackson and Main LLC",
   "OCCUPATION": "consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "C",
   "ID": "RC3493",
   "ENTITY": "IND",
   "ENTITY NAME": "Kendrick",
   "ENTITY NAME CONT.": "Kanahl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "self",
   "OCCUPATION": "Medical Administration",
   "AMOUNT": 436
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3351",
   "ENTITY": "IND",
   "ENTITY NAME": "Kiev",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Empire Broadcasting",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3419",
   "ENTITY": "IND",
   "ENTITY NAME": "King",
   "ENTITY NAME CONT.": "Dennis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hispanic Chamber of Commerce Silicon Valley",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3441",
   "ENTITY": "IND",
   "ENTITY NAME": "Knies",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Association",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3425",
   "ENTITY": "IND",
   "ENTITY NAME": "Lau",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "John Lau Properties",
   "OCCUPATION": "Sales Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1873",
   "ENTITY": "IND",
   "ENTITY NAME": "Lewis",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Zoom",
   "OCCUPATION": "Sales",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3436",
   "ENTITY": "IND",
   "ENTITY NAME": "Lin",
   "ENTITY NAME CONT.": "Kico",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kicolin Realty",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2039",
   "ENTITY": "IND",
   "ENTITY NAME": "Liu",
   "ENTITY NAME CONT.": "Bo",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco",
   "OCCUPATION": "Engineer",
   "AMOUNT": 300
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3416",
   "ENTITY": "IND",
   "ENTITY NAME": "Lopes",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Western States Oil",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3457",
   "ENTITY": "IND",
   "ENTITY NAME": "Low",
   "ENTITY NAME CONT.": "Evan",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "State of California",
   "OCCUPATION": "Assemblyman",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3330",
   "ENTITY": "IND",
   "ENTITY NAME": "Lubow",
   "ENTITY NAME CONT.": "Cheryl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 300
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3329",
   "ENTITY": "IND",
   "ENTITY NAME": "Lynch",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "self",
   "OCCUPATION": "Enviromental/Urban Planner",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2036",
   "ENTITY": "IND",
   "ENTITY NAME": "Mancini",
   "ENTITY NAME CONT.": "Filippo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "self",
   "OCCUPATION": "construction management",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3417",
   "ENTITY": "IND",
   "ENTITY NAME": "Martinez",
   "ENTITY NAME CONT.": "Angel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Community Relations",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1855",
   "ENTITY": "IND",
   "ENTITY NAME": "McArthur",
   "ENTITY NAME CONT.": "Melvin",
   "ENTITY CITY": "Avalon",
   "Entity_ST": "TX",
   "EMPLOYER": "1961",
   "OCCUPATION": "self",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1854",
   "ENTITY": "IND",
   "ENTITY NAME": "McDowell",
   "ENTITY NAME CONT.": "Vincent",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "AT&T",
   "OCCUPATION": "IT Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1857",
   "ENTITY": "IND",
   "ENTITY NAME": "McDowell",
   "ENTITY NAME CONT.": "Vincent",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "AT&T",
   "OCCUPATION": "IT Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3335",
   "ENTITY": "IND",
   "ENTITY NAME": "Mitchem",
   "ENTITY NAME CONT.": "Fred",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara University",
   "OCCUPATION": "Career Counselor",
   "AMOUNT": 25
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3463",
   "ENTITY": "IND",
   "ENTITY NAME": "Motte",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "Seabrook",
   "Entity_ST": "MD",
   "EMPLOYER": "Howard University",
   "OCCUPATION": "Associate Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3338",
   "ENTITY": "IND",
   "ENTITY NAME": "Mountsier",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Pinion Property Co",
   "OCCUPATION": "Principal",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3357",
   "ENTITY": "IND",
   "ENTITY NAME": "Mulcahey",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SDS NexGen Partners LP",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1856",
   "ENTITY": "IND",
   "ENTITY NAME": "Musser",
   "ENTITY NAME CONT.": "Reilly",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Robinson Oil DBA Rotten Robbie",
   "OCCUPATION": "VP Marketing and Merchandising",
   "AMOUNT": 300
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2041",
   "ENTITY": "IND",
   "ENTITY NAME": "Pan",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "OmniVision Technology",
   "OCCUPATION": "self",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1875",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramee",
   "ENTITY NAME CONT.": "Lisa",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Stanford University",
   "OCCUPATION": "Program Coordinator",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3346",
   "ENTITY": "IND",
   "ENTITY NAME": "Reed",
   "ENTITY NAME CONT.": "Kit",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1869",
   "ENTITY": "IND",
   "ENTITY NAME": "Riley",
   "ENTITY NAME CONT.": "Wayne",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Kaiser",
   "OCCUPATION": "Director, IT",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3325",
   "ENTITY": "IND",
   "ENTITY NAME": "Ritter",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Ritter Associated",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1886",
   "ENTITY": "IND",
   "ENTITY NAME": "Robinson",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Robinson Oil Company",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1871",
   "ENTITY": "IND",
   "ENTITY NAME": "Robledo",
   "ENTITY NAME CONT.": "Sammy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Boeing Company",
   "OCCUPATION": "Security",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3349",
   "ENTITY": "IND",
   "ENTITY NAME": "Robledo",
   "ENTITY NAME CONT.": "Sammy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Boeing Company",
   "OCCUPATION": "Security",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1852",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VMWare",
   "OCCUPATION": "Marketing",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3453",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Viavi Solutions Inc",
   "OCCUPATION": "Head of Legal Ops",
   "AMOUNT": 80
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "C",
   "ID": "RC3492",
   "ENTITY": "IND",
   "ENTITY NAME": "Salata",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Construction",
   "OCCUPATION": "Construction",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "C",
   "ID": "RC3569",
   "ENTITY": "IND",
   "ENTITY NAME": "Salata",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Construction",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3432",
   "ENTITY": "IND",
   "ENTITY NAME": "Saucedo",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "NAIOP",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3358",
   "ENTITY": "IND",
   "ENTITY NAME": "Schoennauer",
   "ENTITY NAME CONT.": "Erik",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Schoennauer Company",
   "OCCUPATION": "consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2040",
   "ENTITY": "IND",
   "ENTITY NAME": "Shan",
   "ENTITY NAME CONT.": "Jizhang",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "n/a",
   "OCCUPATION": "housewife",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3342",
   "ENTITY": "IND",
   "ENTITY NAME": "Slattery",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "n/a",
   "OCCUPATION": "housewife",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3340",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Robbie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3429",
   "ENTITY": "IND",
   "ENTITY NAME": "Soto-Galvan",
   "ENTITY NAME CONT.": "Gabriela",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Wonder Years",
   "OCCUPATION": "Preschool Teacher",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1887",
   "ENTITY": "IND",
   "ENTITY NAME": "Strangis",
   "ENTITY NAME CONT.": "Jerry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Strangis Properties",
   "OCCUPATION": "owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3442",
   "ENTITY": "IND",
   "ENTITY NAME": "Swenson",
   "ENTITY NAME CONT.": "Case",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Swenson Construction",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2043",
   "ENTITY": "IND",
   "ENTITY NAME": "Szymanski",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "self",
   "OCCUPATION": "photographer",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3323",
   "ENTITY": "IND",
   "ENTITY NAME": "Tadokoro",
   "ENTITY NAME CONT.": "Seigi",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3324",
   "ENTITY": "IND",
   "ENTITY NAME": "Takodoro",
   "ENTITY NAME CONT.": "Betty",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3361",
   "ENTITY": "IND",
   "ENTITY NAME": "Tersini",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "KT Urban Properties",
   "OCCUPATION": "SVP",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3458",
   "ENTITY": "IND",
   "ENTITY NAME": "Tortora",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sharks Sports & Entertainment LL",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3420",
   "ENTITY": "IND",
   "ENTITY NAME": "Trekell",
   "ENTITY NAME CONT.": "Todd",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Toenisketter Development",
   "OCCUPATION": "Project Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1851",
   "ENTITY": "IND",
   "ENTITY NAME": "Van Evry",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Republic Urban Properties LLC",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2042",
   "ENTITY": "IND",
   "ENTITY NAME": "Varich",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Pinnacle One Insurance",
   "OCCUPATION": "president",
   "AMOUNT": 500
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3348",
   "ENTITY": "IND",
   "ENTITY NAME": "Vora",
   "ENTITY NAME CONT.": "Namrata",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Dynamic Glass",
   "OCCUPATION": "Regional Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1868",
   "ENTITY": "IND",
   "ENTITY NAME": "Waite",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC1876",
   "ENTITY": "IND",
   "ENTITY NAME": "Weaver",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "JR Weaver Consulting",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "C",
   "ID": "RC3494",
   "ENTITY": "IND",
   "ENTITY NAME": "White",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "retired",
   "OCCUPATION": "retired",
   "AMOUNT": 435
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3327",
   "ENTITY": "IND",
   "ENTITY NAME": "Williams",
   "ENTITY NAME CONT.": "Forest",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3421",
   "ENTITY": "IND",
   "ENTITY NAME": "Winston",
   "ENTITY NAME CONT.": "Kim",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Starbucks",
   "OCCUPATION": "Director Government Affairs",
   "AMOUNT": 150
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2038",
   "ENTITY": "IND",
   "ENTITY NAME": "Ye",
   "ENTITY NAME CONT.": "Shen",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Broadcom",
   "OCCUPATION": "Engineer",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2030",
   "ENTITY": "IND",
   "ENTITY NAME": "Zhao",
   "ENTITY NAME CONT.": "Yong",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "MaxReal Realty",
   "OCCUPATION": "realtor",
   "AMOUNT": 200
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2025",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACCO Management Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX633",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amazon",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 78
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2035",
   "ENTITY": "OTH",
   "ENTITY NAME": "Arcadia Development",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3434",
   "ENTITY": "OTH",
   "ENTITY NAME": "Associated Builders and Contractors Northern California Chapter PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Livermore",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3318",
   "ENTITY": "OTH",
   "ENTITY NAME": "Build Jobs PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2034",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cal Western Property Management",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2032",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Apartment Association",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "E",
   "ID": "EX412",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2024",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cambridge Management Co",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX630",
   "ENTITY": "OTH",
   "ENTITY NAME": "CDavis Designs",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX632",
   "ENTITY": "OTH",
   "ENTITY NAME": "CDavis Designs",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX1714",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25051
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX635",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2310
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "I",
   "ID": "RC4708",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 260
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX1650",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 260
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3320",
   "ENTITY": "OTH",
   "ENTITY NAME": "Coca Cola North America",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX625",
   "ENTITY": "OTH",
   "ENTITY NAME": "from designs to Doodads",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rohnert Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 340
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3439",
   "ENTITY": "OTH",
   "ENTITY NAME": "K-1/K-2 Ranch Trust",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3943",
   "ENTITY": "OTH",
   "ENTITY NAME": "Outfront Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX683",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paypal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 27
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX631",
   "ENTITY": "OTH",
   "ENTITY NAME": "Postnet CA169",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 101
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX628",
   "ENTITY": "OTH",
   "ENTITY NAME": "Postnet CA169",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 66
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3350",
   "ENTITY": "OTH",
   "ENTITY NAME": "Premier Recycle",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3549",
   "ENTITY": "OTH",
   "ENTITY NAME": "Prodesse Property Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Foster City",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX682",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rally Piryx LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 749
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX1095",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rally Piryx LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2571",
   "ENTITY": "OTH",
   "ENTITY NAME": "Richfield Park LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3319",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Police Officers Association",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3543",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Water Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX629",
   "ENTITY": "OTH",
   "ENTITY NAME": "Santa Clara County Registrar of Voters",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 102
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2568",
   "ENTITY": "OTH",
   "ENTITY NAME": "Saratoga Plaza LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "E",
   "ID": "EX413",
   "ENTITY": "OTH",
   "ENTITY NAME": "Square Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 54
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX684",
   "ENTITY": "OTH",
   "ENTITY NAME": "Square Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX1096",
   "ENTITY": "OTH",
   "ENTITY NAME": "Square Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 21
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3547",
   "ENTITY": "OTH",
   "ENTITY NAME": "Summerhill Homes LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX1466",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Blue Door Restaurant",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2599
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "E",
   "ID": "EX627",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Blue Door Restaurant",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1180
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2022",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Encinitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "10/18/2018",
   "FORM": "A",
   "ID": "RC3942",
   "ENTITY": "OTH",
   "ENTITY NAME": "Touchstone Development LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2033",
   "ENTITY": "OTH",
   "ENTITY NAME": "Vasona Management Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Jones",
   "FIRST": "Charles",
   "PURPOSE": "Chappie Jones for City Council 2018 D1",
   "DATE": "5/23/2018",
   "FORM": "A",
   "ID": "RC2023",
   "ENTITY": "OTH",
   "ENTITY NAME": "Woodmont Real Estate Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984758",
   "ENTITY": "COM",
   "ENTITY NAME": "Associated General Contractors PAC of California",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "West Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931462",
   "ENTITY": "COM",
   "ENTITY NAME": "Build Jobs PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987584",
   "ENTITY": "COM",
   "ENTITY NAME": "California Alliance for Jobs - Rebuild California Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924616",
   "ENTITY": "COM",
   "ENTITY NAME": "California Apartment Association PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989512",
   "ENTITY": "COM",
   "ENTITY NAME": "Cement Mason's Local 400 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC19",
   "ENTITY": "COM",
   "ENTITY NAME": "CHAPPIE JONES FOR CITY COUNCIL 2018 D1",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931461",
   "ENTITY": "COM",
   "ENTITY NAME": "Committee to Expand the Middle Class, Supported by Airbnb, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923821",
   "ENTITY": "COM",
   "ENTITY NAME": "David Chiu for Assembly 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553881",
   "ENTITY": "COM",
   "ENTITY NAME": "Democratic 21st Century Club",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 142
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923327",
   "ENTITY": "COM",
   "ENTITY NAME": "HNTB Holdings Ltd. PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Kansas City",
   "Entity_ST": "MO",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990298",
   "ENTITY": "COM",
   "ENTITY NAME": "Issues Mobilization PAC California Association of Realtors",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925427",
   "ENTITY": "COM",
   "ENTITY NAME": "Kevin Mullin for Assembly 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923789",
   "ENTITY": "COM",
   "ENTITY NAME": "Larry Stone County Assessor 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987928",
   "ENTITY": "COM",
   "ENTITY NAME": "Neighbors for a Safer San Jose, Yes on F, a Coalition of Community Organizations, Businesses and Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14204
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "D",
   "ID": "DD553440",
   "ENTITY": "COM",
   "ENTITY NAME": "Neighbors for Affordable Housing and Open Space - No on B, Yes on C",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24889
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "D",
   "ID": "DD553476",
   "ENTITY": "COM",
   "ENTITY NAME": "Neighbors for Affordable Housing and Open Space - No on B, Yes on C",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3185
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "D",
   "ID": "DD553107",
   "ENTITY": "COM",
   "ENTITY NAME": "Neighbors for Affordable Housing and Open Space - No on B, Yes on C",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 665
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC11",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 80000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC32",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC60",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 58000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC3",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC94",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 41000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "C",
   "ID": "NON37",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24889
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "C",
   "ID": "NON57",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3185
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC98",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "C",
   "ID": "NON43",
   "ENTITY": "COM",
   "ENTITY NAME": "NEIGHBORS FOR SAM LICCARDO FOR SAN JOSE MAYOR 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989511",
   "ENTITY": "COM",
   "ENTITY NAME": "Northern California District Council of Laborers PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987996",
   "ENTITY": "COM",
   "ENTITY NAME": "Operating Engineers Local Union No. 3 Issues Advocacy/Ballot Initiative PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964648",
   "ENTITY": "COM",
   "ENTITY NAME": "PG&E Corporation - Major Donor Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989930",
   "ENTITY": "COM",
   "ENTITY NAME": "Plumbers, Steamfitters, Refrigeration Fitters, Local 393 Political Action Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "10/26/2018",
   "FORM": "D",
   "ID": "EXP117",
   "ENTITY": "COM",
   "ENTITY NAME": "SAFER SAN JOSE, YES ON MEASURE T",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6310
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990452",
   "ENTITY": "COM",
   "ENTITY NAME": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557288",
   "ENTITY": "COM",
   "ENTITY NAME": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990108",
   "ENTITY": "COM",
   "ENTITY NAME": "San Jose Firefighters, Local 230 PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987567",
   "ENTITY": "COM",
   "ENTITY NAME": "San Jose Police Officers' Association PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10984212",
   "ENTITY": "COM",
   "ENTITY NAME": "Save The Bay Action Fund PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2089
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10989919",
   "ENTITY": "COM",
   "ENTITY NAME": "Save The Bay Action Fund PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 440
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10989913",
   "ENTITY": "COM",
   "ENTITY NAME": "Save The Bay Action Fund PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 440
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10984211",
   "ENTITY": "COM",
   "ENTITY NAME": "Save The Bay Action Fund PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10989918",
   "ENTITY": "COM",
   "ENTITY NAME": "Save The Bay Action Fund PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10989911",
   "ENTITY": "COM",
   "ENTITY NAME": "Save The Bay Action Fund PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10984213",
   "ENTITY": "COM",
   "ENTITY NAME": "Save The Bay Action Fund PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 156
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924593",
   "ENTITY": "COM",
   "ENTITY NAME": "The Silicon Valley Organization PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Encinitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553134",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 80000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553329",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553515",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 58000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D552995",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "D",
   "ID": "DD553370",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24889
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10993784",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6310
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10993783",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6310
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "D",
   "ID": "DD553477",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3185
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "D",
   "ID": "DD553282",
   "ENTITY": "COM",
   "ENTITY NAME": "The Yes on C/No on B, Stop the Sprawl San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10988058",
   "ENTITY": "COM",
   "ENTITY NAME": "United Contractors PAC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553522",
   "ENTITY": "COM",
   "ENTITY NAME": "Villaraigosa for Governor 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553475",
   "ENTITY": "COM",
   "ENTITY NAME": "Villaraigosa for Governor 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "10/26/2018",
   "FORM": "D",
   "ID": "EXP116",
   "ENTITY": "COM",
   "ENTITY NAME": "YES ON MEASURE V, VOTE AFFORDABLE SAN JOSE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6310
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557232",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557244",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 115000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557435",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557289",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557515",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989927",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990039",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 115000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990296",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10985209",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 27563
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10985210",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 27563
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for a Safer San Jose, Yes on F, a Coalition of Community Organizations, Businesses and Mayor Sam Liccardo",
   "DATE": "10/28/2018",
   "FORM": "E",
   "ID": "D556714",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14204
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990295",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "C",
   "ID": "C10983766",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8900
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10987373",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10991486",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10989465",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10989464",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10995959",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 450
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10995960",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 450
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10987374",
   "ENTITY": "COM",
   "ENTITY NAME": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923830",
   "ENTITY": "IND",
   "ENTITY NAME": "Abatecola",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Truven Health Analytics",
   "OCCUPATION": "Director, Operations",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924624",
   "ENTITY": "IND",
   "ENTITY NAME": "Abatecola",
   "ENTITY NAME CONT.": "Yvette",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Adobe Systems",
   "OCCUPATION": "Research Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964929",
   "ENTITY": "IND",
   "ENTITY NAME": "Abbott Sarsfield",
   "ENTITY NAME CONT.": "Wendy",
   "ENTITY CITY": "Lafayette",
   "Entity_ST": "CA",
   "EMPLOYER": "PG&E",
   "OCCUPATION": "Senior Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935163",
   "ENTITY": "IND",
   "ENTITY NAME": "Abeyesinhe",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Porter Ranch",
   "Entity_ST": "CA",
   "EMPLOYER": "Lifestyle Solutions",
   "OCCUPATION": "COO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924708",
   "ENTITY": "IND",
   "ENTITY NAME": "Abronzino",
   "ENTITY NAME CONT.": "Aldo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gold Coast Natural Dist.",
   "OCCUPATION": "Sales & Marketing",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924688",
   "ENTITY": "IND",
   "ENTITY NAME": "Aceves",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928249",
   "ENTITY": "IND",
   "ENTITY NAME": "Aceves",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Parker",
   "Entity_ST": "CO",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923366",
   "ENTITY": "IND",
   "ENTITY NAME": "Acharya",
   "ENTITY NAME CONT.": "SanjeevV",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Sanjeev Acharya",
   "OCCUPATION": "Builder",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924304",
   "ENTITY": "IND",
   "ENTITY NAME": "Acharya",
   "ENTITY NAME CONT.": "Mina",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "SiliconSage Builders, LLC",
   "OCCUPATION": "Designer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925079",
   "ENTITY": "IND",
   "ENTITY NAME": "Adam",
   "ENTITY NAME CONT.": "Marie",
   "ENTITY CITY": "Northridge",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 40
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550318",
   "ENTITY": "IND",
   "ENTITY NAME": "Adam",
   "ENTITY NAME CONT.": "Marie",
   "ENTITY CITY": "Northridge",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924041",
   "ENTITY": "IND",
   "ENTITY NAME": "Adams",
   "ENTITY NAME CONT.": "Tracy",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "GreenWaste Recovery, Inc.",
   "OCCUPATION": "Recycling Services",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925073",
   "ENTITY": "IND",
   "ENTITY NAME": "Adhami",
   "ENTITY NAME CONT.": "Souad",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Sage",
   "OCCUPATION": "Document Processing",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928253",
   "ENTITY": "IND",
   "ENTITY NAME": "Aguilera",
   "ENTITY NAME CONT.": "Claudia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Unified School District",
   "OCCUPATION": "Bilingual Parent Liaison",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925121",
   "ENTITY": "IND",
   "ENTITY NAME": "Ahearn",
   "ENTITY NAME CONT.": "Dennis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925108",
   "ENTITY": "IND",
   "ENTITY NAME": "Aiton",
   "ENTITY NAME CONT.": "Tavius",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Guitar Center",
   "OCCUPATION": "Sales",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935002",
   "ENTITY": "IND",
   "ENTITY NAME": "Ajlouny",
   "ENTITY NAME CONT.": "EdwardN",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924239",
   "ENTITY": "IND",
   "ENTITY NAME": "Akatiff",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924240",
   "ENTITY": "IND",
   "ENTITY NAME": "Akatiff",
   "ENTITY NAME CONT.": "Christy",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924591",
   "ENTITY": "IND",
   "ENTITY NAME": "Akatiff",
   "ENTITY NAME CONT.": "Carol",
   "ENTITY CITY": "South Lake Tahoe",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923110",
   "ENTITY": "IND",
   "ENTITY NAME": "Albanese",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Joseph J. Albanese, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924676",
   "ENTITY": "IND",
   "ENTITY NAME": "Albanese",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923515",
   "ENTITY": "IND",
   "ENTITY NAME": "Albanese",
   "ENTITY NAME CONT.": "ThomasJ",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Central Concrete Supply Co. Inc.",
   "OCCUPATION": "Founder/Business Development",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924306",
   "ENTITY": "IND",
   "ENTITY NAME": "Albanese",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Joseph J. Albanese, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": -1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10962086",
   "ENTITY": "IND",
   "ENTITY NAME": "Alberts",
   "ENTITY NAME CONT.": "Lyn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Alberts Realty",
   "OCCUPATION": "Realtor",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930454",
   "ENTITY": "IND",
   "ENTITY NAME": "Allen",
   "ENTITY NAME CONT.": "Sandra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Royal Coach Tours",
   "OCCUPATION": "President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924118",
   "ENTITY": "IND",
   "ENTITY NAME": "Alloggiamento",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kaiser Permanente",
   "OCCUPATION": "Physician",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924196",
   "ENTITY": "IND",
   "ENTITY NAME": "Almassy",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "PricewaterhouseCoopers LLP",
   "OCCUPATION": "CPA",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925327",
   "ENTITY": "IND",
   "ENTITY NAME": "Alvarez",
   "ENTITY NAME CONT.": "Apolinar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Entertainment",
   "OCCUPATION": "Promoter/Club Rodeo",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924189",
   "ENTITY": "IND",
   "ENTITY NAME": "Alvarez",
   "ENTITY NAME CONT.": "Edward",
   "ENTITY CITY": "Pismo Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "The Foundation for Hispanic Education",
   "OCCUPATION": "Executive",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925064",
   "ENTITY": "IND",
   "ENTITY NAME": "Alves",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hardcastle Auto Body",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922956",
   "ENTITY": "IND",
   "ENTITY NAME": "Amend",
   "ENTITY NAME CONT.": "DanielT",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Toeniskoetter Development Inc.",
   "OCCUPATION": "Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925323",
   "ENTITY": "IND",
   "ENTITY NAME": "Ames",
   "ENTITY NAME CONT.": "LawrenceLowell",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924754",
   "ENTITY": "IND",
   "ENTITY NAME": "Andaluz",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown College Prep",
   "OCCUPATION": "Educator",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928248",
   "ENTITY": "IND",
   "ENTITY NAME": "Andaluz",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown College Prep",
   "OCCUPATION": "Educator",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933743",
   "ENTITY": "IND",
   "ENTITY NAME": "Andaluz",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown College Prep",
   "OCCUPATION": "Educator",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935733",
   "ENTITY": "IND",
   "ENTITY NAME": "Andaluz",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown College Prep",
   "OCCUPATION": "Educator",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961415",
   "ENTITY": "IND",
   "ENTITY NAME": "Andaluz",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown College Prep",
   "OCCUPATION": "Educator",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964644",
   "ENTITY": "IND",
   "ENTITY NAME": "Andaluz",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown College Prep",
   "OCCUPATION": "Educator",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923021",
   "ENTITY": "IND",
   "ENTITY NAME": "Anderson",
   "ENTITY NAME CONT.": "Kurt",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Kurt Anderson",
   "OCCUPATION": "Architect",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925156",
   "ENTITY": "IND",
   "ENTITY NAME": "Anderson",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "EditOne",
   "OCCUPATION": "Owner",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922951",
   "ENTITY": "IND",
   "ENTITY NAME": "Anderson",
   "ENTITY NAME CONT.": "Elliot",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hewlett Packard",
   "OCCUPATION": "IT Developer/Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT11",
   "ENTITY": "IND",
   "ENTITY NAME": "ANNE WALZER",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT12",
   "ENTITY": "IND",
   "ENTITY NAME": "ANNE WALZER",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT40",
   "ENTITY": "IND",
   "ENTITY NAME": "ANNE WALZER",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT20",
   "ENTITY": "IND",
   "ENTITY NAME": "ANNE WALZER",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 680
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT23",
   "ENTITY": "IND",
   "ENTITY NAME": "ANNE WALZER",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 333
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923334",
   "ENTITY": "IND",
   "ENTITY NAME": "Anstandig",
   "ENTITY NAME CONT.": "MarshallW.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Media News Group Inc",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925040",
   "ENTITY": "IND",
   "ENTITY NAME": "Anzoategui",
   "ENTITY NAME CONT.": "Daisy",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Devcon",
   "OCCUPATION": "Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924599",
   "ENTITY": "IND",
   "ENTITY NAME": "Araia",
   "ENTITY NAME CONT.": "Berhane",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Applied Materials",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924778",
   "ENTITY": "IND",
   "ENTITY NAME": "Arata",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "Arata Equipment Company",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925007",
   "ENTITY": "IND",
   "ENTITY NAME": "Arata",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Sanitation",
   "OCCUPATION": "Partner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923777",
   "ENTITY": "IND",
   "ENTITY NAME": "Arbaugh",
   "ENTITY NAME CONT.": "Dana",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Falcon Technology",
   "OCCUPATION": "Sales Rep",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923114",
   "ENTITY": "IND",
   "ENTITY NAME": "Arkin",
   "ENTITY NAME CONT.": "Alexander",
   "ENTITY CITY": "Warren",
   "Entity_ST": "VT",
   "EMPLOYER": "Alexander Arkin",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931690",
   "ENTITY": "IND",
   "ENTITY NAME": "Armanini",
   "ENTITY NAME CONT.": "Gregory",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "VMware",
   "OCCUPATION": "Product Management",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922996",
   "ENTITY": "IND",
   "ENTITY NAME": "Armstrong",
   "ENTITY NAME CONT.": "Gordon",
   "ENTITY CITY": "Woodside",
   "Entity_ST": "CA",
   "EMPLOYER": "Redwood Electric Group",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925080",
   "ENTITY": "IND",
   "ENTITY NAME": "Armstrong",
   "ENTITY NAME CONT.": "Diane",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Commercial Real Estate Broker",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989970",
   "ENTITY": "IND",
   "ENTITY NAME": "Armstrong",
   "ENTITY NAME CONT.": "Hilary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Foundation of Silicon Valley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923814",
   "ENTITY": "IND",
   "ENTITY NAME": "Armstrong Hill",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925006",
   "ENTITY": "IND",
   "ENTITY NAME": "Armstrong Hill",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924279",
   "ENTITY": "IND",
   "ENTITY NAME": "Arrillaga",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Newmark Cornish & Carey",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924261",
   "ENTITY": "IND",
   "ENTITY NAME": "Arvay",
   "ENTITY NAME CONT.": "Drew",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Cushman Wakefiled",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924302",
   "ENTITY": "IND",
   "ENTITY NAME": "Ashar",
   "ENTITY NAME CONT.": "Vaibhavi",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Calix",
   "OCCUPATION": "Engineer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924224",
   "ENTITY": "IND",
   "ENTITY NAME": "Attard",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Barbara Attard",
   "OCCUPATION": "Police Accountability Consultant",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923018",
   "ENTITY": "IND",
   "ENTITY NAME": "Atwell",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Deloitte",
   "OCCUPATION": "Certified Public Accountant",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924277",
   "ENTITY": "IND",
   "ENTITY NAME": "Aumack",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Catholic Community Foundation",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928245",
   "ENTITY": "IND",
   "ENTITY NAME": "Austin",
   "ENTITY NAME CONT.": "Manuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "American Media Solutions, Inc.",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923795",
   "ENTITY": "IND",
   "ENTITY NAME": "Avoy",
   "ENTITY NAME CONT.": "NancyO'Brien",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558267",
   "ENTITY": "IND",
   "ENTITY NAME": "Ayala",
   "ENTITY NAME CONT.": "Sebastian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 590
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558278",
   "ENTITY": "IND",
   "ENTITY NAME": "Ayala",
   "ENTITY NAME CONT.": "Sebastian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 355
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557359",
   "ENTITY": "IND",
   "ENTITY NAME": "Ayala",
   "ENTITY NAME CONT.": "Sebastian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 245
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923000",
   "ENTITY": "IND",
   "ENTITY NAME": "Badagliacco",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sperry Van Ness/SV Advisors",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924609",
   "ENTITY": "IND",
   "ENTITY NAME": "Bader",
   "ENTITY NAME CONT.": "PatriciaJ",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10983761",
   "ENTITY": "IND",
   "ENTITY NAME": "Badriyeh",
   "ENTITY NAME CONT.": "Najat",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Naprotek, Inc.",
   "OCCUPATION": "CEO/Founder",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924106",
   "ENTITY": "IND",
   "ENTITY NAME": "Badriyeh",
   "ENTITY NAME CONT.": "Najat",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Naprotek, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928265",
   "ENTITY": "IND",
   "ENTITY NAME": "Badriyeh",
   "ENTITY NAME CONT.": "Najat",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Naprotek, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923833",
   "ENTITY": "IND",
   "ENTITY NAME": "Baer",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "James Baer",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924295",
   "ENTITY": "IND",
   "ENTITY NAME": "Baer",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "James Baer",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552085",
   "ENTITY": "IND",
   "ENTITY NAME": "Baer",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924179",
   "ENTITY": "IND",
   "ENTITY NAME": "Bailey",
   "ENTITY NAME CONT.": "Jonathan",
   "ENTITY CITY": "Concord",
   "Entity_ST": "CA",
   "EMPLOYER": "Stevens, Ferrone & Bailey Engineering Co.",
   "OCCUPATION": "Civil Engineer",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928016",
   "ENTITY": "IND",
   "ENTITY NAME": "Baines",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936092",
   "ENTITY": "IND",
   "ENTITY NAME": "Bajwa",
   "ENTITY NAME CONT.": "Amarjit",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "7-Eleven",
   "OCCUPATION": "Owner/Operator",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931460",
   "ENTITY": "IND",
   "ENTITY NAME": "Bales",
   "ENTITY NAME CONT.": "AndrewR",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Symphony Silicon Valley",
   "OCCUPATION": "Arts Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925134",
   "ENTITY": "IND",
   "ENTITY NAME": "Balinton",
   "ENTITY NAME CONT.": "Milan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rise and Shine Consulting,LLC",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928260",
   "ENTITY": "IND",
   "ENTITY NAME": "Balinton",
   "ENTITY NAME CONT.": "Milan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rise and Shine Consulting, LLC",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922990",
   "ENTITY": "IND",
   "ENTITY NAME": "Ball",
   "ENTITY NAME CONT.": "Jon",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Hensel Phelps Construction Co.",
   "OCCUPATION": "Building Construction",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922991",
   "ENTITY": "IND",
   "ENTITY NAME": "Ball",
   "ENTITY NAME CONT.": "Paula",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928171",
   "ENTITY": "IND",
   "ENTITY NAME": "Ball",
   "ENTITY NAME CONT.": "AndrewJ",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "RAD Urban",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925346",
   "ENTITY": "IND",
   "ENTITY NAME": "Ballesteros",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Hoge, Fenton, Jones & Appel",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922969",
   "ENTITY": "IND",
   "ENTITY NAME": "Bamburg",
   "ENTITY NAME CONT.": "Bonnie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bonnie Bamburg",
   "OCCUPATION": "Historic Preservation Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935156",
   "ENTITY": "IND",
   "ENTITY NAME": "Bangalore",
   "ENTITY NAME CONT.": "Hari",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mexicali Grill",
   "OCCUPATION": "General Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10962103",
   "ENTITY": "IND",
   "ENTITY NAME": "Bangs",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Oracle",
   "OCCUPATION": "Vice President",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558293",
   "ENTITY": "IND",
   "ENTITY NAME": "Barajas",
   "ENTITY NAME CONT.": "Christian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 494
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557366",
   "ENTITY": "IND",
   "ENTITY NAME": "Barajas",
   "ENTITY NAME CONT.": "Christian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 437
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930959",
   "ENTITY": "IND",
   "ENTITY NAME": "Barnard",
   "ENTITY NAME CONT.": "WilliamFranklin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Aene Automotive Corporation",
   "OCCUPATION": "President",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923061",
   "ENTITY": "IND",
   "ENTITY NAME": "Baron",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mobilehome Communities of America",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922992",
   "ENTITY": "IND",
   "ENTITY NAME": "Barrett",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "Portland",
   "Entity_ST": "OR",
   "EMPLOYER": "Department of Veterans Affairs",
   "OCCUPATION": "Physician",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922993",
   "ENTITY": "IND",
   "ENTITY NAME": "Barrett",
   "ENTITY NAME CONT.": "Robin",
   "ENTITY CITY": "Portland",
   "Entity_ST": "OR",
   "EMPLOYER": "Northwest Womens Clinic",
   "OCCUPATION": "Physician",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924762",
   "ENTITY": "IND",
   "ENTITY NAME": "Barsanti",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Race Street Partners",
   "OCCUPATION": "Vice President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925142",
   "ENTITY": "IND",
   "ENTITY NAME": "Bartels-Mein",
   "ENTITY NAME CONT.": "Valerie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate Services",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556856",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558298",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1438
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556836",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1198
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557307",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1075
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558302",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1042
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556857",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556855",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 950
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556846",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 925
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556848",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556847",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 379
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556835",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558309",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 42
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558299",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 32
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555981",
   "ENTITY": "IND",
   "ENTITY NAME": "Baumgartner",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924208",
   "ENTITY": "IND",
   "ENTITY NAME": "Beatty",
   "ENTITY NAME CONT.": "Rick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Alessandra Foundation",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925095",
   "ENTITY": "IND",
   "ENTITY NAME": "Bell",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Cristo Rey San Jose Jesuit High School",
   "OCCUPATION": "COO",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928273",
   "ENTITY": "IND",
   "ENTITY NAME": "Bellafronto",
   "ENTITY NAME CONT.": "Eric",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Littler Mendelson",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923796",
   "ENTITY": "IND",
   "ENTITY NAME": "Belmonte",
   "ENTITY NAME CONT.": "Luis",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10962159",
   "ENTITY": "IND",
   "ENTITY NAME": "Bennette",
   "ENTITY NAME CONT.": "StephenJ.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923076",
   "ENTITY": "IND",
   "ENTITY NAME": "Berg",
   "ENTITY NAME CONT.": "RichardP",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923003",
   "ENTITY": "IND",
   "ENTITY NAME": "Berger",
   "ENTITY NAME CONT.": "Ed",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Ed Berger",
   "OCCUPATION": "Chemist",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924262",
   "ENTITY": "IND",
   "ENTITY NAME": "Berger",
   "ENTITY NAME CONT.": "Ed",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Ed Berger",
   "OCCUPATION": "Chemist",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922949",
   "ENTITY": "IND",
   "ENTITY NAME": "Berkes",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Federal Realty Investment Trust",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925338",
   "ENTITY": "IND",
   "ENTITY NAME": "Berkey",
   "ENTITY NAME CONT.": "MaryL",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Windsor Union School District",
   "OCCUPATION": "Director of Human Resources",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964309",
   "ENTITY": "IND",
   "ENTITY NAME": "Berman",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zoom",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922910",
   "ENTITY": "IND",
   "ENTITY NAME": "Bernal",
   "ENTITY NAME CONT.": "Mary Carol",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Los Gatos-Saratoga Union High School District",
   "OCCUPATION": "Guidance Counselor",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923507",
   "ENTITY": "IND",
   "ENTITY NAME": "Bernal",
   "ENTITY NAME CONT.": "ThomasC.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Home Depot",
   "OCCUPATION": "Supervisor",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553742",
   "ENTITY": "IND",
   "ENTITY NAME": "Bernal",
   "ENTITY NAME CONT.": "Grace",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 160
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553399",
   "ENTITY": "IND",
   "ENTITY NAME": "Bernal",
   "ENTITY NAME CONT.": "Grace",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 120
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964804",
   "ENTITY": "IND",
   "ENTITY NAME": "Berry",
   "ENTITY NAME CONT.": "Steven",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "NeoPhotonics Corporation",
   "OCCUPATION": "Vice President, Finance",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922968",
   "ENTITY": "IND",
   "ENTITY NAME": "Bert",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Joseph George Wines",
   "OCCUPATION": "Wine Sales",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923495",
   "ENTITY": "IND",
   "ENTITY NAME": "Bettencourt",
   "ENTITY NAME CONT.": "Manuel",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924673",
   "ENTITY": "IND",
   "ENTITY NAME": "Beverley",
   "ENTITY NAME CONT.": "Dawnet",
   "ENTITY CITY": "Port Saint Lucie",
   "Entity_ST": "FL",
   "EMPLOYER": "Donnelley Financial Solutions",
   "OCCUPATION": "Senior Vice President & Managing Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924259",
   "ENTITY": "IND",
   "ENTITY NAME": "Bhandari",
   "ENTITY NAME CONT.": "Rajan",
   "ENTITY CITY": "Los Altos Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "The Permanente Medical Group, Inc.",
   "OCCUPATION": "Neurologist",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936087",
   "ENTITY": "IND",
   "ENTITY NAME": "Bhatia",
   "ENTITY NAME CONT.": "Ajay",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Apple, Inc",
   "OCCUPATION": "Engineer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928235",
   "ENTITY": "IND",
   "ENTITY NAME": "Biagini",
   "ENTITY NAME CONT.": "Theodore",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925288",
   "ENTITY": "IND",
   "ENTITY NAME": "Biagini",
   "ENTITY NAME CONT.": "ThomasJ",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Biagini Properties",
   "OCCUPATION": "Real Estate Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924242",
   "ENTITY": "IND",
   "ENTITY NAME": "Bialson",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924116",
   "ENTITY": "IND",
   "ENTITY NAME": "Biggar",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Orchard Partners",
   "OCCUPATION": "Investor",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924700",
   "ENTITY": "IND",
   "ENTITY NAME": "Binder",
   "ENTITY NAME CONT.": "Heinz",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Binder & Malter LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935166",
   "ENTITY": "IND",
   "ENTITY NAME": "Bird",
   "ENTITY NAME CONT.": "Tiffany",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CBRE",
   "OCCUPATION": "Commercial Real Estate Advisor",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924271",
   "ENTITY": "IND",
   "ENTITY NAME": "Birdwell",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Sares Regis",
   "OCCUPATION": "President, Commercial Development",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922984",
   "ENTITY": "IND",
   "ENTITY NAME": "Bizelli",
   "ENTITY NAME CONT.": "Tracy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Facebook",
   "OCCUPATION": "Training Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923351",
   "ENTITY": "IND",
   "ENTITY NAME": "Blach",
   "ENTITY NAME CONT.": "Margaret",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "S.V. Equipment Leasing",
   "OCCUPATION": "Business Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923352",
   "ENTITY": "IND",
   "ENTITY NAME": "Blach",
   "ENTITY NAME CONT.": "MichaelJ",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "S.V. Equipment Leasing",
   "OCCUPATION": "Business Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923494",
   "ENTITY": "IND",
   "ENTITY NAME": "Black",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "CBRE",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925114",
   "ENTITY": "IND",
   "ENTITY NAME": "Black",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "CBRE",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934228",
   "ENTITY": "IND",
   "ENTITY NAME": "Blackman",
   "ENTITY NAME CONT.": "JamesW",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "James W Blackman Professional Corp",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924048",
   "ENTITY": "IND",
   "ENTITY NAME": "Bland",
   "ENTITY NAME CONT.": "Seth",
   "ENTITY CITY": "Pleasanton",
   "Entity_ST": "CA",
   "EMPLOYER": "Federal Realty Investment Trust",
   "OCCUPATION": "Project Maker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987371",
   "ENTITY": "IND",
   "ENTITY NAME": "Blank",
   "ENTITY NAME CONT.": "Mitchell",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930452",
   "ENTITY": "IND",
   "ENTITY NAME": "Blewett",
   "ENTITY NAME CONT.": "Piers",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Schwegman",
   "OCCUPATION": "Patent Attorney",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964639",
   "ENTITY": "IND",
   "ENTITY NAME": "Bojorquez",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "NTS",
   "OCCUPATION": "Sales Engineer",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923783",
   "ENTITY": "IND",
   "ENTITY NAME": "Boncher",
   "ENTITY NAME CONT.": "JohnC.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Electric",
   "OCCUPATION": "President and CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926757",
   "ENTITY": "IND",
   "ENTITY NAME": "Boncher",
   "ENTITY NAME CONT.": "Brett",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Electric, Inc.",
   "OCCUPATION": "Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924267",
   "ENTITY": "IND",
   "ENTITY NAME": "Bonesteel",
   "ENTITY NAME CONT.": "Eric",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Associate Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925128",
   "ENTITY": "IND",
   "ENTITY NAME": "Boothe",
   "ENTITY NAME CONT.": "Tim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bridge Bank",
   "OCCUPATION": "Banker",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924742",
   "ENTITY": "IND",
   "ENTITY NAME": "Borelli",
   "ENTITY NAME CONT.": "Ralph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Borelli Investment Co.",
   "OCCUPATION": "President",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924207",
   "ENTITY": "IND",
   "ENTITY NAME": "Boscia",
   "ENTITY NAME CONT.": "Kristin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kristin Boscia",
   "OCCUPATION": "Attorney",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925075",
   "ENTITY": "IND",
   "ENTITY NAME": "Bowers",
   "ENTITY NAME CONT.": "Kristi",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Kings Mtn Vineyards",
   "OCCUPATION": "Sales and Marketing",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934229",
   "ENTITY": "IND",
   "ENTITY NAME": "Boxer",
   "ENTITY NAME CONT.": "Amy",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Pura Vida Design Group",
   "OCCUPATION": "Owner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924698",
   "ENTITY": "IND",
   "ENTITY NAME": "Boyarsky",
   "ENTITY NAME CONT.": "Jay",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Deputy District Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922986",
   "ENTITY": "IND",
   "ENTITY NAME": "Boyd",
   "ENTITY NAME CONT.": "Betty",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Premium Parks Property Mgt.",
   "OCCUPATION": "Property Management",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924147",
   "ENTITY": "IND",
   "ENTITY NAME": "Bozzuto",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bozzuto Insurance",
   "OCCUPATION": "Sales",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984880",
   "ENTITY": "IND",
   "ENTITY NAME": "Bramson",
   "ENTITY NAME CONT.": "Ray",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "Chief Impact Officer",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987372",
   "ENTITY": "IND",
   "ENTITY NAME": "Brandenburg",
   "ENTITY NAME CONT.": "DianeM.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg, Staedler & Moore",
   "OCCUPATION": "Real Estate Investment",
   "AMOUNT": 49500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923819",
   "ENTITY": "IND",
   "ENTITY NAME": "Brandenburg",
   "ENTITY NAME CONT.": "LeeH.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg, Staedler & Moore",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923820",
   "ENTITY": "IND",
   "ENTITY NAME": "Brandenburg",
   "ENTITY NAME CONT.": "DianeM.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brandenburg, Staedler & Moore",
   "OCCUPATION": "Real Estate Investment",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924162",
   "ENTITY": "IND",
   "ENTITY NAME": "Braunstein",
   "ENTITY NAME CONT.": "RobertM.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Annabelle Productions",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931685",
   "ENTITY": "IND",
   "ENTITY NAME": "Brear",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Danville",
   "Entity_ST": "CA",
   "EMPLOYER": "Veriflow",
   "OCCUPATION": "Technology",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922962",
   "ENTITY": "IND",
   "ENTITY NAME": "Bretschneider",
   "ENTITY NAME CONT.": "Ric",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925144",
   "ENTITY": "IND",
   "ENTITY NAME": "Bretschneider",
   "ENTITY NAME CONT.": "Ric",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923472",
   "ENTITY": "IND",
   "ENTITY NAME": "Briggs",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Facebook",
   "OCCUPATION": "Chief Marketing Officer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923474",
   "ENTITY": "IND",
   "ENTITY NAME": "Briggs",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Catherine Briggs",
   "OCCUPATION": "College Fundraiser",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933732",
   "ENTITY": "IND",
   "ENTITY NAME": "Brilliot",
   "ENTITY NAME CONT.": "Reena",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Economic Development",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556735",
   "ENTITY": "IND",
   "ENTITY NAME": "Brooks",
   "ENTITY NAME CONT.": "Rowan",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1245
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964928",
   "ENTITY": "IND",
   "ENTITY NAME": "Brooks",
   "ENTITY NAME CONT.": "Anna",
   "ENTITY CITY": "Clovis",
   "Entity_ST": "CA",
   "EMPLOYER": "PG&E",
   "OCCUPATION": "Public Affairs",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928207",
   "ENTITY": "IND",
   "ENTITY NAME": "Brooks",
   "ENTITY NAME CONT.": "Suzy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Campbell Union High School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924621",
   "ENTITY": "IND",
   "ENTITY NAME": "Brouillette",
   "ENTITY NAME CONT.": "Sarah",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sarah Brouillette",
   "OCCUPATION": "Bookkeeper",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924180",
   "ENTITY": "IND",
   "ENTITY NAME": "Brown",
   "ENTITY NAME CONT.": "RichardThomas",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "R & C Brown Associates",
   "OCCUPATION": "Printer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925343",
   "ENTITY": "IND",
   "ENTITY NAME": "Brown",
   "ENTITY NAME CONT.": "Al",
   "ENTITY CITY": "Roswell",
   "Entity_ST": "GA",
   "EMPLOYER": "SmartWave Technologies",
   "OCCUPATION": "CEO",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964011",
   "ENTITY": "IND",
   "ENTITY NAME": "Bruni",
   "ENTITY NAME CONT.": "Arnold",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "ELS Properties",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964007",
   "ENTITY": "IND",
   "ENTITY NAME": "Bruni",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Oracle",
   "OCCUPATION": "Senior Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924276",
   "ENTITY": "IND",
   "ENTITY NAME": "Bryant",
   "ENTITY NAME CONT.": "Virginia",
   "ENTITY CITY": "Vallejo",
   "Entity_ST": "CA",
   "EMPLOYER": "Sares Regis Group of Northern California",
   "OCCUPATION": "CFO/COO",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990942",
   "ENTITY": "IND",
   "ENTITY NAME": "Buchanan",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partnerships USA",
   "OCCUPATION": "Policy Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925292",
   "ENTITY": "IND",
   "ENTITY NAME": "Bui",
   "ENTITY NAME CONT.": "Binh",
   "ENTITY CITY": "Visalia",
   "Entity_ST": "CA",
   "EMPLOYER": "SiliconSage Builders",
   "OCCUPATION": "Photographer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925293",
   "ENTITY": "IND",
   "ENTITY NAME": "Bui",
   "ENTITY NAME CONT.": "Ly",
   "ENTITY CITY": "Visalia",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928220",
   "ENTITY": "IND",
   "ENTITY NAME": "Buigas",
   "ENTITY NAME CONT.": "Gabriel",
   "ENTITY CITY": "Coral Gables",
   "Entity_ST": "FL",
   "EMPLOYER": "UnitedLex",
   "OCCUPATION": "Executive Leadership",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922981",
   "ENTITY": "IND",
   "ENTITY NAME": "Burbank",
   "ENTITY NAME CONT.": "StevenRay",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Campbell Union School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933735",
   "ENTITY": "IND",
   "ENTITY NAME": "Burbank",
   "ENTITY NAME CONT.": "StevenRay",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Campbell Union School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923501",
   "ENTITY": "IND",
   "ENTITY NAME": "Burd",
   "ENTITY NAME CONT.": "ScottDavid",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Initiative Surgical",
   "OCCUPATION": "Medical Sales",
   "AMOUNT": 125
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923484",
   "ENTITY": "IND",
   "ENTITY NAME": "Burgoon",
   "ENTITY NAME CONT.": "J. Robert",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924195",
   "ENTITY": "IND",
   "ENTITY NAME": "Burke",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "eBay",
   "OCCUPATION": "Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924045",
   "ENTITY": "IND",
   "ENTITY NAME": "Burroughs",
   "ENTITY NAME CONT.": "Joshua",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Cadre Urban LLC",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923074",
   "ENTITY": "IND",
   "ENTITY NAME": "Burroughs",
   "ENTITY NAME CONT.": "Christine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Keller Williams",
   "OCCUPATION": "Realtor",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924152",
   "ENTITY": "IND",
   "ENTITY NAME": "Burton",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Plantronics, Inc.",
   "OCCUPATION": "Executive",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931683",
   "ENTITY": "IND",
   "ENTITY NAME": "Busselen",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Danville",
   "Entity_ST": "CA",
   "EMPLOYER": "CrowdStrike",
   "OCCUPATION": "Marketing",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931465",
   "ENTITY": "IND",
   "ENTITY NAME": "Bynum",
   "ENTITY NAME CONT.": "O.W.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925301",
   "ENTITY": "IND",
   "ENTITY NAME": "Cabrera",
   "ENTITY NAME CONT.": "Christopher",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Xactly Corp",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936077",
   "ENTITY": "IND",
   "ENTITY NAME": "Cady",
   "ENTITY NAME CONT.": "MichaelBartlett",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Century Communities",
   "OCCUPATION": "Project Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924705",
   "ENTITY": "IND",
   "ENTITY NAME": "Calegari",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Sanitation Inc.",
   "OCCUPATION": "General Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930960",
   "ENTITY": "IND",
   "ENTITY NAME": "Callahan",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "LinkedIn",
   "OCCUPATION": "General Counsel",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923784",
   "ENTITY": "IND",
   "ENTITY NAME": "Calvin",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Electric",
   "OCCUPATION": "VP, Operations",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934366",
   "ENTITY": "IND",
   "ENTITY NAME": "Camacho",
   "ENTITY NAME CONT.": "Norma",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Valley Water District",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924286",
   "ENTITY": "IND",
   "ENTITY NAME": "Campisi",
   "ENTITY NAME CONT.": "DionD.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Commercial Broker",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925158",
   "ENTITY": "IND",
   "ENTITY NAME": "Campos",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "KRZZ",
   "OCCUPATION": "Sales",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924220",
   "ENTITY": "IND",
   "ENTITY NAME": "Caputo",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924151",
   "ENTITY": "IND",
   "ENTITY NAME": "Caputo",
   "ENTITY NAME CONT.": "Ben",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CBRE",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924682",
   "ENTITY": "IND",
   "ENTITY NAME": "Caputo",
   "ENTITY NAME CONT.": "PaulF",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Caputo & Van Der Walde, LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924150",
   "ENTITY": "IND",
   "ENTITY NAME": "Caputo Jr",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Dan Caputo Co.",
   "OCCUPATION": "Property Management",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925157",
   "ENTITY": "IND",
   "ENTITY NAME": "Cardozo",
   "ENTITY NAME CONT.": "Denyse",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Forum",
   "OCCUPATION": "CEO",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923073",
   "ENTITY": "IND",
   "ENTITY NAME": "Cardus",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Association of Realtors",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922925",
   "ENTITY": "IND",
   "ENTITY NAME": "Carlquist",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Carlquist & McClellan",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925014",
   "ENTITY": "IND",
   "ENTITY NAME": "Carlton",
   "ENTITY NAME CONT.": "Lucy",
   "ENTITY CITY": "Petaluma",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923328",
   "ENTITY": "IND",
   "ENTITY NAME": "Carr",
   "ENTITY NAME CONT.": "Gea",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925316",
   "ENTITY": "IND",
   "ENTITY NAME": "Carter",
   "ENTITY NAME CONT.": "Dennise",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923009",
   "ENTITY": "IND",
   "ENTITY NAME": "Carvalho",
   "ENTITY NAME CONT.": "Kenny",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City Towing & Automotive",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928030",
   "ENTITY": "IND",
   "ENTITY NAME": "Casad",
   "ENTITY NAME CONT.": "StevenJ",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923081",
   "ENTITY": "IND",
   "ENTITY NAME": "Casella",
   "ENTITY NAME CONT.": "Gregory",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Catered Too",
   "OCCUPATION": "Caterer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922976",
   "ENTITY": "IND",
   "ENTITY NAME": "Cassin",
   "ENTITY NAME CONT.": "B J",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "B J Cassin",
   "OCCUPATION": "Venture Capitalist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928228",
   "ENTITY": "IND",
   "ENTITY NAME": "Casto",
   "ENTITY NAME CONT.": "Marc",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Casto Travel",
   "OCCUPATION": "CEO and President",
   "AMOUNT": 750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557399",
   "ENTITY": "IND",
   "ENTITY NAME": "Castro",
   "ENTITY NAME CONT.": "Huascar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 118
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964933",
   "ENTITY": "IND",
   "ENTITY NAME": "Cecil",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "MC2 Bay Area",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924164",
   "ENTITY": "IND",
   "ENTITY NAME": "Chadwick",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Attorney",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984775",
   "ENTITY": "IND",
   "ENTITY NAME": "Chamberlin",
   "ENTITY NAME CONT.": "JudithK.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924750",
   "ENTITY": "IND",
   "ENTITY NAME": "Chamorro",
   "ENTITY NAME CONT.": "Alan",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Lowe",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928166",
   "ENTITY": "IND",
   "ENTITY NAME": "Chan",
   "ENTITY NAME CONT.": "Sherman",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "CBRE",
   "OCCUPATION": "Commercial Real Estate Agent",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557328",
   "ENTITY": "IND",
   "ENTITY NAME": "Chater",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2588
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557337",
   "ENTITY": "IND",
   "ENTITY NAME": "Chater",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1517
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964109",
   "ENTITY": "IND",
   "ENTITY NAME": "Chatterjee",
   "ENTITY NAME CONT.": "Indra",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Goodwin Procter",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924752",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Irene",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Kaiser Permanente",
   "OCCUPATION": "Hospital Administrator",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558266",
   "ENTITY": "IND",
   "ENTITY NAME": "Chen",
   "ENTITY NAME CONT.": "Sarah",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558279",
   "ENTITY": "IND",
   "ENTITY NAME": "Chen",
   "ENTITY NAME CONT.": "Sarah",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 460
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557360",
   "ENTITY": "IND",
   "ENTITY NAME": "Chen",
   "ENTITY NAME CONT.": "Sarah",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 155
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924766",
   "ENTITY": "IND",
   "ENTITY NAME": "Chen",
   "ENTITY NAME CONT.": "Ben",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "China Unicorn Americas",
   "OCCUPATION": "Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924753",
   "ENTITY": "IND",
   "ENTITY NAME": "Cheney",
   "ENTITY NAME CONT.": "Brittain",
   "ENTITY CITY": "Pleasanton",
   "Entity_ST": "CA",
   "EMPLOYER": "Cushman & Wakefield",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940283",
   "ENTITY": "IND",
   "ENTITY NAME": "Chien",
   "ENTITY NAME CONT.": "Cary",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "McDermott Will & Emery",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931470",
   "ENTITY": "IND",
   "ENTITY NAME": "Chirco",
   "ENTITY NAME CONT.": "Judy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935167",
   "ENTITY": "IND",
   "ENTITY NAME": "Chon",
   "ENTITY NAME CONT.": "Hyoung Shim",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "CBRE",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923349",
   "ENTITY": "IND",
   "ENTITY NAME": "Christensen",
   "ENTITY NAME CONT.": "DennisE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Dennis Christensen",
   "OCCUPATION": "Business Consultant",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928234",
   "ENTITY": "IND",
   "ENTITY NAME": "Chuck",
   "ENTITY NAME CONT.": "Samuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rossi, Hamerslough, Reischl & Chuck",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934076",
   "ENTITY": "IND",
   "ENTITY NAME": "Chung",
   "ENTITY NAME CONT.": "Suehyun",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "Sprint",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923831",
   "ENTITY": "IND",
   "ENTITY NAME": "Cilker",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cilker Orchards",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923506",
   "ENTITY": "IND",
   "ENTITY NAME": "Cilker",
   "ENTITY NAME CONT.": "JamesH",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Pine Cone Lumber Co., Inc",
   "OCCUPATION": "Owner",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924269",
   "ENTITY": "IND",
   "ENTITY NAME": "Cinnamon",
   "ENTITY NAME CONT.": "Barry",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Cinnamon Energy Systems",
   "OCCUPATION": "Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924765",
   "ENTITY": "IND",
   "ENTITY NAME": "Cioth",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Eastdil Secured",
   "OCCUPATION": "Commercial Real Estate Sales",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923345",
   "ENTITY": "IND",
   "ENTITY NAME": "Clare",
   "ENTITY NAME CONT.": "Shari",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zoom",
   "OCCUPATION": "Technical Writer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928163",
   "ENTITY": "IND",
   "ENTITY NAME": "Clements",
   "ENTITY NAME CONT.": "Kristen",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Manager",
   "AMOUNT": 75
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984882",
   "ENTITY": "IND",
   "ENTITY NAME": "Clements",
   "ENTITY NAME CONT.": "Kristen",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Division Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925147",
   "ENTITY": "IND",
   "ENTITY NAME": "Coburn",
   "ENTITY NAME CONT.": "Lawrence",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "DoubleDutch",
   "OCCUPATION": "Entrepreneur",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC10",
   "ENTITY": "IND",
   "ENTITY NAME": "COCHRAN",
   "ENTITY NAME CONT.": "NICHOLAS",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "COCHRAN AND ASSOCIATES",
   "OCCUPATION": "CPA",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964096",
   "ENTITY": "IND",
   "ENTITY NAME": "Cogan",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Bain & Company",
   "OCCUPATION": "Management Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924278",
   "ENTITY": "IND",
   "ENTITY NAME": "Colburn",
   "ENTITY NAME CONT.": "Cyrus",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Steel Wave",
   "OCCUPATION": "Construction",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924123",
   "ENTITY": "IND",
   "ENTITY NAME": "Coleman",
   "ENTITY NAME CONT.": "WilliamT",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Veritas Technologies LLC",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10993137",
   "ENTITY": "IND",
   "ENTITY NAME": "Colla",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924227",
   "ENTITY": "IND",
   "ENTITY NAME": "Collins",
   "ENTITY NAME CONT.": "Sean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara University",
   "OCCUPATION": "Director, Environment, Health & Safety",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924748",
   "ENTITY": "IND",
   "ENTITY NAME": "Comiskey",
   "ENTITY NAME CONT.": "Hannah",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922907",
   "ENTITY": "IND",
   "ENTITY NAME": "Conant",
   "ENTITY NAME CONT.": "Alana",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Storefront Political Media",
   "OCCUPATION": "Consultant",
   "AMOUNT": 2
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928218",
   "ENTITY": "IND",
   "ENTITY NAME": "Connelly",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Swenson Builders",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923060",
   "ENTITY": "IND",
   "ENTITY NAME": "Conniff",
   "ENTITY NAME CONT.": "Sandi",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925431",
   "ENTITY": "IND",
   "ENTITY NAME": "Connolly",
   "ENTITY NAME CONT.": "Damon",
   "ENTITY CITY": "San Rafael",
   "Entity_ST": "CA",
   "EMPLOYER": "Marin County",
   "OCCUPATION": "County Supervisor",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924755",
   "ENTITY": "IND",
   "ENTITY NAME": "Cooper",
   "ENTITY NAME CONT.": "JanetK",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924678",
   "ENTITY": "IND",
   "ENTITY NAME": "Copeland",
   "ENTITY NAME CONT.": "JamesM.",
   "ENTITY CITY": "Carmel Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "CJ Lake, LLC",
   "OCCUPATION": "Consultant",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924292",
   "ENTITY": "IND",
   "ENTITY NAME": "Cord",
   "ENTITY NAME CONT.": "Henry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cord Associates",
   "OCCUPATION": "Land Use Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924246",
   "ENTITY": "IND",
   "ENTITY NAME": "Corsiglia",
   "ENTITY NAME CONT.": "Victor",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961417",
   "ENTITY": "IND",
   "ENTITY NAME": "Corsiglia Bondi",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Armanino LLP",
   "OCCUPATION": "CPA",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923322",
   "ENTITY": "IND",
   "ENTITY NAME": "Cottle",
   "ENTITY NAME CONT.": "SeanA",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Hoge Fenton",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924272",
   "ENTITY": "IND",
   "ENTITY NAME": "Courtney",
   "ENTITY NAME CONT.": "Todd",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Max Rhymes",
   "OCCUPATION": "Author",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924296",
   "ENTITY": "IND",
   "ENTITY NAME": "Cox",
   "ENTITY NAME CONT.": "Gene",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Custom Drywall Inc.",
   "OCCUPATION": "Drywall Contractor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924190",
   "ENTITY": "IND",
   "ENTITY NAME": "Crane",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Govern for California",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923803",
   "ENTITY": "IND",
   "ENTITY NAME": "Crawford",
   "ENTITY NAME CONT.": "Gay",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924604",
   "ENTITY": "IND",
   "ENTITY NAME": "Crisham",
   "ENTITY NAME CONT.": "Estella Margaret",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925155",
   "ENTITY": "IND",
   "ENTITY NAME": "Crisham",
   "ENTITY NAME CONT.": "Estella Margaret",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964111",
   "ENTITY": "IND",
   "ENTITY NAME": "Crisham",
   "ENTITY NAME CONT.": "Estella Margaret",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10993136",
   "ENTITY": "IND",
   "ENTITY NAME": "Crisham",
   "ENTITY NAME CONT.": "Estella Margaret",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928267",
   "ENTITY": "IND",
   "ENTITY NAME": "Crisham",
   "ENTITY NAME CONT.": "Susan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928266",
   "ENTITY": "IND",
   "ENTITY NAME": "Crisham",
   "ENTITY NAME CONT.": "Estella Margaret",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924614",
   "ENTITY": "IND",
   "ENTITY NAME": "Cristina",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Greenwaste Recovery, Inc.",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924615",
   "ENTITY": "IND",
   "ENTITY NAME": "Cristina",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Zanker Road Resource Management",
   "OCCUPATION": "Director of Environmental Services",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925341",
   "ENTITY": "IND",
   "ENTITY NAME": "Cristina",
   "ENTITY NAME CONT.": "BarryR.",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "GreenWaste Recovery, Inc.",
   "OCCUPATION": "Management",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924756",
   "ENTITY": "IND",
   "ENTITY NAME": "Cropper",
   "ENTITY NAME CONT.": "DavidP",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "TMG Partners",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964104",
   "ENTITY": "IND",
   "ENTITY NAME": "Cruz",
   "ENTITY NAME CONT.": "MayraE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "De Anza College",
   "OCCUPATION": "Educator",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922923",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunneen",
   "ENTITY NAME CONT.": "JamesF.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies LLC",
   "OCCUPATION": "Principal",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925318",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunningham",
   "ENTITY NAME CONT.": "DennisE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Databricks Inc",
   "OCCUPATION": "Financial Planner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925295",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunningham",
   "ENTITY NAME CONT.": "Leo",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Wilson Sonsini Goodrich & Rosati",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925143",
   "ENTITY": "IND",
   "ENTITY NAME": "Curia",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924186",
   "ENTITY": "IND",
   "ENTITY NAME": "Curia",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924601",
   "ENTITY": "IND",
   "ENTITY NAME": "Curran",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924589",
   "ENTITY": "IND",
   "ENTITY NAME": "Curtis",
   "ENTITY NAME CONT.": "HobartL",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930455",
   "ENTITY": "IND",
   "ENTITY NAME": "Cush",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Virgin America",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964641",
   "ENTITY": "IND",
   "ENTITY NAME": "Cushman",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Cushman & Wakefield",
   "OCCUPATION": "Executive Managing Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925151",
   "ENTITY": "IND",
   "ENTITY NAME": "D'Arpino",
   "ENTITY NAME CONT.": "Vince",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "S&S Welding Inc",
   "OCCUPATION": "President",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924280",
   "ENTITY": "IND",
   "ENTITY NAME": "Daaboul",
   "ENTITY NAME CONT.": "Adolf",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VTA",
   "OCCUPATION": "Civil Engineer",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC52",
   "ENTITY": "IND",
   "ENTITY NAME": "DACHS",
   "ENTITY NAME CONT.": "LAURA",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "S.D. BECHTEL JR. FOUNDATION",
   "OCCUPATION": "PRESIDENT",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922988",
   "ENTITY": "IND",
   "ENTITY NAME": "Dahlberg",
   "ENTITY NAME CONT.": "Roger",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SeaTec LLC",
   "OCCUPATION": "System Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924119",
   "ENTITY": "IND",
   "ENTITY NAME": "Dailey",
   "ENTITY NAME CONT.": "Todd",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Apple, Inc.",
   "OCCUPATION": "Technology",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990355",
   "ENTITY": "IND",
   "ENTITY NAME": "Daily",
   "ENTITY NAME CONT.": "DeanAllan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923505",
   "ENTITY": "IND",
   "ENTITY NAME": "Daily",
   "ENTITY NAME CONT.": "DeanAllan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Real Estate Solutions",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925319",
   "ENTITY": "IND",
   "ENTITY NAME": "Dakin",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Adobe",
   "OCCUPATION": "Engineering Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925044",
   "ENTITY": "IND",
   "ENTITY NAME": "Daley",
   "ENTITY NAME CONT.": "Craig",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Daley's Drywall",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928335",
   "ENTITY": "IND",
   "ENTITY NAME": "Dalma",
   "ENTITY NAME CONT.": "Gina",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "Program Officer",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924115",
   "ENTITY": "IND",
   "ENTITY NAME": "Daniels",
   "ENTITY NAME CONT.": "Lisa",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "KPMG",
   "OCCUPATION": "Partner",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930961",
   "ENTITY": "IND",
   "ENTITY NAME": "Darpino",
   "ENTITY NAME CONT.": "Nick",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924191",
   "ENTITY": "IND",
   "ENTITY NAME": "Daryabari",
   "ENTITY NAME CONT.": "Bita",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Pars Equality Center",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925090",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "Edward",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Petrinovich Pugh & Company",
   "OCCUPATION": "Certified Public Accountant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925152",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "Heidi",
   "ENTITY CITY": "Fairfield",
   "Entity_ST": "CT",
   "EMPLOYER": "Heidi Davis",
   "OCCUPATION": "Physician",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928185",
   "ENTITY": "IND",
   "ENTITY NAME": "Davis",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Newmark Knight Frank",
   "OCCUPATION": "Commercial Real Estate Appraiser",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924047",
   "ENTITY": "IND",
   "ENTITY NAME": "Dawson",
   "ENTITY NAME CONT.": "JohnP.",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925130",
   "ENTITY": "IND",
   "ENTITY NAME": "Dawson",
   "ENTITY NAME CONT.": "Leah",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "Gomez Trial Attorneys",
   "OCCUPATION": "Director of Outreach",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925050",
   "ENTITY": "IND",
   "ENTITY NAME": "Day",
   "ENTITY NAME CONT.": "Vicki",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mineta San Jose Intl. Airport",
   "OCCUPATION": "Director of Marketing",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923355",
   "ENTITY": "IND",
   "ENTITY NAME": "De",
   "ENTITY NAME CONT.": "Avik",
   "ENTITY CITY": "Frisco",
   "Entity_ST": "TX",
   "EMPLOYER": "Silicon Sage Builders",
   "OCCUPATION": "Finance",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923808",
   "ENTITY": "IND",
   "ENTITY NAME": "de Geus",
   "ENTITY NAME CONT.": "Aart",
   "ENTITY CITY": "Los Altos Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "Synopsys, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923112",
   "ENTITY": "IND",
   "ENTITY NAME": "de Grandpre",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Mendham",
   "Entity_ST": "NJ",
   "EMPLOYER": "Lonza",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923113",
   "ENTITY": "IND",
   "ENTITY NAME": "De Grandpre",
   "ENTITY NAME CONT.": "Jocelyn",
   "ENTITY CITY": "Mendham",
   "Entity_ST": "NJ",
   "EMPLOYER": "Intel",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964113",
   "ENTITY": "IND",
   "ENTITY NAME": "De Laplaine",
   "ENTITY NAME CONT.": "Charlotte",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934812",
   "ENTITY": "IND",
   "ENTITY NAME": "Dean",
   "ENTITY NAME CONT.": "Alexander",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Hawk Hill Management LLC",
   "OCCUPATION": "Investor & Chairman",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925335",
   "ENTITY": "IND",
   "ENTITY NAME": "Degutis",
   "ENTITY NAME CONT.": "Martie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924639",
   "ENTITY": "IND",
   "ENTITY NAME": "Del Biaggio",
   "ENTITY NAME CONT.": "JamesA",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "St. Joseph Cathedral",
   "OCCUPATION": "Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923085",
   "ENTITY": "IND",
   "ENTITY NAME": "Del Grande",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Kevin Del Grande",
   "OCCUPATION": "Auto Dealer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923086",
   "ENTITY": "IND",
   "ENTITY NAME": "Del Grande",
   "ENTITY NAME CONT.": "Anita",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Anita Del Grande",
   "OCCUPATION": "Auto Dealer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924681",
   "ENTITY": "IND",
   "ENTITY NAME": "Della Maggiore",
   "ENTITY NAME CONT.": "Rich",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Della Maggiore Tile",
   "OCCUPATION": "Contractor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924605",
   "ENTITY": "IND",
   "ENTITY NAME": "DeLuca",
   "ENTITY NAME CONT.": "Maria",
   "ENTITY CITY": "Olivebridge",
   "Entity_ST": "NY",
   "EMPLOYER": "Maria DeLuca",
   "OCCUPATION": "Filmmaker, Architectural Designer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930956",
   "ENTITY": "IND",
   "ENTITY NAME": "DeMasi",
   "ENTITY NAME CONT.": "Grace",
   "ENTITY CITY": "Davis",
   "Entity_ST": "CA",
   "EMPLOYER": "CAbi",
   "OCCUPATION": "Owner",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925321",
   "ENTITY": "IND",
   "ENTITY NAME": "Demertzis",
   "ENTITY NAME CONT.": "Jimmy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928263",
   "ENTITY": "IND",
   "ENTITY NAME": "Deponzi",
   "ENTITY NAME CONT.": "Ruth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Villages Golf & CC",
   "OCCUPATION": "Activities",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924194",
   "ENTITY": "IND",
   "ENTITY NAME": "Derakhshandeh",
   "ENTITY NAME CONT.": "Mansour",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Ybm Inc",
   "OCCUPATION": "Owner",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990240",
   "ENTITY": "IND",
   "ENTITY NAME": "DeRegt",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "Carmel Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Fortbay",
   "OCCUPATION": "Principal",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925016",
   "ENTITY": "IND",
   "ENTITY NAME": "DeSchryver",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Good Samaritan Hospital",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924666",
   "ENTITY": "IND",
   "ENTITY NAME": "Deshpande",
   "ENTITY NAME CONT.": "Yashodhan",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Nuro Technologies",
   "OCCUPATION": "Software Engineer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925122",
   "ENTITY": "IND",
   "ENTITY NAME": "DeSiervi",
   "ENTITY NAME CONT.": "Rosemary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "West Valley College",
   "OCCUPATION": "Instructor",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925110",
   "ENTITY": "IND",
   "ENTITY NAME": "Desler",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923488",
   "ENTITY": "IND",
   "ENTITY NAME": "DeTurris",
   "ENTITY NAME CONT.": "FrankL.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931459",
   "ENTITY": "IND",
   "ENTITY NAME": "Dey",
   "ENTITY NAME CONT.": "Mita",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mita Dey",
   "OCCUPATION": "Volunteer Mentor",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936080",
   "ENTITY": "IND",
   "ENTITY NAME": "Dhami",
   "ENTITY NAME CONT.": "TejinderS.",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "WFG",
   "OCCUPATION": "Agent",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936099",
   "ENTITY": "IND",
   "ENTITY NAME": "Dhillon",
   "ENTITY NAME CONT.": "Balbir",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Balbir Dhillon",
   "OCCUPATION": "Realtor",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925109",
   "ENTITY": "IND",
   "ENTITY NAME": "Di Salvo",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "DiSalvo Educational Consulting",
   "OCCUPATION": "Owner",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923371",
   "ENTITY": "IND",
   "ENTITY NAME": "Dickinson",
   "ENTITY NAME CONT.": "Jonathan",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923338",
   "ENTITY": "IND",
   "ENTITY NAME": "Dieter",
   "ENTITY NAME CONT.": "Phyllis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928232",
   "ENTITY": "IND",
   "ENTITY NAME": "Dilanni",
   "ENTITY NAME CONT.": "Dante",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Pacific Piano School",
   "OCCUPATION": "Teacher",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924284",
   "ENTITY": "IND",
   "ENTITY NAME": "Dillabough",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Navitas",
   "OCCUPATION": "Venture Capitalist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923369",
   "ENTITY": "IND",
   "ENTITY NAME": "DiNapoli",
   "ENTITY NAME CONT.": "JohnB",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "J.P. Dinapoli Company, Inc.",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923370",
   "ENTITY": "IND",
   "ENTITY NAME": "DiNapoli",
   "ENTITY NAME CONT.": "J. Phillip",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "J.P. Dinapoli Company, Inc.",
   "OCCUPATION": "Chairman",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924293",
   "ENTITY": "IND",
   "ENTITY NAME": "DiNapoli",
   "ENTITY NAME CONT.": "F Matthew",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "DiNapoli Capital Partners",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924182",
   "ENTITY": "IND",
   "ENTITY NAME": "DiNapoli",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "DiNapoli Specialty Foods",
   "OCCUPATION": "Owner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923361",
   "ENTITY": "IND",
   "ENTITY NAME": "DiNapoli Schiro",
   "ENTITY NAME CONT.": "Shirlee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Shirlee DiNapoli Schiro",
   "OCCUPATION": "Real Estate Investment",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964806",
   "ENTITY": "IND",
   "ENTITY NAME": "DiNucci",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ChargePoint",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC47",
   "ENTITY": "IND",
   "ENTITY NAME": "DO",
   "ENTITY NAME CONT.": "THANG",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "AEDIS ARCHITECTS",
   "OCCUPATION": "PRESIDENT",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928209",
   "ENTITY": "IND",
   "ENTITY NAME": "Doi",
   "ENTITY NAME CONT.": "Keish",
   "ENTITY CITY": "Kailua Kona",
   "Entity_ST": "HI",
   "EMPLOYER": "Three Palm Software",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933747",
   "ENTITY": "IND",
   "ENTITY NAME": "Dollinger",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Dollinger Properties",
   "OCCUPATION": "Developer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924177",
   "ENTITY": "IND",
   "ENTITY NAME": "Dorsa",
   "ENTITY NAME CONT.": "Frank",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Classic Car Wash",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924178",
   "ENTITY": "IND",
   "ENTITY NAME": "Dorsa",
   "ENTITY NAME CONT.": "Marilyn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Detail Performance",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924193",
   "ENTITY": "IND",
   "ENTITY NAME": "Dorsa",
   "ENTITY NAME CONT.": "Bart",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bart Dorsa",
   "OCCUPATION": "Artist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935155",
   "ENTITY": "IND",
   "ENTITY NAME": "Dosanjh",
   "ENTITY NAME CONT.": "Inder",
   "ENTITY CITY": "Lafayette",
   "Entity_ST": "CA",
   "EMPLOYER": "Fremont Automotive Retailing Group",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935162",
   "ENTITY": "IND",
   "ENTITY NAME": "Dosanjh",
   "ENTITY NAME CONT.": "Valvinder",
   "ENTITY CITY": "Lafayette",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924274",
   "ENTITY": "IND",
   "ENTITY NAME": "Dostart",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Dostart Development Co",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928011",
   "ENTITY": "IND",
   "ENTITY NAME": "Dowd",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Coronado",
   "Entity_ST": "CA",
   "EMPLOYER": "Robbins, Geller, Rudman and Dowd",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924184",
   "ENTITY": "IND",
   "ENTITY NAME": "Draper",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ProPrincipia International Associates",
   "OCCUPATION": "Electrical Engineer",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925077",
   "ENTITY": "IND",
   "ENTITY NAME": "Draper",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ProPrincipia International Associates",
   "OCCUPATION": "Electrical Engineer",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925112",
   "ENTITY": "IND",
   "ENTITY NAME": "Draper",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ProPrincipia International Associates",
   "OCCUPATION": "Electrical Engineer",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935194",
   "ENTITY": "IND",
   "ENTITY NAME": "Draper",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ProPrincipia International Associates",
   "OCCUPATION": "Electrical Engineer",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933744",
   "ENTITY": "IND",
   "ENTITY NAME": "Draper",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ProPrincipia International Associates",
   "OCCUPATION": "Electrical Engineer",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936078",
   "ENTITY": "IND",
   "ENTITY NAME": "Draper",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ProPrincipia International Associates",
   "OCCUPATION": "Electrical Engineer",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961416",
   "ENTITY": "IND",
   "ENTITY NAME": "Draper",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ProPrincipia International Associates",
   "OCCUPATION": "Electrical Engineer",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964885",
   "ENTITY": "IND",
   "ENTITY NAME": "Draper",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ProPrincipia International Associates",
   "OCCUPATION": "Electrical Engineer",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923490",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital Consultants, Inc.",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924618",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital Consultants, Inc.",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924620",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10926761",
   "ENTITY": "IND",
   "ENTITY NAME": "Driedger",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Associated Capital",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963937",
   "ENTITY": "IND",
   "ENTITY NAME": "Dubbs",
   "ENTITY NAME CONT.": "Ted",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Foxconn",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936095",
   "ENTITY": "IND",
   "ENTITY NAME": "Duley",
   "ENTITY NAME CONT.": "Sarbjot",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sarjtot Duley",
   "OCCUPATION": "Truck Driver",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964918",
   "ENTITY": "IND",
   "ENTITY NAME": "Duncan",
   "ENTITY NAME CONT.": "Chalon",
   "ENTITY CITY": "Palm Desert",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco Systems",
   "OCCUPATION": "Marketing",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556795",
   "ENTITY": "IND",
   "ENTITY NAME": "Dunderdale",
   "ENTITY NAME CONT.": "Doug",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3674
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557329",
   "ENTITY": "IND",
   "ENTITY NAME": "Dunderdale",
   "ENTITY NAME CONT.": "Doug",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1225
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10937935",
   "ENTITY": "IND",
   "ENTITY NAME": "Dunn",
   "ENTITY NAME CONT.": "SteveM",
   "ENTITY CITY": "Lafayette",
   "Entity_ST": "CA",
   "EMPLOYER": "Steelwave",
   "OCCUPATION": "Senior Managing Director, A & D",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925017",
   "ENTITY": "IND",
   "ENTITY NAME": "Dunne",
   "ENTITY NAME CONT.": "MichaelF",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Farmers Insurance",
   "OCCUPATION": "Insurance Broker",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964305",
   "ENTITY": "IND",
   "ENTITY NAME": "Duquette",
   "ENTITY NAME CONT.": "Cindy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intuitive Surgical",
   "OCCUPATION": "Director of International Tax",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928032",
   "ENTITY": "IND",
   "ENTITY NAME": "Dworak",
   "ENTITY NAME CONT.": "JosephE.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925333",
   "ENTITY": "IND",
   "ENTITY NAME": "Ebner",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "KPMG",
   "OCCUPATION": "CPA",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925334",
   "ENTITY": "IND",
   "ENTITY NAME": "Ebner",
   "ENTITY NAME CONT.": "DeDe",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Chord Advisors",
   "OCCUPATION": "CPA",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557338",
   "ENTITY": "IND",
   "ENTITY NAME": "Eckmann",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 821
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923805",
   "ENTITY": "IND",
   "ENTITY NAME": "Eckstrom",
   "ENTITY NAME CONT.": "Roger",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930446",
   "ENTITY": "IND",
   "ENTITY NAME": "Edson",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "Shepard Mullin",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922906",
   "ENTITY": "IND",
   "ENTITY NAME": "Edwards",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Storefront Political Media",
   "OCCUPATION": "Consultant",
   "AMOUNT": 5
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922952",
   "ENTITY": "IND",
   "ENTITY NAME": "Eggers",
   "ENTITY NAME CONT.": "Daryl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Professor of Chemistry",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924598",
   "ENTITY": "IND",
   "ENTITY NAME": "Elias",
   "ENTITY NAME CONT.": "ChristianC.",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Valley Water District",
   "OCCUPATION": "Director of Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924655",
   "ENTITY": "IND",
   "ENTITY NAME": "Ellington",
   "ENTITY NAME CONT.": "RobertE.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924289",
   "ENTITY": "IND",
   "ENTITY NAME": "Elliott",
   "ENTITY NAME CONT.": "Wendy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Wendy Elliott",
   "OCCUPATION": "Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925161",
   "ENTITY": "IND",
   "ENTITY NAME": "Ellis",
   "ENTITY NAME CONT.": "Peggy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923475",
   "ENTITY": "IND",
   "ENTITY NAME": "Emmett-Wilder",
   "ENTITY NAME CONT.": "Kate",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Salesforce.com",
   "OCCUPATION": "Sales Director",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553738",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2550
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552610",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552870",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552013",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552075",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552097",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552088",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553402",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553085",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552072",
   "ENTITY": "IND",
   "ENTITY NAME": "Erickson",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 99
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924044",
   "ENTITY": "IND",
   "ENTITY NAME": "Ernstrom",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "San Francisco 49ers",
   "OCCUPATION": "Sport Management",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928193",
   "ENTITY": "IND",
   "ENTITY NAME": "Espinosa",
   "ENTITY NAME CONT.": "Manolo",
   "ENTITY CITY": "Mill Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Manolo Espinosa",
   "OCCUPATION": "Consultant",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924226",
   "ENTITY": "IND",
   "ENTITY NAME": "Espinoza",
   "ENTITY NAME CONT.": "Reymundo",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "Gardner Family Care Center",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928216",
   "ENTITY": "IND",
   "ENTITY NAME": "Essner",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924129",
   "ENTITY": "IND",
   "ENTITY NAME": "Ettare",
   "ENTITY NAME CONT.": "Antonina",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SanDisk",
   "OCCUPATION": "Engineer",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC62",
   "ENTITY": "IND",
   "ENTITY NAME": "EVERS",
   "ENTITY NAME CONT.": "ELLIOT",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "MVP CAPITAL",
   "OCCUPATION": "INVESTMENT BANKER",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923011",
   "ENTITY": "IND",
   "ENTITY NAME": "Faber",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925119",
   "ENTITY": "IND",
   "ENTITY NAME": "Faber",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924132",
   "ENTITY": "IND",
   "ENTITY NAME": "Facchino",
   "ENTITY NAME CONT.": "Rob",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Terracommercial Real Estate Corporation",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924133",
   "ENTITY": "IND",
   "ENTITY NAME": "Facchino",
   "ENTITY NAME CONT.": "Bob",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Facchino Properties",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924135",
   "ENTITY": "IND",
   "ENTITY NAME": "Facchino",
   "ENTITY NAME CONT.": "Valerie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924136",
   "ENTITY": "IND",
   "ENTITY NAME": "Facchino",
   "ENTITY NAME CONT.": "Deborah",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925011",
   "ENTITY": "IND",
   "ENTITY NAME": "Fagundo",
   "ENTITY NAME CONT.": "Cosme",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Willco Management",
   "OCCUPATION": "Restauranteur",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925097",
   "ENTITY": "IND",
   "ENTITY NAME": "Fahrner",
   "ENTITY NAME CONT.": "Hugh",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928034",
   "ENTITY": "IND",
   "ENTITY NAME": "Farb",
   "ENTITY NAME CONT.": "Sam",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925034",
   "ENTITY": "IND",
   "ENTITY NAME": "Faria",
   "ENTITY NAME CONT.": "Esther",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bellermine Barber Shop",
   "OCCUPATION": "Barber",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924669",
   "ENTITY": "IND",
   "ENTITY NAME": "Faulkner",
   "ENTITY NAME CONT.": "Cindy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Valley Heating, Cooling and Electrical",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924775",
   "ENTITY": "IND",
   "ENTITY NAME": "Fennell",
   "ENTITY NAME CONT.": "J. Kim",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "deCarta",
   "OCCUPATION": "CEO",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928225",
   "ENTITY": "IND",
   "ENTITY NAME": "Fensterwald",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "EdSource",
   "OCCUPATION": "Journalist",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923057",
   "ENTITY": "IND",
   "ENTITY NAME": "Fensterwald",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "EdSource",
   "OCCUPATION": "Journalist",
   "AMOUNT": 80
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990440",
   "ENTITY": "IND",
   "ENTITY NAME": "Fensterwald",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "EdSource",
   "OCCUPATION": "Journalist",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930448",
   "ENTITY": "IND",
   "ENTITY NAME": "Fernandez",
   "ENTITY NAME CONT.": "Edward",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Edward Fernandez",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933748",
   "ENTITY": "IND",
   "ENTITY NAME": "Fessenden",
   "ENTITY NAME CONT.": "Jonathan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VMware",
   "OCCUPATION": "Information Security",
   "AMOUNT": 5
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10937930",
   "ENTITY": "IND",
   "ENTITY NAME": "Fessenden",
   "ENTITY NAME CONT.": "Jonathan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VMware",
   "OCCUPATION": "Information Security",
   "AMOUNT": 5
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10962001",
   "ENTITY": "IND",
   "ENTITY NAME": "Fessenden",
   "ENTITY NAME CONT.": "Jonathan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VMware",
   "OCCUPATION": "Information Security",
   "AMOUNT": 5
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924777",
   "ENTITY": "IND",
   "ENTITY NAME": "Field",
   "ENTITY NAME CONT.": "MatthewH",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "TMG Partners",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928189",
   "ENTITY": "IND",
   "ENTITY NAME": "Figone",
   "ENTITY NAME CONT.": "Debra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC78",
   "ENTITY": "IND",
   "ENTITY NAME": "FILEV",
   "ENTITY NAME CONT.": "ANDREW",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "WRIKE",
   "OCCUPATION": "CEO",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924251",
   "ENTITY": "IND",
   "ENTITY NAME": "Filice",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Felice Insurance",
   "OCCUPATION": "Insurance Agent",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924252",
   "ENTITY": "IND",
   "ENTITY NAME": "Filice",
   "ENTITY NAME CONT.": "Russell",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Filice Insurance Agency",
   "OCCUPATION": "Insurance Agent",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922911",
   "ENTITY": "IND",
   "ENTITY NAME": "Finerty",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928215",
   "ENTITY": "IND",
   "ENTITY NAME": "Finerty",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964099",
   "ENTITY": "IND",
   "ENTITY NAME": "Finerty",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923478",
   "ENTITY": "IND",
   "ENTITY NAME": "Finkle",
   "ENTITY NAME CONT.": "Ned",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "NVIDIA",
   "OCCUPATION": "Vice-President of External Affairs",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924153",
   "ENTITY": "IND",
   "ENTITY NAME": "Fioretta",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922971",
   "ENTITY": "IND",
   "ENTITY NAME": "Fisher",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Valley Oak Partners",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934813",
   "ENTITY": "IND",
   "ENTITY NAME": "Fisher",
   "ENTITY NAME CONT.": "JohnJ.",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Pisces, Inc.",
   "OCCUPATION": "Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934814",
   "ENTITY": "IND",
   "ENTITY NAME": "Fisher",
   "ENTITY NAME CONT.": "Laura",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "StarVista",
   "OCCUPATION": "Counselor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924232",
   "ENTITY": "IND",
   "ENTITY NAME": "Fisher",
   "ENTITY NAME CONT.": "Michelle",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "Blaze Mobile",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925101",
   "ENTITY": "IND",
   "ENTITY NAME": "Fitts",
   "ENTITY NAME CONT.": "Susan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925067",
   "ENTITY": "IND",
   "ENTITY NAME": "Flaherty",
   "ENTITY NAME CONT.": "Georgiana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924658",
   "ENTITY": "IND",
   "ENTITY NAME": "Flanigan",
   "ENTITY NAME CONT.": "M. Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Dignity Helath",
   "OCCUPATION": "Registered Nurse",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936386",
   "ENTITY": "IND",
   "ENTITY NAME": "Flynn",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kathleen Flynn",
   "OCCUPATION": "Mediator/Arbitrator",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924622",
   "ENTITY": "IND",
   "ENTITY NAME": "Folzman",
   "ENTITY NAME CONT.": "ClaudiaB",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Iron Construction",
   "OCCUPATION": "Co-Founder",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925322",
   "ENTITY": "IND",
   "ENTITY NAME": "Fong",
   "ENTITY NAME CONT.": "Dennis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "DPJW Management, LLC",
   "OCCUPATION": "Real Estate Investment/Management",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928170",
   "ENTITY": "IND",
   "ENTITY NAME": "Ford",
   "ENTITY NAME CONT.": "Ryan",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Ford Communications",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924702",
   "ENTITY": "IND",
   "ENTITY NAME": "Fordyce",
   "ENTITY NAME CONT.": "CraigL",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10937934",
   "ENTITY": "IND",
   "ENTITY NAME": "Foreman",
   "ENTITY NAME CONT.": "Roy Kenny",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Cathedral of Faith",
   "OCCUPATION": "Senior Pastor",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923479",
   "ENTITY": "IND",
   "ENTITY NAME": "Foulkes",
   "ENTITY NAME CONT.": "DavidM.",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Apple",
   "OCCUPATION": "Director-Legal Department",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924231",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Terence",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "M.E. Fox & Co., Inc",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926753",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Mary Ellen",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923508",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "BrianE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "West Valley Properties",
   "OCCUPATION": "Real Estate Investment",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923482",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "RobertW",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Markovits & Fox",
   "OCCUPATION": "Property Management",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923485",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "MarvinB",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924693",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Janice",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hoge Fenton Jones & Appel",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923788",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox Sr.",
   "ENTITY NAME CONT.": "MichaelE.",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10962158",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox, Jr.",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Goodwill Industries of Silicon Valley",
   "OCCUPATION": "Executive",
   "AMOUNT": 750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10937936",
   "ENTITY": "IND",
   "ENTITY NAME": "Franklin",
   "ENTITY NAME CONT.": "Azucena",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Pedro's Restaurant",
   "OCCUPATION": "General Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928168",
   "ENTITY": "IND",
   "ENTITY NAME": "Freed",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Indian Wells",
   "Entity_ST": "CA",
   "EMPLOYER": "SummerHill Housing Group",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924244",
   "ENTITY": "IND",
   "ENTITY NAME": "Freedman",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Chevy Chase",
   "Entity_ST": "MD",
   "EMPLOYER": "Arnold & Porter LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924771",
   "ENTITY": "IND",
   "ENTITY NAME": "Freise",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Lift Real Estate Partners LLC",
   "OCCUPATION": "Managing Partner/Co-Founder",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922978",
   "ENTITY": "IND",
   "ENTITY NAME": "Fruchterman",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Benetech",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931471",
   "ENTITY": "IND",
   "ENTITY NAME": "Fry",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Fry's Electronics",
   "OCCUPATION": "Co-Founder",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933733",
   "ENTITY": "IND",
   "ENTITY NAME": "Fuentes",
   "ENTITY NAME CONT.": "Cynthia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Evergreen School District",
   "OCCUPATION": "Educator/Resource Aide",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924707",
   "ENTITY": "IND",
   "ENTITY NAME": "Furtado",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC63",
   "ENTITY": "IND",
   "ENTITY NAME": "GALANT",
   "ENTITY NAME CONT.": "PAUL",
   "ENTITY CITY": "WOODSIDE",
   "Entity_ST": "CA",
   "EMPLOYER": "VERIFONE",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924743",
   "ENTITY": "IND",
   "ENTITY NAME": "Gallaty",
   "ENTITY NAME CONT.": "Aaron",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Ace Seal",
   "OCCUPATION": "Sales",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925005",
   "ENTITY": "IND",
   "ENTITY NAME": "Gallinat",
   "ENTITY NAME CONT.": "Doug",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Outset Medical",
   "OCCUPATION": "Engineering Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924254",
   "ENTITY": "IND",
   "ENTITY NAME": "Gallo",
   "ENTITY NAME CONT.": "Donna",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "South Valley Multi-Specialty Medical Group, Inc.",
   "OCCUPATION": "Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925141",
   "ENTITY": "IND",
   "ENTITY NAME": "Gallo",
   "ENTITY NAME CONT.": "Tino",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964307",
   "ENTITY": "IND",
   "ENTITY NAME": "Gannon",
   "ENTITY NAME CONT.": "Warren",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925331",
   "ENTITY": "IND",
   "ENTITY NAME": "Ganz",
   "ENTITY NAME CONT.": "Steven",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Steven Ganz",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923064",
   "ENTITY": "IND",
   "ENTITY NAME": "Garabedian",
   "ENTITY NAME CONT.": "Pierre",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928272",
   "ENTITY": "IND",
   "ENTITY NAME": "Gates",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Point Church",
   "OCCUPATION": "Minister",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935157",
   "ENTITY": "IND",
   "ENTITY NAME": "Gauba",
   "ENTITY NAME CONT.": "Pooja",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935158",
   "ENTITY": "IND",
   "ENTITY NAME": "Gauba",
   "ENTITY NAME CONT.": "Gaurav",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Advanced Solutions",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924757",
   "ENTITY": "IND",
   "ENTITY NAME": "Gentzkow",
   "ENTITY NAME CONT.": "PaulF",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Robert Half Staffing Services",
   "OCCUPATION": "COO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923004",
   "ENTITY": "IND",
   "ENTITY NAME": "Gertman",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924256",
   "ENTITY": "IND",
   "ENTITY NAME": "Ghanavati",
   "ENTITY NAME CONT.": "Alexsaunder",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "HDS Construction",
   "OCCUPATION": "Construction",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924265",
   "ENTITY": "IND",
   "ENTITY NAME": "Giacalone",
   "ENTITY NAME CONT.": "Victor",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Best Electrical Co., Inc.",
   "OCCUPATION": "Contractor",
   "AMOUNT": 800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925305",
   "ENTITY": "IND",
   "ENTITY NAME": "Giacalone",
   "ENTITY NAME CONT.": "Dominic",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Stegner Development, LLC",
   "OCCUPATION": "Developer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923491",
   "ENTITY": "IND",
   "ENTITY NAME": "Giannini",
   "ENTITY NAME CONT.": "GaryV.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gary Giannini",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923509",
   "ENTITY": "IND",
   "ENTITY NAME": "Giannini",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924114",
   "ENTITY": "IND",
   "ENTITY NAME": "Gibbons-Shapiro",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925304",
   "ENTITY": "IND",
   "ENTITY NAME": "Giles",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924290",
   "ENTITY": "IND",
   "ENTITY NAME": "Ginsborg",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County Assessor",
   "OCCUPATION": "Deputy to the Assessor",
   "AMOUNT": 125
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923810",
   "ENTITY": "IND",
   "ENTITY NAME": "Gisvold",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Piedmont",
   "Entity_ST": "CA",
   "EMPLOYER": "Sensiba San Filippo, LLP",
   "OCCUPATION": "Certified Public Accountant",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924749",
   "ENTITY": "IND",
   "ENTITY NAME": "Gladstein",
   "ENTITY NAME CONT.": "Kenneth",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Sares Regis Group of No. California",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924243",
   "ENTITY": "IND",
   "ENTITY NAME": "Goddard",
   "ENTITY NAME CONT.": "Nick",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923333",
   "ENTITY": "IND",
   "ENTITY NAME": "Gogo",
   "ENTITY NAME CONT.": "JohnnyC",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925099",
   "ENTITY": "IND",
   "ENTITY NAME": "Gogo",
   "ENTITY NAME CONT.": "JohnnyC",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925129",
   "ENTITY": "IND",
   "ENTITY NAME": "Gomez",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "Gomez Iagmin",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556793",
   "ENTITY": "IND",
   "ENTITY NAME": "Gong",
   "ENTITY NAME CONT.": "Brandon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 975
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928331",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzales",
   "ENTITY NAME CONT.": "GabrielM",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924767",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzales",
   "ENTITY NAME CONT.": "RonaldR.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hispanic Foundation of Silicon Valley",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553879",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzalez",
   "ENTITY NAME CONT.": "Norene",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924206",
   "ENTITY": "IND",
   "ENTITY NAME": "Goscila",
   "ENTITY NAME CONT.": "DoreenM.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930962",
   "ENTITY": "IND",
   "ENTITY NAME": "Goscila",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930963",
   "ENTITY": "IND",
   "ENTITY NAME": "Gosling",
   "ENTITY NAME CONT.": "Debra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924181",
   "ENTITY": "IND",
   "ENTITY NAME": "Gould",
   "ENTITY NAME CONT.": "WilliamEric",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Artik Art & Architecture",
   "OCCUPATION": "Architect/Artist",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924696",
   "ENTITY": "IND",
   "ENTITY NAME": "Graham",
   "ENTITY NAME CONT.": "Douglas",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Lockheed Martin",
   "OCCUPATION": "Vice President for Advanced Programs",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928241",
   "ENTITY": "IND",
   "ENTITY NAME": "Gravink",
   "ENTITY NAME CONT.": "Eric",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rossi, Hamerslough, Reischl & Chuck",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923330",
   "ENTITY": "IND",
   "ENTITY NAME": "Greathouse",
   "ENTITY NAME CONT.": "RuthM",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922985",
   "ENTITY": "IND",
   "ENTITY NAME": "Green",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Senior Advisor",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923115",
   "ENTITY": "IND",
   "ENTITY NAME": "Greer",
   "ENTITY NAME CONT.": "JerryL",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Mortgage Outlet",
   "OCCUPATION": "Mortgage Broker",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924770",
   "ENTITY": "IND",
   "ENTITY NAME": "Gregory",
   "ENTITY NAME CONT.": "PhilipLawrence",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Philip Gregory",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC80",
   "ENTITY": "IND",
   "ENTITY NAME": "GROSS",
   "ENTITY NAME CONT.": "MICHAEL",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "ZANKER RECYCLING",
   "OCCUPATION": "DIRECTOR OF SUSTAINABILITY",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925148",
   "ENTITY": "IND",
   "ENTITY NAME": "Gross",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zanker Recycling",
   "OCCUPATION": "Director of Sustainability",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923812",
   "ENTITY": "IND",
   "ENTITY NAME": "Grover",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Barbara Grover",
   "OCCUPATION": "Marriage Family Therapist",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923070",
   "ENTITY": "IND",
   "ENTITY NAME": "Grybos",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SSL Federal, LLC",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923350",
   "ENTITY": "IND",
   "ENTITY NAME": "Guardino",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Leadership Group",
   "OCCUPATION": "President/CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924282",
   "ENTITY": "IND",
   "ENTITY NAME": "Gudeli",
   "ENTITY NAME CONT.": "Anthony",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "LinkedIn Corporation",
   "OCCUPATION": "Strategic Sourcing Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925092",
   "ENTITY": "IND",
   "ENTITY NAME": "Guggenheim",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Guggenheim Entertainment",
   "OCCUPATION": "Producer",
   "AMOUNT": 180
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924287",
   "ENTITY": "IND",
   "ENTITY NAME": "Guido",
   "ENTITY NAME CONT.": "Al",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "San Francisco 49ers",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925308",
   "ENTITY": "IND",
   "ENTITY NAME": "Gupta",
   "ENTITY NAME CONT.": "Vikas",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Vikas Gupta",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924670",
   "ENTITY": "IND",
   "ENTITY NAME": "Gutierrez",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Insikt Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923014",
   "ENTITY": "IND",
   "ENTITY NAME": "Habib",
   "ENTITY NAME CONT.": "Elie",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Habib Insurance Agency",
   "OCCUPATION": "Insurance Agent",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923116",
   "ENTITY": "IND",
   "ENTITY NAME": "Hadaya",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "WMH Corporation",
   "OCCUPATION": "President and CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928208",
   "ENTITY": "IND",
   "ENTITY NAME": "Hadnot",
   "ENTITY NAME CONT.": "Rhonda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Executive Assistant",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924695",
   "ENTITY": "IND",
   "ENTITY NAME": "Hagberg",
   "ENTITY NAME CONT.": "Vicki",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CORevolution Fitness",
   "OCCUPATION": "Fitness Trainer",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923079",
   "ENTITY": "IND",
   "ENTITY NAME": "Hagenmaier",
   "ENTITY NAME CONT.": "Chuck",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923480",
   "ENTITY": "IND",
   "ENTITY NAME": "Haggerty",
   "ENTITY NAME CONT.": "RobertJ.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923356",
   "ENTITY": "IND",
   "ENTITY NAME": "Hallgrimson",
   "ENTITY NAME CONT.": "Steven",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner, Cohen, et al",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923336",
   "ENTITY": "IND",
   "ENTITY NAME": "Hallgrimson",
   "ENTITY NAME CONT.": "ErikL.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cushman & Wakefield",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC61",
   "ENTITY": "IND",
   "ENTITY NAME": "HALSTED",
   "ENTITY NAME CONT.": "ANNE",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "NONE",
   "OCCUPATION": "RETIRED",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928231",
   "ENTITY": "IND",
   "ENTITY NAME": "Hammond",
   "ENTITY NAME CONT.": "Clyde",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hathaway Dinwiddie",
   "OCCUPATION": "Business Developer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928026",
   "ENTITY": "IND",
   "ENTITY NAME": "Hapner",
   "ENTITY NAME CONT.": "Kerry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Director of Cultural Affairs",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930966",
   "ENTITY": "IND",
   "ENTITY NAME": "Harding",
   "ENTITY NAME CONT.": "Walter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Car Zone",
   "OCCUPATION": "Operator",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963830",
   "ENTITY": "IND",
   "ENTITY NAME": "Harell",
   "ENTITY NAME CONT.": "CarolW.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990239",
   "ENTITY": "IND",
   "ENTITY NAME": "Hariri",
   "ENTITY NAME CONT.": "Perry",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Fortbay",
   "OCCUPATION": "Principal",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925100",
   "ENTITY": "IND",
   "ENTITY NAME": "Hariri",
   "ENTITY NAME CONT.": "Farzam",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Farzam Hariri",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551274",
   "ENTITY": "IND",
   "ENTITY NAME": "Hariri",
   "ENTITY NAME CONT.": "Farzam",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925347",
   "ENTITY": "IND",
   "ENTITY NAME": "Hariri",
   "ENTITY NAME CONT.": "Farzam",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Farzam Hariri",
   "OCCUPATION": "Real Estate Investments",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931684",
   "ENTITY": "IND",
   "ENTITY NAME": "Harper",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Chicago",
   "Entity_ST": "IL",
   "EMPLOYER": "Harper Health Streeterville",
   "OCCUPATION": "Physician",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924166",
   "ENTITY": "IND",
   "ENTITY NAME": "Harrigan",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Prospect Silicon Valley",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924140",
   "ENTITY": "IND",
   "ENTITY NAME": "Harris",
   "ENTITY NAME CONT.": "ToddM.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Technology Credit Union",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10962101",
   "ENTITY": "IND",
   "ENTITY NAME": "Hart",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Santa Monica",
   "Entity_ST": "CA",
   "EMPLOYER": "Steinberg Hart",
   "OCCUPATION": "Architect, President & CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC77",
   "ENTITY": "IND",
   "ENTITY NAME": "HARTMAN",
   "ENTITY NAME CONT.": "CRAIG",
   "ENTITY CITY": "CORTE MADERA",
   "Entity_ST": "CA",
   "EMPLOYER": "SELF-EMPLOYED; SAME NAME",
   "OCCUPATION": "ARCHITECT",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925115",
   "ENTITY": "IND",
   "ENTITY NAME": "Hartnett",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "SVG Partners",
   "OCCUPATION": "Founder & CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933874",
   "ENTITY": "IND",
   "ENTITY NAME": "Hartt",
   "ENTITY NAME CONT.": "Susan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Office of Susan Hartt",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924606",
   "ENTITY": "IND",
   "ENTITY NAME": "Hayashi",
   "ENTITY NAME CONT.": "HelenS.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923331",
   "ENTITY": "IND",
   "ENTITY NAME": "Hayes",
   "ENTITY NAME CONT.": "Lindy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Lindy Hayes",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924674",
   "ENTITY": "IND",
   "ENTITY NAME": "Hayse",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "ETM-Electromatic Inc",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923017",
   "ENTITY": "IND",
   "ENTITY NAME": "Head",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Summerhill Land",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925140",
   "ENTITY": "IND",
   "ENTITY NAME": "Headrick",
   "ENTITY NAME CONT.": "JeromeH",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Headrick Construction",
   "OCCUPATION": "General Contractor",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964013",
   "ENTITY": "IND",
   "ENTITY NAME": "Heagerty",
   "ENTITY NAME CONT.": "Antoinette",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922918",
   "ENTITY": "IND",
   "ENTITY NAME": "Heagerty",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "Newmark Realty Capital, Inc.",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925342",
   "ENTITY": "IND",
   "ENTITY NAME": "Heck",
   "ENTITY NAME CONT.": "Stefan",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Nauto, Inc.",
   "OCCUPATION": "Executive",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924146",
   "ENTITY": "IND",
   "ENTITY NAME": "Heffernan",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "Alliant Insurance Services, Inc.",
   "OCCUPATION": "Insurance Broker",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924218",
   "ENTITY": "IND",
   "ENTITY NAME": "Heinz",
   "ENTITY NAME CONT.": "AndreT",
   "ENTITY CITY": "Pittsburgh",
   "Entity_ST": "PA",
   "EMPLOYER": "Sustainable Technology Capital LLC",
   "OCCUPATION": "Principal/Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925098",
   "ENTITY": "IND",
   "ENTITY NAME": "Heinz",
   "ENTITY NAME CONT.": "AndreT",
   "ENTITY CITY": "Pittsburgh",
   "Entity_ST": "PA",
   "EMPLOYER": "Sustainable Technology Capital LLC",
   "OCCUPATION": "Principal/Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925082",
   "ENTITY": "IND",
   "ENTITY NAME": "Helweh",
   "ENTITY NAME CONT.": "Amir",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco Systems",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925083",
   "ENTITY": "IND",
   "ENTITY NAME": "Helweh",
   "ENTITY NAME CONT.": "Rowaida",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925084",
   "ENTITY": "IND",
   "ENTITY NAME": "Helweh",
   "ENTITY NAME CONT.": "Deeb",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Wageworks",
   "OCCUPATION": "Financial Analyst",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925086",
   "ENTITY": "IND",
   "ENTITY NAME": "Helweh",
   "ENTITY NAME CONT.": "Zeyad",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon GE Builders",
   "OCCUPATION": "Financial Analyst",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924160",
   "ENTITY": "IND",
   "ENTITY NAME": "Henderson",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Samaritan Medical Center",
   "OCCUPATION": "Medical Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928205",
   "ENTITY": "IND",
   "ENTITY NAME": "Hendricks",
   "ENTITY NAME CONT.": "Glenn",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "PayPal",
   "OCCUPATION": "Senior Program Manager",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923802",
   "ENTITY": "IND",
   "ENTITY NAME": "Hendricks",
   "ENTITY NAME CONT.": "Glenn",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "PayPal",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922916",
   "ENTITY": "IND",
   "ENTITY NAME": "Hentz",
   "ENTITY NAME CONT.": "Otto",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "Georgetown University",
   "OCCUPATION": "Priest/Professor",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925087",
   "ENTITY": "IND",
   "ENTITY NAME": "Herbert",
   "ENTITY NAME CONT.": "Garrett",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Deloitte",
   "OCCUPATION": "Accounting",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923091",
   "ENTITY": "IND",
   "ENTITY NAME": "Heredia",
   "ENTITY NAME CONT.": "Felipe",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "First Alarm",
   "OCCUPATION": "Security Guard",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931678",
   "ENTITY": "IND",
   "ENTITY NAME": "Heropolous",
   "ENTITY NAME CONT.": "Angelo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hero Ranch LLC",
   "OCCUPATION": "CEO/Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924703",
   "ENTITY": "IND",
   "ENTITY NAME": "Herrera",
   "ENTITY NAME CONT.": "J. Manuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "J. Manuel Herrera",
   "OCCUPATION": "Public Sector Consulting",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924121",
   "ENTITY": "IND",
   "ENTITY NAME": "Herschbach",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924198",
   "ENTITY": "IND",
   "ENTITY NAME": "Herschbach",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924305",
   "ENTITY": "IND",
   "ENTITY NAME": "Herschbach",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": -250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924699",
   "ENTITY": "IND",
   "ENTITY NAME": "Hester",
   "ENTITY NAME CONT.": "Larry",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924148",
   "ENTITY": "IND",
   "ENTITY NAME": "Hettler-Smith",
   "ENTITY NAME CONT.": "Lisa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925069",
   "ENTITY": "IND",
   "ENTITY NAME": "Highlander",
   "ENTITY NAME CONT.": "Richard (Bill)",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922914",
   "ENTITY": "IND",
   "ENTITY NAME": "Hill",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Police Department",
   "OCCUPATION": "Supervisor",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928213",
   "ENTITY": "IND",
   "ENTITY NAME": "Hilliard",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "David Hilliard",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930967",
   "ENTITY": "IND",
   "ENTITY NAME": "Hingle",
   "ENTITY NAME CONT.": "MichaelE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hingle Law",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928014",
   "ENTITY": "IND",
   "ENTITY NAME": "Hiura",
   "ENTITY NAME CONT.": "JerroldA.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Jerrold Hiura",
   "OCCUPATION": "Dentist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925160",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "Quynh",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cereus Corporation",
   "OCCUPATION": "Certified Public Accountant",
   "AMOUNT": 777
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924663",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "Anthony",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "LPMD Architects",
   "OCCUPATION": "Architectural Designer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983753",
   "ENTITY": "IND",
   "ENTITY NAME": "Hoang",
   "ENTITY NAME CONT.": "Kieu",
   "ENTITY CITY": "Agoura Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "RAAS, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 200000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925303",
   "ENTITY": "IND",
   "ENTITY NAME": "Hoang",
   "ENTITY NAME CONT.": "Kieu",
   "ENTITY CITY": "Westlake Village",
   "Entity_ST": "CA",
   "EMPLOYER": "Raas, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925340",
   "ENTITY": "IND",
   "ENTITY NAME": "Hofer",
   "ENTITY NAME CONT.": "Ed",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Commercial Real Estate Broker",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925045",
   "ENTITY": "IND",
   "ENTITY NAME": "Hoffman",
   "ENTITY NAME CONT.": "Ken",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "E. Hoffman Enterprises, Inc.",
   "OCCUPATION": "Partner",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924054",
   "ENTITY": "IND",
   "ENTITY NAME": "Hogan",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Children's Fund",
   "OCCUPATION": "Non-Profit Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928262",
   "ENTITY": "IND",
   "ENTITY NAME": "Holbrook",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Mateo County",
   "OCCUPATION": "Urban Planner",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930451",
   "ENTITY": "IND",
   "ENTITY NAME": "Holden",
   "ENTITY NAME CONT.": "Rick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928274",
   "ENTITY": "IND",
   "ENTITY NAME": "Holguin",
   "ENTITY NAME CONT.": "Nick",
   "ENTITY CITY": "Paso Robles",
   "Entity_ST": "CA",
   "EMPLOYER": "The Patio Kitchen",
   "OCCUPATION": "Chef",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925300",
   "ENTITY": "IND",
   "ENTITY NAME": "Holt",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "La Grange",
   "Entity_ST": "IL",
   "EMPLOYER": "University of Notre Dame",
   "OCCUPATION": "Professor of Business Ethics",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928023",
   "ENTITY": "IND",
   "ENTITY NAME": "Honore",
   "ENTITY NAME CONT.": "Jon",
   "ENTITY CITY": "Mount Hamilton",
   "Entity_ST": "CA",
   "EMPLOYER": "H&H Real Properties LLC",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924149",
   "ENTITY": "IND",
   "ENTITY NAME": "Hood",
   "ENTITY NAME CONT.": "Alastair",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Verdafero",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963907",
   "ENTITY": "IND",
   "ENTITY NAME": "Horn",
   "ENTITY NAME CONT.": "Eric",
   "ENTITY CITY": "Alamo",
   "Entity_ST": "CA",
   "EMPLOYER": "Build Group Inc.",
   "OCCUPATION": "Construction Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924281",
   "ENTITY": "IND",
   "ENTITY NAME": "House",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928033",
   "ENTITY": "IND",
   "ENTITY NAME": "Houston",
   "ENTITY NAME CONT.": "Jolie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC55",
   "ENTITY": "IND",
   "ENTITY NAME": "HOWELL",
   "ENTITY NAME CONT.": "GELSTON",
   "ENTITY CITY": "MENLO PARK",
   "Entity_ST": "CA",
   "EMPLOYER": "SANMINA",
   "OCCUPATION": "SENIOR VICE PRESIDENT",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924283",
   "ENTITY": "IND",
   "ENTITY NAME": "Hudaceck",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Sares Regis Group of Northern CA",
   "OCCUPATION": "Real Estate Developer & Owner",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924237",
   "ENTITY": "IND",
   "ENTITY NAME": "Hudson",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Hudson Management Co.",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10986790",
   "ENTITY": "IND",
   "ENTITY NAME": "Hudson",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Hudson Management Co.",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10989703",
   "ENTITY": "IND",
   "ENTITY NAME": "Hudson",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Hudson Management Co.",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924229",
   "ENTITY": "IND",
   "ENTITY NAME": "Huff",
   "ENTITY NAME CONT.": "Georgie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Capital Properties",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964089",
   "ENTITY": "IND",
   "ENTITY NAME": "Hughes",
   "ENTITY NAME CONT.": "Aidan",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "Arup",
   "OCCUPATION": "Consultant",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924128",
   "ENTITY": "IND",
   "ENTITY NAME": "Hummadi",
   "ENTITY NAME CONT.": "Belal",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Snooozy Inc",
   "OCCUPATION": "CEO",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964097",
   "ENTITY": "IND",
   "ENTITY NAME": "Hunt",
   "ENTITY NAME CONT.": "Gerald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925078",
   "ENTITY": "IND",
   "ENTITY NAME": "Hunt",
   "ENTITY NAME CONT.": "DianeE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923059",
   "ENTITY": "IND",
   "ENTITY NAME": "Hunter",
   "ENTITY NAME CONT.": "Deke",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Hunter Properties",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964886",
   "ENTITY": "IND",
   "ENTITY NAME": "Hurd",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "The Katama Group, LLC",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923066",
   "ENTITY": "IND",
   "ENTITY NAME": "Hussie (aka Hussey)",
   "ENTITY NAME CONT.": "Halfdan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cinequest",
   "OCCUPATION": "Director & Co-Founder",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935171",
   "ENTITY": "IND",
   "ENTITY NAME": "Huyghue",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Jacksonville",
   "Entity_ST": "FL",
   "EMPLOYER": "Michael Huyghue & Associates",
   "OCCUPATION": "Partner/Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC21",
   "ENTITY": "IND",
   "ENTITY NAME": "IMWALLE",
   "ENTITY NAME CONT.": "HENRY",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "NONE",
   "OCCUPATION": "RETIRED",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923062",
   "ENTITY": "IND",
   "ENTITY NAME": "Imwalle",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Imwalle Properties",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924219",
   "ENTITY": "IND",
   "ENTITY NAME": "Ipsen",
   "ENTITY NAME CONT.": "Laura",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Ellucian",
   "OCCUPATION": "President and CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964934",
   "ENTITY": "IND",
   "ENTITY NAME": "Ittner",
   "ENTITY NAME CONT.": "Mary Ellen",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "PG&E",
   "OCCUPATION": "Director",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925103",
   "ENTITY": "IND",
   "ENTITY NAME": "Jackman",
   "ENTITY NAME CONT.": "StevenH",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Flex Ltd",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558258",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobo",
   "ENTITY NAME CONT.": "Emanuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 710
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558280",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobo",
   "ENTITY NAME CONT.": "Emanuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 535
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556858",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobo",
   "ENTITY NAME CONT.": "Emanuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 375
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556783",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobo",
   "ENTITY NAME CONT.": "Emanuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557362",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobo",
   "ENTITY NAME CONT.": "Emanuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923806",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobs-May",
   "ENTITY NAME CONT.": "Jamie",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Jamie Jacobs-May",
   "OCCUPATION": "Mediator",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922958",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobsen",
   "ENTITY NAME CONT.": "Sara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928255",
   "ENTITY": "IND",
   "ENTITY NAME": "Jacobsen",
   "ENTITY NAME CONT.": "Sara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964643",
   "ENTITY": "IND",
   "ENTITY NAME": "Jankovic",
   "ENTITY NAME CONT.": "Walter",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Optical Connectivity",
   "OCCUPATION": "Executive",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557326",
   "ENTITY": "IND",
   "ENTITY NAME": "Jasper",
   "ENTITY NAME CONT.": "Denise",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556733",
   "ENTITY": "IND",
   "ENTITY NAME": "Jasper",
   "ENTITY NAME CONT.": "Denise",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 510
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556799",
   "ENTITY": "IND",
   "ENTITY NAME": "Jasper",
   "ENTITY NAME CONT.": "Denise",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 510
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555992",
   "ENTITY": "IND",
   "ENTITY NAME": "Jasper",
   "ENTITY NAME CONT.": "Denise",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923005",
   "ENTITY": "IND",
   "ENTITY NAME": "Jaye",
   "ENTITY NAME CONT.": "Eric",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Storefront Political Media",
   "OCCUPATION": "Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923498",
   "ENTITY": "IND",
   "ENTITY NAME": "Jean",
   "ENTITY NAME CONT.": "Tina",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933878",
   "ENTITY": "IND",
   "ENTITY NAME": "Jenkins",
   "ENTITY NAME CONT.": "Garry",
   "ENTITY CITY": "Minneapolis",
   "Entity_ST": "MN",
   "EMPLOYER": "University of Minnesota",
   "OCCUPATION": "Professor",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924105",
   "ENTITY": "IND",
   "ENTITY NAME": "Jennings",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Varian Medical Systems",
   "OCCUPATION": "Product Support Engineer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925294",
   "ENTITY": "IND",
   "ENTITY NAME": "Jensen",
   "ENTITY NAME CONT.": "Marcia",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Town of Los Gatos",
   "OCCUPATION": "Councilmember",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924685",
   "ENTITY": "IND",
   "ENTITY NAME": "Jesse",
   "ENTITY NAME CONT.": "Frank",
   "ENTITY CITY": "Alamo",
   "Entity_ST": "CA",
   "EMPLOYER": "Satellite Healthcare, Inc.",
   "OCCUPATION": "Real Estate Executive",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935161",
   "ENTITY": "IND",
   "ENTITY NAME": "Jhaveri",
   "ENTITY NAME CONT.": "Bhavik",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Lifestyle Solutions",
   "OCCUPATION": "Director of Technology",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924230",
   "ENTITY": "IND",
   "ENTITY NAME": "Jiang",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "88 Develoment Group",
   "OCCUPATION": "President",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923099",
   "ENTITY": "IND",
   "ENTITY NAME": "Job",
   "ENTITY NAME CONT.": "Rozanne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925022",
   "ENTITY": "IND",
   "ENTITY NAME": "Job",
   "ENTITY NAME CONT.": "Randall",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933745",
   "ENTITY": "IND",
   "ENTITY NAME": "Job",
   "ENTITY NAME CONT.": "Rozanne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923020",
   "ENTITY": "IND",
   "ENTITY NAME": "Johansen",
   "ENTITY NAME CONT.": "Mack",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923809",
   "ENTITY": "IND",
   "ENTITY NAME": "John",
   "ENTITY NAME CONT.": "Esther",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925309",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnsen",
   "ENTITY NAME CONT.": "Joan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco Systems, Inc.",
   "OCCUPATION": "Senior Program Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925310",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnsen",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964093",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnsen",
   "ENTITY NAME CONT.": "Joan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco Systems, Inc.",
   "OCCUPATION": "Privacy Program Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964095",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnsen",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550494",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Laney",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 520
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550487",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Laney",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 366
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926756",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Michelle",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550495",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Laney",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 82
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550465",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Laney",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 57
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550488",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Laney",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924291",
   "ENTITY": "IND",
   "ENTITY NAME": "Jones",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Hudson Companies",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924124",
   "ENTITY": "IND",
   "ENTITY NAME": "Jones",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rebecca Jones",
   "OCCUPATION": "Attorney",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925135",
   "ENTITY": "IND",
   "ENTITY NAME": "Jones",
   "ENTITY NAME CONT.": "Steven",
   "ENTITY CITY": "Discovery Bay",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922970",
   "ENTITY": "IND",
   "ENTITY NAME": "Josefowitz",
   "ENTITY NAME CONT.": "Nick",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Bay Area Rapid Transit",
   "OCCUPATION": "Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922987",
   "ENTITY": "IND",
   "ENTITY NAME": "Kain",
   "ENTITY NAME CONT.": "Hannah",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ALOM",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934233",
   "ENTITY": "IND",
   "ENTITY NAME": "Kali Rai",
   "ENTITY NAME CONT.": "SharanjitS.",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Jackson Main LLC",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934232",
   "ENTITY": "IND",
   "ENTITY NAME": "Kali-Rai",
   "ENTITY NAME CONT.": "Miriam",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Miriam Kali-Rai",
   "OCCUPATION": "Property Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925132",
   "ENTITY": "IND",
   "ENTITY NAME": "Kaltsas",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Building Materials of America Corp.",
   "OCCUPATION": "Executive",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933872",
   "ENTITY": "IND",
   "ENTITY NAME": "Kamangar",
   "ENTITY NAME CONT.": "Katia",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "SummerHill Housing Group",
   "OCCUPATION": "Builder",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550479",
   "ENTITY": "IND",
   "ENTITY NAME": "Kambietz",
   "ENTITY NAME CONT.": "Gus",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "F",
   "ID": "D550478",
   "ENTITY": "IND",
   "ENTITY NAME": "Kambietz",
   "ENTITY NAME CONT.": "Gus",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925116",
   "ENTITY": "IND",
   "ENTITY NAME": "Kamm",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925004",
   "ENTITY": "IND",
   "ENTITY NAME": "Kang",
   "ENTITY NAME CONT.": "Van-An",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Unified School District",
   "OCCUPATION": "Library Media Center Technician",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935168",
   "ENTITY": "IND",
   "ENTITY NAME": "Kapoor",
   "ENTITY NAME CONT.": "Jag",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "RKG Ventures",
   "OCCUPATION": "Entrepreneur",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935169",
   "ENTITY": "IND",
   "ENTITY NAME": "Kapoor",
   "ENTITY NAME CONT.": "Perminder",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935170",
   "ENTITY": "IND",
   "ENTITY NAME": "Kapoor",
   "ENTITY NAME CONT.": "Jason",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ACT Theater",
   "OCCUPATION": "Actor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928165",
   "ENTITY": "IND",
   "ENTITY NAME": "Kashkooli",
   "ENTITY NAME CONT.": "Heshmatt",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate",
   "OCCUPATION": "Realtor",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924603",
   "ENTITY": "IND",
   "ENTITY NAME": "Kautz",
   "ENTITY NAME CONT.": "Francesca",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Museo Italo Americano",
   "OCCUPATION": "Teacher",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964642",
   "ENTITY": "IND",
   "ENTITY NAME": "Kaval",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Oakland Athletics",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924768",
   "ENTITY": "IND",
   "ENTITY NAME": "Kay",
   "ENTITY NAME CONT.": "Ken",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Ken Kay Associates",
   "OCCUPATION": "Urban Design Landscape Architecture",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924144",
   "ENTITY": "IND",
   "ENTITY NAME": "Keenan",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "Pleasanton",
   "Entity_ST": "CA",
   "EMPLOYER": "MCA & Associates",
   "OCCUPATION": "Owner",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924595",
   "ENTITY": "IND",
   "ENTITY NAME": "Kefauver",
   "ENTITY NAME CONT.": "GailE.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935352",
   "ENTITY": "IND",
   "ENTITY NAME": "Keller",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Saratoga Food Specialties",
   "OCCUPATION": "Plant Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925153",
   "ENTITY": "IND",
   "ENTITY NAME": "Keller",
   "ENTITY NAME CONT.": "Sarah",
   "ENTITY CITY": "West Newton",
   "Entity_ST": "MA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550466",
   "ENTITY": "IND",
   "ENTITY NAME": "Kelley",
   "ENTITY NAME CONT.": "Susan",
   "ENTITY CITY": "Ben Lomond",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 484
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922974",
   "ENTITY": "IND",
   "ENTITY NAME": "Kelliher",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "The San Francisco Foundation",
   "OCCUPATION": "Philanthropy Advisor",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933742",
   "ENTITY": "IND",
   "ENTITY NAME": "Kelly",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kelly & Associates",
   "OCCUPATION": "Accountant",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928212",
   "ENTITY": "IND",
   "ENTITY NAME": "Kennedy",
   "ENTITY NAME CONT.": "GeorgeW",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923511",
   "ENTITY": "IND",
   "ENTITY NAME": "Kennett",
   "ENTITY NAME CONT.": "JohnH",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rotary Club of San Jose",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925154",
   "ENTITY": "IND",
   "ENTITY NAME": "Kenney",
   "ENTITY NAME CONT.": "Kent",
   "ENTITY CITY": "Ben Lomond",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Sanitation",
   "OCCUPATION": "Accountant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928200",
   "ENTITY": "IND",
   "ENTITY NAME": "Kewmpczinski",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553739",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552871",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553403",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553086",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552611",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552012",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552076",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552098",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552089",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552073",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 248
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552094",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 131
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553749",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 107
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553436",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 58
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "F",
   "ID": "D553435",
   "ENTITY": "IND",
   "ENTITY NAME": "Khan",
   "ENTITY NAME CONT.": "Jamal",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924623",
   "ENTITY": "IND",
   "ENTITY NAME": "Kieve",
   "ENTITY NAME CONT.": "RobertS",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Empire Broadasting Corp.",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924236",
   "ENTITY": "IND",
   "ENTITY NAME": "Kim",
   "ENTITY NAME CONT.": "MichaelH",
   "ENTITY CITY": "Lafayette",
   "Entity_ST": "CA",
   "EMPLOYER": "Simeon Properties",
   "OCCUPATION": "CIO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923824",
   "ENTITY": "IND",
   "ENTITY NAME": "King",
   "ENTITY NAME CONT.": "KathleenM.",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Healthier Kids Foundation",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926760",
   "ENTITY": "IND",
   "ENTITY NAME": "King-Stitchman",
   "ENTITY NAME CONT.": "Sandra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924691",
   "ENTITY": "IND",
   "ENTITY NAME": "Kingsley",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "SKS Partners",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923504",
   "ENTITY": "IND",
   "ENTITY NAME": "Kirby",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ARC TEC, Inc",
   "OCCUPATION": "Architect",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925048",
   "ENTITY": "IND",
   "ENTITY NAME": "Kirkland",
   "ENTITY NAME CONT.": "JamesA",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Trimble Navigation Limited",
   "OCCUPATION": "Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925049",
   "ENTITY": "IND",
   "ENTITY NAME": "Kirkland",
   "ENTITY NAME CONT.": "D'Arcy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Murdoch Martell",
   "OCCUPATION": "Financial Consultant",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925018",
   "ENTITY": "IND",
   "ENTITY NAME": "Klayko",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "MKA Capital",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922973",
   "ENTITY": "IND",
   "ENTITY NAME": "Kline",
   "ENTITY NAME CONT.": "Norman",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "LibraryWorld, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933877",
   "ENTITY": "IND",
   "ENTITY NAME": "Knapp",
   "ENTITY NAME CONT.": "Trecia",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Pacific Union Real Estate",
   "OCCUPATION": "Broker and Realtor",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928219",
   "ENTITY": "IND",
   "ENTITY NAME": "Kogura",
   "ENTITY NAME CONT.": "Albert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924264",
   "ENTITY": "IND",
   "ENTITY NAME": "Kolstad",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924769",
   "ENTITY": "IND",
   "ENTITY NAME": "Koopmans",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925023",
   "ENTITY": "IND",
   "ENTITY NAME": "Kovaleski",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "John Kovaleski",
   "OCCUPATION": "Commercial Real Estate Broker",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924689",
   "ENTITY": "IND",
   "ENTITY NAME": "Kownacki",
   "ENTITY NAME CONT.": "Wanda",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924773",
   "ENTITY": "IND",
   "ENTITY NAME": "Kozlowski",
   "ENTITY NAME CONT.": "Kirk",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Saratoga Capital, Inc",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924040",
   "ENTITY": "IND",
   "ENTITY NAME": "Kozuma",
   "ENTITY NAME CONT.": "NeilC.",
   "ENTITY CITY": "Hollister",
   "Entity_ST": "CA",
   "EMPLOYER": "Foothill Community Health Center",
   "OCCUPATION": "Senior Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925312",
   "ENTITY": "IND",
   "ENTITY NAME": "Kracht",
   "ENTITY NAME CONT.": "Roberta",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Roberta Kracht",
   "OCCUPATION": "Psychotherapist",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924241",
   "ENTITY": "IND",
   "ENTITY NAME": "Kracht",
   "ENTITY NAME CONT.": "Roberta",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Roberta Kracht",
   "OCCUPATION": "Psychotherapist",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922924",
   "ENTITY": "IND",
   "ENTITY NAME": "Kracht",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "Lawton Law Firm",
   "OCCUPATION": "Attorney",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990299",
   "ENTITY": "IND",
   "ENTITY NAME": "Kremen",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Dog Patch",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928029",
   "ENTITY": "IND",
   "ENTITY NAME": "Kremen",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Dog Patch",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924268",
   "ENTITY": "IND",
   "ENTITY NAME": "Kroll",
   "ENTITY NAME CONT.": "MarkR",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "Sares Regis Group",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964385",
   "ENTITY": "IND",
   "ENTITY NAME": "Krouskup",
   "ENTITY NAME CONT.": "Brad",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Toeniskoetter Development",
   "OCCUPATION": "Real Estate Investment",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924158",
   "ENTITY": "IND",
   "ENTITY NAME": "Krukrubo",
   "ENTITY NAME CONT.": "Ibinabo",
   "ENTITY CITY": "Danville",
   "Entity_ST": "CA",
   "EMPLOYER": "Ernst & Young",
   "OCCUPATION": "Accountant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10983764",
   "ENTITY": "IND",
   "ENTITY NAME": "Kuechler",
   "ENTITY NAME CONT.": "LarryS",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Armanino LLP",
   "OCCUPATION": "CPA",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924659",
   "ENTITY": "IND",
   "ENTITY NAME": "Kuechler",
   "ENTITY NAME CONT.": "LarryS",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Armanino LLP",
   "OCCUPATION": "CPA",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964107",
   "ENTITY": "IND",
   "ENTITY NAME": "Kuechler",
   "ENTITY NAME CONT.": "LarryS",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Armanino LLP",
   "OCCUPATION": "CPA",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922979",
   "ENTITY": "IND",
   "ENTITY NAME": "Kwok",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Sanitary District",
   "OCCUPATION": "Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922915",
   "ENTITY": "IND",
   "ENTITY NAME": "Labadie",
   "ENTITY NAME CONT.": "Bruce",
   "ENTITY CITY": "Felton",
   "Entity_ST": "CA",
   "EMPLOYER": "Labadie Productions",
   "OCCUPATION": "Music Promoter",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924690",
   "ENTITY": "IND",
   "ENTITY NAME": "Lam",
   "ENTITY NAME CONT.": "Dominic",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Dominic Lam",
   "OCCUPATION": "Engineer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925093",
   "ENTITY": "IND",
   "ENTITY NAME": "Lam",
   "ENTITY NAME CONT.": "Scarlett",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SF Municipal Transportation Agency",
   "OCCUPATION": "Manager IV",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923007",
   "ENTITY": "IND",
   "ENTITY NAME": "Larko",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "JP DiNapoli Companies, Inc.",
   "OCCUPATION": "Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC28",
   "ENTITY": "IND",
   "ENTITY NAME": "LARSEN",
   "ENTITY NAME CONT.": "CHRIS",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "RIPPLE",
   "OCCUPATION": "EXECUTIVE CHAIRMAN",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557188",
   "ENTITY": "IND",
   "ENTITY NAME": "Layland",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989519",
   "ENTITY": "IND",
   "ENTITY NAME": "Lazzarini",
   "ENTITY NAME CONT.": "Jeanne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 3000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924751",
   "ENTITY": "IND",
   "ENTITY NAME": "Lazzarini",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "DAL Properties. Inc.",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925145",
   "ENTITY": "IND",
   "ENTITY NAME": "Lazzarini",
   "ENTITY NAME CONT.": "Nick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cushman & Wakefield",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925315",
   "ENTITY": "IND",
   "ENTITY NAME": "Leanos",
   "ENTITY NAME CONT.": "JaimeA",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Jaime Leanos",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925020",
   "ENTITY": "IND",
   "ENTITY NAME": "Lebaron",
   "ENTITY NAME CONT.": "DavidG.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Saputo Dairy Foods USA",
   "OCCUPATION": "Director of Sales",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924649",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "Mary Jo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "MJL & Associates LLC",
   "OCCUPATION": "Consultant",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964884",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "Big League Impact",
   "OCCUPATION": "Director, Strategy and Partnerships",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923067",
   "ENTITY": "IND",
   "ENTITY NAME": "Lenihan",
   "ENTITY NAME CONT.": "Beverly",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Results Consulting",
   "OCCUPATION": "Non-Profit Consultant",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933876",
   "ENTITY": "IND",
   "ENTITY NAME": "Lettieri",
   "ENTITY NAME CONT.": "FrankPeter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922909",
   "ENTITY": "IND",
   "ENTITY NAME": "Levine",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gap Inc",
   "OCCUPATION": "Software Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963833",
   "ENTITY": "IND",
   "ENTITY NAME": "Lewin",
   "ENTITY NAME CONT.": "Dan'l",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Computer History Museum",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922964",
   "ENTITY": "IND",
   "ENTITY NAME": "Lewis",
   "ENTITY NAME CONT.": "JoeT.",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Orchard Commercial, Inc.",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC9",
   "ENTITY": "IND",
   "ENTITY NAME": "LEYBA",
   "ENTITY NAME CONT.": "JOHN",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "PACIFIC GAS AND ELECTRIC COMPANY",
   "OCCUPATION": "BUSINESS PROCESS ANALYST",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925052",
   "ENTITY": "IND",
   "ENTITY NAME": "Li",
   "ENTITY NAME CONT.": "Xiang",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Bayview Development Group",
   "OCCUPATION": "President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925054",
   "ENTITY": "IND",
   "ENTITY NAME": "Li",
   "ENTITY NAME CONT.": "Leanne",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Bayview Development Group",
   "OCCUPATION": "Management",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933730",
   "ENTITY": "IND",
   "ENTITY NAME": "Liang",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Super Micro Computer, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933879",
   "ENTITY": "IND",
   "ENTITY NAME": "Liberty",
   "ENTITY NAME CONT.": "MichaelD",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Office of Michael Liberty",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924253",
   "ENTITY": "IND",
   "ENTITY NAME": "Libitzky",
   "ENTITY NAME CONT.": "Moses",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "Moses Libitzky",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "B1",
   "ID": "C10922905",
   "ENTITY": "IND",
   "ENTITY NAME": "Liccardo",
   "ENTITY NAME CONT.": "Sam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Mayor",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922954",
   "ENTITY": "IND",
   "ENTITY NAME": "Liccardo",
   "ENTITY NAME CONT.": "Laura",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Laura Liccardo",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923320",
   "ENTITY": "IND",
   "ENTITY NAME": "Liccardo",
   "ENTITY NAME CONT.": "Salvador",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Liccardo Law Firm",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923321",
   "ENTITY": "IND",
   "ENTITY NAME": "Liccardo",
   "ENTITY NAME CONT.": "LauraS",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925296",
   "ENTITY": "IND",
   "ENTITY NAME": "Liccardo",
   "ENTITY NAME CONT.": "Kathy",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Liccardo Travel",
   "OCCUPATION": "Travel Agent",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924266",
   "ENTITY": "IND",
   "ENTITY NAME": "Lierman",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "Intracorp",
   "OCCUPATION": "Regional President; Northwest Region",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923826",
   "ENTITY": "IND",
   "ENTITY NAME": "Liu",
   "ENTITY NAME CONT.": "I-Fang Yvonne",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928221",
   "ENTITY": "IND",
   "ENTITY NAME": "Lo",
   "ENTITY NAME CONT.": "Selina",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924170",
   "ENTITY": "IND",
   "ENTITY NAME": "Lodoen",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "L&D Construction Company, Inc",
   "OCCUPATION": "Construction",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931680",
   "ENTITY": "IND",
   "ENTITY NAME": "Loper",
   "ENTITY NAME CONT.": "Laurence",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Family Giving Tree",
   "OCCUPATION": "Marketing",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925043",
   "ENTITY": "IND",
   "ENTITY NAME": "Lopes",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Western States Oil Company",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558265",
   "ENTITY": "IND",
   "ENTITY NAME": "Lopez",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 320
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557361",
   "ENTITY": "IND",
   "ENTITY NAME": "Lopez",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 210
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963908",
   "ENTITY": "IND",
   "ENTITY NAME": "Lovalenti",
   "ENTITY NAME CONT.": "Phillip",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Aridis Pharmaceuticals",
   "OCCUPATION": "Chemical Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924686",
   "ENTITY": "IND",
   "ENTITY NAME": "Love",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923002",
   "ENTITY": "IND",
   "ENTITY NAME": "Loving",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Community Foundation",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924258",
   "ENTITY": "IND",
   "ENTITY NAME": "Lowenthal",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923807",
   "ENTITY": "IND",
   "ENTITY NAME": "Lund",
   "ENTITY NAME CONT.": "GordonF.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925091",
   "ENTITY": "IND",
   "ENTITY NAME": "Luthard",
   "ENTITY NAME CONT.": "Andre",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923068",
   "ENTITY": "IND",
   "ENTITY NAME": "Lymberis",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker Willow Glen",
   "OCCUPATION": "Realtor",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923353",
   "ENTITY": "IND",
   "ENTITY NAME": "Maben Hammon",
   "ENTITY NAME CONT.": "Meri",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964932",
   "ENTITY": "IND",
   "ENTITY NAME": "Macapinlac",
   "ENTITY NAME CONT.": "Andrae",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "California State Senate",
   "OCCUPATION": "Senior District Representative",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923513",
   "ENTITY": "IND",
   "ENTITY NAME": "Machida",
   "ENTITY NAME CONT.": "KarenM",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928183",
   "ENTITY": "IND",
   "ENTITY NAME": "MacLaren",
   "ENTITY NAME CONT.": "Allan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 114
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923337",
   "ENTITY": "IND",
   "ENTITY NAME": "MacMillan",
   "ENTITY NAME CONT.": "DonaldH",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "MacMillan Properties",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10983762",
   "ENTITY": "IND",
   "ENTITY NAME": "MacRostie",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Tom MacRostie",
   "OCCUPATION": "Affordable Housing Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924285",
   "ENTITY": "IND",
   "ENTITY NAME": "Mahan",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Brigade Group, Inc.",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923357",
   "ENTITY": "IND",
   "ENTITY NAME": "Mahoney",
   "ENTITY NAME CONT.": "Philip",
   "ENTITY CITY": "Los Altos Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "Newmark",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925426",
   "ENTITY": "IND",
   "ENTITY NAME": "Mair",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "South Bay Development",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928211",
   "ENTITY": "IND",
   "ENTITY NAME": "Makiewicz",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925124",
   "ENTITY": "IND",
   "ENTITY NAME": "Mandolini",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Eden Housing, Inc.",
   "OCCUPATION": "Non Profit Director",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925036",
   "ENTITY": "IND",
   "ENTITY NAME": "Manley",
   "ENTITY NAME CONT.": "CharlesM",
   "ENTITY CITY": "Nashville",
   "Entity_ST": "TN",
   "EMPLOYER": "Charles M. Manley",
   "OCCUPATION": "Real Estate Development & Management",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925037",
   "ENTITY": "IND",
   "ENTITY NAME": "Manley",
   "ENTITY NAME CONT.": "LucindaM",
   "ENTITY CITY": "Nashville",
   "Entity_ST": "TN",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922989",
   "ENTITY": "IND",
   "ENTITY NAME": "Manning",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Residential Realty",
   "OCCUPATION": "Associate Broker",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924636",
   "ENTITY": "IND",
   "ENTITY NAME": "Marchese",
   "ENTITY NAME CONT.": "ChristopherJ",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Marchese Farms",
   "OCCUPATION": "Farmer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925354",
   "ENTITY": "IND",
   "ENTITY NAME": "Marchese",
   "ENTITY NAME CONT.": "LisaM",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924125",
   "ENTITY": "IND",
   "ENTITY NAME": "Marimo Berk",
   "ENTITY NAME CONT.": "Elena",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Creekside School",
   "OCCUPATION": "Co-Founder",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928210",
   "ENTITY": "IND",
   "ENTITY NAME": "Markey",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "DGA Architects",
   "OCCUPATION": "Architect",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926749",
   "ENTITY": "IND",
   "ENTITY NAME": "Markey",
   "ENTITY NAME CONT.": "Geraldine",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Geraldine Markey",
   "OCCUPATION": "Talent Acquisition & Development Consultant",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931689",
   "ENTITY": "IND",
   "ENTITY NAME": "Marshall",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "Tempe",
   "Entity_ST": "AZ",
   "EMPLOYER": "Village Bloom, LLC",
   "OCCUPATION": "Partner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC36",
   "ENTITY": "IND",
   "ENTITY NAME": "MARSHMAN",
   "ENTITY NAME CONT.": "BARBARA",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "SAN JOSE MERCURY NEWS",
   "OCCUPATION": "EDITOR",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924675",
   "ENTITY": "IND",
   "ENTITY NAME": "Martin",
   "ENTITY NAME CONT.": "Russell",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "Collective(i)",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924188",
   "ENTITY": "IND",
   "ENTITY NAME": "Martin",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "Sonoma",
   "Entity_ST": "CA",
   "EMPLOYER": "Paul Martin",
   "OCCUPATION": "Filmmaker",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924171",
   "ENTITY": "IND",
   "ENTITY NAME": "Martinez",
   "ENTITY NAME CONT.": "Constance",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Creates",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922982",
   "ENTITY": "IND",
   "ENTITY NAME": "Marvin",
   "ENTITY NAME CONT.": "LeRoy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928257",
   "ENTITY": "IND",
   "ENTITY NAME": "Marvin",
   "ENTITY NAME CONT.": "LeRoy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933749",
   "ENTITY": "IND",
   "ENTITY NAME": "Mashkoori",
   "ENTITY NAME CONT.": "Amir",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "ISDI Digital University",
   "OCCUPATION": "CEO",
   "AMOUNT": 700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925024",
   "ENTITY": "IND",
   "ENTITY NAME": "Mashkoori",
   "ENTITY NAME CONT.": "Amir",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "ISDI Digital University",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925339",
   "ENTITY": "IND",
   "ENTITY NAME": "Matharu",
   "ENTITY NAME CONT.": "NarinderS",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "WRS Materials",
   "OCCUPATION": "Senior Technician",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924270",
   "ENTITY": "IND",
   "ENTITY NAME": "Matteoni",
   "ENTITY NAME CONT.": "NormanE",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Norman Matteoni",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923481",
   "ENTITY": "IND",
   "ENTITY NAME": "Matthews",
   "ENTITY NAME CONT.": "Marjorie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925113",
   "ENTITY": "IND",
   "ENTITY NAME": "Mattson",
   "ENTITY NAME CONT.": "ElizabethJ",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Stanford University",
   "OCCUPATION": "Research & Financial Admin",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925002",
   "ENTITY": "IND",
   "ENTITY NAME": "May",
   "ENTITY NAME CONT.": "Tony",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924288",
   "ENTITY": "IND",
   "ENTITY NAME": "McCabe",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "DBS Bank",
   "OCCUPATION": "Banking",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923065",
   "ENTITY": "IND",
   "ENTITY NAME": "McCollum",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923811",
   "ENTITY": "IND",
   "ENTITY NAME": "McCray",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984881",
   "ENTITY": "IND",
   "ENTITY NAME": "McCrumb",
   "ENTITY NAME CONT.": "Hannelore",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 40
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928269",
   "ENTITY": "IND",
   "ENTITY NAME": "McCrumb",
   "ENTITY NAME CONT.": "Hannelore",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552282",
   "ENTITY": "IND",
   "ENTITY NAME": "McDowell",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552613",
   "ENTITY": "IND",
   "ENTITY NAME": "McDowell",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924625",
   "ENTITY": "IND",
   "ENTITY NAME": "McEnery",
   "ENTITY NAME CONT.": "Jill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924626",
   "ENTITY": "IND",
   "ENTITY NAME": "McEnery",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Farmers Union",
   "OCCUPATION": "General Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925088",
   "ENTITY": "IND",
   "ENTITY NAME": "McEnery",
   "ENTITY NAME CONT.": "JohnP",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "San Pedro Square Association",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923082",
   "ENTITY": "IND",
   "ENTITY NAME": "McKay",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Britannia Arms",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934816",
   "ENTITY": "IND",
   "ENTITY NAME": "McLaughlin",
   "ENTITY NAME CONT.": "Stuart",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Hawk Hill Management LLC",
   "OCCUPATION": "Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924273",
   "ENTITY": "IND",
   "ENTITY NAME": "McLaughlin",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Palo Alto Networks",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925085",
   "ENTITY": "IND",
   "ENTITY NAME": "McMahon",
   "ENTITY NAME CONT.": "Edward",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "Bayview Development Group",
   "OCCUPATION": "CIO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922967",
   "ENTITY": "IND",
   "ENTITY NAME": "McNeil",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Apple",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924600",
   "ENTITY": "IND",
   "ENTITY NAME": "McNeil",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "R Donald McNeil APLC",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933736",
   "ENTITY": "IND",
   "ENTITY NAME": "McNeil",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Church of God San Jose",
   "OCCUPATION": "Associate Pastor",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928028",
   "ENTITY": "IND",
   "ENTITY NAME": "Meijer",
   "ENTITY NAME CONT.": "Alexsandra",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922922",
   "ENTITY": "IND",
   "ENTITY NAME": "Meinhardt",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Furious Collective",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924222",
   "ENTITY": "IND",
   "ENTITY NAME": "Melchiano",
   "ENTITY NAME CONT.": "Ryan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SP2 Restaurant",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964256",
   "ENTITY": "IND",
   "ENTITY NAME": "Melkesian",
   "ENTITY NAME CONT.": "Monica",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "Federal Realty Investment Trust",
   "OCCUPATION": "Director of Development",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923799",
   "ENTITY": "IND",
   "ENTITY NAME": "Melo",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922972",
   "ENTITY": "IND",
   "ENTITY NAME": "Melvin",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Larkspur",
   "Entity_ST": "CA",
   "EMPLOYER": "Touchstone Climbing Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964014",
   "ENTITY": "IND",
   "ENTITY NAME": "Mendizabal",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Foothill De Anza Community College District",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924687",
   "ENTITY": "IND",
   "ENTITY NAME": "Menne",
   "ENTITY NAME CONT.": "Martin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "MCM Diversified",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925068",
   "ENTITY": "IND",
   "ENTITY NAME": "Menne",
   "ENTITY NAME CONT.": "RebeccaS",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rebecca S. Menne",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923329",
   "ENTITY": "IND",
   "ENTITY NAME": "Merino",
   "ENTITY NAME CONT.": "Ruth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964114",
   "ENTITY": "IND",
   "ENTITY NAME": "Merino",
   "ENTITY NAME CONT.": "Ruth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928217",
   "ENTITY": "IND",
   "ENTITY NAME": "Merritt",
   "ENTITY NAME CONT.": "Douglas",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Splunk",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928175",
   "ENTITY": "IND",
   "ENTITY NAME": "Mertens",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Tom Mertens",
   "OCCUPATION": "Communications/PR",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922955",
   "ENTITY": "IND",
   "ENTITY NAME": "Mertens",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Tom Mertens",
   "OCCUPATION": "Communications/PR",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925094",
   "ENTITY": "IND",
   "ENTITY NAME": "Mesa",
   "ENTITY NAME CONT.": "Antolin",
   "ENTITY CITY": "Pembroke Pines",
   "Entity_ST": "FL",
   "EMPLOYER": "Tony Mesa Real Estate School Inc.",
   "OCCUPATION": "President and Head Instructor",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925138",
   "ENTITY": "IND",
   "ENTITY NAME": "Messinger",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Meacham/Oppenheimer, Inc.",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924126",
   "ENTITY": "IND",
   "ENTITY NAME": "Miller",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Michael Miller",
   "OCCUPATION": "Theatrical Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923013",
   "ENTITY": "IND",
   "ENTITY NAME": "Miller",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Educator",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923087",
   "ENTITY": "IND",
   "ENTITY NAME": "Milligan",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Western Digital",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924760",
   "ENTITY": "IND",
   "ENTITY NAME": "Milligan",
   "ENTITY NAME CONT.": "Shawn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "UCP LLC",
   "OCCUPATION": "Developer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923512",
   "ENTITY": "IND",
   "ENTITY NAME": "Milligan",
   "ENTITY NAME CONT.": "Joyce",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924652",
   "ENTITY": "IND",
   "ENTITY NAME": "Milligan",
   "ENTITY NAME CONT.": "LewisV",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924671",
   "ENTITY": "IND",
   "ENTITY NAME": "Minicucci",
   "ENTITY NAME CONT.": "Ben",
   "ENTITY CITY": "Sammamish",
   "Entity_ST": "WA",
   "EMPLOYER": "Alaska Airlines",
   "OCCUPATION": "Management",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925058",
   "ENTITY": "IND",
   "ENTITY NAME": "Minnis",
   "ENTITY NAME CONT.": "Ronald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Concrete Ready Mix, Inc",
   "OCCUPATION": "President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924049",
   "ENTITY": "IND",
   "ENTITY NAME": "Mirenda",
   "ENTITY NAME CONT.": "Anthony",
   "ENTITY CITY": "Hayward",
   "Entity_ST": "CA",
   "EMPLOYER": "Blach Construction Company",
   "OCCUPATION": "Project Executive",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924692",
   "ENTITY": "IND",
   "ENTITY NAME": "Mirkin",
   "ENTITY NAME CONT.": "BarryB",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Barry Mirkin",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925038",
   "ENTITY": "IND",
   "ENTITY NAME": "Mishra",
   "ENTITY NAME CONT.": "VishN",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Clearstone Venture Partners",
   "OCCUPATION": "Venture Capitalist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925137",
   "ENTITY": "IND",
   "ENTITY NAME": "Mitchell",
   "ENTITY NAME CONT.": "Pat",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Parisi House on the Hill",
   "OCCUPATION": "Non Profit Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924127",
   "ENTITY": "IND",
   "ENTITY NAME": "Mittelhauser",
   "ENTITY NAME CONT.": "Erica",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "Stroscher Capistrano, LLC",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923010",
   "ENTITY": "IND",
   "ENTITY NAME": "Mix",
   "ENTITY NAME CONT.": "Jerry",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Finelite Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922912",
   "ENTITY": "IND",
   "ENTITY NAME": "Mjolsness",
   "ENTITY NAME CONT.": "Joel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Mirantis",
   "OCCUPATION": "Technology Consultant",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923080",
   "ENTITY": "IND",
   "ENTITY NAME": "Monley",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Alain Pinel Realtors",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924260",
   "ENTITY": "IND",
   "ENTITY NAME": "Montes De Oca Kuechler",
   "ENTITY NAME CONT.": "Ivonne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928246",
   "ENTITY": "IND",
   "ENTITY NAME": "Moore",
   "ENTITY NAME CONT.": "ChrisT",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Armanino LLP",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930968",
   "ENTITY": "IND",
   "ENTITY NAME": "Moore",
   "ENTITY NAME CONT.": "Marie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928197",
   "ENTITY": "IND",
   "ENTITY NAME": "Moore",
   "ENTITY NAME CONT.": "Dorsey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Conservation Corps",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925133",
   "ENTITY": "IND",
   "ENTITY NAME": "Moran",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "Calistoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Richard Moran",
   "OCCUPATION": "Consultant",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923101",
   "ENTITY": "IND",
   "ENTITY NAME": "Moreles",
   "ENTITY NAME CONT.": "Jess",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Whole Foods Market",
   "OCCUPATION": "Assistant Store Team Lead",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928196",
   "ENTITY": "IND",
   "ENTITY NAME": "Morgan",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924210",
   "ENTITY": "IND",
   "ENTITY NAME": "Moriarty",
   "ENTITY NAME CONT.": "Brad",
   "ENTITY CITY": "Concord",
   "Entity_ST": "MA",
   "EMPLOYER": "Milton Academy",
   "OCCUPATION": "Teacher",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928237",
   "ENTITY": "IND",
   "ENTITY NAME": "Morley",
   "ENTITY NAME CONT.": "Sean",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Morley Bros., LLC",
   "OCCUPATION": "Real Estate Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923782",
   "ENTITY": "IND",
   "ENTITY NAME": "Morris",
   "ENTITY NAME CONT.": "Gaylon",
   "ENTITY CITY": "Boulder Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Electric",
   "OCCUPATION": "VP, Operations",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924172",
   "ENTITY": "IND",
   "ENTITY NAME": "Morrone",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928256",
   "ENTITY": "IND",
   "ENTITY NAME": "Morrone",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923500",
   "ENTITY": "IND",
   "ENTITY NAME": "Most",
   "ENTITY NAME CONT.": "Lexa Jean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922950",
   "ENTITY": "IND",
   "ENTITY NAME": "Moul",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Commercial Real Estate Broker",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923362",
   "ENTITY": "IND",
   "ENTITY NAME": "Mulcahy",
   "ENTITY NAME CONT.": "MichaelP.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SDS NexGen Partners LP",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923363",
   "ENTITY": "IND",
   "ENTITY NAME": "Mulcahy",
   "ENTITY NAME CONT.": "Kimberly",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "HHCRA",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933873",
   "ENTITY": "IND",
   "ENTITY NAME": "Mulcahy",
   "ENTITY NAME CONT.": "TimothyE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SDS Nexgen LLC",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923499",
   "ENTITY": "IND",
   "ENTITY NAME": "Mulic",
   "ENTITY NAME CONT.": "Alexander",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928236",
   "ENTITY": "IND",
   "ENTITY NAME": "Mullen",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Comcast",
   "OCCUPATION": "Marketing",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928239",
   "ENTITY": "IND",
   "ENTITY NAME": "Muller",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928242",
   "ENTITY": "IND",
   "ENTITY NAME": "Muller",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kathleen Muller",
   "OCCUPATION": "Grantwriter",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924157",
   "ENTITY": "IND",
   "ENTITY NAME": "Mullins",
   "ENTITY NAME CONT.": "Kathryn",
   "ENTITY CITY": "Sausalito",
   "Entity_ST": "CA",
   "EMPLOYER": "Kathryn Mullins",
   "OCCUPATION": "Consultant",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924205",
   "ENTITY": "IND",
   "ENTITY NAME": "Munro",
   "ENTITY NAME CONT.": "Dean",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924747",
   "ENTITY": "IND",
   "ENTITY NAME": "Murabito",
   "ENTITY NAME CONT.": "AnthonyC",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Murabito Hao & Barnes LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964112",
   "ENTITY": "IND",
   "ENTITY NAME": "Murawski",
   "ENTITY NAME CONT.": "Stan",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928204",
   "ENTITY": "IND",
   "ENTITY NAME": "Murchan",
   "ENTITY NAME CONT.": "Larry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922980",
   "ENTITY": "IND",
   "ENTITY NAME": "Murchan",
   "ENTITY NAME CONT.": "Larry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925070",
   "ENTITY": "IND",
   "ENTITY NAME": "Naboulsi",
   "ENTITY NAME CONT.": "Ziad",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "Applied Materials",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925071",
   "ENTITY": "IND",
   "ENTITY NAME": "Naboulsi",
   "ENTITY NAME CONT.": "Marwan",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "Dell Technologies",
   "OCCUPATION": "Engineering Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925072",
   "ENTITY": "IND",
   "ENTITY NAME": "Naboulsi",
   "ENTITY NAME CONT.": "Rana",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "Viavi Solutions",
   "OCCUPATION": "Accounting Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925074",
   "ENTITY": "IND",
   "ENTITY NAME": "Naboulsi",
   "ENTITY NAME CONT.": "Hassan",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "SiliconSage Builders",
   "OCCUPATION": "Technology Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925136",
   "ENTITY": "IND",
   "ENTITY NAME": "Nadhiri",
   "ENTITY NAME CONT.": "Muhammad",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Axis Development Group",
   "OCCUPATION": "Reals Estate Development",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936086",
   "ENTITY": "IND",
   "ENTITY NAME": "Nahal",
   "ENTITY NAME CONT.": "Harbhajan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 125
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924694",
   "ENTITY": "IND",
   "ENTITY NAME": "Narter",
   "ENTITY NAME CONT.": "Bart",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924665",
   "ENTITY": "IND",
   "ENTITY NAME": "Nasarabadi",
   "ENTITY NAME CONT.": "Larry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Xepto Computing, Inc.",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925051",
   "ENTITY": "IND",
   "ENTITY NAME": "Natt",
   "ENTITY NAME CONT.": "Manraj",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "George F Saunders Inc.",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556859",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Olivia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1125
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558259",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Olivia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558286",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Olivia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 417
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558285",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Olivia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 375
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556860",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Olivia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 147
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558260",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Olivia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 105
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924656",
   "ENTITY": "IND",
   "ENTITY NAME": "Nazario",
   "ENTITY NAME CONT.": "ThomasA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "University of San Francisco",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935351",
   "ENTITY": "IND",
   "ENTITY NAME": "Neal",
   "ENTITY NAME CONT.": "Walter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Walter Neal",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924110",
   "ENTITY": "IND",
   "ENTITY NAME": "Neale",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "The Core Companies",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923497",
   "ENTITY": "IND",
   "ENTITY NAME": "Needham",
   "ENTITY NAME CONT.": "Stephanie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924120",
   "ENTITY": "IND",
   "ENTITY NAME": "Neighbors",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gallina LLP",
   "OCCUPATION": "Certified Public Accountant",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924199",
   "ENTITY": "IND",
   "ENTITY NAME": "Neighbors",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gallina LLP",
   "OCCUPATION": "Certified Public Accountant",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923780",
   "ENTITY": "IND",
   "ENTITY NAME": "Nelson",
   "ENTITY NAME CONT.": "Eileen",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Electric",
   "OCCUPATION": "Senior VP, Human Resources",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923022",
   "ENTITY": "IND",
   "ENTITY NAME": "Nevens",
   "ENTITY NAME CONT.": "T. Michael",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Permira",
   "OCCUPATION": "Senior Advisor",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923776",
   "ENTITY": "IND",
   "ENTITY NAME": "Newberry",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nest",
   "OCCUPATION": "Head of Network Technology",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552281",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 510
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553404",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 465
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553437",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 406
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552014",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 360
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553087",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 360
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552872",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 330
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552090",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552077",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553740",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 180
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552074",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552086",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "F",
   "ID": "D553434",
   "ENTITY": "IND",
   "ENTITY NAME": "Ngo Tran",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925289",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Vinh",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "SiliconSage Construction",
   "OCCUPATION": "Payroll Assistance",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925290",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Hong Kim",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925149",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Phapchon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Phapchon Nguyen",
   "OCCUPATION": "Teacher",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964816",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Tinh",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "T&T Beauty Supply",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925065",
   "ENTITY": "IND",
   "ENTITY NAME": "Nguyen",
   "ENTITY NAME CONT.": "Bang",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Align Technology",
   "OCCUPATION": "IT Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925003",
   "ENTITY": "IND",
   "ENTITY NAME": "Nino",
   "ENTITY NAME CONT.": "Jonah",
   "ENTITY CITY": "La Jolla",
   "Entity_ST": "CA",
   "EMPLOYER": "Robbins Geller Rudman & Dowd LLP",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925000",
   "ENTITY": "IND",
   "ENTITY NAME": "Nino",
   "ENTITY NAME CONT.": "Deanna",
   "ENTITY CITY": "La Jolla",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928214",
   "ENTITY": "IND",
   "ENTITY NAME": "Nino",
   "ENTITY NAME CONT.": "Dennis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Dennis Nino",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923496",
   "ENTITY": "IND",
   "ENTITY NAME": "Nishihara",
   "ENTITY NAME CONT.": "JeremyS.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sunnyvale School District",
   "OCCUPATION": "Administrator",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928017",
   "ENTITY": "IND",
   "ENTITY NAME": "Niu",
   "ENTITY NAME CONT.": "Shurong",
   "ENTITY CITY": "Hillsborough",
   "Entity_ST": "CA",
   "EMPLOYER": "Horizon Real Properties Holdings, LLC",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553002",
   "ENTITY": "IND",
   "ENTITY NAME": "Niu",
   "ENTITY NAME CONT.": "Shurong",
   "ENTITY CITY": "Hillsborough",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924654",
   "ENTITY": "IND",
   "ENTITY NAME": "Noack",
   "ENTITY NAME CONT.": "RichardM",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924141",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "Laurence",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Laurence Nolan",
   "OCCUPATION": "Construction",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924142",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "Margaret",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924143",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "James Nolan Sr.",
   "OCCUPATION": "Construction",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924145",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "Pauline",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Pauline Nolan",
   "OCCUPATION": "Construction",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924154",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924155",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "Desmond",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Hard Rock Concrete",
   "OCCUPATION": "Contractor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924168",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "Diana",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Diligente Technologies",
   "OCCUPATION": "Account Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924209",
   "ENTITY": "IND",
   "ENTITY NAME": "Nolan",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Hard Rock Concrete Inc",
   "OCCUPATION": "Project Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923489",
   "ENTITY": "IND",
   "ENTITY NAME": "Normandin",
   "ENTITY NAME CONT.": "Margaret",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924197",
   "ENTITY": "IND",
   "ENTITY NAME": "Normandin",
   "ENTITY NAME CONT.": "PaulJ",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Normandin Chrysler",
   "OCCUPATION": "Sales Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925025",
   "ENTITY": "IND",
   "ENTITY NAME": "Normandin",
   "ENTITY NAME CONT.": "Lisa",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925012",
   "ENTITY": "IND",
   "ENTITY NAME": "Normandin",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Normandin Chrysler Jeep Dodge",
   "OCCUPATION": "Owner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925013",
   "ENTITY": "IND",
   "ENTITY NAME": "Normandin",
   "ENTITY NAME CONT.": "Caren",
   "ENTITY CITY": "Rohnert Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Caren Normandin",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924165",
   "ENTITY": "IND",
   "ENTITY NAME": "Novielli",
   "ENTITY NAME CONT.": "Kim",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Richmar Associates",
   "OCCUPATION": "Staffing Professional",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924263",
   "ENTITY": "IND",
   "ENTITY NAME": "Nunez",
   "ENTITY NAME CONT.": "Felipe",
   "ENTITY CITY": "Smyrna",
   "Entity_ST": "GA",
   "EMPLOYER": "Rheem",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964110",
   "ENTITY": "IND",
   "ENTITY NAME": "NyBlom",
   "ENTITY NAME CONT.": "Jack",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Camera Cinemas",
   "OCCUPATION": "President",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924046",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Kane",
   "ENTITY NAME CONT.": "SeanP",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cadence Design Systems",
   "OCCUPATION": "Executive Director, Marketing, Video Production",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923108",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Mahony",
   "ENTITY NAME CONT.": "Conor",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Comet Technologies USA Inc.",
   "OCCUPATION": "Vice President",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964655",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Rourke",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Okkralabs",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923019",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Rourke",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Okkralabs",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923514",
   "ENTITY": "IND",
   "ENTITY NAME": "Oliverio",
   "ENTITY NAME CONT.": "Pierluigi",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Supplyframe",
   "OCCUPATION": "Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923493",
   "ENTITY": "IND",
   "ENTITY NAME": "Olugbode",
   "ENTITY NAME CONT.": "JosephineA",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964827",
   "ENTITY": "IND",
   "ENTITY NAME": "Orton III",
   "ENTITY NAME CONT.": "J.R.",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "Orton Development, Inc.",
   "OCCUPATION": "President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964930",
   "ENTITY": "IND",
   "ENTITY NAME": "Oster",
   "ENTITY NAME CONT.": "Katherine",
   "ENTITY CITY": "Ross",
   "Entity_ST": "CA",
   "EMPLOYER": "Point Reyes Energy",
   "OCCUPATION": "Solar",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923077",
   "ENTITY": "IND",
   "ENTITY NAME": "Ostrowski",
   "ENTITY NAME CONT.": "Julia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hortonworks",
   "OCCUPATION": "Operations Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964108",
   "ENTITY": "IND",
   "ENTITY NAME": "Ostrowski",
   "ENTITY NAME CONT.": "Julia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hortonworks",
   "OCCUPATION": "Operations Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963936",
   "ENTITY": "IND",
   "ENTITY NAME": "Oung",
   "ENTITY NAME CONT.": "Caroline",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924637",
   "ENTITY": "IND",
   "ENTITY NAME": "Owen",
   "ENTITY NAME CONT.": "HelenMarchese",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Marchese Farms",
   "OCCUPATION": "Grower",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924638",
   "ENTITY": "IND",
   "ENTITY NAME": "Owen",
   "ENTITY NAME CONT.": "Edward",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Marchese Farms",
   "OCCUPATION": "Grower",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923092",
   "ENTITY": "IND",
   "ENTITY NAME": "Pacula",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "Hewlett Packard",
   "OCCUPATION": "VP of Marketing",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923093",
   "ENTITY": "IND",
   "ENTITY NAME": "Pacula",
   "ENTITY NAME CONT.": "Rosalie",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "RAND Corporation",
   "OCCUPATION": "Senior Economist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923109",
   "ENTITY": "IND",
   "ENTITY NAME": "Pacula",
   "ENTITY NAME CONT.": "SueEllen",
   "ENTITY CITY": "Santa Clarita",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924684",
   "ENTITY": "IND",
   "ENTITY NAME": "Padfield",
   "ENTITY NAME CONT.": "SaraR.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hudson Management Company Inc.",
   "OCCUPATION": "Accountant",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935154",
   "ENTITY": "IND",
   "ENTITY NAME": "Padgaokar",
   "ENTITY NAME CONT.": "Anagha",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "CRISIL Ltd",
   "OCCUPATION": "Senior Associate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933882",
   "ENTITY": "IND",
   "ENTITY NAME": "Padwal",
   "ENTITY NAME CONT.": "Ashit",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Allied Telesis, Inc.",
   "OCCUPATION": "Chief Risk Officer",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935153",
   "ENTITY": "IND",
   "ENTITY NAME": "Pahwa",
   "ENTITY NAME CONT.": "Ajay",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sunrise Impex LLC",
   "OCCUPATION": "Director, Business Development",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923804",
   "ENTITY": "IND",
   "ENTITY NAME": "Pakbaz",
   "ENTITY NAME CONT.": "Siyamak",
   "ENTITY CITY": "Anna Maria",
   "Entity_ST": "FL",
   "EMPLOYER": "Kirkland & Ellis",
   "OCCUPATION": "Lawyer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924706",
   "ENTITY": "IND",
   "ENTITY NAME": "Pakbaz",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "Anna Maria",
   "Entity_ST": "FL",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928184",
   "ENTITY": "IND",
   "ENTITY NAME": "Palmer Jones",
   "ENTITY NAME CONT.": "Nancy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "First Unitarian Church of San Jose",
   "OCCUPATION": "Unitarian Universalist Minister",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925096",
   "ENTITY": "IND",
   "ENTITY NAME": "Pandori",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Prosecutor",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924672",
   "ENTITY": "IND",
   "ENTITY NAME": "Papier",
   "ENTITY NAME CONT.": "Jason",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Werba Rubin Papier Wealth Management",
   "OCCUPATION": "Wealth Management",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924176",
   "ENTITY": "IND",
   "ENTITY NAME": "Pappas",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Hensel Phelps",
   "OCCUPATION": "Vice President",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923486",
   "ENTITY": "IND",
   "ENTITY NAME": "Parisi",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Therma Corp.",
   "OCCUPATION": "President/CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924744",
   "ENTITY": "IND",
   "ENTITY NAME": "Parkinson",
   "ENTITY NAME CONT.": "Marc",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Pertinovich Pugh and Co.",
   "OCCUPATION": "CPA",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924051",
   "ENTITY": "IND",
   "ENTITY NAME": "Pasek",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Flagship Facility Services, Inc.",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935159",
   "ENTITY": "IND",
   "ENTITY NAME": "Pathiratne",
   "ENTITY NAME CONT.": "Sean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Lifestyle Solutions",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935160",
   "ENTITY": "IND",
   "ENTITY NAME": "Pathiratne",
   "ENTITY NAME CONT.": "ChampaS.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983748",
   "ENTITY": "IND",
   "ENTITY NAME": "Paul",
   "ENTITY NAME CONT.": "JayK.",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Jay Paul Company",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924233",
   "ENTITY": "IND",
   "ENTITY NAME": "Pavicich",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Pavicich Companies",
   "OCCUPATION": "Realtor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924234",
   "ENTITY": "IND",
   "ENTITY NAME": "Pavicich",
   "ENTITY NAME CONT.": "Helen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Pavicich Companies",
   "OCCUPATION": "Realtor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926758",
   "ENTITY": "IND",
   "ENTITY NAME": "Pearman",
   "ENTITY NAME CONT.": "EugeniaE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926759",
   "ENTITY": "IND",
   "ENTITY NAME": "Pearman",
   "ENTITY NAME CONT.": "NoelE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938518",
   "ENTITY": "IND",
   "ENTITY NAME": "Pendleton",
   "ENTITY NAME CONT.": "NathanL.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Nox Cookie Bar",
   "OCCUPATION": "Owner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933734",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralta",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Peralta Insurance Agency",
   "OCCUPATION": "Insurance Agent",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933741",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralta",
   "ENTITY NAME CONT.": "Gregory",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coldwell Banker",
   "OCCUPATION": "Realtor",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924590",
   "ENTITY": "IND",
   "ENTITY NAME": "Pereira",
   "ENTITY NAME CONT.": "Justine",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "DevCon Construction",
   "OCCUPATION": "Corporate Secretary",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924298",
   "ENTITY": "IND",
   "ENTITY NAME": "Pereira",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose, Mayor's Office",
   "OCCUPATION": "Policy Advisor",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923483",
   "ENTITY": "IND",
   "ENTITY NAME": "Pester",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Lafayette",
   "Entity_ST": "CA",
   "EMPLOYER": "Boston Properties",
   "OCCUPATION": "Developer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924042",
   "ENTITY": "IND",
   "ENTITY NAME": "Petersen",
   "ENTITY NAME CONT.": "MarkJ",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Duran & Venables",
   "OCCUPATION": "Contractor",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928259",
   "ENTITY": "IND",
   "ENTITY NAME": "Peterson",
   "ENTITY NAME CONT.": "DonaldC",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Mill Creek Residential",
   "OCCUPATION": "Senior Managing Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925061",
   "ENTITY": "IND",
   "ENTITY NAME": "Peterson",
   "ENTITY NAME CONT.": "DavidM",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cal Sports Center",
   "OCCUPATION": "Director, Owner",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934077",
   "ENTITY": "IND",
   "ENTITY NAME": "Petkewich",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "The Mortgage Outlet",
   "OCCUPATION": "Owner",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924109",
   "ENTITY": "IND",
   "ENTITY NAME": "Phelps",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "PWI, Limited Partnership",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924203",
   "ENTITY": "IND",
   "ENTITY NAME": "Phillips",
   "ENTITY NAME CONT.": "Jessica",
   "ENTITY CITY": "Santa Monica",
   "Entity_ST": "CA",
   "EMPLOYER": "Rand Corporation",
   "OCCUPATION": "Research Administration",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924204",
   "ENTITY": "IND",
   "ENTITY NAME": "Phillips",
   "ENTITY NAME CONT.": "Jessica",
   "ENTITY CITY": "Santa Monica",
   "Entity_ST": "CA",
   "EMPLOYER": "Smith Cooper International",
   "OCCUPATION": "Strategy",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925320",
   "ENTITY": "IND",
   "ENTITY NAME": "Phillips",
   "ENTITY NAME CONT.": "PatriciaL",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928031",
   "ENTITY": "IND",
   "ENTITY NAME": "Picone",
   "ENTITY NAME CONT.": "Christian",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990357",
   "ENTITY": "IND",
   "ENTITY NAME": "Pighini",
   "ENTITY NAME CONT.": "Jacqueline",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553429",
   "ENTITY": "IND",
   "ENTITY NAME": "Pilgrim",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 850
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT25",
   "ENTITY": "IND",
   "ENTITY NAME": "PILGRIM",
   "ENTITY NAME CONT.": "JOHN",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 850
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924235",
   "ENTITY": "IND",
   "ENTITY NAME": "Pitto",
   "ENTITY NAME CONT.": "J. Russell",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "SIMEON Commercial Properties",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923801",
   "ENTITY": "IND",
   "ENTITY NAME": "Pizzo",
   "ENTITY NAME CONT.": "Rosalie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Diocese of San Jose",
   "OCCUPATION": "Church Work",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931686",
   "ENTITY": "IND",
   "ENTITY NAME": "Poch",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Sports Authority",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10989412",
   "ENTITY": "IND",
   "ENTITY NAME": "Poeschel",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 71
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10990943",
   "ENTITY": "IND",
   "ENTITY NAME": "Poeschel",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 44
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10989413",
   "ENTITY": "IND",
   "ENTITY NAME": "Poeschel",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 28
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10989415",
   "ENTITY": "IND",
   "ENTITY NAME": "Poeschel",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 28
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10989416",
   "ENTITY": "IND",
   "ENTITY NAME": "Poeschel",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 28
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10989414",
   "ENTITY": "IND",
   "ENTITY NAME": "Poeschel",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 18
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10989411",
   "ENTITY": "IND",
   "ENTITY NAME": "Poeschel",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 9
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924679",
   "ENTITY": "IND",
   "ENTITY NAME": "Pohle",
   "ENTITY NAME CONT.": "Bruce",
   "ENTITY CITY": "Lincoln",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925291",
   "ENTITY": "IND",
   "ENTITY NAME": "Pohle",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Student",
   "OCCUPATION": "Student",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924758",
   "ENTITY": "IND",
   "ENTITY NAME": "Pollace",
   "ENTITY NAME CONT.": "Tony",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Armored Mobility Inc",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934815",
   "ENTITY": "IND",
   "ENTITY NAME": "Pollnow",
   "ENTITY NAME CONT.": "CharlesF.",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "Hawk Hill Management LLC",
   "OCCUPATION": "Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924657",
   "ENTITY": "IND",
   "ENTITY NAME": "Polverino",
   "ENTITY NAME CONT.": "SamJ",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sam J. Polverino",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925042",
   "ENTITY": "IND",
   "ENTITY NAME": "Poncetta",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Valley Oak Partners",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923829",
   "ENTITY": "IND",
   "ENTITY NAME": "Pond",
   "ENTITY NAME CONT.": "Randall",
   "ENTITY CITY": "Danville",
   "Entity_ST": "CA",
   "EMPLOYER": "Cisco",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924156",
   "ENTITY": "IND",
   "ENTITY NAME": "Popple",
   "ENTITY NAME CONT.": "Ryan",
   "ENTITY CITY": "Half Moon Bay",
   "Entity_ST": "CA",
   "EMPLOYER": "Proterra, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925015",
   "ENTITY": "IND",
   "ENTITY NAME": "Portman",
   "ENTITY NAME CONT.": "Dodd",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Dodd R Portman OD Inc",
   "OCCUPATION": "Optometrist",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925125",
   "ENTITY": "IND",
   "ENTITY NAME": "Potente",
   "ENTITY NAME CONT.": "Alex",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Clyde and Company",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928179",
   "ENTITY": "IND",
   "ENTITY NAME": "Powell",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cinequest",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928224",
   "ENTITY": "IND",
   "ENTITY NAME": "Powers",
   "ENTITY NAME CONT.": "Lynn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923815",
   "ENTITY": "IND",
   "ENTITY NAME": "Powers",
   "ENTITY NAME CONT.": "Lynn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925057",
   "ENTITY": "IND",
   "ENTITY NAME": "Prasad",
   "ENTITY NAME CONT.": "Monoo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Atscale",
   "OCCUPATION": "Technical Account Manager",
   "AMOUNT": 201
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923477",
   "ENTITY": "IND",
   "ENTITY NAME": "Praske",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "El Dorado Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "anyCOMM",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961407",
   "ENTITY": "IND",
   "ENTITY NAME": "Pratt",
   "ENTITY NAME CONT.": "Todd",
   "ENTITY CITY": "Burbank",
   "Entity_ST": "CA",
   "EMPLOYER": "Evolution Strategic Partners, LLC",
   "OCCUPATION": "Founder and Managing Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT22",
   "ENTITY": "IND",
   "ENTITY NAME": "PRESTON",
   "ENTITY NAME CONT.": "CHARLES",
   "ENTITY CITY": "NOVATO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 709
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557186",
   "ENTITY": "IND",
   "ENTITY NAME": "Preston",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 595
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964100",
   "ENTITY": "IND",
   "ENTITY NAME": "Prolo",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Donald Prolo, II",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964640",
   "ENTITY": "IND",
   "ENTITY NAME": "Prolo",
   "ENTITY NAME CONT.": "Joanne",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922995",
   "ENTITY": "IND",
   "ENTITY NAME": "Prouty",
   "ENTITY NAME CONT.": "StephenL",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Scotts Valley Bank",
   "OCCUPATION": "Commercial Banker",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10988055",
   "ENTITY": "IND",
   "ENTITY NAME": "Qualls",
   "ENTITY NAME CONT.": "Darrell",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "QLM, Inc",
   "OCCUPATION": "President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558281",
   "ENTITY": "IND",
   "ENTITY NAME": "Quevedo",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 805
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558292",
   "ENTITY": "IND",
   "ENTITY NAME": "Quevedo",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 770
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556775",
   "ENTITY": "IND",
   "ENTITY NAME": "Quevedo",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 595
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556781",
   "ENTITY": "IND",
   "ENTITY NAME": "Quevedo",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 560
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557363",
   "ENTITY": "IND",
   "ENTITY NAME": "Quevedo",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 473
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556782",
   "ENTITY": "IND",
   "ENTITY NAME": "Quevedo",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 420
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556862",
   "ENTITY": "IND",
   "ENTITY NAME": "Quevedo",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 280
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556725",
   "ENTITY": "IND",
   "ENTITY NAME": "Quevedo",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 65
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923016",
   "ENTITY": "IND",
   "ENTITY NAME": "Quinlan",
   "ENTITY NAME CONT.": "Roger",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "SAP",
   "OCCUPATION": "Executive",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925127",
   "ENTITY": "IND",
   "ENTITY NAME": "Rademann",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Wells Fargo",
   "OCCUPATION": "Executive VP, Region President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935165",
   "ENTITY": "IND",
   "ENTITY NAME": "Rai",
   "ENTITY NAME CONT.": "Rahul",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "RP Consulting Inc.",
   "OCCUPATION": "Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924596",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Adobe",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10991023",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "NubiaM",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hoffman/Via Monte Neighborhood",
   "OCCUPATION": "Property Management",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558270",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramirez",
   "ENTITY NAME CONT.": "Arnoldo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 256
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923476",
   "ENTITY": "IND",
   "ENTITY NAME": "Rangel",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "Gilory",
   "Entity_ST": "CA",
   "EMPLOYER": "Brocade",
   "OCCUPATION": "Dir., Corporate Affairs",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924763",
   "ENTITY": "IND",
   "ENTITY NAME": "Rankin",
   "ENTITY NAME CONT.": "Bill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bill Rankin",
   "OCCUPATION": "Carpenter",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928180",
   "ENTITY": "IND",
   "ENTITY NAME": "Rao",
   "ENTITY NAME CONT.": "Amar",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Biarca",
   "OCCUPATION": "Marketing & Sales",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925063",
   "ENTITY": "IND",
   "ENTITY NAME": "Rasheed",
   "ENTITY NAME CONT.": "Adnan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553880",
   "ENTITY": "IND",
   "ENTITY NAME": "Ratana",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 142
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924213",
   "ENTITY": "IND",
   "ENTITY NAME": "Ratra",
   "ENTITY NAME CONT.": "Sonu",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Akraya",
   "OCCUPATION": "Founder",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924187",
   "ENTITY": "IND",
   "ENTITY NAME": "Ravel",
   "ENTITY NAME CONT.": "AnnMiller",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "University of California",
   "OCCUPATION": "Lecturer, Law School",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928203",
   "ENTITY": "IND",
   "ENTITY NAME": "Ravel",
   "ENTITY NAME CONT.": "AnnMiller",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "University of California Berkeley",
   "OCCUPATION": "Law School Lecturer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924759",
   "ENTITY": "IND",
   "ENTITY NAME": "Razavi",
   "ENTITY NAME CONT.": "Kam",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Capers, Loft Bar and Bistro",
   "OCCUPATION": "Owner",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924223",
   "ENTITY": "IND",
   "ENTITY NAME": "Razumich",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Imwalle Properties",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC20",
   "ENTITY": "IND",
   "ENTITY NAME": "REDDY",
   "ENTITY NAME CONT.": "RAM",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "GLOBAL INDUSTRY ANALYSTS, INC",
   "OCCUPATION": "CHAIRMAN",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923335",
   "ENTITY": "IND",
   "ENTITY NAME": "Redmond",
   "ENTITY NAME CONT.": "Mary Kay",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923822",
   "ENTITY": "IND",
   "ENTITY NAME": "Reed",
   "ENTITY NAME CONT.": "Chuck",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553882",
   "ENTITY": "IND",
   "ENTITY NAME": "Reed",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 47
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925424",
   "ENTITY": "IND",
   "ENTITY NAME": "Regoli",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "South Bay Development Co.",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925021",
   "ENTITY": "IND",
   "ENTITY NAME": "Regonini",
   "ENTITY NAME CONT.": "Todd",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Sares Regis Group",
   "OCCUPATION": "Real Estate Professional",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925348",
   "ENTITY": "IND",
   "ENTITY NAME": "Rewkiewicz",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Michael Rewkiewicz",
   "OCCUPATION": "CPA",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964360",
   "ENTITY": "IND",
   "ENTITY NAME": "Richman",
   "ENTITY NAME CONT.": "Josh",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Bloom Energy",
   "OCCUPATION": "Vice President",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC42",
   "ENTITY": "IND",
   "ENTITY NAME": "RINCON",
   "ENTITY NAME CONT.": "JAMES",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "NONE",
   "OCCUPATION": "NONE",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925126",
   "ENTITY": "IND",
   "ENTITY NAME": "Ring",
   "ENTITY NAME CONT.": "PaulRichard",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "The Core Companies",
   "OCCUPATION": "Development Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961409",
   "ENTITY": "IND",
   "ENTITY NAME": "Ritter",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Ritter Associates",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925027",
   "ENTITY": "IND",
   "ENTITY NAME": "Rivas-Cosby",
   "ENTITY NAME CONT.": "Joan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Board Aid",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925001",
   "ENTITY": "IND",
   "ENTITY NAME": "Rivera",
   "ENTITY NAME CONT.": "Felipe",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "OTM",
   "OCCUPATION": "Account Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924250",
   "ENTITY": "IND",
   "ENTITY NAME": "Robbins",
   "ENTITY NAME CONT.": "Darren",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "Robbins Geller Rudman & Dowd",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964009",
   "ENTITY": "IND",
   "ENTITY NAME": "Roberson",
   "ENTITY NAME CONT.": "Shelly",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Shelly Roberson",
   "OCCUPATION": "Realtor",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923083",
   "ENTITY": "IND",
   "ENTITY NAME": "Robson",
   "ENTITY NAME CONT.": "MarkE",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Development",
   "OCCUPATION": "Developer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923084",
   "ENTITY": "IND",
   "ENTITY NAME": "Robson",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990356",
   "ENTITY": "IND",
   "ENTITY NAME": "Robson",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Robson Homes LLC",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923792",
   "ENTITY": "IND",
   "ENTITY NAME": "Rocca",
   "ENTITY NAME CONT.": "Kari",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Kari Rocca",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923793",
   "ENTITY": "IND",
   "ENTITY NAME": "Rocca",
   "ENTITY NAME CONT.": "ThomasJ.",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Thomas Rocca",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924746",
   "ENTITY": "IND",
   "ENTITY NAME": "Rocco",
   "ENTITY NAME CONT.": "Vera",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928264",
   "ENTITY": "IND",
   "ENTITY NAME": "Rocco",
   "ENTITY NAME CONT.": "Vera",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928250",
   "ENTITY": "IND",
   "ENTITY NAME": "Roche",
   "ENTITY NAME CONT.": "Robin",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922983",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Jason",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hewlett Packard",
   "OCCUPATION": "Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924159",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Leslie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies & Advocacy, LLC",
   "OCCUPATION": "Lobbyist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925118",
   "ENTITY": "IND",
   "ENTITY NAME": "Rodriguez",
   "ENTITY NAME CONT.": "Imelda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Imelda Rodriguez",
   "OCCUPATION": "Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923100",
   "ENTITY": "IND",
   "ENTITY NAME": "Rogers",
   "ENTITY NAME CONT.": "Erica",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Silk Road Medical Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924667",
   "ENTITY": "IND",
   "ENTITY NAME": "Rolla",
   "ENTITY NAME CONT.": "Phillip",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Dan Caputo Co.",
   "OCCUPATION": "Real Estate Broker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924668",
   "ENTITY": "IND",
   "ENTITY NAME": "Rolla",
   "ENTITY NAME CONT.": "Gwynne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Marketing/ActivCard, Inc.",
   "OCCUPATION": "Client Services",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928178",
   "ENTITY": "IND",
   "ENTITY NAME": "Rolla",
   "ENTITY NAME CONT.": "Genevieve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924301",
   "ENTITY": "IND",
   "ENTITY NAME": "Romano Jr.",
   "ENTITY NAME CONT.": "Pasquale",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "ChargePoint Inc.",
   "OCCUPATION": "CEO & President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922994",
   "ENTITY": "IND",
   "ENTITY NAME": "Rosendin",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964931",
   "ENTITY": "IND",
   "ENTITY NAME": "Rosenthal",
   "ENTITY NAME CONT.": "Jay",
   "ENTITY CITY": "Natick",
   "Entity_ST": "MA",
   "EMPLOYER": "Jay Rosenthal",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923323",
   "ENTITY": "IND",
   "ENTITY NAME": "Ross",
   "ENTITY NAME CONT.": "JayM",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933881",
   "ENTITY": "IND",
   "ENTITY NAME": "Ross",
   "ENTITY NAME CONT.": "LawrenceA.R.",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924174",
   "ENTITY": "IND",
   "ENTITY NAME": "Rossi",
   "ENTITY NAME CONT.": "Ronald",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Rossi, Hamerslough, Reischl & Chuck",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936076",
   "ENTITY": "IND",
   "ENTITY NAME": "Rossi",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "David Rossi",
   "OCCUPATION": "Consulting",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922965",
   "ENTITY": "IND",
   "ENTITY NAME": "Roth",
   "ENTITY NAME CONT.": "William G.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "VMWare",
   "OCCUPATION": "Marketing",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925150",
   "ENTITY": "IND",
   "ENTITY NAME": "Rowell",
   "ENTITY NAME CONT.": "KennethE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bay Area Builders, Inc",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930447",
   "ENTITY": "IND",
   "ENTITY NAME": "Rubin",
   "ENTITY NAME CONT.": "Stan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925041",
   "ENTITY": "IND",
   "ENTITY NAME": "Rubnitz",
   "ENTITY NAME CONT.": "Jim",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Self-Employed",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925329",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruby",
   "ENTITY NAME CONT.": "Allen",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Skadden Arps",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925337",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruby",
   "ENTITY NAME CONT.": "Cynthia",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "Community Volunteer",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964012",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruder",
   "ENTITY NAME CONT.": "Gunlek",
   "ENTITY CITY": "Las Vegas",
   "Entity_ST": "NV",
   "EMPLOYER": "S. Martinelli & Company",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964094",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruder",
   "ENTITY NAME CONT.": "Edward",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Square, Inc.",
   "OCCUPATION": "Software Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930965",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruff",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "St. Ignatius College Prep",
   "OCCUPATION": "Principal",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928194",
   "ENTITY": "IND",
   "ENTITY NAME": "Rukstalis",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "J.R. Financial & Insurance Services",
   "OCCUPATION": "Financial Planner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933753",
   "ENTITY": "IND",
   "ENTITY NAME": "Rule",
   "ENTITY NAME CONT.": "Carrie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Redpoint Management, LLC",
   "OCCUPATION": "VP, Finance",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923012",
   "ENTITY": "IND",
   "ENTITY NAME": "Rushing",
   "ENTITY NAME CONT.": "Fran",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924211",
   "ENTITY": "IND",
   "ENTITY NAME": "Russell",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Valley Oak Partners, LLC",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924704",
   "ENTITY": "IND",
   "ENTITY NAME": "Russo",
   "ENTITY NAME CONT.": "Khanh",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Policy Aid",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926751",
   "ENTITY": "IND",
   "ENTITY NAME": "Ryan",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Carlos",
   "Entity_ST": "CA",
   "EMPLOYER": "Green Valley Corporation",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925105",
   "ENTITY": "IND",
   "ENTITY NAME": "Sabatino",
   "ENTITY NAME CONT.": "Murphy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "M&M Properties",
   "OCCUPATION": "Real Estate Agent",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924169",
   "ENTITY": "IND",
   "ENTITY NAME": "Saglimbeni",
   "ENTITY NAME CONT.": "Salvatore",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salvatore Saglimbeni",
   "OCCUPATION": "Real Estate Sales",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10989702",
   "ENTITY": "IND",
   "ENTITY NAME": "Saglimbeni",
   "ENTITY NAME CONT.": "Salvatore",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Institutional Property Advisors",
   "OCCUPATION": "Commercial Real Estate Sales",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936089",
   "ENTITY": "IND",
   "ENTITY NAME": "Saha",
   "ENTITY NAME CONT.": "UttamK",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928191",
   "ENTITY": "IND",
   "ENTITY NAME": "Sakamoto",
   "ENTITY NAME CONT.": "Kathy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Japantown Business Association",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 35
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923094",
   "ENTITY": "IND",
   "ENTITY NAME": "Salad",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salas O'Brien",
   "OCCUPATION": "Mechanical Engineer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922998",
   "ENTITY": "IND",
   "ENTITY NAME": "Salas",
   "ENTITY NAME CONT.": "Carl",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salas O'Brien Engineers, Inc.",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922999",
   "ENTITY": "IND",
   "ENTITY NAME": "Salas",
   "ENTITY NAME CONT.": "Marianne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Salas O'Brien Engineers, Inc.",
   "OCCUPATION": "Business Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922948",
   "ENTITY": "IND",
   "ENTITY NAME": "Salas",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Hollister",
   "Entity_ST": "CA",
   "EMPLOYER": "Tesla",
   "OCCUPATION": "Senior Recruiter",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924248",
   "ENTITY": "IND",
   "ENTITY NAME": "Salata",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "Capitola",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Construction",
   "OCCUPATION": "Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924249",
   "ENTITY": "IND",
   "ENTITY NAME": "Salata",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Capitiola",
   "Entity_ST": "CA",
   "EMPLOYER": "Garden City Construction",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922961",
   "ENTITY": "IND",
   "ENTITY NAME": "Salazar",
   "ENTITY NAME CONT.": "Dayana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Professor",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928254",
   "ENTITY": "IND",
   "ENTITY NAME": "Salazar",
   "ENTITY NAME CONT.": "Dayana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Professor",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924597",
   "ENTITY": "IND",
   "ENTITY NAME": "Salinas",
   "ENTITY NAME CONT.": "MiguelM",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Adobe Foundation",
   "OCCUPATION": "Program Director",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558262",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Zenida",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 715
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558282",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Zenida",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 420
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557364",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Zenida",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 383
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556864",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Zenida",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 319
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925131",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez Castaneda",
   "ENTITY NAME CONT.": "Lorena",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sacred Heart Community Service",
   "OCCUPATION": "Director",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923111",
   "ENTITY": "IND",
   "ENTITY NAME": "Sandretto",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550490",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2861
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553741",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2861
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550483",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2529
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550474",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2187
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552011",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550481",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552091",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552612",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552722",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552873",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552093",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552064",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552016",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552328",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552078",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552079",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552099",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551099",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D552971",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553152",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553405",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553088",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553514",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1431
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553876",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 538
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550484",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Pearleen",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 377
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923325",
   "ENTITY": "IND",
   "ENTITY NAME": "Sangha",
   "ENTITY NAME CONT.": "Harmel",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Micron Technology",
   "OCCUPATION": "Engineering Drirector",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936090",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanghera",
   "ENTITY NAME CONT.": "Ranbir",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "7-Eleven",
   "OCCUPATION": "Owner/Operator",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931467",
   "ENTITY": "IND",
   "ENTITY NAME": "Sapien",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931468",
   "ENTITY": "IND",
   "ENTITY NAME": "Sapien",
   "ENTITY NAME CONT.": "Hermelinda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CET",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924173",
   "ENTITY": "IND",
   "ENTITY NAME": "Satterfield",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "Lafayette",
   "Entity_ST": "CA",
   "EMPLOYER": "G.F.Bunting",
   "OCCUPATION": "Executive Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924108",
   "ENTITY": "IND",
   "ENTITY NAME": "Sausedo",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sausedo Company",
   "OCCUPATION": "Owner/Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924764",
   "ENTITY": "IND",
   "ENTITY NAME": "Sawyer",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556839",
   "ENTITY": "IND",
   "ENTITY NAME": "Scally",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556838",
   "ENTITY": "IND",
   "ENTITY NAME": "Scally",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558306",
   "ENTITY": "IND",
   "ENTITY NAME": "Scally",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 80
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930445",
   "ENTITY": "IND",
   "ENTITY NAME": "Schaezlein",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Western Mountaineering",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923006",
   "ENTITY": "IND",
   "ENTITY NAME": "Schafer",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "Winnetka",
   "Entity_ST": "IL",
   "EMPLOYER": "Winston & Strawn",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931458",
   "ENTITY": "IND",
   "ENTITY NAME": "Schiro Ronco",
   "ENTITY NAME CONT.": "Stephanie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Not Employed",
   "OCCUPATION": "Volunteer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923828",
   "ENTITY": "IND",
   "ENTITY NAME": "Schlageter",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924275",
   "ENTITY": "IND",
   "ENTITY NAME": "Schlossman",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Zscaler, Inc",
   "OCCUPATION": "Chief Legal Officer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925089",
   "ENTITY": "IND",
   "ENTITY NAME": "Schmidt",
   "ENTITY NAME CONT.": "MarkE",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CBRE",
   "OCCUPATION": "Managing Director",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925026",
   "ENTITY": "IND",
   "ENTITY NAME": "Schmidt",
   "ENTITY NAME CONT.": "Jonathan",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "City and County of San Francisco",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925146",
   "ENTITY": "IND",
   "ENTITY NAME": "Schmidt",
   "ENTITY NAME CONT.": "Brian",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "Greenbelt Alliance",
   "OCCUPATION": "Program Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556794",
   "ENTITY": "IND",
   "ENTITY NAME": "Schmidt-Hopper",
   "ENTITY NAME CONT.": "Elly",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 550
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922960",
   "ENTITY": "IND",
   "ENTITY NAME": "Schneider",
   "ENTITY NAME CONT.": "Janis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "R&J Jewelry and Loan",
   "OCCUPATION": "Pawnbroker",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987585",
   "ENTITY": "IND",
   "ENTITY NAME": "Schneider",
   "ENTITY NAME CONT.": "Janis",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "R&J Jewelry and Loan",
   "OCCUPATION": "Pawnbroker",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924050",
   "ENTITY": "IND",
   "ENTITY NAME": "Schoch",
   "ENTITY NAME CONT.": "Mitchell",
   "ENTITY CITY": "Pleasanton",
   "Entity_ST": "CA",
   "EMPLOYER": "Bentek Corp",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925102",
   "ENTITY": "IND",
   "ENTITY NAME": "Schoeppler",
   "ENTITY NAME CONT.": "Martin",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Fujifilm Dimatix",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923785",
   "ENTITY": "IND",
   "ENTITY NAME": "Schott",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Electric",
   "OCCUPATION": "COO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924117",
   "ENTITY": "IND",
   "ENTITY NAME": "Schroeder",
   "ENTITY NAME CONT.": "Sally",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zilka-Kotab",
   "OCCUPATION": "Patent Agent",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923063",
   "ENTITY": "IND",
   "ENTITY NAME": "Schroeder",
   "ENTITY NAME CONT.": "CatharynKruse",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Unified School District",
   "OCCUPATION": "Teacher",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924303",
   "ENTITY": "IND",
   "ENTITY NAME": "Scolaro",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "George Scolaro",
   "OCCUPATION": "Engineer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922913",
   "ENTITY": "IND",
   "ENTITY NAME": "Sconberg",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Anne Sconberg",
   "OCCUPATION": "Investor",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928176",
   "ENTITY": "IND",
   "ENTITY NAME": "Sconberg",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Anne Sconberg",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924712",
   "ENTITY": "IND",
   "ENTITY NAME": "Scott",
   "ENTITY NAME CONT.": "Clarence",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924683",
   "ENTITY": "IND",
   "ENTITY NAME": "Scott",
   "ENTITY NAME CONT.": "Keith",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "anyCOMM Holdings Corp",
   "OCCUPATION": "VP, Business Development",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930955",
   "ENTITY": "IND",
   "ENTITY NAME": "Sears",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Office of John E Sears",
   "OCCUPATION": "Attorney",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924996",
   "ENTITY": "IND",
   "ENTITY NAME": "Seaver",
   "ENTITY NAME CONT.": "DerrickC",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Association",
   "OCCUPATION": "Director of Policy & Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964257",
   "ENTITY": "IND",
   "ENTITY NAME": "Seidel",
   "ENTITY NAME CONT.": "Alexander",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Seidel Architects",
   "OCCUPATION": "Architect",
   "AMOUNT": 750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922921",
   "ENTITY": "IND",
   "ENTITY NAME": "Setser",
   "ENTITY NAME CONT.": "Kenneth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Signature Flight Support",
   "OCCUPATION": "General Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923008",
   "ENTITY": "IND",
   "ENTITY NAME": "Shadman",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Shad Design Group",
   "OCCUPATION": "Engineer",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923078",
   "ENTITY": "IND",
   "ENTITY NAME": "Shafran-Mukai",
   "ENTITY NAME CONT.": "Beth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "El Camino Hospital",
   "OCCUPATION": "Human Resources Manager",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925326",
   "ENTITY": "IND",
   "ENTITY NAME": "Shafran-Mukai",
   "ENTITY NAME CONT.": "Beth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "El Camino Hospital",
   "OCCUPATION": "Human Resources Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923096",
   "ENTITY": "IND",
   "ENTITY NAME": "Shahidi",
   "ENTITY NAME CONT.": "Masoud",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "EnS Associates, Inv. LLC",
   "OCCUPATION": "Principal",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928223",
   "ENTITY": "IND",
   "ENTITY NAME": "Shahidi",
   "ENTITY NAME CONT.": "Masoud",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "EnS Associates, Inv. LLC",
   "OCCUPATION": "Principal",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10991021",
   "ENTITY": "IND",
   "ENTITY NAME": "Shahidi",
   "ENTITY NAME CONT.": "Masoud",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "EnS Associates, Inv. LLC",
   "OCCUPATION": "Principal",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558263",
   "ENTITY": "IND",
   "ENTITY NAME": "Sharkey",
   "ENTITY NAME CONT.": "Miriam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 405
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557367",
   "ENTITY": "IND",
   "ENTITY NAME": "Sharkey",
   "ENTITY NAME CONT.": "Miriam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 383
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558283",
   "ENTITY": "IND",
   "ENTITY NAME": "Sharkey",
   "ENTITY NAME CONT.": "Miriam",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 345
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925314",
   "ENTITY": "IND",
   "ENTITY NAME": "Sharma",
   "ENTITY NAME CONT.": "Shaveta",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Shaveta Sharma",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936091",
   "ENTITY": "IND",
   "ENTITY NAME": "Sharma",
   "ENTITY NAME CONT.": "Shashi",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "7-Eleven",
   "OCCUPATION": "Owner/Operator",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928201",
   "ENTITY": "IND",
   "ENTITY NAME": "Sherry",
   "ENTITY NAME CONT.": "Bill",
   "ENTITY CITY": "Loudon",
   "Entity_ST": "TN",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928190",
   "ENTITY": "IND",
   "ENTITY NAME": "Shev",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928261",
   "ENTITY": "IND",
   "ENTITY NAME": "Shev",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924245",
   "ENTITY": "IND",
   "ENTITY NAME": "Shirazi",
   "ENTITY NAME CONT.": "Amir",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Moe's Stop",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923340",
   "ENTITY": "IND",
   "ENTITY NAME": "Shrack Combs",
   "ENTITY NAME CONT.": "Margo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Oracle",
   "OCCUPATION": "Director, Global Pricing",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930453",
   "ENTITY": "IND",
   "ENTITY NAME": "Sibilia",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Keller Williams Realty",
   "OCCUPATION": "Realtor",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931681",
   "ENTITY": "IND",
   "ENTITY NAME": "Siddique",
   "ENTITY NAME CONT.": "Athar",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Xilinx, Inc.",
   "OCCUPATION": "Compensation Director",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925299",
   "ENTITY": "IND",
   "ENTITY NAME": "Siewert",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "Livermore",
   "Entity_ST": "CA",
   "EMPLOYER": "Terrence J. Rose, Inc.",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550464",
   "ENTITY": "IND",
   "ENTITY NAME": "Simon",
   "ENTITY NAME CONT.": "Dylan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 113
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923341",
   "ENTITY": "IND",
   "ENTITY NAME": "Sindelar",
   "ENTITY NAME CONT.": "Toni",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Discovery Charter School",
   "OCCUPATION": "Teacher",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924221",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh",
   "ENTITY NAME CONT.": "Harry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ShieldX Networks",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936082",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh",
   "ENTITY NAME CONT.": "Mahipal",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "7-Eleven",
   "OCCUPATION": "Owner/Operator",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936079",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh",
   "ENTITY NAME CONT.": "Surjit",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924202",
   "ENTITY": "IND",
   "ENTITY NAME": "Sinunu-Towery",
   "ENTITY NAME CONT.": "Karyn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925313",
   "ENTITY": "IND",
   "ENTITY NAME": "Skillicorn",
   "ENTITY NAME CONT.": "Pamela",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551273",
   "ENTITY": "IND",
   "ENTITY NAME": "Skillicorn",
   "ENTITY NAME CONT.": "Pamela",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922966",
   "ENTITY": "IND",
   "ENTITY NAME": "Skrivan",
   "ENTITY NAME CONT.": "Sam",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "Doosan Gridtech",
   "OCCUPATION": "Software Development Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923781",
   "ENTITY": "IND",
   "ENTITY NAME": "Slakey",
   "ENTITY NAME CONT.": "WilliamR.",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Electric",
   "OCCUPATION": "CFO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922977",
   "ENTITY": "IND",
   "ENTITY NAME": "Smart",
   "ENTITY NAME CONT.": "RichardH",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926754",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "JacquelineK.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924113",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Pete",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate",
   "OCCUPATION": "Realtor",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931472",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "BenjaminT.",
   "ENTITY CITY": "Scotts Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "BTSIV, LLC",
   "OCCUPATION": "Partner",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924294",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "ElizabethA.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924175",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Burton",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922920",
   "ENTITY": "IND",
   "ENTITY NAME": "Sobota",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Google",
   "OCCUPATION": "Director, Corporate Development",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924161",
   "ENTITY": "IND",
   "ENTITY NAME": "Sobrato",
   "ENTITY NAME CONT.": "John M.M",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "The Sobrato Organization",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928173",
   "ENTITY": "IND",
   "ENTITY NAME": "Soellner",
   "ENTITY NAME CONT.": "Walter",
   "ENTITY CITY": "San  Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925066",
   "ENTITY": "IND",
   "ENTITY NAME": "Solari",
   "ENTITY NAME CONT.": "Tracey",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Newmark Cornish & Carey",
   "OCCUPATION": "Commercial Real Estate Agent",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923098",
   "ENTITY": "IND",
   "ENTITY NAME": "Solnik",
   "ENTITY NAME CONT.": "Raymond",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Buena Vista",
   "OCCUPATION": "Business",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928187",
   "ENTITY": "IND",
   "ENTITY NAME": "Solnik",
   "ENTITY NAME CONT.": "Raymond",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Buena Vista",
   "OCCUPATION": "Business",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925046",
   "ENTITY": "IND",
   "ENTITY NAME": "Sonsini",
   "ENTITY NAME CONT.": "Lisa",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "The Sobrato Organization",
   "OCCUPATION": "Board President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925047",
   "ENTITY": "IND",
   "ENTITY NAME": "Sonsini",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "The Sobrato Organization",
   "OCCUPATION": "Chairman of the Investment Committee",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923344",
   "ENTITY": "IND",
   "ENTITY NAME": "Souders",
   "ENTITY NAME CONT.": "Bill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bill Souders",
   "OCCUPATION": "Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964805",
   "ENTITY": "IND",
   "ENTITY NAME": "Southwell",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Marriott International",
   "OCCUPATION": "Hotel Manager",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933731",
   "ENTITY": "IND",
   "ENTITY NAME": "Sparks",
   "ENTITY NAME CONT.": "Darren",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CliftonLarsonAllen",
   "OCCUPATION": "CPA",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924225",
   "ENTITY": "IND",
   "ENTITY NAME": "Spektor",
   "ENTITY NAME CONT.": "Russell",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Direct Resource Management, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923097",
   "ENTITY": "IND",
   "ENTITY NAME": "Spencer",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925123",
   "ENTITY": "IND",
   "ENTITY NAME": "Spencer",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928258",
   "ENTITY": "IND",
   "ENTITY NAME": "Spencer",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987309",
   "ENTITY": "IND",
   "ENTITY NAME": "Spero",
   "ENTITY NAME CONT.": "Benjamin",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Spectrum Equity",
   "OCCUPATION": "Managing Director",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923487",
   "ENTITY": "IND",
   "ENTITY NAME": "Spieker",
   "ENTITY NAME CONT.": "Tod",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Spieker Companies",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924774",
   "ENTITY": "IND",
   "ENTITY NAME": "Spinner",
   "ENTITY NAME CONT.": "Steven",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "RevUp Software",
   "OCCUPATION": "CEO",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925019",
   "ENTITY": "IND",
   "ENTITY NAME": "Stallman",
   "ENTITY NAME CONT.": "Julie",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924664",
   "ENTITY": "IND",
   "ENTITY NAME": "Starbird",
   "ENTITY NAME CONT.": "Drew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara University",
   "OCCUPATION": "Dean of the Business School",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923510",
   "ENTITY": "IND",
   "ENTITY NAME": "Stegner",
   "ENTITY NAME CONT.": "CharlesK",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Stegner Development",
   "OCCUPATION": "Developer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924212",
   "ENTITY": "IND",
   "ENTITY NAME": "Storm",
   "ENTITY NAME CONT.": "EdwardD.",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Storm Land LLC",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933754",
   "ENTITY": "IND",
   "ENTITY NAME": "Storm",
   "ENTITY NAME CONT.": "EdwardD.",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Storm Land LLC",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933755",
   "ENTITY": "IND",
   "ENTITY NAME": "Storm",
   "ENTITY NAME CONT.": "EdwardD.",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Storm Land LLC",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": -100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923818",
   "ENTITY": "IND",
   "ENTITY NAME": "Strangis",
   "ENTITY NAME CONT.": "Janet",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Strangis Properties",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925008",
   "ENTITY": "IND",
   "ENTITY NAME": "Stucky",
   "ENTITY NAME CONT.": "Allen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "MASS Precision",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925159",
   "ENTITY": "IND",
   "ENTITY NAME": "Stump",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "James Stump",
   "OCCUPATION": "Chef",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964306",
   "ENTITY": "IND",
   "ENTITY NAME": "Suba",
   "ENTITY NAME CONT.": "Royce",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CMG Partners, Inc.",
   "OCCUPATION": "General Counsel",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964238",
   "ENTITY": "IND",
   "ENTITY NAME": "Sueki",
   "ENTITY NAME CONT.": "Gail",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Fresenius Medical Care",
   "OCCUPATION": "Director, Program Mngmt.",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983752",
   "ENTITY": "IND",
   "ENTITY NAME": "Sullivan",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "Woodside",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923473",
   "ENTITY": "IND",
   "ENTITY NAME": "Sullivan",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935350",
   "ENTITY": "IND",
   "ENTITY NAME": "Sullivan",
   "ENTITY NAME CONT.": "Godfrey",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Splunk",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935353",
   "ENTITY": "IND",
   "ENTITY NAME": "Sunner",
   "ENTITY NAME CONT.": "Balwinder",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Air One Worldwide Transportation",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925307",
   "ENTITY": "IND",
   "ENTITY NAME": "Sunseri",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bel Bacio Italian Cafe",
   "OCCUPATION": "Owner",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923095",
   "ENTITY": "IND",
   "ENTITY NAME": "Surace",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Appvance",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923015",
   "ENTITY": "IND",
   "ENTITY NAME": "Sutherland",
   "ENTITY NAME CONT.": "Craig",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928240",
   "ENTITY": "IND",
   "ENTITY NAME": "Sweetnam",
   "ENTITY NAME CONT.": "Jan",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Federal Realty",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928172",
   "ENTITY": "IND",
   "ENTITY NAME": "Szymkiewicz",
   "ENTITY NAME CONT.": "George",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924608",
   "ENTITY": "IND",
   "ENTITY NAME": "Tam",
   "ENTITY NAME CONT.": "RaymondJ",
   "ENTITY CITY": "Honolulu",
   "Entity_ST": "HI",
   "EMPLOYER": "Raymond Tam",
   "OCCUPATION": "Attorney",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964102",
   "ENTITY": "IND",
   "ENTITY NAME": "Tamisiea",
   "ENTITY NAME CONT.": "Margaret",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Margaret Tamisiea",
   "OCCUPATION": "Program Manager",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC79",
   "ENTITY": "IND",
   "ENTITY NAME": "TAN",
   "ENTITY NAME CONT.": "LYDIA",
   "ENTITY CITY": "STANFORD",
   "Entity_ST": "CA",
   "EMPLOYER": "BENTALL KENNEDY US",
   "OCCUPATION": "REAL ESTATE",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928206",
   "ENTITY": "IND",
   "ENTITY NAME": "Tanner",
   "ENTITY NAME CONT.": "Marilyn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990038",
   "ENTITY": "IND",
   "ENTITY NAME": "Tate",
   "ENTITY NAME CONT.": "LanceJ.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Tate Diversified Development Inc.",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924772",
   "ENTITY": "IND",
   "ENTITY NAME": "Taussig",
   "ENTITY NAME CONT.": "Reed",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "ThreatMetrix Inc.",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925311",
   "ENTITY": "IND",
   "ENTITY NAME": "Taylor",
   "ENTITY NAME CONT.": "Stuart",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Altair Engineering",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925010",
   "ENTITY": "IND",
   "ENTITY NAME": "Tebo",
   "ENTITY NAME CONT.": "NoelA",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963933",
   "ENTITY": "IND",
   "ENTITY NAME": "Tepman",
   "ENTITY NAME CONT.": "Don",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Don Tepman",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923358",
   "ENTITY": "IND",
   "ENTITY NAME": "Tersini",
   "ENTITY NAME CONT.": "MarkE",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "KT Properties",
   "OCCUPATION": "Senior VP",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923816",
   "ENTITY": "IND",
   "ENTITY NAME": "Tersini",
   "ENTITY NAME CONT.": "Ken",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "KT Properties",
   "OCCUPATION": "Senior Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923071",
   "ENTITY": "IND",
   "ENTITY NAME": "Thesing",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964767",
   "ENTITY": "IND",
   "ENTITY NAME": "Thi Le",
   "ENTITY NAME CONT.": "Nhe",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Hayward Quartz Technology, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10936096",
   "ENTITY": "IND",
   "ENTITY NAME": "Thind",
   "ENTITY NAME CONT.": "Inderjit",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "7-Eleven",
   "OCCUPATION": "Owner/Operator",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923786",
   "ENTITY": "IND",
   "ENTITY NAME": "Thome",
   "ENTITY NAME CONT.": "Rob",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cupertino Electric",
   "OCCUPATION": "VP, Operations Commercial Division",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928226",
   "ENTITY": "IND",
   "ENTITY NAME": "Thompson",
   "ENTITY NAME CONT.": "Malcolm",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "NextFlex",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923360",
   "ENTITY": "IND",
   "ENTITY NAME": "Tien",
   "ENTITY NAME CONT.": "Alan",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Wong Young Development Corp",
   "OCCUPATION": "Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924052",
   "ENTITY": "IND",
   "ENTITY NAME": "Tilden",
   "ENTITY NAME CONT.": "Brad",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "Alaska Airlines",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925107",
   "ENTITY": "IND",
   "ENTITY NAME": "Timiraos-McEnery",
   "ENTITY NAME CONT.": "EricaL",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Erica McEnery",
   "OCCUPATION": "Medical Doctor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558277",
   "ENTITY": "IND",
   "ENTITY NAME": "Tirado",
   "ENTITY NAME CONT.": "Angela",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 415
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558268",
   "ENTITY": "IND",
   "ENTITY NAME": "Tirado",
   "ENTITY NAME CONT.": "Angela",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 410
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10962102",
   "ENTITY": "IND",
   "ENTITY NAME": "Titinger",
   "ENTITY NAME CONT.": "Jorge",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SGI",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923502",
   "ENTITY": "IND",
   "ENTITY NAME": "Toeniskoetter",
   "ENTITY NAME CONT.": "CharlesJ.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Toeniskoetter Development Inc.",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923503",
   "ENTITY": "IND",
   "ENTITY NAME": "Toeniskoetter",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Homemaker",
   "OCCUPATION": "Homemaker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925081",
   "ENTITY": "IND",
   "ENTITY NAME": "Toeniskoetter",
   "ENTITY NAME CONT.": "Leah",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Deloitte",
   "OCCUPATION": "Corporate Citizenship",
   "AMOUNT": 210
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925111",
   "ENTITY": "IND",
   "ENTITY NAME": "Tompkison",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Tompkison Group",
   "OCCUPATION": "Public Affairs",
   "AMOUNT": 1100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556841",
   "ENTITY": "IND",
   "ENTITY NAME": "Tonnis",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556842",
   "ENTITY": "IND",
   "ENTITY NAME": "Tonnis",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 402
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555982",
   "ENTITY": "IND",
   "ENTITY NAME": "Tonnis",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555983",
   "ENTITY": "IND",
   "ENTITY NAME": "Tonnis",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923001",
   "ENTITY": "IND",
   "ENTITY NAME": "Toomey",
   "ENTITY NAME CONT.": "Sean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Commercial Real Estate Salesperson",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987370",
   "ENTITY": "IND",
   "ENTITY NAME": "Tortora",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Sharks Sports & Entertainment",
   "OCCUPATION": "Executive Vice President and General Counsel",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924745",
   "ENTITY": "IND",
   "ENTITY NAME": "Tourk",
   "ENTITY NAME CONT.": "Alex",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Ground Floor Public Affairs Corp",
   "OCCUPATION": "Owner",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924602",
   "ENTITY": "IND",
   "ENTITY NAME": "Tourtelotte",
   "ENTITY NAME CONT.": "Elaine",
   "ENTITY CITY": "Longmeadow",
   "Entity_ST": "MA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922919",
   "ENTITY": "IND",
   "ENTITY NAME": "Tourtelotte",
   "ENTITY NAME CONT.": "John H.",
   "ENTITY CITY": "Newton",
   "Entity_ST": "MA",
   "EMPLOYER": "Rivermoor Energy",
   "OCCUPATION": "Managing Director",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964103",
   "ENTITY": "IND",
   "ENTITY NAME": "Tourtelotte",
   "ENTITY NAME CONT.": "John H.",
   "ENTITY CITY": "Newton",
   "Entity_ST": "MA",
   "EMPLOYER": "Rivermoor Energy",
   "OCCUPATION": "Manager",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925009",
   "ENTITY": "IND",
   "ENTITY NAME": "Trekell",
   "ENTITY NAME CONT.": "ToddC",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Toeniskoetter Development, Inc.",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928268",
   "ENTITY": "IND",
   "ENTITY NAME": "Triplett",
   "ENTITY NAME CONT.": "Raymond J.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Triplett Financial",
   "OCCUPATION": "Estate and Life Insurance Planner",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925425",
   "ENTITY": "IND",
   "ENTITY NAME": "Trobbe",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "South Bay Development Co.",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964817",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Thanh",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Lee's Supermarket/Sandwiches",
   "OCCUPATION": "Owner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923354",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Eddie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Silicon Valley Organization",
   "OCCUPATION": "Director, Public Policy & Advocacy",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923492",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Eddie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Silicon Valley Organization",
   "OCCUPATION": "Director, Public Policy & Advocacy",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984873",
   "ENTITY": "IND",
   "ENTITY NAME": "Tucker",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Tucker Construction Inc",
   "OCCUPATION": "President",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923069",
   "ENTITY": "IND",
   "ENTITY NAME": "Turner",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Lincoln Glen Manor",
   "OCCUPATION": "Administrator",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923088",
   "ENTITY": "IND",
   "ENTITY NAME": "Turner",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10984112",
   "ENTITY": "IND",
   "ENTITY NAME": "Turturici",
   "ENTITY NAME CONT.": "Carla",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SEMI",
   "OCCUPATION": "Marketing",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925429",
   "ENTITY": "IND",
   "ENTITY NAME": "Ubhaus",
   "ENTITY NAME CONT.": "LynnB",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924183",
   "ENTITY": "IND",
   "ENTITY NAME": "Valentine",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hensel Phelps",
   "OCCUPATION": "Project Development Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924130",
   "ENTITY": "IND",
   "ENTITY NAME": "Valladao",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964766",
   "ENTITY": "IND",
   "ENTITY NAME": "Van Le",
   "ENTITY NAME CONT.": "Chieu",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Lee's Sandwiches International, Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925062",
   "ENTITY": "IND",
   "ENTITY NAME": "Venzon",
   "ENTITY NAME CONT.": "Eric",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Teamwrkx, Inc.",
   "OCCUPATION": "President & CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924192",
   "ENTITY": "IND",
   "ENTITY NAME": "Verma",
   "ENTITY NAME CONT.": "Vishal",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Edgewood Ventures",
   "OCCUPATION": "Partner",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928025",
   "ENTITY": "IND",
   "ENTITY NAME": "Viaggi",
   "ENTITY NAME CONT.": "SarahD",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924185",
   "ENTITY": "IND",
   "ENTITY NAME": "Vieira",
   "ENTITY NAME CONT.": "DavideB.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931457",
   "ENTITY": "IND",
   "ENTITY NAME": "Vieira",
   "ENTITY NAME CONT.": "Batista",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC8",
   "ENTITY": "IND",
   "ENTITY NAME": "VIEIRA",
   "ENTITY NAME CONT.": "DAVIDE",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "NONE",
   "OCCUPATION": "RETIRED",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC56",
   "ENTITY": "IND",
   "ENTITY NAME": "VIEIRA",
   "ENTITY NAME CONT.": "BATISTA",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "NONE",
   "OCCUPATION": "RETIRED",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924228",
   "ENTITY": "IND",
   "ENTITY NAME": "Villaluna",
   "ENTITY NAME CONT.": "Alberto",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "The Common Good",
   "OCCUPATION": "Public/External Affairs",
   "AMOUNT": 225
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925330",
   "ENTITY": "IND",
   "ENTITY NAME": "Vogel",
   "ENTITY NAME CONT.": "Bernard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Law Group",
   "OCCUPATION": "Attorney",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925120",
   "ENTITY": "IND",
   "ENTITY NAME": "Von Raesfeld",
   "ENTITY NAME CONT.": "Darryl",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924200",
   "ENTITY": "IND",
   "ENTITY NAME": "Vuckovich",
   "ENTITY NAME CONT.": "Stan",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "KBM Hogue",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923342",
   "ENTITY": "IND",
   "ENTITY NAME": "Wade",
   "ENTITY NAME CONT.": "Deborah",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928195",
   "ENTITY": "IND",
   "ENTITY NAME": "Wade",
   "ENTITY NAME CONT.": "Deborah",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925076",
   "ENTITY": "IND",
   "ENTITY NAME": "Waite",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924238",
   "ENTITY": "IND",
   "ENTITY NAME": "Walrod",
   "ENTITY NAME CONT.": "Ty",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Bright Funds Inc",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924761",
   "ENTITY": "IND",
   "ENTITY NAME": "Walsh",
   "ENTITY NAME CONT.": "Melody",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Melody Walsh",
   "OCCUPATION": "Writer",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D552998",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1140
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553432",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1020
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557319",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556811",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557171",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557172",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557212",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557214",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557215",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557216",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 760
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556769",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 720
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556772",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 720
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557187",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 680
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556907",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 665
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557211",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 665
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550456",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 570
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557213",
   "ENTITY": "IND",
   "ENTITY NAME": "Walzer",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 540
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924697",
   "ENTITY": "IND",
   "ENTITY NAME": "Ward",
   "ENTITY NAME CONT.": "Bryan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Specialized Bicycles",
   "OCCUPATION": "Dir. of Marketing",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC107",
   "ENTITY": "IND",
   "ENTITY NAME": "WARMENHOVEN",
   "ENTITY NAME CONT.": "DANIEL",
   "ENTITY CITY": "MONTE SERENO",
   "Entity_ST": "CA",
   "EMPLOYER": "NONE",
   "OCCUPATION": "RETIRED",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC108",
   "ENTITY": "IND",
   "ENTITY NAME": "WARMENHOVEN",
   "ENTITY NAME CONT.": "CHARMAINE",
   "ENTITY CITY": "MONTE SERENO",
   "Entity_ST": "CA",
   "EMPLOYER": "NONE",
   "OCCUPATION": "RETIRED",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925297",
   "ENTITY": "IND",
   "ENTITY NAME": "Warmenhoven",
   "ENTITY NAME CONT.": "Charmaine",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925298",
   "ENTITY": "IND",
   "ENTITY NAME": "Warmenhoven",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928192",
   "ENTITY": "IND",
   "ENTITY NAME": "Watkins",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "Pleasanton",
   "Entity_ST": "CA",
   "EMPLOYER": "Flextronix",
   "OCCUPATION": "Board Member",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924776",
   "ENTITY": "IND",
   "ENTITY NAME": "Waxman",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "CBIZ",
   "OCCUPATION": "Chief Marketing Officer",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925104",
   "ENTITY": "IND",
   "ENTITY NAME": "Webb",
   "ENTITY NAME CONT.": "Ann",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984883",
   "ENTITY": "IND",
   "ENTITY NAME": "Webb",
   "ENTITY NAME CONT.": "Ann",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924611",
   "ENTITY": "IND",
   "ENTITY NAME": "Weigel",
   "ENTITY NAME CONT.": "FrankC.",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "Greenwaste Recovery, Inc.",
   "OCCUPATION": "Chief Operating Officer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930969",
   "ENTITY": "IND",
   "ENTITY NAME": "Weintraub",
   "ENTITY NAME CONT.": "Dana",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "Stanford University",
   "OCCUPATION": "Pediatrician",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923072",
   "ENTITY": "IND",
   "ENTITY NAME": "Welch",
   "ENTITY NAME CONT.": "Kyle",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Globalsoundries",
   "OCCUPATION": "Sales Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924257",
   "ENTITY": "IND",
   "ENTITY NAME": "Weldon",
   "ENTITY NAME CONT.": "JamesF",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Alliphant, Inc.",
   "OCCUPATION": "Chief Executive Officer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923825",
   "ENTITY": "IND",
   "ENTITY NAME": "Wen-Shin Lee",
   "ENTITY NAME CONT.": "Branden",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Lucile Packard Children's Hospital",
   "OCCUPATION": "Ophthalmologist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925430",
   "ENTITY": "IND",
   "ENTITY NAME": "Wenner",
   "ENTITY NAME CONT.": "WaldemarH",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924300",
   "ENTITY": "IND",
   "ENTITY NAME": "Werner",
   "ENTITY NAME CONT.": "ThomasH",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "SunPower",
   "OCCUPATION": "Engineer",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924299",
   "ENTITY": "IND",
   "ENTITY NAME": "Werner",
   "ENTITY NAME CONT.": "Suzanne",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Suzanne Werner",
   "OCCUPATION": "Tutor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923332",
   "ENTITY": "IND",
   "ENTITY NAME": "Werp",
   "ENTITY NAME CONT.": "DianeB",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925117",
   "ENTITY": "IND",
   "ENTITY NAME": "West",
   "ENTITY NAME CONT.": "Tony",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Uber",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922975",
   "ENTITY": "IND",
   "ENTITY NAME": "Whamond",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Hingham",
   "Entity_ST": "MA",
   "EMPLOYER": "MIT",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930444",
   "ENTITY": "IND",
   "ENTITY NAME": "White",
   "ENTITY NAME CONT.": "Jean-Marie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Netflix",
   "OCCUPATION": "Director of Engineering",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10962000",
   "ENTITY": "IND",
   "ENTITY NAME": "Whitney",
   "ENTITY NAME CONT.": "Devin",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "PayPal",
   "OCCUPATION": "Government Relations",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935164",
   "ENTITY": "IND",
   "ENTITY NAME": "Whitstone",
   "ENTITY NAME CONT.": "Nick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CBRE",
   "OCCUPATION": "First Vice President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928332",
   "ENTITY": "IND",
   "ENTITY NAME": "Wible",
   "ENTITY NAME CONT.": "JohnW.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Shea Homes of Northern California",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928233",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilcox",
   "ENTITY NAME CONT.": "Ken",
   "ENTITY CITY": "Potola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558264",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilde",
   "ENTITY NAME CONT.": "Jasper",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2350
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557365",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilde",
   "ENTITY NAME CONT.": "Jasper",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1945
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556863",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilde",
   "ENTITY NAME CONT.": "Jasper",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1870
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558284",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilde",
   "ENTITY NAME CONT.": "Jasper",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1530
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556774",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilde",
   "ENTITY NAME CONT.": "Jasper",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1360
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556779",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilde",
   "ENTITY NAME CONT.": "Jasper",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556780",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilde",
   "ENTITY NAME CONT.": "Jasper",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928202",
   "ENTITY": "IND",
   "ENTITY NAME": "Wilke",
   "ENTITY NAME CONT.": "Anne",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Siemens Healthineers",
   "OCCUPATION": "Technical Support",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931688",
   "ENTITY": "IND",
   "ENTITY NAME": "Williams",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Manhattan Beach",
   "Entity_ST": "CA",
   "EMPLOYER": "Quinn Emanuel Urquhart & Sullivan",
   "OCCUPATION": "Attorney",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922963",
   "ENTITY": "IND",
   "ENTITY NAME": "Williams",
   "ENTITY NAME CONT.": "Alan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Oracle",
   "OCCUPATION": "Product Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933880",
   "ENTITY": "IND",
   "ENTITY NAME": "Williams",
   "ENTITY NAME CONT.": "JamesD.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nokia",
   "OCCUPATION": "Finance Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924053",
   "ENTITY": "IND",
   "ENTITY NAME": "Williams",
   "ENTITY NAME CONT.": "Joel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "EZBadge",
   "OCCUPATION": "Engineer",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923817",
   "ENTITY": "IND",
   "ENTITY NAME": "Winter",
   "ENTITY NAME CONT.": "CorinneM",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "Winter Consulting Group",
   "OCCUPATION": "Consultant",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550475",
   "ENTITY": "IND",
   "ENTITY NAME": "Winthrop",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1422
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551098",
   "ENTITY": "IND",
   "ENTITY NAME": "Winthrop",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550462",
   "ENTITY": "IND",
   "ENTITY NAME": "Winthrop",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 268
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550480",
   "ENTITY": "IND",
   "ENTITY NAME": "Winthrop",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 110
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550469",
   "ENTITY": "IND",
   "ENTITY NAME": "Winthrop",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 101
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550463",
   "ENTITY": "IND",
   "ENTITY NAME": "Winthrop",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 80
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552071",
   "ENTITY": "IND",
   "ENTITY NAME": "Winthrop",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "F",
   "ID": "D550468",
   "ENTITY": "IND",
   "ENTITY NAME": "Winthrop",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928035",
   "ENTITY": "IND",
   "ENTITY NAME": "Wolf",
   "ENTITY NAME CONT.": "Jonathan",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Berliner Cohen",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989969",
   "ENTITY": "IND",
   "ENTITY NAME": "Wolf",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "Public Health Institute",
   "OCCUPATION": "Grants and Contracts Specialist II",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922908",
   "ENTITY": "IND",
   "ENTITY NAME": "Wolff",
   "ENTITY NAME CONT.": "Keith",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Wolff Urban",
   "OCCUPATION": "President",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924214",
   "ENTITY": "IND",
   "ENTITY NAME": "Wolff",
   "ENTITY NAME CONT.": "LewisN.",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Wolff Urban Development",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924215",
   "ENTITY": "IND",
   "ENTITY NAME": "Wolff",
   "ENTITY NAME CONT.": "Kari",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Wolff Urban Development",
   "OCCUPATION": "VP, Hotel Management",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924217",
   "ENTITY": "IND",
   "ENTITY NAME": "Wolff",
   "ENTITY NAME CONT.": "JeanA",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "Jean Wolff",
   "OCCUPATION": "Artist",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923359",
   "ENTITY": "IND",
   "ENTITY NAME": "Wong",
   "ENTITY NAME CONT.": "Allen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Allen Wong",
   "OCCUPATION": "Real Estate Investor",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923364",
   "ENTITY": "IND",
   "ENTITY NAME": "Wong",
   "ENTITY NAME CONT.": "Gilbert",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Foothill De Anza Community College District",
   "OCCUPATION": "Trustee",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928198",
   "ENTITY": "IND",
   "ENTITY NAME": "Woodworth",
   "ENTITY NAME CONT.": "R. Byron",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "KM Commercial Real Estate",
   "OCCUPATION": "Sales",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923058",
   "ENTITY": "IND",
   "ENTITY NAME": "Worrall",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922917",
   "ENTITY": "IND",
   "ENTITY NAME": "Wymer",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nextdoor.com",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931469",
   "ENTITY": "IND",
   "ENTITY NAME": "Xu",
   "ENTITY NAME CONT.": "Stephanie",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "East West Bank",
   "OCCUPATION": "Banker",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924644",
   "ENTITY": "IND",
   "ENTITY NAME": "Yamaichi",
   "ENTITY NAME CONT.": "Eiko",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924247",
   "ENTITY": "IND",
   "ENTITY NAME": "Yamane",
   "ENTITY NAME CONT.": "Ernest",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Steinberg Architects",
   "OCCUPATION": "Architect",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924111",
   "ENTITY": "IND",
   "ENTITY NAME": "Yandle",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "NEWMARK Cornish & Carey",
   "OCCUPATION": "Managing Partner",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924255",
   "ENTITY": "IND",
   "ENTITY NAME": "York",
   "ENTITY NAME CONT.": "Jed",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "San Francisco 49ers",
   "OCCUPATION": "CEO",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925325",
   "ENTITY": "IND",
   "ENTITY NAME": "Young",
   "ENTITY NAME CONT.": "Conrad",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Conrad Young",
   "OCCUPATION": "Physical Therapist",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926750",
   "ENTITY": "IND",
   "ENTITY NAME": "Yu",
   "ENTITY NAME CONT.": "ConnieYoung",
   "ENTITY CITY": "Los Altos Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "Connie Yu",
   "OCCUPATION": "Writer/Historian",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924163",
   "ENTITY": "IND",
   "ENTITY NAME": "Yucek",
   "ENTITY NAME CONT.": "Tevfik",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Qualcomm",
   "OCCUPATION": "Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924107",
   "ENTITY": "IND",
   "ENTITY NAME": "Yuen",
   "ENTITY NAME CONT.": "Manuel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924997",
   "ENTITY": "IND",
   "ENTITY NAME": "Zamudio",
   "ENTITY NAME CONT.": "Mark",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Broker",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934669",
   "ENTITY": "IND",
   "ENTITY NAME": "Zanni",
   "ENTITY NAME CONT.": "Tim",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "KPMG LLP",
   "OCCUPATION": "Executive",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924677",
   "ENTITY": "IND",
   "ENTITY NAME": "Zazueta",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Loring Ward",
   "OCCUPATION": "Financial Services",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924680",
   "ENTITY": "IND",
   "ENTITY NAME": "Zazueta",
   "ENTITY NAME CONT.": "Katie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Downtown College Prep",
   "OCCUPATION": "Director of Advancement",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550316",
   "ENTITY": "IND",
   "ENTITY NAME": "Zazueta",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550317",
   "ENTITY": "IND",
   "ENTITY NAME": "Zazueta",
   "ENTITY NAME CONT.": "Katie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924122",
   "ENTITY": "IND",
   "ENTITY NAME": "Zazueta",
   "ENTITY NAME CONT.": "Fernando",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924998",
   "ENTITY": "IND",
   "ENTITY NAME": "Zell",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Zell Associates, Inc.",
   "OCCUPATION": "Property Manager",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924999",
   "ENTITY": "IND",
   "ENTITY NAME": "Zell",
   "ENTITY NAME CONT.": "Sherman",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964106",
   "ENTITY": "IND",
   "ENTITY NAME": "Zemene",
   "ENTITY NAME CONT.": "Orion",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Fresh Brand Foods",
   "OCCUPATION": "Owner",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928270",
   "ENTITY": "IND",
   "ENTITY NAME": "Zenk",
   "ENTITY NAME CONT.": "Jessica",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Urban Planner",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558269",
   "ENTITY": "IND",
   "ENTITY NAME": "Zepeda",
   "ENTITY NAME CONT.": "Rosie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 110
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10922997",
   "ENTITY": "IND",
   "ENTITY NAME": "Zraick",
   "ENTITY NAME CONT.": "Ronald",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Petrinovich Pugh & Company",
   "OCCUPATION": "Director",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928251",
   "ENTITY": "IND",
   "ENTITY NAME": "Zuniga",
   "ENTITY NAME CONT.": "Matthew",
   "ENTITY CITY": "Hayward",
   "Entity_ST": "CA",
   "EMPLOYER": "Bellarmine College Prep",
   "OCCUPATION": "Alumni Director",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924043",
   "ENTITY": "IND",
   "ENTITY NAME": "Zwick",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Housing Trust Silicon Valley",
   "OCCUPATION": "Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924662",
   "ENTITY": "OTH",
   "ENTITY NAME": "A.M. Plumbing Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984117",
   "ENTITY": "OTH",
   "ENTITY NAME": "Abode Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924617",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACCO Management Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551384",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACT! Cloud",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Scottsdale",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551815",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACT! Cloud",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Scottsdale",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552935",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACT! Cloud",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Scottsdale",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552128",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACT! Cloud",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Scottsdale",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553393",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACT! Cloud",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Scottsdale",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550503",
   "ENTITY": "OTH",
   "ENTITY NAME": "ACT! Cloud",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Scottsdale",
   "Entity_ST": "AZ",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10985165",
   "ENTITY": "OTH",
   "ENTITY NAME": "Adobe Systems",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964098",
   "ENTITY": "OTH",
   "ENTITY NAME": "Advance Soil Technology, Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926752",
   "ENTITY": "OTH",
   "ENTITY NAME": "AECOM Technical Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Austin",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987027",
   "ENTITY": "OTH",
   "ENTITY NAME": "Affirmed Housing Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553877",
   "ENTITY": "OTH",
   "ENTITY NAME": "Airbnb",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 280
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553878",
   "ENTITY": "OTH",
   "ENTITY NAME": "Alaska Air",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 258
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924632",
   "ENTITY": "OTH",
   "ENTITY NAME": "All Seasons Roofing & Waterproofing, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989931",
   "ENTITY": "OTH",
   "ENTITY NAME": "Allied Telesis Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963831",
   "ENTITY": "OTH",
   "ENTITY NAME": "Alongi Brothers, Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556425",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amazon.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550498",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amazon.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 33
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555984",
   "ENTITY": "OTH",
   "ENTITY NAME": "Amazon.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Seattle",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551383",
   "ENTITY": "OTH",
   "ENTITY NAME": "Apple Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 842
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924592",
   "ENTITY": "OTH",
   "ENTITY NAME": "Arcadia Development Co.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928022",
   "ENTITY": "OTH",
   "ENTITY NAME": "Assemi Group, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fresno",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551396",
   "ENTITY": "OTH",
   "ENTITY NAME": "AT&T Mobility",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 80
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553386",
   "ENTITY": "OTH",
   "ENTITY NAME": "AT&T Mobility",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 53
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552120",
   "ENTITY": "OTH",
   "ENTITY NAME": "AT&T Mobility",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 52
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552896",
   "ENTITY": "OTH",
   "ENTITY NAME": "AT&T Mobility",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 52
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934231",
   "ENTITY": "OTH",
   "ENTITY NAME": "Atlantic Pacific National Realty",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928024",
   "ENTITY": "OTH",
   "ENTITY NAME": "Atwood & Associates",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10986828",
   "ENTITY": "OTH",
   "ENTITY NAME": "Barry Swenson Builder",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928181",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bay Area Management",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557345",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bay Area News Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Colorado Springs",
   "Entity_ST": "CO",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964889",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bay Stone Depot Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924633",
   "ENTITY": "OTH",
   "ENTITY NAME": "BC Plumbing, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556726",
   "ENTITY": "OTH",
   "ENTITY NAME": "Best Buy",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 65
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964010",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bestronics, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1111
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938046",
   "ENTITY": "OTH",
   "ENTITY NAME": "BGMV Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923368",
   "ENTITY": "OTH",
   "ENTITY NAME": "Biggs Cardosa Associates, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934230",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bluefin Realty Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928227",
   "ENTITY": "OTH",
   "ENTITY NAME": "Boccardo Management Group, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984760",
   "ENTITY": "OTH",
   "ENTITY NAME": "BRIDGE Housing Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC24",
   "ENTITY": "OTH",
   "ENTITY NAME": "BROADCOM CORPORATION AND AFFILIATED ENTITIES",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983747",
   "ENTITY": "OTH",
   "ENTITY NAME": "Build Group, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984493",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bumb & Associates Inc. and Affiliated Entities",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928244",
   "ENTITY": "OTH",
   "ENTITY NAME": "C2K Architecture, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Portland",
   "Entity_ST": "OR",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553379",
   "ENTITY": "OTH",
   "ENTITY NAME": "Caffe Frascati",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 41
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924630",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cal-Western Property Management",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931682",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Janitorial Supply Corp.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924650",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Partners, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for a Safer San Jose, Yes on F, a Coalition of Community Organizations, Businesses and Mayor Sam Liccardo",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D549942",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550506",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557402",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557403",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557401",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558327",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Secretary of State",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC53",
   "ENTITY": "OTH",
   "ENTITY NAME": "CALIFORNIA WASTE SOLUTIONS, INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983746",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Water Service Co.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923471",
   "ENTITY": "OTH",
   "ENTITY NAME": "California Water Service Co.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964258",
   "ENTITY": "OTH",
   "ENTITY NAME": "Calvano Development Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924629",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cambridge Management Co.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558291",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cardenas",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 72
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10993138",
   "ENTITY": "OTH",
   "ENTITY NAME": "Carroll Engineering, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550460",
   "ENTITY": "OTH",
   "ENTITY NAME": "Casa Vicky",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987307",
   "ENTITY": "OTH",
   "ENTITY NAME": "Casey Construction, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984342",
   "ENTITY": "OTH",
   "ENTITY NAME": "Casino M8trix",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928243",
   "ENTITY": "OTH",
   "ENTITY NAME": "Center for Developing Minds",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10989418",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chan Zuckerberg Advocacy",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555973",
   "ENTITY": "OTH",
   "ENTITY NAME": "Change Research",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989517",
   "ENTITY": "OTH",
   "ENTITY NAME": "Charities Housing Development Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556792",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chater Camera",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6257
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557330",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chater Camera",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1223
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552899",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chevron",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 69
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553837",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chevron",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 62
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551814",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chevron",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 54
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552936",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chevron",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550500",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chez Leslie Catering",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 286
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557466",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chipotle",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 39
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989441",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cisco Systems, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928012",
   "ENTITY": "OTH",
   "ENTITY NAME": "Citation Homes Central",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552092",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10325
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556776",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 597
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553743",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 160
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556870",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556871",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 135
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553400",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 120
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556869",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 53
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558308",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551389",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552897",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551390",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925349",
   "ENTITY": "OTH",
   "ENTITY NAME": "Civil Justice Association of California",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964653",
   "ENTITY": "OTH",
   "ENTITY NAME": "Clarion Bay Development, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1199
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556796",
   "ENTITY": "OTH",
   "ENTITY NAME": "Clinton Perry Photography",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1510
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557340",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cloud Hunter Studios LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553428",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cloud Hunter Studios LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556766",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cloud Hunter Studios LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556825",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cloud Hunter Studios LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553745",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cloud Hunter Studios LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983755",
   "ENTITY": "OTH",
   "ENTITY NAME": "Coastline Water Resources, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rio Linda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10993140",
   "ENTITY": "OTH",
   "ENTITY NAME": "Coca-Cola North America",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928027",
   "ENTITY": "OTH",
   "ENTITY NAME": "Coca-Cola North America",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557463",
   "ENTITY": "OTH",
   "ENTITY NAME": "College Hunks Hauling Junk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 713
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938040",
   "ENTITY": "OTH",
   "ENTITY NAME": "College Market",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 251
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931456",
   "ENTITY": "OTH",
   "ENTITY NAME": "Columbia California Good Government Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557343",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comcast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 107100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556827",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comcast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 85000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557342",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comcast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 85000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556758",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comcast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 65000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556808",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comcast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 63750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT9",
   "ENTITY": "OTH",
   "ENTITY NAME": "COMCAST",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 49569
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT17",
   "ENTITY": "OTH",
   "ENTITY NAME": "COMCAST",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 41463
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553397",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comcast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 31520
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT36",
   "ENTITY": "OTH",
   "ENTITY NAME": "COMCAST",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 22687
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT42",
   "ENTITY": "OTH",
   "ENTITY NAME": "COMCAST",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553407",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comcast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9235
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557344",
   "ENTITY": "OTH",
   "ENTITY NAME": "Comcast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5610
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10984780",
   "ENTITY": "OTH",
   "ENTITY NAME": "Committee for Green Foothills",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 306
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987519",
   "ENTITY": "OTH",
   "ENTITY NAME": "Construction Employers' Association",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550476",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 21761
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557389",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15501
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556730",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12087
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556778",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8820
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556845",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6900
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557390",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5870
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552063",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3883
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557388",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553016",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2271
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553840",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2197
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552096",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2115
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556844",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 651
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553839",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 327
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550477",
   "ENTITY": "OTH",
   "ENTITY NAME": "Contribution Solutions, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10988057",
   "ENTITY": "OTH",
   "ENTITY NAME": "Core Affordable Housing, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557314",
   "ENTITY": "OTH",
   "ENTITY NAME": "Costco Wholesale",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 76
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556429",
   "ENTITY": "OTH",
   "ENTITY NAME": "Craigslist.org",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983751",
   "ENTITY": "OTH",
   "ENTITY NAME": "Critchfield Mechanical, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923797",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cucuzza Family Partnership",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987517",
   "ENTITY": "OTH",
   "ENTITY NAME": "Cupertino Electric Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924297",
   "ENTITY": "OTH",
   "ENTITY NAME": "Custom Drywall",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990105",
   "ENTITY": "OTH",
   "ENTITY NAME": "D & D Ranch",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923367",
   "ENTITY": "OTH",
   "ENTITY NAME": "D-Line Constructors, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987855",
   "ENTITY": "OTH",
   "ENTITY NAME": "Daley's Drywall & Taping, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987856",
   "ENTITY": "OTH",
   "ENTITY NAME": "Danco Communities, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Arcata",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964361",
   "ENTITY": "OTH",
   "ENTITY NAME": "Del Grande Dealer Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550273",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5682
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550185",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3231
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550056",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3219
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550186",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2511
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP41",
   "ENTITY": "OTH",
   "ENTITY NAME": "DEMOCRACY ENGINE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "WASHINGTON",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1641
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550319",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 904
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551275",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 869
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553717",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 823
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551276",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 642
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556047",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 531
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553762",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 529
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557194",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 451
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP106",
   "ENTITY": "OTH",
   "ENTITY NAME": "DEMOCRACY ENGINE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "WASHINGTON",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 401
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551399",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 357
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551590",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 349
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551810",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 309
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP105",
   "ENTITY": "OTH",
   "ENTITY NAME": "DEMOCRACY ENGINE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "WASHINGTON",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 261
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551278",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 261
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551918",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 259
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552530",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 227
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551968",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 184
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553294",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 156
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556043",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 121
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551277",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 107
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551279",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 105
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP46",
   "ENTITY": "OTH",
   "ENTITY NAME": "DEMOCRACY ENGINE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "WASHINGTON",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP104",
   "ENTITY": "OTH",
   "ENTITY NAME": "DEMOCRACY ENGINE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "WASHINGTON",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 99
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551280",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 95
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552108",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 79
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552841",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 73
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP39",
   "ENTITY": "OTH",
   "ENTITY NAME": "DEMOCRACY ENGINE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "WASHINGTON",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557379",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 33
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553151",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 32
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556874",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 31
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556422",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 26
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551398",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556048",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552403",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557455",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552934",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553150",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP40",
   "ENTITY": "OTH",
   "ENTITY NAME": "DEMOCRACY ENGINE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "WASHINGTON",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551917",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557276",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557433",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557444",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557454",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552287",
   "ENTITY": "OTH",
   "ENTITY NAME": "Democracy Engine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552842",
   "ENTITY": "OTH",
   "ENTITY NAME": "Dennis Hearne Photography",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2510
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553819",
   "ENTITY": "OTH",
   "ENTITY NAME": "Dennis Hearne Photography",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924640",
   "ENTITY": "OTH",
   "ENTITY NAME": "Dimetrius Painting II, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928169",
   "ENTITY": "OTH",
   "ENTITY NAME": "DJM Capital Partners, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552898",
   "ENTITY": "OTH",
   "ENTITY NAME": "DoubleTree Hotel - San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930950",
   "ENTITY": "OTH",
   "ENTITY NAME": "DTBA, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC81",
   "ENTITY": "OTH",
   "ENTITY NAME": "DTS, INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "CALABASAS",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10985166",
   "ENTITY": "OTH",
   "ENTITY NAME": "Duran & Venables, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934990",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eagle Communications",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984118",
   "ENTITY": "OTH",
   "ENTITY NAME": "EAH Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Rafael",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551391",
   "ENTITY": "OTH",
   "ENTITY NAME": "Earl of Sandwich",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 211
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552116",
   "ENTITY": "OTH",
   "ENTITY NAME": "Earl of Sandwich",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 161
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989520",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eden Housing Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Hayward",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930953",
   "ENTITY": "OTH",
   "ENTITY NAME": "El Guapo's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558288",
   "ENTITY": "OTH",
   "ENTITY NAME": "El Rico Pan Bakery",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 56
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964646",
   "ENTITY": "OTH",
   "ENTITY NAME": "Eli Thomas of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10940133",
   "ENTITY": "OTH",
   "ENTITY NAME": "EnS Associates Inv., LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930957",
   "ENTITY": "OTH",
   "ENTITY NAME": "Enterprise Trust & Investment Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934877",
   "ENTITY": "OTH",
   "ENTITY NAME": "EPC IT Solutions",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10983802",
   "ENTITY": "OTH",
   "ENTITY NAME": "Essex Portfolio LP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923800",
   "ENTITY": "OTH",
   "ENTITY NAME": "Evergreen Coffee Company, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989510",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989515",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557377",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556761",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556904",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557174",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556817",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556738",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552081",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8925
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557322",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557349",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556812",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7813
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557175",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5575
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553001",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551101",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4094
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552066",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4094
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552067",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4094
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556755",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2590
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556790",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556798",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2338
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555993",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555974",
   "ENTITY": "OTH",
   "ENTITY NAME": "Facebook, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964386",
   "ENTITY": "OTH",
   "ENTITY NAME": "Fair Isaac Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552440",
   "ENTITY": "OTH",
   "ENTITY NAME": "Fairbank, Maslin, Maullin, Metz & Associates, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555968",
   "ENTITY": "OTH",
   "ENTITY NAME": "Fairbank, Maslin, Maullin, Metz & Associates, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555967",
   "ENTITY": "OTH",
   "ENTITY NAME": "Fairbank, Maslin, Maullin, Metz & Associates, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553426",
   "ENTITY": "OTH",
   "ENTITY NAME": "Falco Inc., 76 Gas Station",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 41
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925139",
   "ENTITY": "OTH",
   "ENTITY NAME": "Farmers Union Restaurant",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550504",
   "ENTITY": "OTH",
   "ENTITY NAME": "Farmers Union Restaurant",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558307",
   "ENTITY": "OTH",
   "ENTITY NAME": "FedEx Office",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 67
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D556873",
   "ENTITY": "OTH",
   "ENTITY NAME": "FedEx Office",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924645",
   "ENTITY": "OTH",
   "ENTITY NAME": "Ferma Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923794",
   "ENTITY": "OTH",
   "ENTITY NAME": "Filice Accountancy Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Gilroy",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10983763",
   "ENTITY": "OTH",
   "ENTITY NAME": "First Community Housing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925428",
   "ENTITY": "OTH",
   "ENTITY NAME": "Fisher Property Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "West Palm Beach",
   "Entity_ST": "FL",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556840",
   "ENTITY": "OTH",
   "ENTITY NAME": "FM3 Research",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10993139",
   "ENTITY": "OTH",
   "ENTITY NAME": "Garden City Sanitation, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924660",
   "ENTITY": "OTH",
   "ENTITY NAME": "Garden City Sanitation, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924635",
   "ENTITY": "OTH",
   "ENTITY NAME": "George D. Garcia, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928182",
   "ENTITY": "OTH",
   "ENTITY NAME": "Giant Creative Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938043",
   "ENTITY": "OTH",
   "ENTITY NAME": "Gobind Pur Carrier",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964091",
   "ENTITY": "OTH",
   "ENTITY NAME": "Gold Coast Natural",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923827",
   "ENTITY": "OTH",
   "ENTITY NAME": "Gold Touch Investments LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557210",
   "ENTITY": "OTH",
   "ENTITY NAME": "Google.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6375
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556737",
   "ENTITY": "OTH",
   "ENTITY NAME": "Google.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552084",
   "ENTITY": "OTH",
   "ENTITY NAME": "Google.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556806",
   "ENTITY": "OTH",
   "ENTITY NAME": "Google.com",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10988007",
   "ENTITY": "OTH",
   "ENTITY NAME": "Granite Construction Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Watsonville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990037",
   "ENTITY": "OTH",
   "ENTITY NAME": "Graniterock",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Watsonville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924648",
   "ENTITY": "OTH",
   "ENTITY NAME": "Green Valley Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10990947",
   "ENTITY": "OTH",
   "ENTITY NAME": "Greenbelt Alliance",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1243
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "C",
   "ID": "C10990297",
   "ENTITY": "OTH",
   "ENTITY NAME": "Greenbelt Alliance",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1116
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10988037",
   "ENTITY": "OTH",
   "ENTITY NAME": "Greenbelt Alliance",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1074
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924613",
   "ENTITY": "OTH",
   "ENTITY NAME": "Greenwaste Recovery, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556884",
   "ENTITY": "OTH",
   "ENTITY NAME": "Grocery Outlet",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 43
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556423",
   "ENTITY": "OTH",
   "ENTITY NAME": "Grocery Outlet",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984761",
   "ENTITY": "OTH",
   "ENTITY NAME": "Habitat for Humanity East Bay/Silicon Valley",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556046",
   "ENTITY": "OTH",
   "ENTITY NAME": "Harland Clarke",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Antonio",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 33
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556051",
   "ENTITY": "OTH",
   "ENTITY NAME": "Harland Clarke",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Antonio",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 33
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983750",
   "ENTITY": "OTH",
   "ENTITY NAME": "Hensel Phelps",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Greeley",
   "Entity_ST": "CO",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928020",
   "ENTITY": "OTH",
   "ENTITY NAME": "Horizon Real Properties LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938045",
   "ENTITY": "OTH",
   "ENTITY NAME": "Hothi Freightlines",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10986968",
   "ENTITY": "OTH",
   "ENTITY NAME": "Housing Trust Silicon Valley",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928199",
   "ENTITY": "OTH",
   "ENTITY NAME": "Huawei Technologies USA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT19",
   "ENTITY": "OTH",
   "ENTITY NAME": "HULU",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 29412
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT37",
   "ENTITY": "OTH",
   "ENTITY NAME": "HULU",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SANTA MONICA",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963935",
   "ENTITY": "OTH",
   "ENTITY NAME": "HWG Law Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930951",
   "ENTITY": "OTH",
   "ENTITY NAME": "Inception Homes, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989514",
   "ENTITY": "OTH",
   "ENTITY NAME": "Inception Homes, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928018",
   "ENTITY": "OTH",
   "ENTITY NAME": "Insight Realty Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557375",
   "ENTITY": "OTH",
   "ENTITY NAME": "Intelli LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550502",
   "ENTITY": "OTH",
   "ENTITY NAME": "Intuit",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 244
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550501",
   "ENTITY": "OTH",
   "ENTITY NAME": "Intuit",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552901",
   "ENTITY": "OTH",
   "ENTITY NAME": "Jack In The Box",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928229",
   "ENTITY": "OTH",
   "ENTITY NAME": "Jarvis Manufacturing, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10984116",
   "ENTITY": "OTH",
   "ENTITY NAME": "JMB Construction, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "South San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933746",
   "ENTITY": "OTH",
   "ENTITY NAME": "Johanson & Yau",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989854",
   "ENTITY": "OTH",
   "ENTITY NAME": "John Edward (Jed) York & Affiliated Entities, Including the Forty Niners Football Company, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10986829",
   "ENTITY": "OTH",
   "ENTITY NAME": "Joseph J Albanese, Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923787",
   "ENTITY": "OTH",
   "ENTITY NAME": "Joseph J Albanese, Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557370",
   "ENTITY": "OTH",
   "ENTITY NAME": "KAZA Radio",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2550
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557182",
   "ENTITY": "OTH",
   "ENTITY NAME": "KAZA Radio",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1326
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928333",
   "ENTITY": "OTH",
   "ENTITY NAME": "KB Home South Bay Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557355",
   "ENTITY": "OTH",
   "ENTITY NAME": "KBRG-FM",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13239
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923778",
   "ENTITY": "OTH",
   "ENTITY NAME": "Kenneth Rodrigues & Partners, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557352",
   "ENTITY": "OTH",
   "ENTITY NAME": "KIQI-AM & KATD-AM",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1564
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989932",
   "ENTITY": "OTH",
   "ENTITY NAME": "KP Financial Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Pasadena",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557357",
   "ENTITY": "OTH",
   "ENTITY NAME": "KRZZ-FM",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9435
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557181",
   "ENTITY": "OTH",
   "ENTITY NAME": "KSJX Radio",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6605
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557353",
   "ENTITY": "OTH",
   "ENTITY NAME": "KSOL-FM",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7076
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557354",
   "ENTITY": "OTH",
   "ENTITY NAME": "KVVF-FM",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1870
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557180",
   "ENTITY": "OTH",
   "ENTITY NAME": "KVVN Radio",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 578
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557356",
   "ENTITY": "OTH",
   "ENTITY NAME": "KZSF",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 833
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987518",
   "ENTITY": "OTH",
   "ENTITY NAME": "L & D Construction Co., Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555970",
   "ENTITY": "OTH",
   "ENTITY NAME": "L2",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Bothell",
   "Entity_ST": "WA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923343",
   "ENTITY": "OTH",
   "ENTITY NAME": "La Cumbre Enterprises Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557434",
   "ENTITY": "OTH",
   "ENTITY NAME": "La Victoria Taqueria",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553398",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lake Research Partners",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 21728
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553401",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lake Research Partners",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8999
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT24",
   "ENTITY": "OTH",
   "ENTITY NAME": "LAVOI CREATIVE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "NEW ORLEANS",
   "Entity_ST": "LA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9398
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553473",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lavoi Creative, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New Orleans",
   "Entity_ST": "LA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5664
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924653",
   "ENTITY": "OTH",
   "ENTITY NAME": "Law Offices Of Timothy Gill",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558310",
   "ENTITY": "OTH",
   "ENTITY NAME": "Laz Parking",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 42
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557460",
   "ENTITY": "OTH",
   "ENTITY NAME": "Laz Parking",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558300",
   "ENTITY": "OTH",
   "ENTITY NAME": "Laz Parking",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550458",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lee's Sandwiches",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 464
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984759",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lehigh Hanson, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Irving",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987025",
   "ENTITY": "OTH",
   "ENTITY NAME": "LifeMoves",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Menlo Park",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964259",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lighthouse Public Affairs, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930952",
   "ENTITY": "OTH",
   "ENTITY NAME": "Los Gatos Bar and Grill",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964260",
   "ENTITY": "OTH",
   "ENTITY NAME": "LPMD Architects",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557397",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lucky",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 29
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556881",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lunardi's - Meridian",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557309",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lunardi's - Meridian",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556428",
   "ENTITY": "OTH",
   "ENTITY NAME": "Manley's Donuts",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 23
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550505",
   "ENTITY": "OTH",
   "ENTITY NAME": "Market & San Pedro Garage",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983757",
   "ENTITY": "OTH",
   "ENTITY NAME": "Marques Pipeline, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Rio Linda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC54",
   "ENTITY": "OTH",
   "ENTITY NAME": "MCCALMONT CORPORATION",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "CAMPBELL",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964261",
   "ENTITY": "OTH",
   "ENTITY NAME": "McDonald's Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oak Brook",
   "Entity_ST": "IL",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984763",
   "ENTITY": "OTH",
   "ENTITY NAME": "MCK Services Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Martinez",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934811",
   "ENTITY": "OTH",
   "ENTITY NAME": "McLarney Construction",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923832",
   "ENTITY": "OTH",
   "ENTITY NAME": "McManagement, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924641",
   "ENTITY": "OTH",
   "ENTITY NAME": "MDE Electric Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557462",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mezcal Restaurant & Bar",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1086
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553818",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mezcal Restaurant & Bar",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 933
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558287",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mi Ranchito Taqueria",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 177
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552112",
   "ENTITY": "OTH",
   "ENTITY NAME": "Microsoft Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989442",
   "ENTITY": "OTH",
   "ENTITY NAME": "MidPen Housing Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Foster City",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556759",
   "ENTITY": "OTH",
   "ENTITY NAME": "MightyHive",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1375
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557321",
   "ENTITY": "OTH",
   "ENTITY NAME": "MightyHive",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1169
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556813",
   "ENTITY": "OTH",
   "ENTITY NAME": "MightyHive",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1003
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT32",
   "ENTITY": "OTH",
   "ENTITY NAME": "MIGHTYHIVE",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 935
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556903",
   "ENTITY": "OTH",
   "ENTITY NAME": "MightyHive",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 762
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557178",
   "ENTITY": "OTH",
   "ENTITY NAME": "MightyHive",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 762
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT26",
   "ENTITY": "OTH",
   "ENTITY NAME": "MINJAR INC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SANTA CLARA",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928222",
   "ENTITY": "OTH",
   "ENTITY NAME": "Morley Bros., LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10963832",
   "ENTITY": "OTH",
   "ENTITY NAME": "Motor Body Co, Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938042",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mount Everest Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553005",
   "ENTITY": "OTH",
   "ENTITY NAME": "Mountain Mike's Pizza",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 237
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938047",
   "ENTITY": "OTH",
   "ENTITY NAME": "Muhar Enterprises Incorporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924631",
   "ENTITY": "OTH",
   "ENTITY NAME": "Music Vision & Entertainment",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557228",
   "ENTITY": "OTH",
   "ENTITY NAME": "NBC Sports Bay Area",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556823",
   "ENTITY": "OTH",
   "ENTITY NAME": "NBC Sports Bay Area",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964105",
   "ENTITY": "OTH",
   "ENTITY NAME": "Nederlander of California",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555966",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Ground Strategies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16011
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556786",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Ground Strategies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11493
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556908",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Ground Strategies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11493
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557168",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Ground Strategies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9336
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556785",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Ground Strategies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4651
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556909",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Ground Strategies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3686
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556784",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Ground Strategies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3359
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557358",
   "ENTITY": "OTH",
   "ENTITY NAME": "New Ground Strategies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2492
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555965",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556424",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552894",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 550
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551385",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 550
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551386",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 550
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552119",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 550
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553377",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 550
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557291",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 202
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for a Safer San Jose, Yes on F, a Coalition of Community Organizations, Businesses and Mayor Sam Liccardo",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D548258",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for a Safer San Jose, Yes on F, a Coalition of Community Organizations, Businesses and Mayor Sam Liccardo",
   "DATE": "7/30/2018",
   "FORM": "E",
   "ID": "D551864",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for a Safer San Jose, Yes on F, a Coalition of Community Organizations, Businesses and Mayor Sam Liccardo",
   "DATE": "10/28/2018",
   "FORM": "E",
   "ID": "D556742",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550461",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558297",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "E",
   "ID": "D555888",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558294",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558312",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553820",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555964",
   "ENTITY": "OTH",
   "ENTITY NAME": "NGP VAN, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Washington",
   "Entity_ST": "DC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556764",
   "ENTITY": "OTH",
   "ENTITY NAME": "Nhat Bao Calitoday",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556819",
   "ENTITY": "OTH",
   "ENTITY NAME": "Nhat Bao Calitoday",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10984113",
   "ENTITY": "OTH",
   "ENTITY NAME": "Nibbi Bros. Associates, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552111",
   "ENTITY": "OTH",
   "ENTITY NAME": "Nick the Greek",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556427",
   "ENTITY": "OTH",
   "ENTITY NAME": "Noah's NY Bagels",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556880",
   "ENTITY": "OTH",
   "ENTITY NAME": "Noah's NY Bagels",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 47
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "I",
   "ID": "C10991290",
   "ENTITY": "OTH",
   "ENTITY NAME": "Noah's NY Bagels",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 47
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556879",
   "ENTITY": "OTH",
   "ENTITY NAME": "Noah's NY Bagels",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10961413",
   "ENTITY": "OTH",
   "ENTITY NAME": "Novin Development Corp.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558272",
   "ENTITY": "OTH",
   "ENTITY NAME": "Nucleus",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924701",
   "ENTITY": "OTH",
   "ENTITY NAME": "O'Flaherty's Pub",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938044",
   "ENTITY": "OTH",
   "ENTITY NAME": "Oakland Port Trucking, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT31",
   "ENTITY": "OTH",
   "ENTITY NAME": "OATH (AMERICAS) INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "NEW YORK",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557351",
   "ENTITY": "OTH",
   "ENTITY NAME": "Oath Anericas",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Omaha",
   "Entity_ST": "NE",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4505
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550485",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 377
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556868",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 295
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553835",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 290
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558326",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 252
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550037",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 231
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551816",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 229
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550493",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 218
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553375",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 181
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557310",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 179
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557396",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 162
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557193",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 144
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557395",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 125
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552892",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 123
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553372",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 123
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550492",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 118
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556883",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 118
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557400",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 118
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551380",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 113
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556867",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 94
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557459",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 87
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550497",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 83
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552124",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 76
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552115",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 71
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552117",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 70
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552114",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 59
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550496",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 54
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552938",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 49
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556885",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 47
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550038",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 44
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552126",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 41
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550486",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 41
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552893",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552125",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553389",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553737",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553382",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 27
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551381",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 22
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553004",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 21
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557311",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office  Depot - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 18
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933740",
   "ENTITY": "OTH",
   "ENTITY NAME": "OJK, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987853",
   "ENTITY": "OTH",
   "ENTITY NAME": "P.A.T.H.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10926755",
   "ENTITY": "OTH",
   "ENTITY NAME": "P.H. Smith Westwood Properties II",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924643",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Bay Masonry Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557325",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46461
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556810",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36258
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556906",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36258
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557170",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 32830
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557222",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 28996
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556768",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 28086
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556771",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 28086
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557220",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25585
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557223",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25585
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557230",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19752
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557231",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19752
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557185",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 18978
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553431",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9291
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D552997",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9146
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT39",
   "ENTITY": "OTH",
   "ENTITY NAME": "PACIFIC PRINT RESOURCES",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "EMERYVILLE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9040
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT30",
   "ENTITY": "OTH",
   "ENTITY NAME": "PACIFIC PRINT RESOURCES",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "EMERYVILLE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7534
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556900",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7195
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556822",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7195
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557224",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7170
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557217",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7017
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT13",
   "ENTITY": "OTH",
   "ENTITY NAME": "PACIFIC PRINT RESOURCES",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "EMERYVILLE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6449
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT14",
   "ENTITY": "OTH",
   "ENTITY NAME": "PACIFIC PRINT RESOURCES",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "EMERYVILLE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6449
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557219",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6004
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550473",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5808
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557221",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5503
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552068",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5420
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557318",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4903
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557184",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4104
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557173",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4104
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550457",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2723
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557346",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2583
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556805",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2570
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556734",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2231
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556800",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2231
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553000",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1940
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556756",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1345
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556801",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 848
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557347",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 543
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555959",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555986",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555987",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555990",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555991",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Print Resources",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Emeryville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983749",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Realty Investment Group, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10935152",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacwend 1 Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Modesto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT10",
   "ENTITY": "OTH",
   "ENTITY NAME": "PANDORA MEDIA INC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "CHICAGO",
   "Entity_ST": "IL",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT18",
   "ENTITY": "OTH",
   "ENTITY NAME": "PANDORA MEDIA INC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "CHICAGO",
   "Entity_ST": "IL",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556824",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pandora Media Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Chicago",
   "Entity_ST": "IL",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 28900
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556426",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paragon Print Systems, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Erie",
   "Entity_ST": "PA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 171
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557341",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paramount",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Leesburg",
   "Entity_ST": "VA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2273
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557327",
   "ENTITY": "OTH",
   "ENTITY NAME": "Paramount",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Leesburg",
   "Entity_ST": "VA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 525
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10983754",
   "ENTITY": "OTH",
   "ENTITY NAME": "Peninsula Open Space Trust",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 49950
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928271",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pinger, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964015",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pizza My Heart",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553394",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pizza My Heart",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 62
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550499",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pizza My Heart",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 38
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551813",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6233
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964101",
   "ENTITY": "OTH",
   "ENTITY NAME": "Poor House Bistro, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964310",
   "ENTITY": "OTH",
   "ENTITY NAME": "Power Integrations Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923339",
   "ENTITY": "OTH",
   "ENTITY NAME": "Preston Pipelines, Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10924651",
   "ENTITY": "OTH",
   "ENTITY NAME": "Prodesse Property Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553478",
   "ENTITY": "OTH",
   "ENTITY NAME": "Public Policy Polling",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Raleigh",
   "Entity_ST": "NC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555972",
   "ENTITY": "OTH",
   "ENTITY NAME": "Public Policy Polling",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Raleigh",
   "Entity_ST": "NC",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557339",
   "ENTITY": "OTH",
   "ENTITY NAME": "Ray Day Productions",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Half Moon Bay",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 900
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923813",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rebello's Towing Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "A",
   "ID": "INC22",
   "ENTITY": "OTH",
   "ENTITY NAME": "REPUBLIC URBAN PROPERTIES LLC AND AFFILIATED ENTITIES",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989440",
   "ENTITY": "OTH",
   "ENTITY NAME": "Resources for Community Development",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924610",
   "ENTITY": "OTH",
   "ENTITY NAME": "RG Speno, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923324",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rick's Furniture",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923346",
   "ENTITY": "OTH",
   "ENTITY NAME": "RLMP LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964654",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rockwood Design Associates, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990109",
   "ENTITY": "OTH",
   "ENTITY NAME": "ROEM Development Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923779",
   "ENTITY": "OTH",
   "ENTITY NAME": "ROEM Development Corporation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990241",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rosendin Electric, Inc. Contractors",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930958",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rosie McCann's Irish Pub and Restaurant",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557446",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rosies New York Pizza",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 96
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557394",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rosies New York Pizza",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 95
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553736",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rotten Robbie",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928247",
   "ENTITY": "OTH",
   "ENTITY NAME": "Russian Music School, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933875",
   "ENTITY": "OTH",
   "ENTITY NAME": "Ruth and Going, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924642",
   "ENTITY": "OTH",
   "ENTITY NAME": "S & S Drywall, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931464",
   "ENTITY": "OTH",
   "ENTITY NAME": "S.E.I. Development",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552288",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway - San Carlos",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 46
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552129",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway - San Carlos",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553735",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway - The Market",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 53
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550039",
   "ENTITY": "OTH",
   "ENTITY NAME": "Safeway - The Market",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10989917",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Francisco Bay Area Planning & Urban Research Assoc. (SPUR)",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 434
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "C",
   "ID": "C10989910",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Francisco Bay Area Planning & Urban Research Assoc. (SPUR)",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 434
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557316",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Francisco Study Center",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556872",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose AV Rental",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553388",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose AV Rental",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 55
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930954",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Bar & Grill",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC67",
   "ENTITY": "OTH",
   "ENTITY NAME": "SAN JOSE COMMERCIAL PROPERTIES",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "HAMILTON",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933737",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Light Tower LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928336",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Water Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552900",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Pedro Square Gift Shop",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928167",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sares Regis Group of No. California, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10983765",
   "ENTITY": "OTH",
   "ENTITY NAME": "Satellite Affordable Housing Associates Property Management (SAHA PM)",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkeley",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923365",
   "ENTITY": "OTH",
   "ENTITY NAME": "SDS Nexgen Partners LP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930449",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sharks Sports & Entertainment",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928188",
   "ENTITY": "OTH",
   "ENTITY NAME": "Shea & Shea",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987854",
   "ENTITY": "OTH",
   "ENTITY NAME": "Shea Properties Management Company, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Aliso Viejo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930964",
   "ENTITY": "OTH",
   "ENTITY NAME": "Shimmick Construction Co., Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964647",
   "ENTITY": "OTH",
   "ENTITY NAME": "Shorenstein Realty Services, L.P.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984495",
   "ENTITY": "OTH",
   "ENTITY NAME": "SHP-CUTE, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938039",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sidhu Stores Inc",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925106",
   "ENTITY": "OTH",
   "ENTITY NAME": "Silicon Valley Comic Con, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Medway",
   "Entity_ST": "MA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987995",
   "ENTITY": "OTH",
   "ENTITY NAME": "Silicon Valley Community Foundation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 35000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987852",
   "ENTITY": "OTH",
   "ENTITY NAME": "Silicon Valley Community Foundation",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "A",
   "ID": "C10964008",
   "ENTITY": "OTH",
   "ENTITY NAME": "Silicon Valley Property Management Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964239",
   "ENTITY": "OTH",
   "ENTITY NAME": "Skidmore, Owings & Merrill LLP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556763",
   "ENTITY": "OTH",
   "ENTITY NAME": "Song Moi Magazine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556818",
   "ENTITY": "OTH",
   "ENTITY NAME": "Song Moi Magazine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928164",
   "ENTITY": "OTH",
   "ENTITY NAME": "South Bay Construction",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10931466",
   "ENTITY": "OTH",
   "ENTITY NAME": "Splash!Events, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923347",
   "ENTITY": "OTH",
   "ENTITY NAME": "Splash!Events, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 300
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552860",
   "ENTITY": "OTH",
   "ENTITY NAME": "SPUR",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923326",
   "ENTITY": "OTH",
   "ENTITY NAME": "St. James Plaza",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/2/2018",
   "FORM": "A",
   "ID": "C10984115",
   "ENTITY": "OTH",
   "ENTITY NAME": "Standard West Coast LP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Angeles",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556886",
   "ENTITY": "OTH",
   "ENTITY NAME": "Starbucks",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557312",
   "ENTITY": "OTH",
   "ENTITY NAME": "Starbucks",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558301",
   "ENTITY": "OTH",
   "ENTITY NAME": "Starbucks",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT28",
   "ENTITY": "OTH",
   "ENTITY NAME": "STARS MANAGEMENT",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924201",
   "ENTITY": "OTH",
   "ENTITY NAME": "Steinberg Architects",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557209",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 156784
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557333",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 136288
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556757",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 115250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557336",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 114034
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556826",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557169",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 98100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556767",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 95059
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556901",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 93478
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557335",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 91920
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556809",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 87390
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556807",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 75000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP14",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 68316
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557323",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 59798
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP34",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 58780
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP16",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 55665
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556821",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 54593
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557229",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 54160
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557372",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557317",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 45121
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D552996",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 44308
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557225",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40384
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558271",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553396",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 37083
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP50",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 36995
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553430",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34936
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557183",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34814
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP71",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 29988
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP26",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 29412
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP90",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 26691
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556816",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 26604
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552065",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20420
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557334",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19155
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556762",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16950
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP58",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15648
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556736",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP73",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP75",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP85",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556815",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13648
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556791",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13639
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552082",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553744",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11437
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556899",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11324
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552080",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10609
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555975",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10400
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550455",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10213
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553471",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553760",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556788",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558273",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555977",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556849",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553406",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9235
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556804",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8973
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556802",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8493
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556797",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7646
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP92",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7459
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP96",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7294
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550472",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 7100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557369",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP100",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553472",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5664
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556787",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5553
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555963",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5402
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551100",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552070",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552856",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557373",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557179",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556732",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4640
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557324",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4462
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555961",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4129
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556754",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4015
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557371",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3059
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553427",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3058
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556789",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555979",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558275",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1771
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D555971",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1678
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550454",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 579
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552069",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 450
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553748",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 375
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550471",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 307
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553761",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 288
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for a Safer San Jose, Yes on F, a Coalition of Community Organizations, Businesses and Mayor Sam Liccardo",
   "DATE": "7/30/2018",
   "FORM": "F",
   "ID": "D541880",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for a Safer San Jose, Yes on F, a Coalition of Community Organizations, Businesses and Mayor Sam Liccardo",
   "DATE": "7/30/2018",
   "FORM": "F",
   "ID": "D542338",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "F",
   "ID": "D550814",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555958",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555962",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "F",
   "ID": "PAY88",
   "ENTITY": "OTH",
   "ENTITY NAME": "STOREFRONT POLITICAL MEDIA",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555985",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555988",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D555989",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555943",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555969",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555976",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D555978",
   "ENTITY": "OTH",
   "ENTITY NAME": "Storefront Political Media",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10925355",
   "ENTITY": "OTH",
   "ENTITY NAME": "SummerHill Homes LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10934991",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sungenix Energy Solutions",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC68",
   "ENTITY": "OTH",
   "ENTITY NAME": "SUPER MICRO COMPUTER, INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924607",
   "ENTITY": "OTH",
   "ENTITY NAME": "Surplus Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP69",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9405
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550459",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4090
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP112",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4003
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "E",
   "ID": "EXP114",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2497
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556727",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 948
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556777",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 864
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556843",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 696
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557332",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 680
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558311",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 659
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557331",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 575
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557308",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 491
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D556007",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D557137",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D557138",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "F",
   "ID": "D556008",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D556009",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "F",
   "ID": "D557139",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "F",
   "ID": "PAY45",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "F",
   "ID": "PAY110",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sutton Law Firm",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN FRANCISCO",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 0
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923798",
   "ENTITY": "OTH",
   "ENTITY NAME": "SWHM Properties, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556861",
   "ENTITY": "OTH",
   "ENTITY NAME": "Taqueria Eduardo",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 147
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552289",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 177
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552109",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 149
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553836",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 127
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551393",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 49
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552110",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 41
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552937",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551392",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928177",
   "ENTITY": "OTH",
   "ENTITY NAME": "TEAMWRKX, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557376",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tele-Town Hall Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Arlington",
   "Entity_ST": "VA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2660
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558276",
   "ENTITY": "OTH",
   "ENTITY NAME": "Tele-Town Hall Services",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Arlington",
   "Entity_ST": "VA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1771
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990107",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Conco Companies - Gonsalves & Santucci, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Concord",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10988121",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Core Companies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964919",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Core Companies",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989516",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Health Trust",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964115",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Hoffman Agency",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/3/2018",
   "FORM": "A",
   "ID": "C10984114",
   "ENTITY": "OTH",
   "ENTITY NAME": "The John Stewart Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928021",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Nicholson Family Partnership",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Aptos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924647",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Schoennauer Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552127",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1875
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553003",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1875
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551394",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551395",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556837",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1694
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553384",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556894",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553834",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558303",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 450
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553385",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 375
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557306",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Silicon Valley Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 248
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984867",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Sobrato Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928019",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Sobrato Organization",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558289",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Tamale Factory",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 103
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557350",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556760",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 33625
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557378",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556814",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 24497
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557320",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 21250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557226",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556773",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16520
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556902",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16218
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557176",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16218
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT33",
   "ENTITY": "OTH",
   "ENTITY NAME": "THE TRADE DESK",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "VENTURA",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11815
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556905",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11311
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558274",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556803",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6855
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553746",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT35",
   "ENTITY": "OTH",
   "ENTITY NAME": "THE TRADE DESK",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "VENTURA",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6213
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557227",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5270
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT38",
   "ENTITY": "OTH",
   "ENTITY NAME": "THE TRADE DESK",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "VENTURA",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4930
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557177",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Trade Desk",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Ventura",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4250
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550482",
   "ENTITY": "OTH",
   "ENTITY NAME": "The UPS Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 87
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553376",
   "ENTITY": "OTH",
   "ENTITY NAME": "The UPS Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 69
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553758",
   "ENTITY": "OTH",
   "ENTITY NAME": "The UPS Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 27
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553378",
   "ENTITY": "OTH",
   "ENTITY NAME": "The UPS Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 27
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553734",
   "ENTITY": "OTH",
   "ENTITY NAME": "The UPS Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 21
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "E",
   "ID": "EXP6",
   "ENTITY": "OTH",
   "ENTITY NAME": "THE UPS STORE #3648",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 110
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10938041",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Wine Fountaine",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 251
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "A",
   "ID": "INC82",
   "ENTITY": "OTH",
   "ENTITY NAME": "THIN FILM ELECTRONICS, INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10987308",
   "ENTITY": "OTH",
   "ENTITY NAME": "TMG Partners",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 25000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558261",
   "ENTITY": "OTH",
   "ENTITY NAME": "Togo's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 105
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557348",
   "ENTITY": "OTH",
   "ENTITY NAME": "TOSKR, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1884
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553395",
   "ENTITY": "OTH",
   "ENTITY NAME": "TOSKR, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 748
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552087",
   "ENTITY": "OTH",
   "ENTITY NAME": "TOSKR, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 362
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552644",
   "ENTITY": "OTH",
   "ENTITY NAME": "TOSKR, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 360
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D550470",
   "ENTITY": "OTH",
   "ENTITY NAME": "TOSKR, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 280
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553371",
   "ENTITY": "OTH",
   "ENTITY NAME": "Total Wireless",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Miami",
   "Entity_ST": "FL",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 112
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553817",
   "ENTITY": "OTH",
   "ENTITY NAME": "Total Wireless",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Miami",
   "Entity_ST": "FL",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 112
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553390",
   "ENTITY": "OTH",
   "ENTITY NAME": "Trader Joe's - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 71
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552113",
   "ENTITY": "OTH",
   "ENTITY NAME": "Trader Joe's - Coleman",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 55
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928230",
   "ENTITY": "OTH",
   "ENTITY NAME": "Trumark Homes LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552083",
   "ENTITY": "OTH",
   "ENTITY NAME": "Twitter, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10989945",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Concrete, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Euless",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552095",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Post Office - Parkmoor",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557313",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postal Service",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "",
   "Entity_ST": "",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1750
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D552999",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postmaster",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17140
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553433",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postmaster",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16447
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552123",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postmaster",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552902",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postmaster",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550489",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postmaster",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552122",
   "ENTITY": "OTH",
   "ENTITY NAME": "U.S. Postmaster",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT41",
   "ENTITY": "OTH",
   "ENTITY NAME": "USPS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "OAKLAND",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 18725
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "7/23/2018",
   "FORM": "G",
   "ID": "PDT21",
   "ENTITY": "OTH",
   "ENTITY NAME": "USPS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "OAKLAND",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14351
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT16",
   "ENTITY": "OTH",
   "ENTITY NAME": "USPS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "OAKLAND",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13509
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "YES ON C / NO ON B, STOP THE SPRAWL SAN JOSE, SUPPORTED BY MAYOR SAM LICCARDO",
   "DATE": "5/25/2018",
   "FORM": "G",
   "ID": "PDT15",
   "ENTITY": "OTH",
   "ENTITY NAME": "USPS",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "OAKLAND",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 13509
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928186",
   "ENTITY": "OTH",
   "ENTITY NAME": "Valbridge Property Advisors",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924627",
   "ENTITY": "OTH",
   "ENTITY NAME": "Vasona Management, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924661",
   "ENTITY": "OTH",
   "ENTITY NAME": "VIB Law",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556765",
   "ENTITY": "OTH",
   "ENTITY NAME": "Vietnam Daily News",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556820",
   "ENTITY": "OTH",
   "ENTITY NAME": "Vietnam Daily News",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4800
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924646",
   "ENTITY": "OTH",
   "ENTITY NAME": "VMC Travel Express",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1100
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10925344",
   "ENTITY": "OTH",
   "ENTITY NAME": "Webcor Construction LP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557292",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 90
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "E",
   "ID": "D550507",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 62
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557467",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 61
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553392",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556419",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556420",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556897",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557234",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557240",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557235",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557381",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 60
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556878",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 45
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557233",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 45
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551382",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 32
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553381",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553373",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553383",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553733",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553816",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553757",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556041",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556620",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556622",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556750",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "I",
   "ID": "C10987735",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D556898",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557195",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557239",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557293",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557398",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557443",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556045",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556421",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556629",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557393",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556050",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556882",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557315",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557514",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558324",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 17
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553732",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557368",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557277",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557374",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557445",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557516",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557458",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557464",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on T and V for a Safer Stronger San Jose, Supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558325",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 12
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552121",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552895",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551379",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553380",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551378",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553374",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 6
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552118",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D557290",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wells Fargo Bank",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924634",
   "ENTITY": "OTH",
   "ENTITY NAME": "West Coast Framing, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Marysville",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "A",
   "ID": "C10964765",
   "ENTITY": "OTH",
   "ENTITY NAME": "Westcoast Precision, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553838",
   "ENTITY": "OTH",
   "ENTITY NAME": "Whole Foods",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 209
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551388",
   "ENTITY": "OTH",
   "ENTITY NAME": "Whole Foods",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 85
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D552290",
   "ENTITY": "OTH",
   "ENTITY NAME": "Whole Foods",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 66
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553391",
   "ENTITY": "OTH",
   "ENTITY NAME": "Whole Foods",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 55
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551387",
   "ENTITY": "OTH",
   "ENTITY NAME": "Whole Foods",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 21
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "5/24/2018",
   "FORM": "E",
   "ID": "D553387",
   "ENTITY": "OTH",
   "ENTITY NAME": "Whole Foods",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 19
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10930450",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wilson Sonsini",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10937931",
   "ENTITY": "OTH",
   "ENTITY NAME": "Windflower Properties",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10923823",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wood Rodgers Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924628",
   "ENTITY": "OTH",
   "ENTITY NAME": "Woodmont Real Estate Services, LP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Belmont",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "E",
   "ID": "D558290",
   "ENTITY": "OTH",
   "ENTITY NAME": "Y Market & Liquor",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 9
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10933739",
   "ENTITY": "OTH",
   "ENTITY NAME": "Yellow Checker Cab Co., Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 700
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "A",
   "ID": "C10928334",
   "ENTITY": "OTH",
   "ENTITY NAME": "Yellow Checker Cab Co., Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "D",
   "ID": "DD553761",
   "ENTITY": "OTH",
   "ENTITY NAME": "Yes on Regional Measure 3- Keeping the Bay Area moving, sponsored by Bay Area Civic Leadership Associations",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 288
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "E",
   "ID": "D556770",
   "ENTITY": "OTH",
   "ENTITY NAME": "YGS Group",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "York",
   "Entity_ST": "PA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 520
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "6/4/2018",
   "FORM": "E",
   "ID": "D553747",
   "ENTITY": "OTH",
   "ENTITY NAME": "YouTube",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Bruno",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "1/31/2019",
   "FORM": "A",
   "ID": "C10990106",
   "ENTITY": "OTH",
   "ENTITY NAME": "YWCA of Silicon Valley",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924612",
   "ENTITY": "OTH",
   "ENTITY NAME": "Zanker Road Resource Management, Ltd.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "4/27/2018",
   "FORM": "E",
   "ID": "D551397",
   "ENTITY": "OTH",
   "ENTITY NAME": "Zanotto's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Safer San Jose, Yes on Measure T, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984778",
   "ENTITY": "SCC",
   "ENTITY NAME": "Northern California Carpenters Regional Council Small Contributor Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Yes on Measure V, Vote Affordable San Jose, supported by Mayor Sam Liccardo",
   "DATE": "10/26/2018",
   "FORM": "A",
   "ID": "C10984776",
   "ENTITY": "SCC",
   "ENTITY NAME": "Northern California Carpenters Regional Council Small Contributor Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 20000
 },
 {
   "LAST": "Liccardo",
   "FIRST": "Sam",
   "PURPOSE": "Neighbors for Sam Liccardo for San Jose Mayor 2018",
   "DATE": "1/31/2018",
   "FORM": "A",
   "ID": "C10924594",
   "ENTITY": "",
   "ENTITY NAME": "Corsiglia, McMahon & Allard, LLP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1321",
   "ENTITY": "COM",
   "ENTITY NAME": "BAYMEC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1320",
   "ENTITY": "COM",
   "ENTITY NAME": "Neighbors for Affordable Housing and Open Space",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2801",
   "ENTITY": "COM",
   "ENTITY NAME": "Rivera For City Council 2018",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1758",
   "ENTITY": "IND",
   "ENTITY NAME": "Acharya",
   "ENTITY NAME CONT.": "Sanjeev",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Sage Builders",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1207",
   "ENTITY": "IND",
   "ENTITY NAME": "Ahrens",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "CA. State Assembly",
   "OCCUPATION": "Policy Aid",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1451",
   "ENTITY": "IND",
   "ENTITY NAME": "Ahrens",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "CA. State Assembly",
   "OCCUPATION": "Policy Aid",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1680",
   "ENTITY": "IND",
   "ENTITY NAME": "Allen",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Unified School District",
   "OCCUPATION": "Public Information Officer",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1192",
   "ENTITY": "IND",
   "ENTITY NAME": "Alloway",
   "ENTITY NAME CONT.": "Shunnon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 5
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1779",
   "ENTITY": "IND",
   "ENTITY NAME": "Ames",
   "ENTITY NAME CONT.": "Lawrence",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2838",
   "ENTITY": "IND",
   "ENTITY NAME": "Amirkhas",
   "ENTITY NAME CONT.": "Atour",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Morris & Sons Towing",
   "OCCUPATION": "Self",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2839",
   "ENTITY": "IND",
   "ENTITY NAME": "Amirkhas",
   "ENTITY NAME CONT.": "Grace",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Morris & Sons Towing",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2843",
   "ENTITY": "IND",
   "ENTITY NAME": "Amirkhas",
   "ENTITY NAME CONT.": "Ashour",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Morris & Sons Towing",
   "OCCUPATION": "Auction Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1426",
   "ENTITY": "IND",
   "ENTITY NAME": "Anderson",
   "ENTITY NAME CONT.": "Kurt",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Architect",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2718",
   "ENTITY": "IND",
   "ENTITY NAME": "Anderson",
   "ENTITY NAME CONT.": "Amy N",
   "ENTITY CITY": "Santa Monica",
   "Entity_ST": "CA",
   "EMPLOYER": "PATH Ventures",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 70
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1226",
   "ENTITY": "IND",
   "ENTITY NAME": "Arriaga",
   "ENTITY NAME CONT.": "John E.",
   "ENTITY CITY": "Fair Oaks",
   "Entity_ST": "CA",
   "EMPLOYER": "President",
   "OCCUPATION": "JEA & Associates",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1620",
   "ENTITY": "IND",
   "ENTITY NAME": "Arrillaga",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Newmark",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1668",
   "ENTITY": "IND",
   "ENTITY NAME": "Awad",
   "ENTITY NAME CONT.": "Jamie",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Club Papi Productions",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 150
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1797",
   "ENTITY": "IND",
   "ENTITY NAME": "Ayala",
   "ENTITY NAME CONT.": "Edward",
   "ENTITY CITY": "Fresno",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "C",
   "ID": "RC1228",
   "ENTITY": "IND",
   "ENTITY NAME": "Banks",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Stanford University",
   "OCCUPATION": "Senior Web Developer",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2724",
   "ENTITY": "IND",
   "ENTITY NAME": "Benner",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "Santa Cruz",
   "Entity_ST": "CA",
   "EMPLOYER": "University of California Santa Cruz",
   "OCCUPATION": "Professor",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1440",
   "ENTITY": "IND",
   "ENTITY NAME": "Bernard",
   "ENTITY NAME CONT.": "Marie",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Sunnyvale Community Services",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 99
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "A",
   "ID": "RC4175",
   "ENTITY": "IND",
   "ENTITY NAME": "Berry",
   "ENTITY NAME CONT.": "Rhonda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Our City Forrest",
   "OCCUPATION": "President",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3068",
   "ENTITY": "IND",
   "ENTITY NAME": "Bolger",
   "ENTITY NAME CONT.": "Brenna M.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "PRX Digital",
   "OCCUPATION": "CEO",
   "AMOUNT": 75
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX661",
   "ENTITY": "IND",
   "ENTITY NAME": "Brady",
   "ENTITY NAME CONT.": "Kymberli",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 175
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1217",
   "ENTITY": "IND",
   "ENTITY NAME": "Brouillette",
   "ENTITY NAME CONT.": "Sarah",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self Employed",
   "OCCUPATION": "Bookkeeper",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1678",
   "ENTITY": "IND",
   "ENTITY NAME": "Brownstein",
   "ENTITY NAME CONT.": "Robert",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partners USA",
   "OCCUPATION": "Strategic Advisor",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3088",
   "ENTITY": "IND",
   "ENTITY NAME": "Bruce",
   "ENTITY NAME CONT.": "Marjorie",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "Splash Bar",
   "OCCUPATION": "Bar Biz",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1448",
   "ENTITY": "IND",
   "ENTITY NAME": "Brunner",
   "ENTITY NAME CONT.": "Alison",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Foundation of Silicon Valley",
   "OCCUPATION": "CEO\\ Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3087",
   "ENTITY": "IND",
   "ENTITY NAME": "Brunner",
   "ENTITY NAME CONT.": "Alison",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Law Foundation of Silicon Valley",
   "OCCUPATION": "CEO\\ Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2731",
   "ENTITY": "IND",
   "ENTITY NAME": "Buchholz",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Corporate Advisory Services",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1763",
   "ENTITY": "IND",
   "ENTITY NAME": "Burroughs",
   "ENTITY NAME CONT.": "Joshua",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Cadre Urban LLC",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1214",
   "ENTITY": "IND",
   "ENTITY NAME": "Cady",
   "ENTITY NAME CONT.": "Randall",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1215",
   "ENTITY": "IND",
   "ENTITY NAME": "Cady",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Real State",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1432",
   "ENTITY": "IND",
   "ENTITY NAME": "Carrillo",
   "ENTITY NAME CONT.": "Pete",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Principal\\Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1431",
   "ENTITY": "IND",
   "ENTITY NAME": "Caruso",
   "ENTITY NAME CONT.": "Salvatore",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "SCDC",
   "OCCUPATION": "Architect",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1783",
   "ENTITY": "IND",
   "ENTITY NAME": "Chaffin",
   "ENTITY NAME CONT.": "Sarah",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "First Funding",
   "OCCUPATION": "Advisor",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1659",
   "ENTITY": "IND",
   "ENTITY NAME": "Chambliss",
   "ENTITY NAME CONT.": "Sherl",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Moving Mountains Center",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2803",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Cindy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "County Supervisor",
   "AMOUNT": 300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1821",
   "ENTITY": "IND",
   "ENTITY NAME": "Chavez",
   "ENTITY NAME CONT.": "Irene",
   "ENTITY CITY": "Morgan Hill",
   "Entity_ST": "CA",
   "EMPLOYER": "Kaiser Permanente",
   "OCCUPATION": "Hospital Administrator",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC2408",
   "ENTITY": "IND",
   "ENTITY NAME": "Cheng",
   "ENTITY NAME CONT.": "Shiao Ping",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1455",
   "ENTITY": "IND",
   "ENTITY NAME": "Chicoine",
   "ENTITY NAME CONT.": "Louis",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Abode Services",
   "OCCUPATION": "Administrator",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1458",
   "ENTITY": "IND",
   "ENTITY NAME": "Chung",
   "ENTITY NAME CONT.": "Patrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Fire fighters PAC",
   "OCCUPATION": "Union Employer",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1416",
   "ENTITY": "IND",
   "ENTITY NAME": "Clayton",
   "ENTITY NAME CONT.": "Roark",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Printing Works",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2850",
   "ENTITY": "IND",
   "ENTITY NAME": "Cohen",
   "ENTITY NAME CONT.": "Jean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "UA Local 393",
   "OCCUPATION": "Political Communications Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1175",
   "ENTITY": "IND",
   "ENTITY NAME": "Colunga",
   "ENTITY NAME CONT.": "Raul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1176",
   "ENTITY": "IND",
   "ENTITY NAME": "Colunga",
   "ENTITY NAME CONT.": "Laura",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1786",
   "ENTITY": "IND",
   "ENTITY NAME": "Cord",
   "ENTITY NAME CONT.": "Henry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cord Associates",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1173",
   "ENTITY": "IND",
   "ENTITY NAME": "Cortese",
   "ENTITY NAME CONT.": "Dave",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "County Supervisor",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3067",
   "ENTITY": "IND",
   "ENTITY NAME": "Cortez",
   "ENTITY NAME CONT.": "Darrel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Police",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1675",
   "ENTITY": "IND",
   "ENTITY NAME": "Cosby",
   "ENTITY NAME CONT.": "Joan Rivas-",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Couty of Santa Clara",
   "OCCUPATION": "Board Aide",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1445",
   "ENTITY": "IND",
   "ENTITY NAME": "Cunneen",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Strategies",
   "OCCUPATION": "Partner",
   "AMOUNT": 300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1446",
   "ENTITY": "IND",
   "ENTITY NAME": "Dean",
   "ENTITY NAME CONT.": "Burt",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Rebello's Towing",
   "OCCUPATION": "Private Property Towing & Repossession",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1180",
   "ENTITY": "IND",
   "ENTITY NAME": "Dietzgen",
   "ENTITY NAME CONT.": "Joe",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1459",
   "ENTITY": "IND",
   "ENTITY NAME": "Dillabough",
   "ENTITY NAME CONT.": "Gary",
   "ENTITY CITY": "Atherton",
   "Entity_ST": "CA",
   "EMPLOYER": "Navitas Capital",
   "OCCUPATION": "Venture Capital",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "A",
   "ID": "RC4151",
   "ENTITY": "IND",
   "ENTITY NAME": "Disalvo",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Trustee Area 4 Board of Education",
   "OCCUPATION": "Board Member",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC2443",
   "ENTITY": "IND",
   "ENTITY NAME": "Dotson",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Solutions LLC",
   "OCCUPATION": "Founder/CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1679",
   "ENTITY": "IND",
   "ENTITY NAME": "Eu",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Vision First",
   "OCCUPATION": "Optometrist",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1177",
   "ENTITY": "IND",
   "ENTITY NAME": "Faas",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "SJSU",
   "OCCUPATION": "VP. Finance + Admin.",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2727",
   "ENTITY": "IND",
   "ENTITY NAME": "Fillmore",
   "ENTITY NAME CONT.": "Karen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara Co. Probation Dept.",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2809",
   "ENTITY": "IND",
   "ENTITY NAME": "Filter",
   "ENTITY NAME CONT.": "Alyssa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Frank Rimerman + Co. LLP",
   "OCCUPATION": "CPA",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1662",
   "ENTITY": "IND",
   "ENTITY NAME": "Fisher",
   "ENTITY NAME CONT.": "Joseph",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hortonworks",
   "OCCUPATION": "IT Profesional",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3083",
   "ENTITY": "IND",
   "ENTITY NAME": "Flynn",
   "ENTITY NAME CONT.": "Kathleen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1423",
   "ENTITY": "IND",
   "ENTITY NAME": "Foster",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "Palo Alto",
   "Entity_ST": "CA",
   "EMPLOYER": "Westley Foundation",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1018",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1019",
   "ENTITY": "IND",
   "ENTITY NAME": "Fox",
   "ENTITY NAME CONT.": "Mary",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1437",
   "ENTITY": "IND",
   "ENTITY NAME": "Freise",
   "ENTITY NAME CONT.": "Christopher",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Lift Partners",
   "OCCUPATION": "Developer\\Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1186",
   "ENTITY": "IND",
   "ENTITY NAME": "Gallardo",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intero Real Estate Services",
   "OCCUPATION": "Realtor",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1771",
   "ENTITY": "IND",
   "ENTITY NAME": "Gardner",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley of Nonprofits",
   "OCCUPATION": "CEO",
   "AMOUNT": 450
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1421",
   "ENTITY": "IND",
   "ENTITY NAME": "Gardner",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley of Nonprofits",
   "OCCUPATION": "CEO",
   "AMOUNT": 150
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3070",
   "ENTITY": "IND",
   "ENTITY NAME": "Ginsborg",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "Deputy to the Assesor",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2802",
   "ENTITY": "IND",
   "ENTITY NAME": "Ginsbury",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County",
   "OCCUPATION": "Deputy Assesor",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1626",
   "ENTITY": "IND",
   "ENTITY NAME": "Goddard",
   "ENTITY NAME CONT.": "Nick",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2835",
   "ENTITY": "IND",
   "ENTITY NAME": "Goldstein",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Barbara Goldstein & Associates",
   "OCCUPATION": "Cultural Planner",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1622",
   "ENTITY": "IND",
   "ENTITY NAME": "Gonzales",
   "ENTITY NAME CONT.": "Ronald R",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Hispanic Foundation of Silicon Valley",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1420",
   "ENTITY": "IND",
   "ENTITY NAME": "Gordon",
   "ENTITY NAME CONT.": "Dan",
   "ENTITY CITY": "Redwood City",
   "Entity_ST": "CA",
   "EMPLOYER": "Gordon Biersch",
   "OCCUPATION": "Brewery Management",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2725",
   "ENTITY": "IND",
   "ENTITY NAME": "Grazios",
   "ENTITY NAME CONT.": "Erin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Robinson Oil Dba Rotten Robbie",
   "OCCUPATION": "Vice President",
   "AMOUNT": 300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1188",
   "ENTITY": "IND",
   "ENTITY NAME": "Greathouse",
   "ENTITY NAME CONT.": "E. Kent",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "E",
   "ID": "EX1303",
   "ENTITY": "IND",
   "ENTITY NAME": "Grijalba",
   "ENTITY NAME CONT.": "Ruben",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1199",
   "ENTITY": "IND",
   "ENTITY NAME": "Grover",
   "ENTITY NAME CONT.": "Barbara",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Therapist",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1021",
   "ENTITY": "IND",
   "ENTITY NAME": "Guess",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "Stockton",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Police departnment",
   "OCCUPATION": "Police officer",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3069",
   "ENTITY": "IND",
   "ENTITY NAME": "Hammon",
   "ENTITY NAME CONT.": "Walter",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Lawyer",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1425",
   "ENTITY": "IND",
   "ENTITY NAME": "Harlan",
   "ENTITY NAME CONT.": "Sparky",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Bill Wilson Center",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2804",
   "ENTITY": "IND",
   "ENTITY NAME": "Harris",
   "ENTITY NAME CONT.": "Jeremy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1038",
   "ENTITY": "IND",
   "ENTITY NAME": "Hawes",
   "ENTITY NAME CONT.": "Amanda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Lawyer",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3074",
   "ENTITY": "IND",
   "ENTITY NAME": "Hernandez",
   "ENTITY NAME CONT.": "Paulo",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Land Planner",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1439",
   "ENTITY": "IND",
   "ENTITY NAME": "Hirsch",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "Beverly Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "CS Kansas City Corp.",
   "OCCUPATION": "Board Member",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1032",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "Jean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "News For Chinese",
   "OCCUPATION": "Radio Host",
   "AMOUNT": 499
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3075",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "Anthony",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "LPMD Architects",
   "OCCUPATION": "Architectural Designer",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1182",
   "ENTITY": "IND",
   "ENTITY NAME": "Ho",
   "ENTITY NAME CONT.": "Wendy",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Silicon Valley Council",
   "OCCUPATION": "Policy Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2844",
   "ENTITY": "IND",
   "ENTITY NAME": "Hoang",
   "ENTITY NAME CONT.": "Khiem",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Unbrella Salon Inc.",
   "OCCUPATION": "Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1665",
   "ENTITY": "IND",
   "ENTITY NAME": "Hughes",
   "ENTITY NAME CONT.": "Dalia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The New Ballet",
   "OCCUPATION": "Director",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1417",
   "ENTITY": "IND",
   "ENTITY NAME": "Hurley",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 54
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3089",
   "ENTITY": "IND",
   "ENTITY NAME": "Hussie",
   "ENTITY NAME CONT.": "Halfdan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Cinequest",
   "OCCUPATION": "Director & Founder",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1443",
   "ENTITY": "IND",
   "ENTITY NAME": "Imwalle",
   "ENTITY NAME CONT.": "Donald",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Imwalle Properties",
   "OCCUPATION": "Real State Employer",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC2407",
   "ENTITY": "IND",
   "ENTITY NAME": "Ismail",
   "ENTITY NAME CONT.": "Hanif",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self Employed",
   "OCCUPATION": "Consultant",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1457",
   "ENTITY": "IND",
   "ENTITY NAME": "Jennings",
   "ENTITY NAME CONT.": "Marilee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Children's Discovery",
   "OCCUPATION": "Nonprofit Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2716",
   "ENTITY": "IND",
   "ENTITY NAME": "Johnson",
   "ENTITY NAME CONT.": "Michelle",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1030",
   "ENTITY": "IND",
   "ENTITY NAME": "KaliRai",
   "ENTITY NAME CONT.": "Sharanjit",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Jackson and Main LLC",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1201",
   "ENTITY": "IND",
   "ENTITY NAME": "Kamei",
   "ENTITY NAME CONT.": "Ellen",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "CA. State Assembly",
   "OCCUPATION": "District Director",
   "AMOUNT": 99
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1031",
   "ENTITY": "IND",
   "ENTITY NAME": "Keli-Rai",
   "ENTITY NAME CONT.": "Miriam",
   "ENTITY CITY": "Fremont",
   "Entity_ST": "CA",
   "EMPLOYER": "Jackson and Main LLC",
   "OCCUPATION": "Administrator Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2728",
   "ENTITY": "IND",
   "ENTITY NAME": "Kim",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Framcisco",
   "Entity_ST": "CA",
   "EMPLOYER": "Simeon",
   "OCCUPATION": "Re Development",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2715",
   "ENTITY": "IND",
   "ENTITY NAME": "Knies",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Assn.",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1653",
   "ENTITY": "IND",
   "ENTITY NAME": "Kovaleski",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Colliers International",
   "OCCUPATION": "Commercial Real Estate Broker",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1631",
   "ENTITY": "IND",
   "ENTITY NAME": "Kozlowski",
   "ENTITY NAME CONT.": "Kirk",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Saratoga Capital Inc.",
   "OCCUPATION": "Commercial Real Estate",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1205",
   "ENTITY": "IND",
   "ENTITY NAME": "Kutilek",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1454",
   "ENTITY": "IND",
   "ENTITY NAME": "Kutilek",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3073",
   "ENTITY": "IND",
   "ENTITY NAME": "Larko",
   "ENTITY NAME CONT.": "Peter A.",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "JP. Dinapoli Construction, INC",
   "OCCUPATION": "Planner",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1438",
   "ENTITY": "IND",
   "ENTITY NAME": "Larko",
   "ENTITY NAME CONT.": "Peter",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "JP DiNapoli Companies Inc.",
   "OCCUPATION": "Manager",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1436",
   "ENTITY": "IND",
   "ENTITY NAME": "Le",
   "ENTITY NAME CONT.": "Nicole",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Self",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3072",
   "ENTITY": "IND",
   "ENTITY NAME": "Lebron",
   "ENTITY NAME CONT.": "Charisse MA",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "County of Santa Clara",
   "OCCUPATION": "Policy Aid",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC2412",
   "ENTITY": "IND",
   "ENTITY NAME": "Lee",
   "ENTITY NAME CONT.": "Linda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "California Line Dance Association",
   "OCCUPATION": "Dance Instructor",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1414",
   "ENTITY": "IND",
   "ENTITY NAME": "Levin",
   "ENTITY NAME CONT.": "Jeffrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 180
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1442",
   "ENTITY": "IND",
   "ENTITY NAME": "Levine",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gap Inc.",
   "OCCUPATION": "IT. Software Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "A",
   "ID": "RC4176",
   "ENTITY": "IND",
   "ENTITY NAME": "Levine",
   "ENTITY NAME CONT.": "Jeff",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Gap Inc.",
   "OCCUPATION": "IT. Software Engineer",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2840",
   "ENTITY": "IND",
   "ENTITY NAME": "Li",
   "ENTITY NAME CONT.": "Zhen",
   "ENTITY CITY": "Saratoga",
   "Entity_ST": "CA",
   "EMPLOYER": "Zhen Li",
   "OCCUPATION": "Self",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1683",
   "ENTITY": "IND",
   "ENTITY NAME": "Li",
   "ENTITY NAME CONT.": "Leanne",
   "ENTITY CITY": "Los Altos",
   "Entity_ST": "CA",
   "EMPLOYER": "Bayview Development Group",
   "OCCUPATION": "Management",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC2409",
   "ENTITY": "IND",
   "ENTITY NAME": "Lin",
   "ENTITY NAME CONT.": "Mike",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "K1 & K2 Almond Ranch",
   "OCCUPATION": "Farmer/Manager",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC2410",
   "ENTITY": "IND",
   "ENTITY NAME": "Lin",
   "ENTITY NAME CONT.": "Kico",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Kicolin Realty",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1611",
   "ENTITY": "IND",
   "ENTITY NAME": "Lippman",
   "ENTITY NAME CONT.": "Gregory",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ACE Charter SAchools",
   "OCCUPATION": "Nonprofit Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1222",
   "ENTITY": "IND",
   "ENTITY NAME": "Lodoen",
   "ENTITY NAME CONT.": "Stephen",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "L & D Const. Co. Inc.",
   "OCCUPATION": "Businessman",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1223",
   "ENTITY": "IND",
   "ENTITY NAME": "Lodoen",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "L & D Construction Co. Inc.",
   "OCCUPATION": "Businessman",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1224",
   "ENTITY": "IND",
   "ENTITY NAME": "Lodoen",
   "ENTITY NAME CONT.": "Michael Alan",
   "ENTITY CITY": "Portola Valley",
   "Entity_ST": "CA",
   "EMPLOYER": "L & D Const. Co. Inc.",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1412",
   "ENTITY": "IND",
   "ENTITY NAME": "Loving",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Destination Home",
   "OCCUPATION": "Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1456",
   "ENTITY": "IND",
   "ENTITY NAME": "Lucero",
   "ENTITY NAME CONT.": "Matt",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Viktoriya's Supplies, LLC",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1034",
   "ENTITY": "IND",
   "ENTITY NAME": "Maben",
   "ENTITY NAME CONT.": "Meri",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SV Education Foundation",
   "OCCUPATION": "Education Manager",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1036",
   "ENTITY": "IND",
   "ENTITY NAME": "Martinez",
   "ENTITY NAME CONT.": "Constance",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "Sv Creates",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1196",
   "ENTITY": "IND",
   "ENTITY NAME": "Martinez",
   "ENTITY NAME CONT.": "Ramon",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1418",
   "ENTITY": "IND",
   "ENTITY NAME": "Mastrocola",
   "ENTITY NAME CONT.": "Phil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1823",
   "ENTITY": "IND",
   "ENTITY NAME": "Matulich",
   "ENTITY NAME CONT.": "Marc",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Airfield Supply Co.",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1197",
   "ENTITY": "IND",
   "ENTITY NAME": "McCollum",
   "ENTITY NAME CONT.": "Charlie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1617",
   "ENTITY": "IND",
   "ENTITY NAME": "McCollum",
   "ENTITY NAME CONT.": "Charles",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1220",
   "ENTITY": "IND",
   "ENTITY NAME": "McEnery",
   "ENTITY NAME CONT.": "Tom",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Farmers Union",
   "OCCUPATION": "General Partner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1221",
   "ENTITY": "IND",
   "ENTITY NAME": "McEnery",
   "ENTITY NAME CONT.": "Jill",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1767",
   "ENTITY": "IND",
   "ENTITY NAME": "McNulty",
   "ENTITY NAME CONT.": "Scott",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose",
   "OCCUPATION": "Police Officer",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3071",
   "ENTITY": "IND",
   "ENTITY NAME": "Melkesian",
   "ENTITY NAME CONT.": "Allan",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Grayson Community Management",
   "OCCUPATION": "President",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1613",
   "ENTITY": "IND",
   "ENTITY NAME": "Menne",
   "ENTITY NAME CONT.": "Martin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "MCM Diversified",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1682",
   "ENTITY": "IND",
   "ENTITY NAME": "Michelis",
   "ENTITY NAME CONT.": "Victoria",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Teal's Real",
   "OCCUPATION": "Nonprofit",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1791",
   "ENTITY": "IND",
   "ENTITY NAME": "Mitchell",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Parisi House on the Hill",
   "OCCUPATION": "Nonprofit Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2805",
   "ENTITY": "IND",
   "ENTITY NAME": "Moller",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "R. Moller",
   "OCCUPATION": "Project Mngmt",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1805",
   "ENTITY": "IND",
   "ENTITY NAME": "Morales",
   "ENTITY NAME CONT.": "Bob",
   "ENTITY CITY": "Arcadia",
   "Entity_ST": "CA",
   "EMPLOYER": "Learn 4 Life",
   "OCCUPATION": "Vice President",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1428",
   "ENTITY": "IND",
   "ENTITY NAME": "Moreles",
   "ENTITY NAME CONT.": "Jess",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Whole foods Market",
   "OCCUPATION": "Asst. Store team Lead",
   "AMOUNT": 300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3086",
   "ENTITY": "IND",
   "ENTITY NAME": "Mulcahy",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SDS NexGen Partners LP",
   "OCCUPATION": "Real Estate Development",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1607",
   "ENTITY": "IND",
   "ENTITY NAME": "Musser",
   "ENTITY NAME CONT.": "Reilly",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Robinson Oil dba Rotten Robbie",
   "OCCUPATION": "Vice President of Marketing & Merchandise",
   "AMOUNT": 300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1039",
   "ENTITY": "IND",
   "ENTITY NAME": "Navarro",
   "ENTITY NAME CONT.": "Ruben",
   "ENTITY CITY": "San jose",
   "Entity_ST": "CA",
   "EMPLOYER": "None",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1761",
   "ENTITY": "IND",
   "ENTITY NAME": "Neale",
   "ENTITY NAME CONT.": "David",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Core Companies",
   "OCCUPATION": "Real Estate Developer",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1762",
   "ENTITY": "IND",
   "ENTITY NAME": "Neale",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "The Core Companies",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1785",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Bryan",
   "ENTITY NAME CONT.": "Rebecca",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "Defense-Ability",
   "OCCUPATION": "Business Owner",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1794",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Kane",
   "ENTITY NAME CONT.": "Sean",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Big Kahuna Productions",
   "OCCUPATION": "Marketing Director",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1419",
   "ENTITY": "IND",
   "ENTITY NAME": "O'Neill",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1219",
   "ENTITY": "IND",
   "ENTITY NAME": "Orozco",
   "ENTITY NAME CONT.": "Paul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Iguanas",
   "OCCUPATION": "Owner",
   "AMOUNT": 300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1029",
   "ENTITY": "IND",
   "ENTITY NAME": "Patel",
   "ENTITY NAME CONT.": "Anil",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Charles Motel",
   "OCCUPATION": "Self",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1677",
   "ENTITY": "IND",
   "ENTITY NAME": "Payne",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "East Side Union District",
   "OCCUPATION": "High School English Teacher",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1328",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Raul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX547",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Raul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX658",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Raul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1323",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Raul",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "B1",
   "ID": "LN25",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Raul R.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "City Council",
   "AMOUNT": 380
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "B1",
   "ID": "LN23",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Raul R.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "City Council",
   "AMOUNT": 312
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1200",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Jesse",
   "ENTITY CITY": "Hayward",
   "Entity_ST": "CA",
   "EMPLOYER": "NCCRC",
   "OCCUPATION": "Field Representative",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX673",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Denise",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 68
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "B1",
   "ID": "LN26",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Raul R.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "City Council",
   "AMOUNT": 40
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1016",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Denise",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Unenployed",
   "OCCUPATION": "House wife",
   "AMOUNT": 25
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC2021",
   "ENTITY": "IND",
   "ENTITY NAME": "Peralez",
   "ENTITY NAME CONT.": "Raul R.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "City Council",
   "AMOUNT": 11
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1800",
   "ENTITY": "IND",
   "ENTITY NAME": "Phillips",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1204",
   "ENTITY": "IND",
   "ENTITY NAME": "Poch",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Sports Authority",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1449",
   "ENTITY": "IND",
   "ENTITY NAME": "Poch",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "Sports Authority",
   "OCCUPATION": "Executive Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1645",
   "ENTITY": "IND",
   "ENTITY NAME": "Powers",
   "ENTITY NAME CONT.": "Charlotte",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1441",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramos",
   "ENTITY NAME CONT.": "Angelina",
   "ENTITY CITY": "Union City",
   "Entity_ST": "CA",
   "EMPLOYER": "ACE Charter Schools",
   "OCCUPATION": "Director of Community Engagement",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1415",
   "ENTITY": "IND",
   "ENTITY NAME": "Ramos",
   "ENTITY NAME CONT.": "Christina",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City Of San Jose",
   "OCCUPATION": "Goverment",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1444",
   "ENTITY": "IND",
   "ENTITY NAME": "Rawson",
   "ENTITY NAME CONT.": "Brendan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Jazz",
   "OCCUPATION": "Director",
   "AMOUNT": 90
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2807",
   "ENTITY": "IND",
   "ENTITY NAME": "Rewkiewicz",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "CPA",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2808",
   "ENTITY": "IND",
   "ENTITY NAME": "Rewkiewicz",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "CPA",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2849",
   "ENTITY": "IND",
   "ENTITY NAME": "Roberts",
   "ENTITY NAME CONT.": "Joel",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "PATH Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1424",
   "ENTITY": "IND",
   "ENTITY NAME": "Robinson",
   "ENTITY NAME CONT.": "Thomas",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Robinson Oil Corporation",
   "OCCUPATION": "President",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2729",
   "ENTITY": "IND",
   "ENTITY NAME": "Robinson",
   "ENTITY NAME CONT.": "Lynn",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Unemployed",
   "OCCUPATION": "Unemployed",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2847",
   "ENTITY": "IND",
   "ENTITY NAME": "Rosa",
   "ENTITY NAME CONT.": "Richard De La",
   "ENTITY CITY": "Las Vegas",
   "Entity_ST": "NV",
   "EMPLOYER": "Dr. La Rosa Latin American Imports",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1033",
   "ENTITY": "IND",
   "ENTITY NAME": "Ross",
   "ENTITY NAME CONT.": "Jay",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Hopkins & Carley",
   "OCCUPATION": "Attorney",
   "AMOUNT": 300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1681",
   "ENTITY": "IND",
   "ENTITY NAME": "Rubnitz",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Monte Sereno",
   "Entity_ST": "CA",
   "EMPLOYER": "NARJ LLC",
   "OCCUPATION": "Real Estate",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "A",
   "ID": "RC4149",
   "ENTITY": "IND",
   "ENTITY NAME": "Ruiz",
   "ENTITY NAME CONT.": "Mary Ann",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 25
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1190",
   "ENTITY": "IND",
   "ENTITY NAME": "Rulloda",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Splash Bar",
   "OCCUPATION": "General Manager",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1202",
   "ENTITY": "IND",
   "ENTITY NAME": "Rust",
   "ENTITY NAME CONT.": "Audrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1450",
   "ENTITY": "IND",
   "ENTITY NAME": "Rust",
   "ENTITY NAME CONT.": "Audrey",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1171",
   "ENTITY": "IND",
   "ENTITY NAME": "Saito",
   "ENTITY NAME CONT.": "Richard",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1413",
   "ENTITY": "IND",
   "ENTITY NAME": "Salazar",
   "ENTITY NAME CONT.": "Dayana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Professor",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2834",
   "ENTITY": "IND",
   "ENTITY NAME": "Salazar",
   "ENTITY NAME CONT.": "Dayana",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose State University",
   "OCCUPATION": "Professor",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1195",
   "ENTITY": "IND",
   "ENTITY NAME": "Sammeta",
   "ENTITY NAME CONT.": "Vijay",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Civic Foundry",
   "OCCUPATION": "CEO",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1227",
   "ENTITY": "IND",
   "ENTITY NAME": "Sanchez",
   "ENTITY NAME CONT.": "Aurelia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 30
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1649",
   "ENTITY": "IND",
   "ENTITY NAME": "Sandoval",
   "ENTITY NAME CONT.": "Vanessa",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Chief of Staff",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1225",
   "ENTITY": "IND",
   "ENTITY NAME": "Sapien",
   "ENTITY NAME CONT.": "Hermelinda",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "CET",
   "OCCUPATION": "President/ CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1433",
   "ENTITY": "IND",
   "ENTITY NAME": "Sausedo",
   "ENTITY NAME CONT.": "Patricia",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1672",
   "ENTITY": "IND",
   "ENTITY NAME": "Schaefer",
   "ENTITY NAME CONT.": "Erica",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Intuitive Surgical",
   "OCCUPATION": "Public Relations",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2726",
   "ENTITY": "IND",
   "ENTITY NAME": "Schaupp",
   "ENTITY NAME CONT.": "Carolyn",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SCCOE",
   "OCCUPATION": "Teacher",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3085",
   "ENTITY": "IND",
   "ENTITY NAME": "Schiro",
   "ENTITY NAME CONT.": "Shirlee",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "SDS NexGen Partners LP",
   "OCCUPATION": "Retired",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3079",
   "ENTITY": "IND",
   "ENTITY NAME": "Seaver",
   "ENTITY NAME CONT.": "Derrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Association",
   "OCCUPATION": "Director of Policy & Operations",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1638",
   "ENTITY": "IND",
   "ENTITY NAME": "Seaver",
   "ENTITY NAME CONT.": "Derrick",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose Downtown Association",
   "OCCUPATION": "Director of Policy & Operations",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1184",
   "ENTITY": "IND",
   "ENTITY NAME": "Simmons",
   "ENTITY NAME CONT.": "Chris",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "NEU2U Thrift Boutique",
   "OCCUPATION": "Owner",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2720",
   "ENTITY": "IND",
   "ENTITY NAME": "Singh",
   "ENTITY NAME CONT.": "Paramjeet",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "ISS Micro INC.",
   "OCCUPATION": "Self Employed",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1037",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Theodore",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self",
   "OCCUPATION": "Consultant",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2723",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Jennifer",
   "ENTITY CITY": "Los Altos Hills",
   "Entity_ST": "CA",
   "EMPLOYER": "Bay Area Women's Sports Initiative",
   "OCCUPATION": "Non Profit Leader",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1447",
   "ENTITY": "IND",
   "ENTITY NAME": "Smith",
   "ENTITY NAME CONT.": "Lisa Hettler",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2837",
   "ENTITY": "IND",
   "ENTITY NAME": "Soto-Galvan",
   "ENTITY NAME CONT.": "Gabriela",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Self Employed",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2841",
   "ENTITY": "IND",
   "ENTITY NAME": "Sounders",
   "ENTITY NAME CONT.": "William",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "TRI-Align",
   "OCCUPATION": "Consultant",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1452",
   "ENTITY": "IND",
   "ENTITY NAME": "Southwick",
   "ENTITY NAME CONT.": "Stephanie",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Greenfield Draa & Harrington",
   "OCCUPATION": "Attorney",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2848",
   "ENTITY": "IND",
   "ENTITY NAME": "Sreekrishnan",
   "ENTITY NAME CONT.": "Tara",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "City Of Berkeley",
   "OCCUPATION": "Legislative Assistant",
   "AMOUNT": 20
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1788",
   "ENTITY": "IND",
   "ENTITY NAME": "Stephens",
   "ENTITY NAME CONT.": "Michael",
   "ENTITY CITY": "Oceanside",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1040",
   "ENTITY": "IND",
   "ENTITY NAME": "Strangis",
   "ENTITY NAME CONT.": "Jerry",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Strangis Properties",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1041",
   "ENTITY": "IND",
   "ENTITY NAME": "Strangis",
   "ENTITY NAME CONT.": "Janet",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Strangis Properties",
   "OCCUPATION": "Owner",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1325",
   "ENTITY": "IND",
   "ENTITY NAME": "Stroker",
   "ENTITY NAME CONT.": "Eric C,",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX371",
   "ENTITY": "IND",
   "ENTITY NAME": "Stroker",
   "ENTITY NAME CONT.": "Eric C.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX548",
   "ENTITY": "IND",
   "ENTITY NAME": "Stroker",
   "ENTITY NAME CONT.": "Eric C",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX603",
   "ENTITY": "IND",
   "ENTITY NAME": "Stroker",
   "ENTITY NAME CONT.": "Eric C",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX660",
   "ENTITY": "IND",
   "ENTITY NAME": "Stroker",
   "ENTITY NAME CONT.": "Eric C.",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "E",
   "ID": "EX1305",
   "ENTITY": "IND",
   "ENTITY NAME": "Stroker",
   "ENTITY NAME CONT.": "Eric C",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1308",
   "ENTITY": "IND",
   "ENTITY NAME": "Stroker",
   "ENTITY NAME CONT.": "Eric C",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX605",
   "ENTITY": "IND",
   "ENTITY NAME": "Stroker",
   "ENTITY NAME CONT.": "Eric C",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 213
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1802",
   "ENTITY": "IND",
   "ENTITY NAME": "Swenson",
   "ENTITY NAME CONT.": "Case",
   "ENTITY CITY": "Los Gatos",
   "Entity_ST": "CA",
   "EMPLOYER": "Swenson",
   "OCCUPATION": "Construction",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1315",
   "ENTITY": "IND",
   "ENTITY NAME": "Tensuan",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "Mountain View",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1216",
   "ENTITY": "IND",
   "ENTITY NAME": "Todd",
   "ENTITY NAME CONT.": "Teresa",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "N F P",
   "OCCUPATION": "Insurance Agent",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1460",
   "ENTITY": "IND",
   "ENTITY NAME": "Tompkison",
   "ENTITY NAME CONT.": "Catherine",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "The Thompkison Group",
   "OCCUPATION": "Public Affairs",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2836",
   "ENTITY": "IND",
   "ENTITY NAME": "Tortora",
   "ENTITY NAME CONT.": "John",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sharks Sports & Entertainment, LLC",
   "OCCUPATION": "CO-President",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1435",
   "ENTITY": "IND",
   "ENTITY NAME": "Tran",
   "ENTITY NAME CONT.": "Vince",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Santa Clara County Office of education",
   "OCCUPATION": "Engineer",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1829",
   "ENTITY": "IND",
   "ENTITY NAME": "Trayer",
   "ENTITY NAME CONT.": "Todd",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of San Jose",
   "OCCUPATION": "Police Officer",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1028",
   "ENTITY": "IND",
   "ENTITY NAME": "Trung",
   "ENTITY NAME CONT.": "Andrew",
   "ENTITY CITY": "Sunnyvale",
   "Entity_ST": "CA",
   "EMPLOYER": "UBS",
   "OCCUPATION": "Finance",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2730",
   "ENTITY": "IND",
   "ENTITY NAME": "Truong",
   "ENTITY NAME CONT.": "Elizabeth",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Lee's Sandwiches",
   "OCCUPATION": "Self",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1206",
   "ENTITY": "IND",
   "ENTITY NAME": "Vaiz",
   "ENTITY NAME CONT.": "Lucila",
   "ENTITY CITY": "Gustine",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partners",
   "OCCUPATION": "Coordinator",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1453",
   "ENTITY": "IND",
   "ENTITY NAME": "Vaiz",
   "ENTITY NAME CONT.": "Lucila",
   "ENTITY CITY": "Gustine",
   "Entity_ST": "CA",
   "EMPLOYER": "Working Partners",
   "OCCUPATION": "Coordinator",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1770",
   "ENTITY": "IND",
   "ENTITY NAME": "Vuckovich",
   "ENTITY NAME CONT.": "Stan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "KBM-Hogue",
   "OCCUPATION": "CEO",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1218",
   "ENTITY": "IND",
   "ENTITY NAME": "Walia",
   "ENTITY NAME CONT.": "Vinni",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Team San Jose",
   "OCCUPATION": "Director of Facilities",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1427",
   "ENTITY": "IND",
   "ENTITY NAME": "Williams",
   "ENTITY NAME CONT.": "Alan",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Oracle",
   "OCCUPATION": "Product Manager",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1434",
   "ENTITY": "IND",
   "ENTITY NAME": "Wong",
   "ENTITY NAME CONT.": "Dora",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Coca Cola",
   "OCCUPATION": "Director of Public Affairs & Communications",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2833",
   "ENTITY": "IND",
   "ENTITY NAME": "Woock",
   "ENTITY NAME CONT.": "Greg",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Pinger Inc.",
   "OCCUPATION": "CEO",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2824",
   "ENTITY": "IND",
   "ENTITY NAME": "Wymer",
   "ENTITY NAME CONT.": "Steve",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Nextdoor",
   "OCCUPATION": "Vice President",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2842",
   "ENTITY": "IND",
   "ENTITY NAME": "Yanagisawa",
   "ENTITY NAME CONT.": "Noriko",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "A",
   "ID": "RC4177",
   "ENTITY": "IND",
   "ENTITY NAME": "Yanagisawa",
   "ENTITY NAME CONT.": "Noriko",
   "ENTITY CITY": "Cupertino",
   "Entity_ST": "CA",
   "EMPLOYER": "Retired",
   "OCCUPATION": "Retired",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1422",
   "ENTITY": "IND",
   "ENTITY NAME": "Yazowski",
   "ENTITY NAME CONT.": "Sharon",
   "ENTITY CITY": "Unit # 2 North Hollywood",
   "Entity_ST": "CA",
   "EMPLOYER": "Mortimer & Mimi Levitt Foundation",
   "OCCUPATION": "Nonprofit Executive",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1760",
   "ENTITY": "IND",
   "ENTITY NAME": "Yumen",
   "ENTITY NAME CONT.": "James",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "San Jose",
   "OCCUPATION": "Police",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1319",
   "ENTITY": "IND",
   "ENTITY NAME": "Zamora",
   "ENTITY NAME CONT.": "Gil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1327",
   "ENTITY": "IND",
   "ENTITY NAME": "Zamora",
   "ENTITY NAME CONT.": "Gil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX620",
   "ENTITY": "IND",
   "ENTITY NAME": "Zamora",
   "ENTITY NAME CONT.": "Gil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 750
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1642",
   "ENTITY": "IND",
   "ENTITY NAME": "Zamora",
   "ENTITY NAME CONT.": "Gil",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Sketch-Artist, LLC",
   "OCCUPATION": "Forensic Artist",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3084",
   "ENTITY": "IND",
   "ENTITY NAME": "Zazueta",
   "ENTITY NAME CONT.": "Daniel",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "City of Santa Clara",
   "OCCUPATION": "Attorney",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1429",
   "ENTITY": "IND",
   "ENTITY NAME": "Zwick",
   "ENTITY NAME CONT.": "Kevin",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "Housing Trust Silicon Valley",
   "OCCUPATION": "Nonprofit Director",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX687",
   "ENTITY": "OTH",
   "ENTITY NAME": "50 West",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX595",
   "ENTITY": "OTH",
   "ENTITY NAME": "99 C Only Store",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Chula Vista",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 23
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2714",
   "ENTITY": "OTH",
   "ENTITY NAME": "AECOM Technical Services INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Austin",
   "Entity_ST": "TX",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1022",
   "ENTITY": "OTH",
   "ENTITY NAME": "Affirmed Housing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX597",
   "ENTITY": "OTH",
   "ENTITY NAME": "Airbnb, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 301
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2845",
   "ENTITY": "OTH",
   "ENTITY NAME": "Airfield Supply Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX606",
   "ENTITY": "OTH",
   "ENTITY NAME": "Alliance Graphics",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Berkely",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 571
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1023",
   "ENTITY": "OTH",
   "ENTITY NAME": "Armando Gomez Consulting",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX416",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bank of The West",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX543",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bay Area Asian Pacific American Legislative Staffers",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1198",
   "ENTITY": "OTH",
   "ENTITY NAME": "Bayview Development Group Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2740",
   "ENTITY": "OTH",
   "ENTITY NAME": "Building Industry Association",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Walnut Creek",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX668",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chevron",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 14
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX669",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chipotle Mexican Grill",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 71
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX665",
   "ENTITY": "OTH",
   "ENTITY NAME": "Chipotle Mexican Grill",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 57
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX596",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2305
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX672",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 4
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX670",
   "ENTITY": "OTH",
   "ENTITY NAME": "City of San Jose City Hall",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2722",
   "ENTITY": "OTH",
   "ENTITY NAME": "Coca Cola Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX667",
   "ENTITY": "OTH",
   "ENTITY NAME": "CSJ Convention CTR Garage",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 10
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX607",
   "ENTITY": "OTH",
   "ENTITY NAME": "E. Chavez Annual Scholarship Breakfast",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1056
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX594",
   "ENTITY": "OTH",
   "ENTITY NAME": "EL Patron Mexican Food",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 307
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX593",
   "ENTITY": "OTH",
   "ENTITY NAME": "El Pescador",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "La Jolla",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 150
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX599",
   "ENTITY": "OTH",
   "ENTITY NAME": "Flames Eatery",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 49
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "E",
   "ID": "EX1206",
   "ENTITY": "OTH",
   "ENTITY NAME": "Forager",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 812
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1309",
   "ENTITY": "OTH",
   "ENTITY NAME": "Fry's Electronics",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 61
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "E",
   "ID": "EX1203",
   "ENTITY": "OTH",
   "ENTITY NAME": "Fry's Electronics",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 61
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1203",
   "ENTITY": "OTH",
   "ENTITY NAME": "Greenfield Draa & Harrington",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2823",
   "ENTITY": "OTH",
   "ENTITY NAME": "Horizon Real properties Holdings, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Mateo",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2020",
   "ENTITY": "OTH",
   "ENTITY NAME": "IBEW Union # 332 Education Fund",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "A",
   "ID": "RC4179",
   "ENTITY": "OTH",
   "ENTITY NAME": "IFPTE 21/TJ Anthony PAC FUND",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2717",
   "ENTITY": "OTH",
   "ENTITY NAME": "Insight Realty Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1165",
   "ENTITY": "OTH",
   "ENTITY NAME": "JBHA INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "A",
   "ID": "RC4148",
   "ENTITY": "OTH",
   "ENTITY NAME": "John Edward (Jed) York & Affiliated Entities, Including the Forty Niners Football Company LLC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Santa Clara",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2810",
   "ENTITY": "OTH",
   "ENTITY NAME": "JP Dinapoli",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1209",
   "ENTITY": "OTH",
   "ENTITY NAME": "Laborers Local Union 270 Pac",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX604",
   "ENTITY": "OTH",
   "ENTITY NAME": "Latino Leadership",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 210
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX602",
   "ENTITY": "OTH",
   "ENTITY NAME": "Latino Leadership Alliance",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3076",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lighthouse Public Affairs, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX600",
   "ENTITY": "OTH",
   "ENTITY NAME": "Lolita's At the Park",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 37
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX372",
   "ENTITY": "OTH",
   "ENTITY NAME": "MailChimp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 40
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX546",
   "ENTITY": "OTH",
   "ENTITY NAME": "MailChimp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX598",
   "ENTITY": "OTH",
   "ENTITY NAME": "MailChimp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX621",
   "ENTITY": "OTH",
   "ENTITY NAME": "MailChimp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX664",
   "ENTITY": "OTH",
   "ENTITY NAME": "MailChimp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1307",
   "ENTITY": "OTH",
   "ENTITY NAME": "MailChimp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Atlanta",
   "Entity_ST": "GA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "E",
   "ID": "EX1205",
   "ENTITY": "OTH",
   "ENTITY NAME": "Miller & Olson LLP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Burlingame",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1329",
   "ENTITY": "OTH",
   "ENTITY NAME": "Neighbors for Affordable Housing  & Open Space",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 5000
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3317",
   "ENTITY": "OTH",
   "ENTITY NAME": "Northern California Carpenters Regional Council",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Oakland",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2806",
   "ENTITY": "OTH",
   "ENTITY NAME": "O'Flaherty's",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX373",
   "ENTITY": "OTH",
   "ENTITY NAME": "Office Depot",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 51
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "A",
   "ID": "RC4150",
   "ENTITY": "OTH",
   "ENTITY NAME": "Operating Engineers Local Union No #3",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Alameda",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1318",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 11686
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "E",
   "ID": "EX1202",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 322
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX608",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 295
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX549",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 244
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX368",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 189
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX370",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 101
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX418",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 101
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX622",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 70
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX369",
   "ENTITY": "OTH",
   "ENTITY NAME": "Pacific Printing",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 30
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1310",
   "ENTITY": "OTH",
   "ENTITY NAME": "Panera Bread",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 34
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX376",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 16
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX619",
   "ENTITY": "OTH",
   "ENTITY NAME": "PayPal",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 3
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1208",
   "ENTITY": "OTH",
   "ENTITY NAME": "Plumbers Steamfitters & Refrigeration Fitters",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3080",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Action Committee",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 200
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX609",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 1300
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1324",
   "ENTITY": "OTH",
   "ENTITY NAME": "Political Data Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Norwalk",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 491
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX375",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rainbow Chamber of Commerce Silicon Valley",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 50
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "A",
   "ID": "RC4188",
   "ENTITY": "OTH",
   "ENTITY NAME": "Rebello's Towing Services, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "A",
   "ID": "RC4147",
   "ENTITY": "OTH",
   "ENTITY NAME": "Republic Services INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1020",
   "ENTITY": "OTH",
   "ENTITY NAME": "Republic Urban Properties LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX601",
   "ENTITY": "OTH",
   "ENTITY NAME": "Richard Walker's Pancake House",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Diego",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 132
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1027",
   "ENTITY": "OTH",
   "ENTITY NAME": "RLMP LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX685",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sales@signrocket",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "St. Paul Park",
   "Entity_ST": "MN",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 405
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1017",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Police Officers Association",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2721",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose Water Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX686",
   "ENTITY": "OTH",
   "ENTITY NAME": "San Jose/Silicon Valley NAACP",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Milpitas",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 406
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1025",
   "ENTITY": "OTH",
   "ENTITY NAME": "Santa Clara & San Benito Building & Construction Trades Council",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX666",
   "ENTITY": "OTH",
   "ENTITY NAME": "Santa Clara Chevron",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 15
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3091",
   "ENTITY": "OTH",
   "ENTITY NAME": "SDS NexGen",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "A",
   "ID": "RC4180",
   "ENTITY": "OTH",
   "ENTITY NAME": "Service Employees International Union Local 521",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC3077",
   "ENTITY": "OTH",
   "ENTITY NAME": "Seven Hills Properties, LLC",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1213",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sheet Metal Workers Local Union # 104",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Ramon",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX374",
   "ENTITY": "OTH",
   "ENTITY NAME": "Silicon Valley Young Democrats",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 250
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX659",
   "ENTITY": "OTH",
   "ENTITY NAME": "South Bay AFL-CIO Labor Council Cope",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX367",
   "ENTITY": "OTH",
   "ENTITY NAME": "SP2",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 800
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "C",
   "ID": "RC2019",
   "ENTITY": "OTH",
   "ENTITY NAME": "SP2",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1024",
   "ENTITY": "OTH",
   "ENTITY NAME": "Speno Enterprises Lp",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1212",
   "ENTITY": "OTH",
   "ENTITY NAME": "Sprinkler Fitters And Apprentices Local # 483 Pac",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Sacramento",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX417",
   "ENTITY": "OTH",
   "ENTITY NAME": "Squarespace, Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "New York",
   "Entity_ST": "NY",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 312
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1210",
   "ENTITY": "OTH",
   "ENTITY NAME": "Steinberg Architects",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX377",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 749
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX675",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 263
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX578",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 159
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/3/2018",
   "FORM": "E",
   "ID": "EX1330",
   "ENTITY": "OTH",
   "ENTITY NAME": "Stripe",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Francisco",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 8
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1026",
   "ENTITY": "OTH",
   "ENTITY NAME": "Super Micro Computer INC.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "SAN JOSE",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "E",
   "ID": "EX1204",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 115
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX688",
   "ENTITY": "OTH",
   "ENTITY NAME": "Target",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 33
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2719",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Ritz",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 500
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "A",
   "ID": "RC1168",
   "ENTITY": "OTH",
   "ENTITY NAME": "The Schoennauer Company",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "1/30/2018",
   "FORM": "E",
   "ID": "EX415",
   "ENTITY": "OTH",
   "ENTITY NAME": "United States Post Office",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 112
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX545",
   "ENTITY": "OTH",
   "ENTITY NAME": "US Post Office",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "Campbell",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 100
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX671",
   "ENTITY": "OTH",
   "ENTITY NAME": "Which Wich",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 27
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "A",
   "ID": "RC2825",
   "ENTITY": "OTH",
   "ENTITY NAME": "Wymer & Associates Inc.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 600
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX544",
   "ENTITY": "OTH",
   "ENTITY NAME": "Your CA Democratic Party",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 120
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "4/26/2018",
   "FORM": "E",
   "ID": "EX555",
   "ENTITY": "OTH",
   "ENTITY NAME": "Yu-Ai Kai Annual Fundraising",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 400
 },
 {
   "LAST": "Peralez",
   "FIRST": "Raul",
   "PURPOSE": "Raul Peralez for SJ City Council 2018 D3",
   "DATE": "6/1/2018",
   "FORM": "E",
   "ID": "EX1306",
   "ENTITY": "PTY",
   "ENTITY NAME": "UDC Santa Clara Co.",
   "ENTITY NAME CONT.": "",
   "ENTITY CITY": "San Jose",
   "Entity_ST": "CA",
   "EMPLOYER": "",
   "OCCUPATION": "",
   "AMOUNT": 2500
 }
]